function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7AfLj", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "DashboardEditable", ()=>$872b0d98ab184287$export$33b9febc64bdf6bf);
    $parcel$export(module.exports, "default", ()=>$872b0d98ab184287$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2Zxiy;
    var $92Z2l;
    var $65Ltd;
    var $lL5b5;
    var $JIPqS;
    var $duhqo;
    var $iyrll;
    var $32Vhm;
    var $1rce7;
    var $1CEw6;
    var $5HxxK;
    var $4kIa4;
    var $h7J1E;
    var $beRD7;
    var $koVbs;
    var $6jY6G;
    var $gh1hi;
    var $dIdda = parcelRequire("dIdda");
    var $dWAHS;
    var $fkN9I;
    var $1WOL5;
    var $57x9W;
    var $fVBqv;
    var $6WXUd;
    var $jd4if;
    var $c92ZE;
    var $hsZLS;
    const $872b0d98ab184287$export$33b9febc64bdf6bf = ()=>{
        const { data: data, error: error, loading: loading } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const { registerConnectGadget: registerConnectGadget, unregisterConnectGadget: unregisterConnectGadget, setCustomTitle: setCustomTitle } = (0, (0, parcelRequire("h7J1E")).useConnectGadgetTitles)();
        const setLayout = (0, (0, parcelRequire("fkN9I")).useLayoutChange)();
        const showLayoutFlag = (0, (0, parcelRequire("hsZLS")).useLayoutChangeErrorFlag)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onLayoutHandler = (0, $5uXOq.useCallback)((...args)=>{
            setLayout(...args).catch(showLayoutFlag);
        }, [
            setLayout,
            showLayoutFlag
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kIa4")).DashboardContentContainer), {
            analyticsExperience: (0, (0, parcelRequire("JIPqS")).VIEW_DASHBOARD_EDITABLE_EXPERIENCE),
            saveCustomGadgetTitle: setCustomTitle,
            resourceData: {
                data: data,
                error: error,
                loading: loading
            },
            permissionErrorFallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).DashboardPermissionErrorPageAsync), null)
        }, data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("32Vhm")).DashboardController), {
            id: data.id,
            automaticRefreshMs: data.automaticRefreshMs
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dWAHS")).RightPanelLayoutContainer), {
            isOpenByDefault: true,
            defaultPanelId: `${(0, (0, parcelRequire("6WXUd")).addGadgetPanelId)}-0`,
            rightContent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVBqv")).AsyncAddGadgetPanel), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jd4if")).HeaderEditable), {
            data: data,
            banners: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                appearance: "discovery"
            }, formatMessage((0, (0, parcelRequire("1WOL5")).default).editingInfo)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("duhqo")).DeprecationBanner), {
                gadgets: data.gadgets,
                gadgetId: data.id
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1CEw6")).EngagementBanners), null)),
            onLayoutSelected: onLayoutHandler
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HxxK")).ColumnLayout), {
            data: data,
            dnd: {
                DragDropContext: (0, parcelRequire("2Zxiy")).DragDropContext,
                Draggable: (0, parcelRequire("2Zxiy")).Draggable,
                Droppable: (0, parcelRequire("2Zxiy")).Droppable
            },
            columnPlaceholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c92ZE")).ColumnPlaceholder), null),
            layoutPlaceholder: null,
            onLayoutReposition: onLayoutHandler
        }, ({ isAnyDragging: isAnyDragging, ...gadgetProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iyrll")).DashboardControllerContextConsumer), null, ({ refreshId: refreshId, onMount: onMount })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57x9W")).GadgetEditable), {
                    ...gadgetProps,
                    isConnectDisabled: isAnyDragging,
                    dashboardId: data.id,
                    refreshId: refreshId,
                    onMount: onMount,
                    onRegisterConnectGadget: registerConnectGadget,
                    onUnregisterConnectGadget: unregisterConnectGadget
                }))))) : null);
    };
    var $872b0d98ab184287$export$2e2bcd8739ae039 = ()=>{
        const { data: data, error: error, loading: loading } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { path: viewPath } = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW)) ?? {};
        const { path: systemDashboardPath } = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)) ?? {};
        const { id: id, title: title } = data ?? {};
        if (id === (0, (0, parcelRequire("JIPqS")).SYSTEM_DASHBOARD_ID)) return systemDashboardPath != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: (0, $dIdda.generatePath)(systemDashboardPath)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).DashboardPermissionErrorPageAsync), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rce7")).DashboardPageContainer), {
            analyticsSourceName: (0, (0, parcelRequire("JIPqS")).DASHBOARD_EDIT_SOURCENAME),
            analyticsExperience: (0, (0, parcelRequire("JIPqS")).VIEW_DASHBOARD_EDITABLE_EXPERIENCE),
            documentTitle: title ? formatMessage((0, (0, parcelRequire("1WOL5")).default).pageTitle, {
                dashboardName: title
            }) : formatMessage((0, (0, parcelRequire("1WOL5")).default).pageTitleFallback),
            unauthorisedFallback: viewPath && id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: (0, $dIdda.generatePath)(viewPath, {
                    dashboardId: id
                })
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).DashboardPermissionErrorPageAsync), null),
            unauthenticatedFallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lL5b5")).default), null),
            resourceData: {
                data: data,
                error: error,
                loading: loading
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($872b0d98ab184287$export$33b9febc64bdf6bf, null));
    };
});
parcelRegister("2Zxiy", function(module, exports) {
    $parcel$export(module.exports, "DragDropContext", ()=>$22db1ba098eb3017$export$237bd83162c14364);
    $parcel$export(module.exports, "Draggable", ()=>$22db1ba098eb3017$export$f2a139e5d18b9882);
    $parcel$export(module.exports, "Droppable", ()=>$22db1ba098eb3017$export$423ec2075359570a);
    var $5uXOq = parcelRequire("5uXOq");
    var $3YMLK;
    var $1AwyE = parcelRequire("1AwyE");
    var $gzM5u = parcelRequire("gzM5u");
    var $22j3V;
    parcelRequire("i6AsN");
    var $AuRrZ = parcelRequire("AuRrZ");
    var $9bdMd = parcelRequire("9bdMd");
    var $3YKxB;
    var $g7psY;
    var $i2aN7 = parcelRequire("i2aN7");
    var $cs3hJ = parcelRequire("cs3hJ");
    var $crAmF;
    var $3BSY2 = parcelRequire("3BSY2");
    var $4iZOV = parcelRequire("4iZOV");
    var $7nsd3 = parcelRequire("7nsd3");
    var $1DIXK = parcelRequire("1DIXK");
    var $22db1ba098eb3017$var$isProduction = true;
    var $22db1ba098eb3017$var$spacesAndTabs = /[ \t]{2,}/g;
    var $22db1ba098eb3017$var$lineStartWithSpaces = /^[ \t]*/gm;
    var $22db1ba098eb3017$var$clean = function clean(value) {
        return value.replace($22db1ba098eb3017$var$spacesAndTabs, ' ').replace($22db1ba098eb3017$var$lineStartWithSpaces, '').trim();
    };
    var $22db1ba098eb3017$var$getDevMessage = function getDevMessage(message) {
        return $22db1ba098eb3017$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $22db1ba098eb3017$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
    };
    var $22db1ba098eb3017$var$getFormattedMessage = function getFormattedMessage(message) {
        return [
            $22db1ba098eb3017$var$getDevMessage(message),
            'color: #00C584; font-size: 1.2em; font-weight: bold;',
            'line-height: 1.5',
            'color: #723874;'
        ];
    };
    var $22db1ba098eb3017$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
    function $22db1ba098eb3017$var$log(type, message) {
        var _console;
        if ($22db1ba098eb3017$var$isProduction) return;
        if (typeof window !== 'undefined' && window[$22db1ba098eb3017$var$isDisabledFlag]) return;
        (_console = console)[type].apply(_console, $22db1ba098eb3017$var$getFormattedMessage(message));
    }
    var $22db1ba098eb3017$var$warning = $22db1ba098eb3017$var$log.bind(null, 'warn');
    var $22db1ba098eb3017$var$error = $22db1ba098eb3017$var$log.bind(null, 'error');
    function $22db1ba098eb3017$var$noop() {}
    function $22db1ba098eb3017$var$getOptions(shared, fromBinding) {
        return (0, $gzM5u.default)({}, shared, fromBinding);
    }
    function $22db1ba098eb3017$var$bindEvents(el, bindings, sharedOptions) {
        var unbindings = bindings.map(function(binding) {
            var options = $22db1ba098eb3017$var$getOptions(sharedOptions, binding.options);
            el.addEventListener(binding.eventName, binding.fn, options);
            return function unbind() {
                el.removeEventListener(binding.eventName, binding.fn, options);
            };
        });
        return function unbindAll() {
            unbindings.forEach(function(unbind) {
                unbind();
            });
        };
    }
    var $22db1ba098eb3017$var$isProduction$1 = true;
    var $22db1ba098eb3017$var$prefix = 'Invariant failed';
    function $22db1ba098eb3017$var$RbdInvariant(message) {
        this.message = message;
    }
    $22db1ba098eb3017$var$RbdInvariant.prototype.toString = function toString() {
        return this.message;
    };
    function $22db1ba098eb3017$var$invariant(condition, message) {
        if (condition) return;
        if ($22db1ba098eb3017$var$isProduction$1) throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix);
        else throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix + ": " + (message || ''));
    }
    var $22db1ba098eb3017$var$ErrorBoundary = function(_React$Component) {
        (0, $1AwyE.default)(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.callbacks = null;
            _this.unbind = $22db1ba098eb3017$var$noop;
            _this.onWindowError = function(event) {
                var callbacks = _this.getCallbacks();
                if (callbacks.isDragging()) callbacks.tryAbort();
                var err = event.error;
                if (err instanceof $22db1ba098eb3017$var$RbdInvariant) event.preventDefault();
            };
            _this.getCallbacks = function() {
                if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
                return _this.callbacks;
            };
            _this.setCallbacks = function(callbacks) {
                _this.callbacks = callbacks;
            };
            return _this;
        }
        var _proto = ErrorBoundary.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this.unbind = $22db1ba098eb3017$var$bindEvents(window, [
                {
                    eventName: 'error',
                    fn: this.onWindowError
                }
            ]);
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unbind();
        };
        _proto.componentDidCatch = function componentDidCatch(err) {
            if (err instanceof $22db1ba098eb3017$var$RbdInvariant) {
                this.setState({});
                return;
            }
            throw err;
        };
        _proto.render = function render() {
            return this.props.children(this.setCallbacks);
        };
        return ErrorBoundary;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    var $22db1ba098eb3017$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
    var $22db1ba098eb3017$var$position = function position(index) {
        return index + 1;
    };
    var $22db1ba098eb3017$var$onDragStart = function onDragStart(start) {
        return "\n  You have lifted an item in position " + $22db1ba098eb3017$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
    };
    var $22db1ba098eb3017$var$withLocation = function withLocation(source, destination) {
        var isInHomeList = source.droppableId === destination.droppableId;
        var startPosition = $22db1ba098eb3017$var$position(source.index);
        var endPosition = $22db1ba098eb3017$var$position(destination.index);
        if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
        return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
    };
    var $22db1ba098eb3017$var$withCombine = function withCombine(id, source, combine) {
        var inHomeList = source.droppableId === combine.droppableId;
        if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
        return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
    };
    var $22db1ba098eb3017$var$onDragUpdate = function onDragUpdate(update) {
        var location = update.destination;
        if (location) return $22db1ba098eb3017$var$withLocation(update.source, location);
        var combine = update.combine;
        if (combine) return $22db1ba098eb3017$var$withCombine(update.draggableId, update.source, combine);
        return 'You are over an area that cannot be dropped on';
    };
    var $22db1ba098eb3017$var$returnedToStart = function returnedToStart(source) {
        return "\n  The item has returned to its starting position\n  of " + $22db1ba098eb3017$var$position(source.index) + "\n";
    };
    var $22db1ba098eb3017$var$onDragEnd = function onDragEnd(result) {
        if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n    ";
        var location = result.destination;
        var combine = result.combine;
        if (location) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withLocation(result.source, location) + "\n    ";
        if (combine) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
        return "\n    The item has been dropped while not over a drop area.\n    " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n  ";
    };
    var $22db1ba098eb3017$var$preset = {
        liftInstruction: $22db1ba098eb3017$var$liftInstruction,
        onDragStart: $22db1ba098eb3017$var$onDragStart,
        onDragUpdate: $22db1ba098eb3017$var$onDragUpdate,
        onDragEnd: $22db1ba098eb3017$var$onDragEnd
    };
    var $22db1ba098eb3017$var$origin = {
        x: 0,
        y: 0
    };
    var $22db1ba098eb3017$var$add = function add(point1, point2) {
        return {
            x: point1.x + point2.x,
            y: point1.y + point2.y
        };
    };
    var $22db1ba098eb3017$var$subtract = function subtract(point1, point2) {
        return {
            x: point1.x - point2.x,
            y: point1.y - point2.y
        };
    };
    var $22db1ba098eb3017$var$isEqual = function isEqual(point1, point2) {
        return point1.x === point2.x && point1.y === point2.y;
    };
    var $22db1ba098eb3017$var$negate = function negate(point) {
        return {
            x: point.x !== 0 ? -point.x : 0,
            y: point.y !== 0 ? -point.y : 0
        };
    };
    var $22db1ba098eb3017$var$patch = function patch(line, value, otherValue) {
        var _ref;
        if (otherValue === void 0) otherValue = 0;
        return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
    };
    var $22db1ba098eb3017$var$distance = function distance(point1, point2) {
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    };
    var $22db1ba098eb3017$var$closest = function closest(target, points) {
        return Math.min.apply(Math, points.map(function(point) {
            return $22db1ba098eb3017$var$distance(target, point);
        }));
    };
    var $22db1ba098eb3017$var$apply = function apply(fn) {
        return function(point) {
            return {
                x: fn(point.x),
                y: fn(point.y)
            };
        };
    };
    var $22db1ba098eb3017$var$executeClip = function(frame, subject) {
        var result = (0, (0, parcelRequire("3YKxB")).getRect)({
            top: Math.max(subject.top, frame.top),
            right: Math.min(subject.right, frame.right),
            bottom: Math.min(subject.bottom, frame.bottom),
            left: Math.max(subject.left, frame.left)
        });
        if (result.width <= 0 || result.height <= 0) return null;
        return result;
    };
    var $22db1ba098eb3017$var$offsetByPosition = function offsetByPosition(spacing, point) {
        return {
            top: spacing.top + point.y,
            left: spacing.left + point.x,
            bottom: spacing.bottom + point.y,
            right: spacing.right + point.x
        };
    };
    var $22db1ba098eb3017$var$getCorners = function getCorners(spacing) {
        return [
            {
                x: spacing.left,
                y: spacing.top
            },
            {
                x: spacing.right,
                y: spacing.top
            },
            {
                x: spacing.left,
                y: spacing.bottom
            },
            {
                x: spacing.right,
                y: spacing.bottom
            }
        ];
    };
    var $22db1ba098eb3017$var$noSpacing = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var $22db1ba098eb3017$var$scroll = function scroll(target, frame) {
        if (!frame) return target;
        return $22db1ba098eb3017$var$offsetByPosition(target, frame.scroll.diff.displacement);
    };
    var $22db1ba098eb3017$var$increase = function increase(target, axis, withPlaceholder) {
        if (withPlaceholder && withPlaceholder.increasedBy) {
            var _extends2;
            return (0, $gzM5u.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
        }
        return target;
    };
    var $22db1ba098eb3017$var$clip = function clip(target, frame) {
        if (frame && frame.shouldClipSubject) return $22db1ba098eb3017$var$executeClip(frame.pageMarginBox, target);
        return (0, (0, parcelRequire("3YKxB")).getRect)(target);
    };
    var $22db1ba098eb3017$var$getSubject = function(_ref) {
        var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
        var scrolled = $22db1ba098eb3017$var$scroll(page.marginBox, frame);
        var increased = $22db1ba098eb3017$var$increase(scrolled, axis, withPlaceholder);
        var clipped = $22db1ba098eb3017$var$clip(increased, frame);
        return {
            page: page,
            withPlaceholder: withPlaceholder,
            active: clipped
        };
    };
    var $22db1ba098eb3017$var$scrollDroppable = function(droppable, newScroll) {
        !droppable.frame && $22db1ba098eb3017$var$invariant(false);
        var scrollable = droppable.frame;
        var scrollDiff = $22db1ba098eb3017$var$subtract(newScroll, scrollable.scroll.initial);
        var scrollDisplacement = $22db1ba098eb3017$var$negate(scrollDiff);
        var frame = (0, $gzM5u.default)({}, scrollable, {
            scroll: {
                initial: scrollable.scroll.initial,
                current: newScroll,
                diff: {
                    value: scrollDiff,
                    displacement: scrollDisplacement
                },
                max: scrollable.scroll.max
            }
        });
        var subject = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: droppable.subject.withPlaceholder,
            axis: droppable.axis,
            frame: frame
        });
        var result = (0, $gzM5u.default)({}, droppable, {
            frame: frame,
            subject: subject
        });
        return result;
    };
    function $22db1ba098eb3017$var$values(map) {
        return (0, ($parcel$interopDefault($i2aN7)))(map);
    }
    function $22db1ba098eb3017$var$findIndex(list, predicate) {
        if (list.findIndex) return list.findIndex(predicate);
        for(var i = 0; i < list.length; i++){
            if (predicate(list[i])) return i;
        }
        return -1;
    }
    function $22db1ba098eb3017$var$find(list, predicate) {
        if (list.find) return list.find(predicate);
        var index = $22db1ba098eb3017$var$findIndex(list, predicate);
        if (index !== -1) return list[index];
        return undefined;
    }
    function $22db1ba098eb3017$var$toArray(list) {
        return Array.prototype.slice.call(list);
    }
    var $22db1ba098eb3017$var$toDroppableMap = (0, (0, parcelRequire("g7psY")).default)(function(droppables) {
        return droppables.reduce(function(previous, current) {
            previous[current.descriptor.id] = current;
            return previous;
        }, {});
    });
    var $22db1ba098eb3017$var$toDraggableMap = (0, (0, parcelRequire("g7psY")).default)(function(draggables) {
        return draggables.reduce(function(previous, current) {
            previous[current.descriptor.id] = current;
            return previous;
        }, {});
    });
    var $22db1ba098eb3017$var$toDroppableList = (0, (0, parcelRequire("g7psY")).default)(function(droppables) {
        return $22db1ba098eb3017$var$values(droppables);
    });
    var $22db1ba098eb3017$var$toDraggableList = (0, (0, parcelRequire("g7psY")).default)(function(draggables) {
        return $22db1ba098eb3017$var$values(draggables);
    });
    var $22db1ba098eb3017$var$getDraggablesInsideDroppable = (0, (0, parcelRequire("g7psY")).default)(function(droppableId, draggables) {
        var result = $22db1ba098eb3017$var$toDraggableList(draggables).filter(function(draggable) {
            return droppableId === draggable.descriptor.droppableId;
        }).sort(function(a, b) {
            return a.descriptor.index - b.descriptor.index;
        });
        return result;
    });
    function $22db1ba098eb3017$var$tryGetDestination(impact) {
        if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
        return null;
    }
    function $22db1ba098eb3017$var$tryGetCombine(impact) {
        if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
        return null;
    }
    var $22db1ba098eb3017$var$removeDraggableFromList = (0, (0, parcelRequire("g7psY")).default)(function(remove, list) {
        return list.filter(function(item) {
            return item.descriptor.id !== remove.descriptor.id;
        });
    });
    var $22db1ba098eb3017$var$moveToNextCombine = function(_ref) {
        var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
        if (!destination.isCombineEnabled) return null;
        var location = $22db1ba098eb3017$var$tryGetDestination(previousImpact);
        if (!location) return null;
        function getImpact(target) {
            var at = {
                type: 'COMBINE',
                combine: {
                    draggableId: target,
                    droppableId: destination.descriptor.id
                }
            };
            return (0, $gzM5u.default)({}, previousImpact, {
                at: at
            });
        }
        var all = previousImpact.displaced.all;
        var closestId = all.length ? all[0] : null;
        if (isMovingForward) return closestId ? getImpact(closestId) : null;
        var withoutDraggable = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
        if (!closestId) {
            if (!withoutDraggable.length) return null;
            var last = withoutDraggable[withoutDraggable.length - 1];
            return getImpact(last.descriptor.id);
        }
        var indexOfClosest = $22db1ba098eb3017$var$findIndex(withoutDraggable, function(d) {
            return d.descriptor.id === closestId;
        });
        !(indexOfClosest !== -1) && $22db1ba098eb3017$var$invariant(false);
        var proposedIndex = indexOfClosest - 1;
        if (proposedIndex < 0) return null;
        var before = withoutDraggable[proposedIndex];
        return getImpact(before.descriptor.id);
    };
    var $22db1ba098eb3017$var$isHomeOf = function(draggable, destination) {
        return draggable.descriptor.droppableId === destination.descriptor.id;
    };
    var $22db1ba098eb3017$var$noDisplacedBy = {
        point: $22db1ba098eb3017$var$origin,
        value: 0
    };
    var $22db1ba098eb3017$var$emptyGroups = {
        invisible: {},
        visible: {},
        all: []
    };
    var $22db1ba098eb3017$var$noImpact = {
        displaced: $22db1ba098eb3017$var$emptyGroups,
        displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
        at: null
    };
    var $22db1ba098eb3017$var$isWithin = function(lowerBound, upperBound) {
        return function(value) {
            return lowerBound <= value && value <= upperBound;
        };
    };
    var $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame = function(frame) {
        var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
        return function(subject) {
            var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
            if (isContained) return true;
            var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
            var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
            var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
            if (isPartiallyContained) return true;
            var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
            var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
            var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
            if (isTargetBiggerThanFrame) return true;
            var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
            return isTargetBiggerOnOneAxis;
        };
    };
    var $22db1ba098eb3017$var$isTotallyVisibleThroughFrame = function(frame) {
        var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
        return function(subject) {
            var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
            return isContained;
        };
    };
    var $22db1ba098eb3017$var$vertical = {
        direction: 'vertical',
        line: 'y',
        crossAxisLine: 'x',
        start: 'top',
        end: 'bottom',
        size: 'height',
        crossAxisStart: 'left',
        crossAxisEnd: 'right',
        crossAxisSize: 'width'
    };
    var $22db1ba098eb3017$var$horizontal = {
        direction: 'horizontal',
        line: 'x',
        crossAxisLine: 'y',
        start: 'left',
        end: 'right',
        size: 'width',
        crossAxisStart: 'top',
        crossAxisEnd: 'bottom',
        crossAxisSize: 'height'
    };
    var $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
        return function(frame) {
            var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
            var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
            return function(subject) {
                if (axis === $22db1ba098eb3017$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
                return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
            };
        };
    };
    var $22db1ba098eb3017$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
        var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $22db1ba098eb3017$var$origin;
        return $22db1ba098eb3017$var$offsetByPosition(target, displacement);
    };
    var $22db1ba098eb3017$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
        if (!destination.subject.active) return false;
        return isVisibleThroughFrameFn(destination.subject.active)(target);
    };
    var $22db1ba098eb3017$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
        return isVisibleThroughFrameFn(viewport)(target);
    };
    var $22db1ba098eb3017$var$isVisible = function isVisible(_ref) {
        var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
        var displacedTarget = withDroppableDisplacement ? $22db1ba098eb3017$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
        return $22db1ba098eb3017$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $22db1ba098eb3017$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
    };
    var $22db1ba098eb3017$var$isPartiallyVisible = function isPartiallyVisible(args) {
        return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
            isVisibleThroughFrameFn: $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame
        }));
    };
    var $22db1ba098eb3017$var$isTotallyVisible = function isTotallyVisible(args) {
        return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
            isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrame
        }));
    };
    var $22db1ba098eb3017$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
        return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
            isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
        }));
    };
    var $22db1ba098eb3017$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
        if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
        if (!last) return true;
        var invisible = last.invisible, visible = last.visible;
        if (invisible[id]) return false;
        var previous = visible[id];
        return previous ? previous.shouldAnimate : true;
    };
    function $22db1ba098eb3017$var$getTarget(draggable, displacedBy) {
        var marginBox = draggable.page.marginBox;
        var expandBy = {
            top: displacedBy.point.y,
            right: 0,
            bottom: 0,
            left: displacedBy.point.x
        };
        return (0, (0, parcelRequire("3YKxB")).getRect)((0, (0, parcelRequire("3YKxB")).expand)(marginBox, expandBy));
    }
    function $22db1ba098eb3017$var$getDisplacementGroups(_ref) {
        var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
        return afterDragging.reduce(function process(groups, draggable) {
            var target = $22db1ba098eb3017$var$getTarget(draggable, displacedBy);
            var id = draggable.descriptor.id;
            groups.all.push(id);
            var isVisible = $22db1ba098eb3017$var$isPartiallyVisible({
                target: target,
                destination: destination,
                viewport: viewport,
                withDroppableDisplacement: true
            });
            if (!isVisible) {
                groups.invisible[draggable.descriptor.id] = true;
                return groups;
            }
            var shouldAnimate = $22db1ba098eb3017$var$getShouldAnimate(id, last, forceShouldAnimate);
            var displacement = {
                draggableId: id,
                shouldAnimate: shouldAnimate
            };
            groups.visible[id] = displacement;
            return groups;
        }, {
            all: [],
            visible: {},
            invisible: {}
        });
    }
    function $22db1ba098eb3017$var$getIndexOfLastItem(draggables, options) {
        if (!draggables.length) return 0;
        var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
        return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
    }
    function $22db1ba098eb3017$var$goAtEnd(_ref) {
        var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
        var newIndex = $22db1ba098eb3017$var$getIndexOfLastItem(insideDestination, {
            inHomeList: inHomeList
        });
        return {
            displaced: $22db1ba098eb3017$var$emptyGroups,
            displacedBy: displacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: newIndex
                }
            }
        };
    }
    function $22db1ba098eb3017$var$calculateReorderImpact(_ref2) {
        var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
        var inHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
        if (index == null) return $22db1ba098eb3017$var$goAtEnd({
            insideDestination: insideDestination,
            inHomeList: inHomeList,
            displacedBy: displacedBy,
            destination: destination
        });
        var match = $22db1ba098eb3017$var$find(insideDestination, function(item) {
            return item.descriptor.index === index;
        });
        if (!match) return $22db1ba098eb3017$var$goAtEnd({
            insideDestination: insideDestination,
            inHomeList: inHomeList,
            displacedBy: displacedBy,
            destination: destination
        });
        var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
        var sliceFrom = insideDestination.indexOf(match);
        var impacted = withoutDragging.slice(sliceFrom);
        var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
            afterDragging: impacted,
            destination: destination,
            displacedBy: displacedBy,
            last: last,
            viewport: viewport.frame,
            forceShouldAnimate: forceShouldAnimate
        });
        return {
            displaced: displaced,
            displacedBy: displacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: index
                }
            }
        };
    }
    function $22db1ba098eb3017$var$didStartAfterCritical(draggableId, afterCritical) {
        return Boolean(afterCritical.effected[draggableId]);
    }
    var $22db1ba098eb3017$var$fromCombine = function(_ref) {
        var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
        if (!destination.isCombineEnabled) return null;
        var combineId = combine.draggableId;
        var combineWith = draggables[combineId];
        var combineWithIndex = combineWith.descriptor.index;
        var didCombineWithStartAfterCritical = $22db1ba098eb3017$var$didStartAfterCritical(combineId, afterCritical);
        if (didCombineWithStartAfterCritical) {
            if (isMovingForward) return combineWithIndex;
            return combineWithIndex - 1;
        }
        if (isMovingForward) return combineWithIndex + 1;
        return combineWithIndex;
    };
    var $22db1ba098eb3017$var$fromReorder = function(_ref) {
        var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
        if (!insideDestination.length) return null;
        var currentIndex = location.index;
        var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
        var firstIndex = insideDestination[0].descriptor.index;
        var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
        var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
        if (proposedIndex < firstIndex) return null;
        if (proposedIndex > upperBound) return null;
        return proposedIndex;
    };
    var $22db1ba098eb3017$var$moveToNextIndex = function(_ref) {
        var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
        var wasAt = previousImpact.at;
        !wasAt && $22db1ba098eb3017$var$invariant(false);
        if (wasAt.type === 'REORDER') {
            var _newIndex = $22db1ba098eb3017$var$fromReorder({
                isMovingForward: isMovingForward,
                isInHomeList: isInHomeList,
                location: wasAt.destination,
                insideDestination: insideDestination
            });
            if (_newIndex == null) return null;
            return $22db1ba098eb3017$var$calculateReorderImpact({
                draggable: draggable,
                insideDestination: insideDestination,
                destination: destination,
                viewport: viewport,
                last: previousImpact.displaced,
                displacedBy: previousImpact.displacedBy,
                index: _newIndex
            });
        }
        var newIndex = $22db1ba098eb3017$var$fromCombine({
            isMovingForward: isMovingForward,
            destination: destination,
            displaced: previousImpact.displaced,
            draggables: draggables,
            combine: wasAt.combine,
            afterCritical: afterCritical
        });
        if (newIndex == null) return null;
        return $22db1ba098eb3017$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    };
    var $22db1ba098eb3017$var$getCombinedItemDisplacement = function(_ref) {
        var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
        var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
        if ($22db1ba098eb3017$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $22db1ba098eb3017$var$origin : $22db1ba098eb3017$var$negate(displacedBy.point);
        return isDisplaced ? displacedBy.point : $22db1ba098eb3017$var$origin;
    };
    var $22db1ba098eb3017$var$whenCombining = function(_ref) {
        var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        !combine && $22db1ba098eb3017$var$invariant(false);
        var combineWith = combine.draggableId;
        var center = draggables[combineWith].page.borderBox.center;
        var displaceBy = $22db1ba098eb3017$var$getCombinedItemDisplacement({
            displaced: impact.displaced,
            afterCritical: afterCritical,
            combineWith: combineWith,
            displacedBy: impact.displacedBy
        });
        return $22db1ba098eb3017$var$add(center, displaceBy);
    };
    var $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
        return box.margin[axis.start] + box.borderBox[axis.size] / 2;
    };
    var $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
        return box.margin[axis.end] + box.borderBox[axis.size] / 2;
    };
    var $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
        return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
    };
    var $22db1ba098eb3017$var$goAfter = function goAfter(_ref) {
        var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
        return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
    };
    var $22db1ba098eb3017$var$goBefore = function goBefore(_ref2) {
        var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
        return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
    };
    var $22db1ba098eb3017$var$goIntoStart = function goIntoStart(_ref3) {
        var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
        return $22db1ba098eb3017$var$patch(axis.line, moveInto.contentBox[axis.start] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
    };
    var $22db1ba098eb3017$var$whenReordering = function(_ref) {
        var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
        var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
        var draggablePage = draggable.page;
        var axis = droppable.axis;
        if (!insideDestination.length) return $22db1ba098eb3017$var$goIntoStart({
            axis: axis,
            moveInto: droppable.page,
            isMoving: draggablePage
        });
        var displaced = impact.displaced, displacedBy = impact.displacedBy;
        var closestAfter = displaced.all[0];
        if (closestAfter) {
            var closest = draggables[closestAfter];
            if ($22db1ba098eb3017$var$didStartAfterCritical(closestAfter, afterCritical)) return $22db1ba098eb3017$var$goBefore({
                axis: axis,
                moveRelativeTo: closest.page,
                isMoving: draggablePage
            });
            var withDisplacement = (0, (0, parcelRequire("3YKxB")).offset)(closest.page, displacedBy.point);
            return $22db1ba098eb3017$var$goBefore({
                axis: axis,
                moveRelativeTo: withDisplacement,
                isMoving: draggablePage
            });
        }
        var last = insideDestination[insideDestination.length - 1];
        if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
        if ($22db1ba098eb3017$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
            var page = (0, (0, parcelRequire("3YKxB")).offset)(last.page, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point));
            return $22db1ba098eb3017$var$goAfter({
                axis: axis,
                moveRelativeTo: page,
                isMoving: draggablePage
            });
        }
        return $22db1ba098eb3017$var$goAfter({
            axis: axis,
            moveRelativeTo: last.page,
            isMoving: draggablePage
        });
    };
    var $22db1ba098eb3017$var$withDroppableDisplacement = function(droppable, point) {
        var frame = droppable.frame;
        if (!frame) return point;
        return $22db1ba098eb3017$var$add(point, frame.scroll.diff.displacement);
    };
    var $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
        var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
        var original = draggable.page.borderBox.center;
        var at = impact.at;
        if (!droppable) return original;
        if (!at) return original;
        if (at.type === 'REORDER') return $22db1ba098eb3017$var$whenReordering({
            impact: impact,
            draggable: draggable,
            draggables: draggables,
            droppable: droppable,
            afterCritical: afterCritical
        });
        return $22db1ba098eb3017$var$whenCombining({
            impact: impact,
            draggables: draggables,
            afterCritical: afterCritical
        });
    };
    var $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact = function(args) {
        var withoutDisplacement = $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement(args);
        var droppable = args.droppable;
        var withDisplacement = droppable ? $22db1ba098eb3017$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
        return withDisplacement;
    };
    var $22db1ba098eb3017$var$scrollViewport = function(viewport, newScroll) {
        var diff = $22db1ba098eb3017$var$subtract(newScroll, viewport.scroll.initial);
        var displacement = $22db1ba098eb3017$var$negate(diff);
        var frame = (0, (0, parcelRequire("3YKxB")).getRect)({
            top: newScroll.y,
            bottom: newScroll.y + viewport.frame.height,
            left: newScroll.x,
            right: newScroll.x + viewport.frame.width
        });
        var updated = {
            frame: frame,
            scroll: {
                initial: viewport.scroll.initial,
                max: viewport.scroll.max,
                current: newScroll,
                diff: {
                    value: diff,
                    displacement: displacement
                }
            }
        };
        return updated;
    };
    function $22db1ba098eb3017$var$getDraggables(ids, draggables) {
        return ids.map(function(id) {
            return draggables[id];
        });
    }
    function $22db1ba098eb3017$var$tryGetVisible(id, groups) {
        for(var i = 0; i < groups.length; i++){
            var displacement = groups[i].visible[id];
            if (displacement) return displacement;
        }
        return null;
    }
    var $22db1ba098eb3017$var$speculativelyIncrease = function(_ref) {
        var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
        var scrolledViewport = $22db1ba098eb3017$var$scrollViewport(viewport, $22db1ba098eb3017$var$add(viewport.scroll.current, maxScrollChange));
        var scrolledDroppable = destination.frame ? $22db1ba098eb3017$var$scrollDroppable(destination, $22db1ba098eb3017$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
        var last = impact.displaced;
        var withViewportScroll = $22db1ba098eb3017$var$getDisplacementGroups({
            afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
            destination: destination,
            displacedBy: impact.displacedBy,
            viewport: scrolledViewport.frame,
            last: last,
            forceShouldAnimate: false
        });
        var withDroppableScroll = $22db1ba098eb3017$var$getDisplacementGroups({
            afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
            destination: scrolledDroppable,
            displacedBy: impact.displacedBy,
            viewport: viewport.frame,
            last: last,
            forceShouldAnimate: false
        });
        var invisible = {};
        var visible = {};
        var groups = [
            last,
            withViewportScroll,
            withDroppableScroll
        ];
        last.all.forEach(function(id) {
            var displacement = $22db1ba098eb3017$var$tryGetVisible(id, groups);
            if (displacement) {
                visible[id] = displacement;
                return;
            }
            invisible[id] = true;
        });
        var newImpact = (0, $gzM5u.default)({}, impact, {
            displaced: {
                all: last.all,
                invisible: invisible,
                visible: visible
            }
        });
        return newImpact;
    };
    var $22db1ba098eb3017$var$withViewportDisplacement = function(viewport, point) {
        return $22db1ba098eb3017$var$add(viewport.scroll.diff.displacement, point);
    };
    var $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter = function(_ref) {
        var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
        var withoutPageScrollChange = $22db1ba098eb3017$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
        var offset = $22db1ba098eb3017$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
        return $22db1ba098eb3017$var$add(draggable.client.borderBox.center, offset);
    };
    var $22db1ba098eb3017$var$isTotallyVisibleInNewLocation = function(_ref) {
        var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
        var changeNeeded = $22db1ba098eb3017$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
        var shifted = $22db1ba098eb3017$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
        var args = {
            target: shifted,
            destination: destination,
            withDroppableDisplacement: withDroppableDisplacement,
            viewport: viewport
        };
        return onlyOnMainAxis ? $22db1ba098eb3017$var$isTotallyVisibleOnAxis(args) : $22db1ba098eb3017$var$isTotallyVisible(args);
    };
    var $22db1ba098eb3017$var$moveToNextPlace = function(_ref) {
        var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
        if (!destination.isEnabled) return null;
        var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
        var isInHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
        var impact = $22db1ba098eb3017$var$moveToNextCombine({
            isMovingForward: isMovingForward,
            draggable: draggable,
            destination: destination,
            insideDestination: insideDestination,
            previousImpact: previousImpact
        }) || $22db1ba098eb3017$var$moveToNextIndex({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            draggable: draggable,
            draggables: draggables,
            destination: destination,
            insideDestination: insideDestination,
            previousImpact: previousImpact,
            viewport: viewport,
            afterCritical: afterCritical
        });
        if (!impact) return null;
        var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
            impact: impact,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: destination,
            newPageBorderBoxCenter: pageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        if (isVisibleInNewLocation) {
            var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
                pageBorderBoxCenter: pageBorderBoxCenter,
                draggable: draggable,
                viewport: viewport
            });
            return {
                clientSelection: clientSelection,
                impact: impact,
                scrollJumpRequest: null
            };
        }
        var distance = $22db1ba098eb3017$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
        var cautious = $22db1ba098eb3017$var$speculativelyIncrease({
            impact: impact,
            viewport: viewport,
            destination: destination,
            draggables: draggables,
            maxScrollChange: distance
        });
        return {
            clientSelection: previousClientSelection,
            impact: cautious,
            scrollJumpRequest: distance
        };
    };
    var $22db1ba098eb3017$var$getKnownActive = function getKnownActive(droppable) {
        var rect = droppable.subject.active;
        !rect && $22db1ba098eb3017$var$invariant(false);
        return rect;
    };
    var $22db1ba098eb3017$var$getBestCrossAxisDroppable = function(_ref) {
        var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
        var active = source.subject.active;
        if (!active) return null;
        var axis = source.axis;
        var isBetweenSourceClipped = $22db1ba098eb3017$var$isWithin(active[axis.start], active[axis.end]);
        var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
            return droppable !== source;
        }).filter(function(droppable) {
            return droppable.isEnabled;
        }).filter(function(droppable) {
            return Boolean(droppable.subject.active);
        }).filter(function(droppable) {
            return $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame(viewport.frame)($22db1ba098eb3017$var$getKnownActive(droppable));
        }).filter(function(droppable) {
            var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
            if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
            return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
        }).filter(function(droppable) {
            var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
            var isBetweenDestinationClipped = $22db1ba098eb3017$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
            return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
        }).sort(function(a, b) {
            var first = $22db1ba098eb3017$var$getKnownActive(a)[axis.crossAxisStart];
            var second = $22db1ba098eb3017$var$getKnownActive(b)[axis.crossAxisStart];
            if (isMovingForward) return first - second;
            return second - first;
        }).filter(function(droppable, index, array) {
            return $22db1ba098eb3017$var$getKnownActive(droppable)[axis.crossAxisStart] === $22db1ba098eb3017$var$getKnownActive(array[0])[axis.crossAxisStart];
        });
        if (!candidates.length) return null;
        if (candidates.length === 1) return candidates[0];
        var contains = candidates.filter(function(droppable) {
            var isWithinDroppable = $22db1ba098eb3017$var$isWithin($22db1ba098eb3017$var$getKnownActive(droppable)[axis.start], $22db1ba098eb3017$var$getKnownActive(droppable)[axis.end]);
            return isWithinDroppable(pageBorderBoxCenter[axis.line]);
        });
        if (contains.length === 1) return contains[0];
        if (contains.length > 1) return contains.sort(function(a, b) {
            return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
        })[0];
        return candidates.sort(function(a, b) {
            var first = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(a)));
            var second = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(b)));
            if (first !== second) return first - second;
            return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
        })[0];
    };
    var $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
        var original = draggable.page.borderBox.center;
        return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$subtract(original, afterCritical.displacedBy.point) : original;
    };
    var $22db1ba098eb3017$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
        var original = draggable.page.borderBox;
        return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$offsetByPosition(original, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point)) : original;
    };
    var $22db1ba098eb3017$var$getClosestDraggable = function(_ref) {
        var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
        var sorted = insideDestination.filter(function(draggable) {
            return $22db1ba098eb3017$var$isTotallyVisible({
                target: $22db1ba098eb3017$var$getCurrentPageBorderBox(draggable, afterCritical),
                destination: destination,
                viewport: viewport.frame,
                withDroppableDisplacement: true
            });
        }).sort(function(a, b) {
            var distanceToA = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
            var distanceToB = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
            if (distanceToA < distanceToB) return -1;
            if (distanceToB < distanceToA) return 1;
            return a.descriptor.index - b.descriptor.index;
        });
        return sorted[0] || null;
    };
    var $22db1ba098eb3017$var$getDisplacedBy = (0, (0, parcelRequire("g7psY")).default)(function getDisplacedBy(axis, displaceBy) {
        var displacement = displaceBy[axis.line];
        return {
            value: displacement,
            point: $22db1ba098eb3017$var$patch(axis.line, displacement)
        };
    });
    var $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
        var axis = droppable.axis;
        if (droppable.descriptor.mode === 'virtual') return $22db1ba098eb3017$var$patch(axis.line, placeholderSize[axis.line]);
        var availableSpace = droppable.subject.page.contentBox[axis.size];
        var insideDroppable = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
        var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
            return sum + dimension.client.marginBox[axis.size];
        }, 0);
        var requiredSpace = spaceUsed + placeholderSize[axis.line];
        var needsToGrowBy = requiredSpace - availableSpace;
        if (needsToGrowBy <= 0) return null;
        return $22db1ba098eb3017$var$patch(axis.line, needsToGrowBy);
    };
    var $22db1ba098eb3017$var$withMaxScroll = function withMaxScroll(frame, max) {
        return (0, $gzM5u.default)({}, frame, {
            scroll: (0, $gzM5u.default)({}, frame.scroll, {
                max: max
            })
        });
    };
    var $22db1ba098eb3017$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
        var frame = droppable.frame;
        !!$22db1ba098eb3017$var$isHomeOf(draggable, droppable) && $22db1ba098eb3017$var$invariant(false);
        !!droppable.subject.withPlaceholder && $22db1ba098eb3017$var$invariant(false);
        var placeholderSize = $22db1ba098eb3017$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
        var requiredGrowth = $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
        var added = {
            placeholderSize: placeholderSize,
            increasedBy: requiredGrowth,
            oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
        };
        if (!frame) {
            var _subject = $22db1ba098eb3017$var$getSubject({
                page: droppable.subject.page,
                withPlaceholder: added,
                axis: droppable.axis,
                frame: droppable.frame
            });
            return (0, $gzM5u.default)({}, droppable, {
                subject: _subject
            });
        }
        var maxScroll = requiredGrowth ? $22db1ba098eb3017$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
        var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, maxScroll);
        var subject = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: newFrame
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: subject,
            frame: newFrame
        });
    };
    var $22db1ba098eb3017$var$removePlaceholder = function removePlaceholder(droppable) {
        var added = droppable.subject.withPlaceholder;
        !added && $22db1ba098eb3017$var$invariant(false);
        var frame = droppable.frame;
        if (!frame) {
            var _subject2 = $22db1ba098eb3017$var$getSubject({
                page: droppable.subject.page,
                axis: droppable.axis,
                frame: null,
                withPlaceholder: null
            });
            return (0, $gzM5u.default)({}, droppable, {
                subject: _subject2
            });
        }
        var oldMaxScroll = added.oldFrameMaxScroll;
        !oldMaxScroll && $22db1ba098eb3017$var$invariant(false);
        var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, oldMaxScroll);
        var subject = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: newFrame,
            withPlaceholder: null
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: subject,
            frame: newFrame
        });
    };
    var $22db1ba098eb3017$var$moveToNewDroppable = function(_ref) {
        var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
        if (!moveRelativeTo) {
            if (insideDestination.length) return null;
            var proposed = {
                displaced: $22db1ba098eb3017$var$emptyGroups,
                displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
                at: {
                    type: 'REORDER',
                    destination: {
                        droppableId: destination.descriptor.id,
                        index: 0
                    }
                }
            };
            var proposedPageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
                impact: proposed,
                draggable: draggable,
                droppable: destination,
                draggables: draggables,
                afterCritical: afterCritical
            });
            var withPlaceholder = $22db1ba098eb3017$var$isHomeOf(draggable, destination) ? destination : $22db1ba098eb3017$var$addPlaceholder(destination, draggable, draggables);
            var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
                draggable: draggable,
                destination: withPlaceholder,
                newPageBorderBoxCenter: proposedPageBorderBoxCenter,
                viewport: viewport.frame,
                withDroppableDisplacement: false,
                onlyOnMainAxis: true
            });
            return isVisibleInNewLocation ? proposed : null;
        }
        var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
        var proposedIndex = function() {
            var relativeTo = moveRelativeTo.descriptor.index;
            if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
            if (isGoingBeforeTarget) return relativeTo;
            return relativeTo + 1;
        }();
        var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
        return $22db1ba098eb3017$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            displacedBy: displacedBy,
            last: $22db1ba098eb3017$var$emptyGroups,
            index: proposedIndex
        });
    };
    var $22db1ba098eb3017$var$moveCrossAxis = function(_ref) {
        var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
        var destination = $22db1ba098eb3017$var$getBestCrossAxisDroppable({
            isMovingForward: isMovingForward,
            pageBorderBoxCenter: previousPageBorderBoxCenter,
            source: isOver,
            droppables: droppables,
            viewport: viewport
        });
        if (!destination) return null;
        var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
        var moveRelativeTo = $22db1ba098eb3017$var$getClosestDraggable({
            pageBorderBoxCenter: previousPageBorderBoxCenter,
            viewport: viewport,
            destination: destination,
            insideDestination: insideDestination,
            afterCritical: afterCritical
        });
        var impact = $22db1ba098eb3017$var$moveToNewDroppable({
            previousPageBorderBoxCenter: previousPageBorderBoxCenter,
            destination: destination,
            draggable: draggable,
            draggables: draggables,
            moveRelativeTo: moveRelativeTo,
            insideDestination: insideDestination,
            viewport: viewport,
            afterCritical: afterCritical
        });
        if (!impact) return null;
        var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
            impact: impact,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    };
    var $22db1ba098eb3017$var$whatIsDraggedOver = function(impact) {
        var at = impact.at;
        if (!at) return null;
        if (at.type === 'REORDER') return at.destination.droppableId;
        return at.combine.droppableId;
    };
    var $22db1ba098eb3017$var$getDroppableOver = function getDroppableOver(impact, droppables) {
        var id = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
        return id ? droppables[id] : null;
    };
    var $22db1ba098eb3017$var$moveInDirection = function(_ref) {
        var state = _ref.state, type = _ref.type;
        var isActuallyOver = $22db1ba098eb3017$var$getDroppableOver(state.impact, state.dimensions.droppables);
        var isMainAxisMovementAllowed = Boolean(isActuallyOver);
        var home = state.dimensions.droppables[state.critical.droppable.id];
        var isOver = isActuallyOver || home;
        var direction = isOver.axis.direction;
        var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
        if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
        var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
        var draggable = state.dimensions.draggables[state.critical.draggable.id];
        var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
        var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
        return isMovingOnMainAxis ? $22db1ba098eb3017$var$moveToNextPlace({
            isMovingForward: isMovingForward,
            previousPageBorderBoxCenter: previousPageBorderBoxCenter,
            draggable: draggable,
            destination: isOver,
            draggables: draggables,
            viewport: state.viewport,
            previousClientSelection: state.current.client.selection,
            previousImpact: state.impact,
            afterCritical: state.afterCritical
        }) : $22db1ba098eb3017$var$moveCrossAxis({
            isMovingForward: isMovingForward,
            previousPageBorderBoxCenter: previousPageBorderBoxCenter,
            draggable: draggable,
            isOver: isOver,
            draggables: draggables,
            droppables: droppables,
            viewport: state.viewport,
            afterCritical: state.afterCritical
        });
    };
    function $22db1ba098eb3017$var$isMovementAllowed(state) {
        return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
    }
    function $22db1ba098eb3017$var$isPositionInFrame(frame) {
        var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
        return function run(point) {
            return isWithinVertical(point.y) && isWithinHorizontal(point.x);
        };
    }
    function $22db1ba098eb3017$var$getHasOverlap(first, second) {
        return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
    }
    function $22db1ba098eb3017$var$getFurthestAway(_ref) {
        var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
        var startCenter = draggable.page.borderBox.center;
        var sorted = candidates.map(function(candidate) {
            var axis = candidate.axis;
            var target = $22db1ba098eb3017$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
            return {
                id: candidate.descriptor.id,
                distance: $22db1ba098eb3017$var$distance(startCenter, target)
            };
        }).sort(function(a, b) {
            return b.distance - a.distance;
        });
        return sorted[0] ? sorted[0].id : null;
    }
    function $22db1ba098eb3017$var$getDroppableOver$1(_ref2) {
        var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
        var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(item) {
            if (!item.isEnabled) return false;
            var active = item.subject.active;
            if (!active) return false;
            if (!$22db1ba098eb3017$var$getHasOverlap(pageBorderBox, active)) return false;
            if ($22db1ba098eb3017$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
            var axis = item.axis;
            var childCenter = active.center[axis.crossAxisLine];
            var crossAxisStart = pageBorderBox[axis.crossAxisStart];
            var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
            var isContained = $22db1ba098eb3017$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
            var isStartContained = isContained(crossAxisStart);
            var isEndContained = isContained(crossAxisEnd);
            if (!isStartContained && !isEndContained) return true;
            if (isStartContained) return crossAxisStart < childCenter;
            return crossAxisEnd > childCenter;
        });
        if (!candidates.length) return null;
        if (candidates.length === 1) return candidates[0].descriptor.id;
        return $22db1ba098eb3017$var$getFurthestAway({
            pageBorderBox: pageBorderBox,
            draggable: draggable,
            candidates: candidates
        });
    }
    var $22db1ba098eb3017$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
        return (0, (0, parcelRequire("3YKxB")).getRect)($22db1ba098eb3017$var$offsetByPosition(rect, point));
    };
    var $22db1ba098eb3017$var$withDroppableScroll = function(droppable, area) {
        var frame = droppable.frame;
        if (!frame) return area;
        return $22db1ba098eb3017$var$offsetRectByPosition(area, frame.scroll.diff.value);
    };
    function $22db1ba098eb3017$var$getIsDisplaced(_ref) {
        var displaced = _ref.displaced, id = _ref.id;
        return Boolean(displaced.visible[id] || displaced.invisible[id]);
    }
    function $22db1ba098eb3017$var$atIndex(_ref) {
        var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
        if (!closest) return null;
        if (!inHomeList) return closest.descriptor.index;
        if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
        return closest.descriptor.index;
    }
    var $22db1ba098eb3017$var$getReorderImpact = function(_ref2) {
        var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
        var axis = destination.axis;
        var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
        var displacement = displacedBy.value;
        var targetStart = targetRect[axis.start];
        var targetEnd = targetRect[axis.end];
        var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
        var closest = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
            var id = child.descriptor.id;
            var childCenter = child.page.borderBox.center[axis.line];
            var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
            var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
                displaced: last,
                id: id
            });
            if (didStartAfterCritical$1) {
                if (isDisplaced) return targetEnd <= childCenter;
                return targetStart < childCenter - displacement;
            }
            if (isDisplaced) return targetEnd <= childCenter + displacement;
            return targetStart < childCenter;
        });
        var newIndex = $22db1ba098eb3017$var$atIndex({
            draggable: draggable,
            closest: closest,
            inHomeList: $22db1ba098eb3017$var$isHomeOf(draggable, destination)
        });
        return $22db1ba098eb3017$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: last,
            displacedBy: displacedBy,
            index: newIndex
        });
    };
    var $22db1ba098eb3017$var$combineThresholdDivisor = 4;
    var $22db1ba098eb3017$var$getCombineImpact = function(_ref) {
        var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
        if (!destination.isCombineEnabled) return null;
        var axis = destination.axis;
        var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
        var displacement = displacedBy.value;
        var targetStart = targetRect[axis.start];
        var targetEnd = targetRect[axis.end];
        var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
        var combineWith = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
            var id = child.descriptor.id;
            var childRect = child.page.borderBox;
            var childSize = childRect[axis.size];
            var threshold = childSize / $22db1ba098eb3017$var$combineThresholdDivisor;
            var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
            var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
                displaced: previousImpact.displaced,
                id: id
            });
            if (didStartAfterCritical$1) {
                if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
                return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
            }
            if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
            return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
        });
        if (!combineWith) return null;
        var impact = {
            displacedBy: displacedBy,
            displaced: previousImpact.displaced,
            at: {
                type: 'COMBINE',
                combine: {
                    draggableId: combineWith.descriptor.id,
                    droppableId: destination.descriptor.id
                }
            }
        };
        return impact;
    };
    var $22db1ba098eb3017$var$getDragImpact = function(_ref) {
        var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
        var pageBorderBox = $22db1ba098eb3017$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
        var destinationId = $22db1ba098eb3017$var$getDroppableOver$1({
            pageBorderBox: pageBorderBox,
            draggable: draggable,
            droppables: droppables
        });
        if (!destinationId) return $22db1ba098eb3017$var$noImpact;
        var destination = droppables[destinationId];
        var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
        var pageBorderBoxWithDroppableScroll = $22db1ba098eb3017$var$withDroppableScroll(destination, pageBorderBox);
        return $22db1ba098eb3017$var$getCombineImpact({
            pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
            draggable: draggable,
            previousImpact: previousImpact,
            destination: destination,
            insideDestination: insideDestination,
            afterCritical: afterCritical
        }) || $22db1ba098eb3017$var$getReorderImpact({
            pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
            draggable: draggable,
            destination: destination,
            insideDestination: insideDestination,
            last: previousImpact.displaced,
            viewport: viewport,
            afterCritical: afterCritical
        });
    };
    var $22db1ba098eb3017$var$patchDroppableMap = function(droppables, updated) {
        var _extends2;
        return (0, $gzM5u.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
    };
    var $22db1ba098eb3017$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
        var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
        var last = $22db1ba098eb3017$var$whatIsDraggedOver(previousImpact);
        var now = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
        if (!last) return droppables;
        if (last === now) return droppables;
        var lastDroppable = droppables[last];
        if (!lastDroppable.subject.withPlaceholder) return droppables;
        var updated = $22db1ba098eb3017$var$removePlaceholder(lastDroppable);
        return $22db1ba098eb3017$var$patchDroppableMap(droppables, updated);
    };
    var $22db1ba098eb3017$var$recomputePlaceholders = function(_ref2) {
        var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
        var cleaned = $22db1ba098eb3017$var$clearUnusedPlaceholder({
            previousImpact: previousImpact,
            impact: impact,
            droppables: droppables
        });
        var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
        if (!isOver) return cleaned;
        var droppable = droppables[isOver];
        if ($22db1ba098eb3017$var$isHomeOf(draggable, droppable)) return cleaned;
        if (droppable.subject.withPlaceholder) return cleaned;
        var patched = $22db1ba098eb3017$var$addPlaceholder(droppable, draggable, draggables);
        return $22db1ba098eb3017$var$patchDroppableMap(cleaned, patched);
    };
    var $22db1ba098eb3017$var$update = function(_ref) {
        var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
        var viewport = forcedViewport || state.viewport;
        var dimensions = forcedDimensions || state.dimensions;
        var clientSelection = forcedClientSelection || state.current.client.selection;
        var offset = $22db1ba098eb3017$var$subtract(clientSelection, state.initial.client.selection);
        var client = {
            offset: offset,
            selection: clientSelection,
            borderBoxCenter: $22db1ba098eb3017$var$add(state.initial.client.borderBoxCenter, offset)
        };
        var page = {
            selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.current),
            borderBoxCenter: $22db1ba098eb3017$var$add(client.borderBoxCenter, viewport.scroll.current),
            offset: $22db1ba098eb3017$var$add(client.offset, viewport.scroll.diff.value)
        };
        var current = {
            client: client,
            page: page
        };
        if (state.phase === 'COLLECTING') return (0, $gzM5u.default)({
            phase: 'COLLECTING'
        }, state, {
            dimensions: dimensions,
            viewport: viewport,
            current: current
        });
        var draggable = dimensions.draggables[state.critical.draggable.id];
        var newImpact = forcedImpact || $22db1ba098eb3017$var$getDragImpact({
            pageOffset: page.offset,
            draggable: draggable,
            draggables: dimensions.draggables,
            droppables: dimensions.droppables,
            previousImpact: state.impact,
            viewport: viewport,
            afterCritical: state.afterCritical
        });
        var withUpdatedPlaceholders = $22db1ba098eb3017$var$recomputePlaceholders({
            draggable: draggable,
            impact: newImpact,
            previousImpact: state.impact,
            draggables: dimensions.draggables,
            droppables: dimensions.droppables
        });
        var result = (0, $gzM5u.default)({}, state, {
            current: current,
            dimensions: {
                draggables: dimensions.draggables,
                droppables: withUpdatedPlaceholders
            },
            impact: newImpact,
            viewport: viewport,
            scrollJumpRequest: scrollJumpRequest || null,
            forceShouldAnimate: scrollJumpRequest ? false : null
        });
        return result;
    };
    function $22db1ba098eb3017$var$getDraggables$1(ids, draggables) {
        return ids.map(function(id) {
            return draggables[id];
        });
    }
    var $22db1ba098eb3017$var$recompute = function(_ref) {
        var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
        var last = impact.displaced;
        var afterDragging = $22db1ba098eb3017$var$getDraggables$1(last.all, draggables);
        var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
            afterDragging: afterDragging,
            destination: destination,
            displacedBy: impact.displacedBy,
            viewport: viewport.frame,
            forceShouldAnimate: forceShouldAnimate,
            last: last
        });
        return (0, $gzM5u.default)({}, impact, {
            displaced: displaced
        });
    };
    var $22db1ba098eb3017$var$getClientBorderBoxCenter = function(_ref) {
        var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
        var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
            impact: impact,
            draggable: draggable,
            draggables: draggables,
            droppable: droppable,
            afterCritical: afterCritical
        });
        return $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
    };
    var $22db1ba098eb3017$var$refreshSnap = function(_ref) {
        var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
        !(state.movementMode === 'SNAP') && $22db1ba098eb3017$var$invariant(false);
        var needsVisibilityCheck = state.impact;
        var viewport = forcedViewport || state.viewport;
        var dimensions = forcedDimensions || state.dimensions;
        var draggables = dimensions.draggables, droppables = dimensions.droppables;
        var draggable = draggables[state.critical.draggable.id];
        var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(needsVisibilityCheck);
        !isOver && $22db1ba098eb3017$var$invariant(false);
        var destination = droppables[isOver];
        var impact = $22db1ba098eb3017$var$recompute({
            impact: needsVisibilityCheck,
            viewport: viewport,
            destination: destination,
            draggables: draggables
        });
        var clientSelection = $22db1ba098eb3017$var$getClientBorderBoxCenter({
            impact: impact,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            viewport: viewport,
            afterCritical: state.afterCritical
        });
        return $22db1ba098eb3017$var$update({
            impact: impact,
            clientSelection: clientSelection,
            state: state,
            dimensions: dimensions,
            viewport: viewport
        });
    };
    var $22db1ba098eb3017$var$getHomeLocation = function(descriptor) {
        return {
            index: descriptor.index,
            droppableId: descriptor.droppableId
        };
    };
    var $22db1ba098eb3017$var$getLiftEffect = function(_ref) {
        var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
        var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(home.axis, draggable.displaceBy);
        var insideHome = $22db1ba098eb3017$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
        var rawIndex = insideHome.indexOf(draggable);
        !(rawIndex !== -1) && $22db1ba098eb3017$var$invariant(false);
        var afterDragging = insideHome.slice(rawIndex + 1);
        var effected = afterDragging.reduce(function(previous, item) {
            previous[item.descriptor.id] = true;
            return previous;
        }, {});
        var afterCritical = {
            inVirtualList: home.descriptor.mode === 'virtual',
            displacedBy: displacedBy,
            effected: effected
        };
        var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
            afterDragging: afterDragging,
            destination: home,
            displacedBy: displacedBy,
            last: null,
            viewport: viewport.frame,
            forceShouldAnimate: false
        });
        var impact = {
            displaced: displaced,
            displacedBy: displacedBy,
            at: {
                type: 'REORDER',
                destination: $22db1ba098eb3017$var$getHomeLocation(draggable.descriptor)
            }
        };
        return {
            impact: impact,
            afterCritical: afterCritical
        };
    };
    var $22db1ba098eb3017$var$patchDimensionMap = function(dimensions, updated) {
        return {
            draggables: dimensions.draggables,
            droppables: $22db1ba098eb3017$var$patchDroppableMap(dimensions.droppables, updated)
        };
    };
    var $22db1ba098eb3017$var$records = {};
    var $22db1ba098eb3017$var$isEnabled = false;
    var $22db1ba098eb3017$var$isTimingsEnabled = function isTimingsEnabled() {
        return $22db1ba098eb3017$var$isEnabled;
    };
    var $22db1ba098eb3017$var$start = function start(key) {
        var now;
    };
    var $22db1ba098eb3017$var$finish = function finish(key) {
        var now, previous, result, rounded, style;
    };
    var $22db1ba098eb3017$var$offsetDraggable = function(_ref) {
        var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
        var client = (0, (0, parcelRequire("3YKxB")).offset)(draggable.client, offset$1);
        var page = (0, (0, parcelRequire("3YKxB")).withScroll)(client, initialWindowScroll);
        var moved = (0, $gzM5u.default)({}, draggable, {
            placeholder: (0, $gzM5u.default)({}, draggable.placeholder, {
                client: client
            }),
            client: client,
            page: page
        });
        return moved;
    };
    var $22db1ba098eb3017$var$getFrame = function(droppable) {
        var frame = droppable.frame;
        !frame && $22db1ba098eb3017$var$invariant(false);
        return frame;
    };
    var $22db1ba098eb3017$var$adjustAdditionsForScrollChanges = function(_ref) {
        var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
        var windowScrollChange = viewport.scroll.diff.value;
        return additions.map(function(draggable) {
            var droppableId = draggable.descriptor.droppableId;
            var modified = updatedDroppables[droppableId];
            var frame = $22db1ba098eb3017$var$getFrame(modified);
            var droppableScrollChange = frame.scroll.diff.value;
            var totalChange = $22db1ba098eb3017$var$add(windowScrollChange, droppableScrollChange);
            var moved = $22db1ba098eb3017$var$offsetDraggable({
                draggable: draggable,
                offset: totalChange,
                initialWindowScroll: viewport.scroll.initial
            });
            return moved;
        });
    };
    var $22db1ba098eb3017$var$timingsKey = 'Processing dynamic changes';
    var $22db1ba098eb3017$var$publishWhileDraggingInVirtual = function(_ref) {
        var _extends2, _extends3;
        var state = _ref.state, published = _ref.published;
        $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingsKey);
        var withScrollChange = published.modified.map(function(update) {
            var existing = state.dimensions.droppables[update.droppableId];
            var scrolled = $22db1ba098eb3017$var$scrollDroppable(existing, update.scroll);
            return scrolled;
        });
        var droppables = (0, $gzM5u.default)({}, state.dimensions.droppables, $22db1ba098eb3017$var$toDroppableMap(withScrollChange));
        var updatedAdditions = $22db1ba098eb3017$var$toDraggableMap($22db1ba098eb3017$var$adjustAdditionsForScrollChanges({
            additions: published.additions,
            updatedDroppables: droppables,
            viewport: state.viewport
        }));
        var draggables = (0, $gzM5u.default)({}, state.dimensions.draggables, updatedAdditions);
        published.removals.forEach(function(id) {
            delete draggables[id];
        });
        var dimensions = {
            droppables: droppables,
            draggables: draggables
        };
        var wasOverId = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
        var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
        var draggable = dimensions.draggables[state.critical.draggable.id];
        var home = dimensions.droppables[state.critical.droppable.id];
        var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: draggables,
            viewport: state.viewport
        }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
        var impact = $22db1ba098eb3017$var$getDragImpact({
            pageOffset: state.current.page.offset,
            draggable: dimensions.draggables[state.critical.draggable.id],
            draggables: dimensions.draggables,
            droppables: dimensions.droppables,
            previousImpact: previousImpact,
            viewport: state.viewport,
            afterCritical: afterCritical
        });
        $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingsKey);
        var draggingState = (0, $gzM5u.default)({
            phase: 'DRAGGING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
        if (state.phase === 'COLLECTING') return draggingState;
        var dropPending = (0, $gzM5u.default)({
            phase: 'DROP_PENDING'
        }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
        return dropPending;
    };
    var $22db1ba098eb3017$var$isSnapping = function isSnapping(state) {
        return state.movementMode === 'SNAP';
    };
    var $22db1ba098eb3017$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
        var dimensions = $22db1ba098eb3017$var$patchDimensionMap(state.dimensions, updated);
        if (!$22db1ba098eb3017$var$isSnapping(state) || isEnabledChanging) return $22db1ba098eb3017$var$update({
            state: state,
            dimensions: dimensions
        });
        return $22db1ba098eb3017$var$refreshSnap({
            state: state,
            dimensions: dimensions
        });
    };
    function $22db1ba098eb3017$var$removeScrollJumpRequest(state) {
        if (state.isDragging && state.movementMode === 'SNAP') return (0, $gzM5u.default)({
            phase: 'DRAGGING'
        }, state, {
            scrollJumpRequest: null
        });
        return state;
    }
    var $22db1ba098eb3017$var$idle = {
        phase: 'IDLE',
        completed: null,
        shouldFlush: false
    };
    var $22db1ba098eb3017$var$reducer = function(state, action) {
        if (state === void 0) state = $22db1ba098eb3017$var$idle;
        if (action.type === 'FLUSH') return (0, $gzM5u.default)({}, $22db1ba098eb3017$var$idle, {
            shouldFlush: true
        });
        if (action.type === 'INITIAL_PUBLISH') {
            !(state.phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
            var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
            var draggable = dimensions.draggables[critical.draggable.id];
            var home = dimensions.droppables[critical.droppable.id];
            var client = {
                selection: clientSelection,
                borderBoxCenter: draggable.client.borderBox.center,
                offset: $22db1ba098eb3017$var$origin
            };
            var initial = {
                client: client,
                page: {
                    selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                    borderBoxCenter: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                    offset: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.diff.value)
                }
            };
            var isWindowScrollAllowed = $22db1ba098eb3017$var$toDroppableList(dimensions.droppables).every(function(item) {
                return !item.isFixedOnPage;
            });
            var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
                draggable: draggable,
                home: home,
                draggables: dimensions.draggables,
                viewport: viewport
            }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
            var result = {
                phase: 'DRAGGING',
                isDragging: true,
                critical: critical,
                movementMode: movementMode,
                dimensions: dimensions,
                initial: initial,
                current: initial,
                isWindowScrollAllowed: isWindowScrollAllowed,
                impact: impact,
                afterCritical: afterCritical,
                onLiftImpact: impact,
                viewport: viewport,
                scrollJumpRequest: null,
                forceShouldAnimate: null
            };
            return result;
        }
        if (action.type === 'COLLECTION_STARTING') {
            var _extends2;
            if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
            !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
            var _result = (0, $gzM5u.default)({
                phase: 'COLLECTING'
            }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
            return _result;
        }
        if (action.type === 'PUBLISH_WHILE_DRAGGING') {
            !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
            return $22db1ba098eb3017$var$publishWhileDraggingInVirtual({
                state: state,
                published: action.payload
            });
        }
        if (action.type === 'MOVE') {
            if (state.phase === 'DROP_PENDING') return state;
            !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
            var _clientSelection = action.payload.client;
            if ($22db1ba098eb3017$var$isEqual(_clientSelection, state.current.client.selection)) return state;
            return $22db1ba098eb3017$var$update({
                state: state,
                clientSelection: _clientSelection,
                impact: $22db1ba098eb3017$var$isSnapping(state) ? state.impact : null
            });
        }
        if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
            if (state.phase === 'DROP_PENDING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
            if (state.phase === 'COLLECTING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
            !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
            var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
            var target = state.dimensions.droppables[id];
            if (!target) return state;
            var scrolled = $22db1ba098eb3017$var$scrollDroppable(target, newScroll);
            return $22db1ba098eb3017$var$postDroppableChange(state, scrolled, false);
        }
        if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
            if (state.phase === 'DROP_PENDING') return state;
            !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
            var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
            var _target = state.dimensions.droppables[_id];
            !_target && $22db1ba098eb3017$var$invariant(false);
            !(_target.isEnabled !== isEnabled) && $22db1ba098eb3017$var$invariant(false);
            var updated = (0, $gzM5u.default)({}, _target, {
                isEnabled: isEnabled
            });
            return $22db1ba098eb3017$var$postDroppableChange(state, updated, true);
        }
        if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
            if (state.phase === 'DROP_PENDING') return state;
            !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
            var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
            var _target2 = state.dimensions.droppables[_id2];
            !_target2 && $22db1ba098eb3017$var$invariant(false);
            !(_target2.isCombineEnabled !== isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
            var _updated = (0, $gzM5u.default)({}, _target2, {
                isCombineEnabled: isCombineEnabled
            });
            return $22db1ba098eb3017$var$postDroppableChange(state, _updated, true);
        }
        if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
            if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
            !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
            !state.isWindowScrollAllowed && $22db1ba098eb3017$var$invariant(false);
            var _newScroll = action.payload.newScroll;
            if ($22db1ba098eb3017$var$isEqual(state.viewport.scroll.current, _newScroll)) return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
            var _viewport = $22db1ba098eb3017$var$scrollViewport(state.viewport, _newScroll);
            if ($22db1ba098eb3017$var$isSnapping(state)) return $22db1ba098eb3017$var$refreshSnap({
                state: state,
                viewport: _viewport
            });
            return $22db1ba098eb3017$var$update({
                state: state,
                viewport: _viewport
            });
        }
        if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
            if (!$22db1ba098eb3017$var$isMovementAllowed(state)) return state;
            var maxScroll = action.payload.maxScroll;
            if ($22db1ba098eb3017$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
            var withMaxScroll = (0, $gzM5u.default)({}, state.viewport, {
                scroll: (0, $gzM5u.default)({}, state.viewport.scroll, {
                    max: maxScroll
                })
            });
            return (0, $gzM5u.default)({
                phase: 'DRAGGING'
            }, state, {
                viewport: withMaxScroll
            });
        }
        if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
            if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
            !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
            var _result2 = $22db1ba098eb3017$var$moveInDirection({
                state: state,
                type: action.type
            });
            if (!_result2) return state;
            return $22db1ba098eb3017$var$update({
                state: state,
                impact: _result2.impact,
                clientSelection: _result2.clientSelection,
                scrollJumpRequest: _result2.scrollJumpRequest
            });
        }
        if (action.type === 'DROP_PENDING') {
            var _extends3;
            var reason = action.payload.reason;
            !(state.phase === 'COLLECTING') && $22db1ba098eb3017$var$invariant(false);
            var newState = (0, $gzM5u.default)({
                phase: 'DROP_PENDING'
            }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
            return newState;
        }
        if (action.type === 'DROP_ANIMATE') {
            var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
            var _result3 = {
                phase: 'DROP_ANIMATING',
                completed: completed,
                dropDuration: dropDuration,
                newHomeClientOffset: newHomeClientOffset,
                dimensions: state.dimensions
            };
            return _result3;
        }
        if (action.type === 'DROP_COMPLETE') {
            var _completed = action.payload.completed;
            return {
                phase: 'IDLE',
                completed: _completed,
                shouldFlush: false
            };
        }
        return state;
    };
    var $22db1ba098eb3017$var$beforeInitialCapture = function beforeInitialCapture(args) {
        return {
            type: 'BEFORE_INITIAL_CAPTURE',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$lift = function lift(args) {
        return {
            type: 'LIFT',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$initialPublish = function initialPublish(args) {
        return {
            type: 'INITIAL_PUBLISH',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$publishWhileDragging = function publishWhileDragging(args) {
        return {
            type: 'PUBLISH_WHILE_DRAGGING',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$collectionStarting = function collectionStarting() {
        return {
            type: 'COLLECTION_STARTING',
            payload: null
        };
    };
    var $22db1ba098eb3017$var$updateDroppableScroll = function updateDroppableScroll(args) {
        return {
            type: 'UPDATE_DROPPABLE_SCROLL',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
        return {
            type: 'UPDATE_DROPPABLE_IS_ENABLED',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
        return {
            type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$move = function move(args) {
        return {
            type: 'MOVE',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$moveByWindowScroll = function moveByWindowScroll(args) {
        return {
            type: 'MOVE_BY_WINDOW_SCROLL',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
        return {
            type: 'UPDATE_VIEWPORT_MAX_SCROLL',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$moveUp = function moveUp() {
        return {
            type: 'MOVE_UP',
            payload: null
        };
    };
    var $22db1ba098eb3017$var$moveDown = function moveDown() {
        return {
            type: 'MOVE_DOWN',
            payload: null
        };
    };
    var $22db1ba098eb3017$var$moveRight = function moveRight() {
        return {
            type: 'MOVE_RIGHT',
            payload: null
        };
    };
    var $22db1ba098eb3017$var$moveLeft = function moveLeft() {
        return {
            type: 'MOVE_LEFT',
            payload: null
        };
    };
    var $22db1ba098eb3017$var$flush = function flush() {
        return {
            type: 'FLUSH',
            payload: null
        };
    };
    var $22db1ba098eb3017$var$animateDrop = function animateDrop(args) {
        return {
            type: 'DROP_ANIMATE',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$completeDrop = function completeDrop(args) {
        return {
            type: 'DROP_COMPLETE',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$drop = function drop(args) {
        return {
            type: 'DROP',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$dropPending = function dropPending(args) {
        return {
            type: 'DROP_PENDING',
            payload: args
        };
    };
    var $22db1ba098eb3017$var$dropAnimationFinished = function dropAnimationFinished() {
        return {
            type: 'DROP_ANIMATION_FINISHED',
            payload: null
        };
    };
    function $22db1ba098eb3017$var$checkIndexes(insideDestination) {
        if (insideDestination.length <= 1) return;
        var indexes = insideDestination.map(function(d) {
            return d.descriptor.index;
        });
        var errors = {};
        for(var i = 1; i < indexes.length; i++){
            var current = indexes[i];
            var previous = indexes[i - 1];
            if (current !== previous + 1) errors[current] = true;
        }
        if (!(0, ($parcel$interopDefault($cs3hJ)))(errors).length) return;
        var formatted = indexes.map(function(index) {
            var hasError = Boolean(errors[index]);
            return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
        }).join(', ');
    }
    function $22db1ba098eb3017$var$validateDimensions(critical, dimensions) {
        var insideDestination;
    }
    var $22db1ba098eb3017$var$lift$1 = function(marshal) {
        return function(_ref) {
            var getState = _ref.getState, dispatch = _ref.dispatch;
            return function(next) {
                return function(action) {
                    if (action.type !== 'LIFT') {
                        next(action);
                        return;
                    }
                    var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                    var initial = getState();
                    if (initial.phase === 'DROP_ANIMATING') dispatch($22db1ba098eb3017$var$completeDrop({
                        completed: initial.completed
                    }));
                    !(getState().phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                    dispatch($22db1ba098eb3017$var$flush());
                    dispatch($22db1ba098eb3017$var$beforeInitialCapture({
                        draggableId: id,
                        movementMode: movementMode
                    }));
                    var scrollOptions = {
                        shouldPublishImmediately: movementMode === 'SNAP'
                    };
                    var request = {
                        draggableId: id,
                        scrollOptions: scrollOptions
                    };
                    var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                    $22db1ba098eb3017$var$validateDimensions(critical, dimensions);
                    dispatch($22db1ba098eb3017$var$initialPublish({
                        critical: critical,
                        dimensions: dimensions,
                        clientSelection: clientSelection,
                        movementMode: movementMode,
                        viewport: viewport
                    }));
                };
            };
        };
    };
    var $22db1ba098eb3017$var$style = function(marshal) {
        return function() {
            return function(next) {
                return function(action) {
                    if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                    if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                    if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                    next(action);
                };
            };
        };
    };
    var $22db1ba098eb3017$var$curves = {
        outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
        drop: 'cubic-bezier(.2,1,.1,1)'
    };
    var $22db1ba098eb3017$var$combine = {
        opacity: {
            drop: 0,
            combining: 0.7
        },
        scale: {
            drop: 0.75
        }
    };
    var $22db1ba098eb3017$var$timings = {
        outOfTheWay: 0.2,
        minDropTime: 0.33,
        maxDropTime: 0.55
    };
    var $22db1ba098eb3017$var$outOfTheWayTiming = $22db1ba098eb3017$var$timings.outOfTheWay + "s " + $22db1ba098eb3017$var$curves.outOfTheWay;
    var $22db1ba098eb3017$var$transitions = {
        fluid: "opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
        snap: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming + ", opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
        drop: function drop(duration) {
            var timing = duration + "s " + $22db1ba098eb3017$var$curves.drop;
            return "transform " + timing + ", opacity " + timing;
        },
        outOfTheWay: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming,
        placeholder: "height " + $22db1ba098eb3017$var$outOfTheWayTiming + ", width " + $22db1ba098eb3017$var$outOfTheWayTiming + ", margin " + $22db1ba098eb3017$var$outOfTheWayTiming
    };
    var $22db1ba098eb3017$var$moveTo = function moveTo(offset) {
        return $22db1ba098eb3017$var$isEqual(offset, $22db1ba098eb3017$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
    };
    var $22db1ba098eb3017$var$transforms = {
        moveTo: $22db1ba098eb3017$var$moveTo,
        drop: function drop(offset, isCombining) {
            var translate = $22db1ba098eb3017$var$moveTo(offset);
            if (!translate) return null;
            if (!isCombining) return translate;
            return translate + " scale(" + $22db1ba098eb3017$var$combine.scale.drop + ")";
        }
    };
    var $22db1ba098eb3017$var$minDropTime = $22db1ba098eb3017$var$timings.minDropTime, $22db1ba098eb3017$var$maxDropTime = $22db1ba098eb3017$var$timings.maxDropTime;
    var $22db1ba098eb3017$var$dropTimeRange = $22db1ba098eb3017$var$maxDropTime - $22db1ba098eb3017$var$minDropTime;
    var $22db1ba098eb3017$var$maxDropTimeAtDistance = 1500;
    var $22db1ba098eb3017$var$cancelDropModifier = 0.6;
    var $22db1ba098eb3017$var$getDropDuration = function(_ref) {
        var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
        var distance$1 = $22db1ba098eb3017$var$distance(current, destination);
        if (distance$1 <= 0) return $22db1ba098eb3017$var$minDropTime;
        if (distance$1 >= $22db1ba098eb3017$var$maxDropTimeAtDistance) return $22db1ba098eb3017$var$maxDropTime;
        var percentage = distance$1 / $22db1ba098eb3017$var$maxDropTimeAtDistance;
        var duration = $22db1ba098eb3017$var$minDropTime + $22db1ba098eb3017$var$dropTimeRange * percentage;
        var withDuration = reason === 'CANCEL' ? duration * $22db1ba098eb3017$var$cancelDropModifier : duration;
        return Number(withDuration.toFixed(2));
    };
    var $22db1ba098eb3017$var$getNewHomeClientOffset = function(_ref) {
        var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
        var draggables = dimensions.draggables, droppables = dimensions.droppables;
        var droppableId = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
        var destination = droppableId ? droppables[droppableId] : null;
        var home = droppables[draggable.descriptor.droppableId];
        var newClientCenter = $22db1ba098eb3017$var$getClientBorderBoxCenter({
            impact: impact,
            draggable: draggable,
            draggables: draggables,
            afterCritical: afterCritical,
            droppable: destination || home,
            viewport: viewport
        });
        var offset = $22db1ba098eb3017$var$subtract(newClientCenter, draggable.client.borderBox.center);
        return offset;
    };
    var $22db1ba098eb3017$var$getDropImpact = function(_ref) {
        var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
        if (!lastImpact.at || reason !== 'DROP') {
            var recomputedHomeImpact = $22db1ba098eb3017$var$recompute({
                draggables: draggables,
                impact: onLiftImpact,
                destination: home,
                viewport: viewport,
                forceShouldAnimate: true
            });
            return {
                impact: recomputedHomeImpact,
                didDropInsideDroppable: false
            };
        }
        if (lastImpact.at.type === 'REORDER') return {
            impact: lastImpact,
            didDropInsideDroppable: true
        };
        var withoutMovement = (0, $gzM5u.default)({}, lastImpact, {
            displaced: $22db1ba098eb3017$var$emptyGroups
        });
        return {
            impact: withoutMovement,
            didDropInsideDroppable: true
        };
    };
    var $22db1ba098eb3017$var$drop$1 = function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'DROP') {
                    next(action);
                    return;
                }
                var state = getState();
                var reason = action.payload.reason;
                if (state.phase === 'COLLECTING') {
                    dispatch($22db1ba098eb3017$var$dropPending({
                        reason: reason
                    }));
                    return;
                }
                if (state.phase === 'IDLE') return;
                var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
                !!isWaitingForDrop && $22db1ba098eb3017$var$invariant(false);
                !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
                var critical = state.critical;
                var dimensions = state.dimensions;
                var draggable = dimensions.draggables[state.critical.draggable.id];
                var _getDropImpact = $22db1ba098eb3017$var$getDropImpact({
                    reason: reason,
                    lastImpact: state.impact,
                    afterCritical: state.afterCritical,
                    onLiftImpact: state.onLiftImpact,
                    home: state.dimensions.droppables[state.critical.droppable.id],
                    viewport: state.viewport,
                    draggables: state.dimensions.draggables
                }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
                var destination = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetDestination(impact) : null;
                var combine = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetCombine(impact) : null;
                var source = {
                    index: critical.draggable.index,
                    droppableId: critical.droppable.id
                };
                var result = {
                    draggableId: draggable.descriptor.id,
                    type: draggable.descriptor.type,
                    source: source,
                    reason: reason,
                    mode: state.movementMode,
                    destination: destination,
                    combine: combine
                };
                var newHomeClientOffset = $22db1ba098eb3017$var$getNewHomeClientOffset({
                    impact: impact,
                    draggable: draggable,
                    dimensions: dimensions,
                    viewport: state.viewport,
                    afterCritical: state.afterCritical
                });
                var completed = {
                    critical: state.critical,
                    afterCritical: state.afterCritical,
                    result: result,
                    impact: impact
                };
                var isAnimationRequired = !$22db1ba098eb3017$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
                if (!isAnimationRequired) {
                    dispatch($22db1ba098eb3017$var$completeDrop({
                        completed: completed
                    }));
                    return;
                }
                var dropDuration = $22db1ba098eb3017$var$getDropDuration({
                    current: state.current.client.offset,
                    destination: newHomeClientOffset,
                    reason: reason
                });
                var args = {
                    newHomeClientOffset: newHomeClientOffset,
                    dropDuration: dropDuration,
                    completed: completed
                };
                dispatch($22db1ba098eb3017$var$animateDrop(args));
            };
        };
    };
    var $22db1ba098eb3017$var$getWindowScroll = function() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    };
    function $22db1ba098eb3017$var$getWindowScrollBinding(update) {
        return {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn(event) {
                if (event.target !== window && event.target !== window.document) return;
                update();
            }
        };
    }
    function $22db1ba098eb3017$var$getScrollListener(_ref) {
        var onWindowScroll = _ref.onWindowScroll;
        function updateScroll() {
            onWindowScroll($22db1ba098eb3017$var$getWindowScroll());
        }
        var scheduled = (0, (0, parcelRequire("crAmF")).default)(updateScroll);
        var binding = $22db1ba098eb3017$var$getWindowScrollBinding(scheduled);
        var unbind = $22db1ba098eb3017$var$noop;
        function isActive() {
            return unbind !== $22db1ba098eb3017$var$noop;
        }
        function start() {
            !!isActive() && $22db1ba098eb3017$var$invariant(false);
            unbind = $22db1ba098eb3017$var$bindEvents(window, [
                binding
            ]);
        }
        function stop() {
            !isActive() && $22db1ba098eb3017$var$invariant(false);
            scheduled.cancel();
            unbind();
            unbind = $22db1ba098eb3017$var$noop;
        }
        return {
            start: start,
            stop: stop,
            isActive: isActive
        };
    }
    var $22db1ba098eb3017$var$shouldEnd = function shouldEnd(action) {
        return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
    };
    var $22db1ba098eb3017$var$scrollListener = function(store) {
        var listener = $22db1ba098eb3017$var$getScrollListener({
            onWindowScroll: function onWindowScroll(newScroll) {
                store.dispatch($22db1ba098eb3017$var$moveByWindowScroll({
                    newScroll: newScroll
                }));
            }
        });
        return function(next) {
            return function(action) {
                if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
                if (listener.isActive() && $22db1ba098eb3017$var$shouldEnd(action)) listener.stop();
                next(action);
            };
        };
    };
    var $22db1ba098eb3017$var$getExpiringAnnounce = function(announce) {
        var wasCalled = false;
        var isExpired = false;
        var timeoutId = setTimeout(function() {
            isExpired = true;
        });
        var result = function result(message) {
            if (wasCalled) return;
            if (isExpired) return;
            wasCalled = true;
            announce(message);
            clearTimeout(timeoutId);
        };
        result.wasCalled = function() {
            return wasCalled;
        };
        return result;
    };
    var $22db1ba098eb3017$var$getAsyncMarshal = function() {
        var entries = [];
        var execute = function execute(timerId) {
            var index = $22db1ba098eb3017$var$findIndex(entries, function(item) {
                return item.timerId === timerId;
            });
            !(index !== -1) && $22db1ba098eb3017$var$invariant(false);
            var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
            entry.callback();
        };
        var add = function add(fn) {
            var timerId = setTimeout(function() {
                return execute(timerId);
            });
            var entry = {
                timerId: timerId,
                callback: fn
            };
            entries.push(entry);
        };
        var flush = function flush() {
            if (!entries.length) return;
            var shallow = [].concat(entries);
            entries.length = 0;
            shallow.forEach(function(entry) {
                clearTimeout(entry.timerId);
                entry.callback();
            });
        };
        return {
            add: add,
            flush: flush
        };
    };
    var $22db1ba098eb3017$var$areLocationsEqual = function areLocationsEqual(first, second) {
        if (first == null && second == null) return true;
        if (first == null || second == null) return false;
        return first.droppableId === second.droppableId && first.index === second.index;
    };
    var $22db1ba098eb3017$var$isCombineEqual = function isCombineEqual(first, second) {
        if (first == null && second == null) return true;
        if (first == null || second == null) return false;
        return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
    };
    var $22db1ba098eb3017$var$isCriticalEqual = function isCriticalEqual(first, second) {
        if (first === second) return true;
        var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
        var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
        return isDraggableEqual && isDroppableEqual;
    };
    var $22db1ba098eb3017$var$withTimings = function withTimings(key, fn) {
        $22db1ba098eb3017$var$start(key);
        fn();
        $22db1ba098eb3017$var$finish(key);
    };
    var $22db1ba098eb3017$var$getDragStart = function getDragStart(critical, mode) {
        return {
            draggableId: critical.draggable.id,
            type: critical.droppable.type,
            source: {
                droppableId: critical.droppable.id,
                index: critical.draggable.index
            },
            mode: mode
        };
    };
    var $22db1ba098eb3017$var$execute = function execute(responder, data, announce, getDefaultMessage) {
        if (!responder) {
            announce(getDefaultMessage(data));
            return;
        }
        var willExpire = $22db1ba098eb3017$var$getExpiringAnnounce(announce);
        var provided = {
            announce: willExpire
        };
        responder(data, provided);
        if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
    };
    var $22db1ba098eb3017$var$getPublisher = function(getResponders, announce) {
        var asyncMarshal = $22db1ba098eb3017$var$getAsyncMarshal();
        var dragging = null;
        var beforeCapture = function beforeCapture(draggableId, mode) {
            !!dragging && $22db1ba098eb3017$var$invariant(false);
            $22db1ba098eb3017$var$withTimings('onBeforeCapture', function() {
                var fn = getResponders().onBeforeCapture;
                if (fn) {
                    var before = {
                        draggableId: draggableId,
                        mode: mode
                    };
                    fn(before);
                }
            });
        };
        var beforeStart = function beforeStart(critical, mode) {
            !!dragging && $22db1ba098eb3017$var$invariant(false);
            $22db1ba098eb3017$var$withTimings('onBeforeDragStart', function() {
                var fn = getResponders().onBeforeDragStart;
                if (fn) fn($22db1ba098eb3017$var$getDragStart(critical, mode));
            });
        };
        var start = function start(critical, mode) {
            !!dragging && $22db1ba098eb3017$var$invariant(false);
            var data = $22db1ba098eb3017$var$getDragStart(critical, mode);
            dragging = {
                mode: mode,
                lastCritical: critical,
                lastLocation: data.source,
                lastCombine: null
            };
            asyncMarshal.add(function() {
                $22db1ba098eb3017$var$withTimings('onDragStart', function() {
                    return $22db1ba098eb3017$var$execute(getResponders().onDragStart, data, announce, $22db1ba098eb3017$var$preset.onDragStart);
                });
            });
        };
        var update = function update(critical, impact) {
            var location = $22db1ba098eb3017$var$tryGetDestination(impact);
            var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
            !dragging && $22db1ba098eb3017$var$invariant(false);
            var hasCriticalChanged = !$22db1ba098eb3017$var$isCriticalEqual(critical, dragging.lastCritical);
            if (hasCriticalChanged) dragging.lastCritical = critical;
            var hasLocationChanged = !$22db1ba098eb3017$var$areLocationsEqual(dragging.lastLocation, location);
            if (hasLocationChanged) dragging.lastLocation = location;
            var hasGroupingChanged = !$22db1ba098eb3017$var$isCombineEqual(dragging.lastCombine, combine);
            if (hasGroupingChanged) dragging.lastCombine = combine;
            if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
            var data = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(critical, dragging.mode), {
                combine: combine,
                destination: location
            });
            asyncMarshal.add(function() {
                $22db1ba098eb3017$var$withTimings('onDragUpdate', function() {
                    return $22db1ba098eb3017$var$execute(getResponders().onDragUpdate, data, announce, $22db1ba098eb3017$var$preset.onDragUpdate);
                });
            });
        };
        var flush = function flush() {
            !dragging && $22db1ba098eb3017$var$invariant(false);
            asyncMarshal.flush();
        };
        var drop = function drop(result) {
            !dragging && $22db1ba098eb3017$var$invariant(false);
            dragging = null;
            $22db1ba098eb3017$var$withTimings('onDragEnd', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragEnd, result, announce, $22db1ba098eb3017$var$preset.onDragEnd);
            });
        };
        var abort = function abort() {
            if (!dragging) return;
            var result = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(dragging.lastCritical, dragging.mode), {
                combine: null,
                destination: null,
                reason: 'CANCEL'
            });
            drop(result);
        };
        return {
            beforeCapture: beforeCapture,
            beforeStart: beforeStart,
            start: start,
            update: update,
            flush: flush,
            drop: drop,
            abort: abort
        };
    };
    var $22db1ba098eb3017$var$responders = function(getResponders, announce) {
        var publisher = $22db1ba098eb3017$var$getPublisher(getResponders, announce);
        return function(store) {
            return function(next) {
                return function(action) {
                    if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                        publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                        return;
                    }
                    if (action.type === 'INITIAL_PUBLISH') {
                        var critical = action.payload.critical;
                        publisher.beforeStart(critical, action.payload.movementMode);
                        next(action);
                        publisher.start(critical, action.payload.movementMode);
                        return;
                    }
                    if (action.type === 'DROP_COMPLETE') {
                        var result = action.payload.completed.result;
                        publisher.flush();
                        next(action);
                        publisher.drop(result);
                        return;
                    }
                    next(action);
                    if (action.type === 'FLUSH') {
                        publisher.abort();
                        return;
                    }
                    var state = store.getState();
                    if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
                };
            };
        };
    };
    var $22db1ba098eb3017$var$dropAnimationFinish = function(store) {
        return function(next) {
            return function(action) {
                if (action.type !== 'DROP_ANIMATION_FINISHED') {
                    next(action);
                    return;
                }
                var state = store.getState();
                !(state.phase === 'DROP_ANIMATING') && $22db1ba098eb3017$var$invariant(false);
                store.dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: state.completed
                }));
            };
        };
    };
    var $22db1ba098eb3017$var$dropAnimationFlushOnScroll = function(store) {
        var unbind = null;
        var frameId = null;
        function clear() {
            if (frameId) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            if (unbind) {
                unbind();
                unbind = null;
            }
        }
        return function(next) {
            return function(action) {
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
                next(action);
                if (action.type !== 'DROP_ANIMATE') return;
                var binding = {
                    eventName: 'scroll',
                    options: {
                        capture: true,
                        passive: false,
                        once: true
                    },
                    fn: function flushDropAnimation() {
                        var state = store.getState();
                        if (state.phase === 'DROP_ANIMATING') store.dispatch($22db1ba098eb3017$var$dropAnimationFinished());
                    }
                };
                frameId = requestAnimationFrame(function() {
                    frameId = null;
                    unbind = $22db1ba098eb3017$var$bindEvents(window, [
                        binding
                    ]);
                });
            };
        };
    };
    var $22db1ba098eb3017$var$dimensionMarshalStopper = function(marshal) {
        return function() {
            return function(next) {
                return function(action) {
                    if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                    next(action);
                };
            };
        };
    };
    var $22db1ba098eb3017$var$focus = function(marshal) {
        var isWatching = false;
        return function() {
            return function(next) {
                return function(action) {
                    if (action.type === 'INITIAL_PUBLISH') {
                        isWatching = true;
                        marshal.tryRecordFocus(action.payload.critical.draggable.id);
                        next(action);
                        marshal.tryRestoreFocusRecorded();
                        return;
                    }
                    next(action);
                    if (!isWatching) return;
                    if (action.type === 'FLUSH') {
                        isWatching = false;
                        marshal.tryRestoreFocusRecorded();
                        return;
                    }
                    if (action.type === 'DROP_COMPLETE') {
                        isWatching = false;
                        var result = action.payload.completed.result;
                        if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                        marshal.tryRestoreFocusRecorded();
                    }
                };
            };
        };
    };
    var $22db1ba098eb3017$var$shouldStop = function shouldStop(action) {
        return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
    };
    var $22db1ba098eb3017$var$autoScroll = function(autoScroller) {
        return function(store) {
            return function(next) {
                return function(action) {
                    if ($22db1ba098eb3017$var$shouldStop(action)) {
                        autoScroller.stop();
                        next(action);
                        return;
                    }
                    if (action.type === 'INITIAL_PUBLISH') {
                        next(action);
                        var state = store.getState();
                        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
                        autoScroller.start(state);
                        return;
                    }
                    next(action);
                    autoScroller.scroll(store.getState());
                };
            };
        };
    };
    var $22db1ba098eb3017$var$pendingDrop = function(store) {
        return function(next) {
            return function(action) {
                next(action);
                if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
                var postActionState = store.getState();
                if (postActionState.phase !== 'DROP_PENDING') return;
                if (postActionState.isWaiting) return;
                store.dispatch($22db1ba098eb3017$var$drop({
                    reason: postActionState.reason
                }));
            };
        };
    };
    var $22db1ba098eb3017$var$composeEnhancers = (0, (0, parcelRequire("22j3V")).compose);
    var $22db1ba098eb3017$var$createStore = function(_ref) {
        var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
        return (0, (0, parcelRequire("22j3V")).createStore)($22db1ba098eb3017$var$reducer, $22db1ba098eb3017$var$composeEnhancers((0, (0, parcelRequire("22j3V")).applyMiddleware)($22db1ba098eb3017$var$style(styleMarshal), $22db1ba098eb3017$var$dimensionMarshalStopper(dimensionMarshal), $22db1ba098eb3017$var$lift$1(dimensionMarshal), $22db1ba098eb3017$var$drop$1, $22db1ba098eb3017$var$dropAnimationFinish, $22db1ba098eb3017$var$dropAnimationFlushOnScroll, $22db1ba098eb3017$var$pendingDrop, $22db1ba098eb3017$var$autoScroll(autoScroller), $22db1ba098eb3017$var$scrollListener, $22db1ba098eb3017$var$focus(focusMarshal), $22db1ba098eb3017$var$responders(getResponders, announce))));
    };
    var $22db1ba098eb3017$var$clean$1 = function clean() {
        return {
            additions: {},
            removals: {},
            modified: {}
        };
    };
    var $22db1ba098eb3017$var$timingKey = 'Publish collection from DOM';
    function $22db1ba098eb3017$var$createPublisher(_ref) {
        var registry = _ref.registry, callbacks = _ref.callbacks;
        var staging = $22db1ba098eb3017$var$clean$1();
        var frameId = null;
        var collect = function collect() {
            if (frameId) return;
            callbacks.collectionStarting();
            frameId = requestAnimationFrame(function() {
                frameId = null;
                $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingKey);
                var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
                var added = (0, ($parcel$interopDefault($cs3hJ)))(additions).map(function(id) {
                    return registry.draggable.getById(id).getDimension($22db1ba098eb3017$var$origin);
                }).sort(function(a, b) {
                    return a.descriptor.index - b.descriptor.index;
                });
                var updated = (0, ($parcel$interopDefault($cs3hJ)))(modified).map(function(id) {
                    var entry = registry.droppable.getById(id);
                    var scroll = entry.callbacks.getScrollWhileDragging();
                    return {
                        droppableId: id,
                        scroll: scroll
                    };
                });
                var result = {
                    additions: added,
                    removals: (0, ($parcel$interopDefault($cs3hJ)))(removals),
                    modified: updated
                };
                staging = $22db1ba098eb3017$var$clean$1();
                $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingKey);
                callbacks.publish(result);
            });
        };
        var add = function add(entry) {
            var id = entry.descriptor.id;
            staging.additions[id] = entry;
            staging.modified[entry.descriptor.droppableId] = true;
            if (staging.removals[id]) delete staging.removals[id];
            collect();
        };
        var remove = function remove(entry) {
            var descriptor = entry.descriptor;
            staging.removals[descriptor.id] = true;
            staging.modified[descriptor.droppableId] = true;
            if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
            collect();
        };
        var stop = function stop() {
            if (!frameId) return;
            cancelAnimationFrame(frameId);
            frameId = null;
            staging = $22db1ba098eb3017$var$clean$1();
        };
        return {
            add: add,
            remove: remove,
            stop: stop
        };
    }
    var $22db1ba098eb3017$var$getMaxScroll = function(_ref) {
        var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
        var maxScroll = $22db1ba098eb3017$var$subtract({
            x: scrollWidth,
            y: scrollHeight
        }, {
            x: width,
            y: height
        });
        var adjustedMaxScroll = {
            x: Math.max(0, maxScroll.x),
            y: Math.max(0, maxScroll.y)
        };
        return adjustedMaxScroll;
    };
    var $22db1ba098eb3017$var$getDocumentElement = function() {
        var doc = document.documentElement;
        !doc && $22db1ba098eb3017$var$invariant(false);
        return doc;
    };
    var $22db1ba098eb3017$var$getMaxWindowScroll = function() {
        var doc = $22db1ba098eb3017$var$getDocumentElement();
        var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
            scrollHeight: doc.scrollHeight,
            scrollWidth: doc.scrollWidth,
            width: doc.clientWidth,
            height: doc.clientHeight
        });
        return maxScroll;
    };
    var $22db1ba098eb3017$var$getViewport = function() {
        var scroll = $22db1ba098eb3017$var$getWindowScroll();
        var maxScroll = $22db1ba098eb3017$var$getMaxWindowScroll();
        var top = scroll.y;
        var left = scroll.x;
        var doc = $22db1ba098eb3017$var$getDocumentElement();
        var width = doc.clientWidth;
        var height = doc.clientHeight;
        var right = left + width;
        var bottom = top + height;
        var frame = (0, (0, parcelRequire("3YKxB")).getRect)({
            top: top,
            left: left,
            right: right,
            bottom: bottom
        });
        var viewport = {
            frame: frame,
            scroll: {
                initial: scroll,
                current: scroll,
                max: maxScroll,
                diff: {
                    value: $22db1ba098eb3017$var$origin,
                    displacement: $22db1ba098eb3017$var$origin
                }
            }
        };
        return viewport;
    };
    var $22db1ba098eb3017$var$getInitialPublish = function(_ref) {
        var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
        var timingKey = 'Initial collection from DOM';
        $22db1ba098eb3017$var$start(timingKey);
        var viewport = $22db1ba098eb3017$var$getViewport();
        var windowScroll = viewport.scroll.current;
        var home = critical.droppable;
        var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
            return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
        });
        var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
            return entry.getDimension(windowScroll);
        });
        var dimensions = {
            draggables: $22db1ba098eb3017$var$toDraggableMap(draggables),
            droppables: $22db1ba098eb3017$var$toDroppableMap(droppables)
        };
        $22db1ba098eb3017$var$finish(timingKey);
        var result = {
            dimensions: dimensions,
            critical: critical,
            viewport: viewport
        };
        return result;
    };
    function $22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, entry) {
        if (entry.descriptor.id === dragging.id) return false;
        if (entry.descriptor.type !== dragging.type) return false;
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        if (home.descriptor.mode !== 'virtual') return false;
        return true;
    }
    var $22db1ba098eb3017$var$createDimensionMarshal = function(registry, callbacks) {
        var collection = null;
        var publisher = $22db1ba098eb3017$var$createPublisher({
            callbacks: {
                publish: callbacks.publishWhileDragging,
                collectionStarting: callbacks.collectionStarting
            },
            registry: registry
        });
        var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
            !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
            if (!collection) return;
            callbacks.updateDroppableIsEnabled({
                id: id,
                isEnabled: isEnabled
            });
        };
        var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
            if (!collection) return;
            !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
            callbacks.updateDroppableIsCombineEnabled({
                id: id,
                isCombineEnabled: isCombineEnabled
            });
        };
        var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
            if (!collection) return;
            !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
            callbacks.updateDroppableScroll({
                id: id,
                newScroll: newScroll
            });
        };
        var scrollDroppable = function scrollDroppable(id, change) {
            if (!collection) return;
            registry.droppable.getById(id).callbacks.scroll(change);
        };
        var stopPublishing = function stopPublishing() {
            if (!collection) return;
            publisher.stop();
            var home = collection.critical.droppable;
            registry.droppable.getAllByType(home.type).forEach(function(entry) {
                return entry.callbacks.dragStopped();
            });
            collection.unsubscribe();
            collection = null;
        };
        var subscriber = function subscriber(event) {
            !collection && $22db1ba098eb3017$var$invariant(false);
            var dragging = collection.critical.draggable;
            if (event.type === 'ADDITION') {
                if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
            }
            if (event.type === 'REMOVAL') {
                if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
            }
        };
        var startPublishing = function startPublishing(request) {
            !!collection && $22db1ba098eb3017$var$invariant(false);
            var entry = registry.draggable.getById(request.draggableId);
            var home = registry.droppable.getById(entry.descriptor.droppableId);
            var critical = {
                draggable: entry.descriptor,
                droppable: home.descriptor
            };
            var unsubscribe = registry.subscribe(subscriber);
            collection = {
                critical: critical,
                unsubscribe: unsubscribe
            };
            return $22db1ba098eb3017$var$getInitialPublish({
                critical: critical,
                registry: registry,
                scrollOptions: request.scrollOptions
            });
        };
        var marshal = {
            updateDroppableIsEnabled: updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
            scrollDroppable: scrollDroppable,
            updateDroppableScroll: updateDroppableScroll,
            startPublishing: startPublishing,
            stopPublishing: stopPublishing
        };
        return marshal;
    };
    var $22db1ba098eb3017$var$canStartDrag = function(state, id) {
        if (state.phase === 'IDLE') return true;
        if (state.phase !== 'DROP_ANIMATING') return false;
        if (state.completed.result.draggableId === id) return false;
        return state.completed.result.reason === 'DROP';
    };
    var $22db1ba098eb3017$var$scrollWindow = function(change) {
        window.scrollBy(change.x, change.y);
    };
    var $22db1ba098eb3017$var$getScrollableDroppables = (0, (0, parcelRequire("g7psY")).default)(function(droppables) {
        return $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
            if (!droppable.isEnabled) return false;
            if (!droppable.frame) return false;
            return true;
        });
    });
    var $22db1ba098eb3017$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
        var maybe = $22db1ba098eb3017$var$find($22db1ba098eb3017$var$getScrollableDroppables(droppables), function(droppable) {
            !droppable.frame && $22db1ba098eb3017$var$invariant(false);
            return $22db1ba098eb3017$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
        });
        return maybe;
    };
    var $22db1ba098eb3017$var$getBestScrollableDroppable = function(_ref) {
        var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
        if (destination) {
            var _dimension = droppables[destination];
            if (!_dimension.frame) return null;
            return _dimension;
        }
        var dimension = $22db1ba098eb3017$var$getScrollableDroppableOver(center, droppables);
        return dimension;
    };
    var $22db1ba098eb3017$var$config = {
        startFromPercentage: 0.25,
        maxScrollAtPercentage: 0.05,
        maxPixelScroll: 28,
        ease: function ease(percentage) {
            return Math.pow(percentage, 2);
        },
        durationDampening: {
            stopDampeningAt: 1200,
            accelerateAt: 360
        }
    };
    var $22db1ba098eb3017$var$getDistanceThresholds = function(container, axis) {
        var startScrollingFrom = container[axis.size] * $22db1ba098eb3017$var$config.startFromPercentage;
        var maxScrollValueAt = container[axis.size] * $22db1ba098eb3017$var$config.maxScrollAtPercentage;
        var thresholds = {
            startScrollingFrom: startScrollingFrom,
            maxScrollValueAt: maxScrollValueAt
        };
        return thresholds;
    };
    var $22db1ba098eb3017$var$getPercentage = function(_ref) {
        var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
        var range = endOfRange - startOfRange;
        if (range === 0) return 0;
        var currentInRange = current - startOfRange;
        var percentage = currentInRange / range;
        return percentage;
    };
    var $22db1ba098eb3017$var$minScroll = 1;
    var $22db1ba098eb3017$var$getValueFromDistance = function(distanceToEdge, thresholds) {
        if (distanceToEdge > thresholds.startScrollingFrom) return 0;
        if (distanceToEdge <= thresholds.maxScrollValueAt) return $22db1ba098eb3017$var$config.maxPixelScroll;
        if (distanceToEdge === thresholds.startScrollingFrom) return $22db1ba098eb3017$var$minScroll;
        var percentageFromMaxScrollValueAt = $22db1ba098eb3017$var$getPercentage({
            startOfRange: thresholds.maxScrollValueAt,
            endOfRange: thresholds.startScrollingFrom,
            current: distanceToEdge
        });
        var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
        var scroll = $22db1ba098eb3017$var$config.maxPixelScroll * $22db1ba098eb3017$var$config.ease(percentageFromStartScrollingFrom);
        return Math.ceil(scroll);
    };
    var $22db1ba098eb3017$var$accelerateAt = $22db1ba098eb3017$var$config.durationDampening.accelerateAt;
    var $22db1ba098eb3017$var$stopAt = $22db1ba098eb3017$var$config.durationDampening.stopDampeningAt;
    var $22db1ba098eb3017$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
        var startOfRange = dragStartTime;
        var endOfRange = $22db1ba098eb3017$var$stopAt;
        var now = (0, ($parcel$interopDefault($3BSY2)))();
        var runTime = now - startOfRange;
        if (runTime >= $22db1ba098eb3017$var$stopAt) return proposedScroll;
        if (runTime < $22db1ba098eb3017$var$accelerateAt) return $22db1ba098eb3017$var$minScroll;
        var betweenAccelerateAtAndStopAtPercentage = $22db1ba098eb3017$var$getPercentage({
            startOfRange: $22db1ba098eb3017$var$accelerateAt,
            endOfRange: endOfRange,
            current: runTime
        });
        var scroll = proposedScroll * $22db1ba098eb3017$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
        return Math.ceil(scroll);
    };
    var $22db1ba098eb3017$var$getValue = function(_ref) {
        var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
        var scroll = $22db1ba098eb3017$var$getValueFromDistance(distanceToEdge, thresholds);
        if (scroll === 0) return 0;
        if (!shouldUseTimeDampening) return scroll;
        return Math.max($22db1ba098eb3017$var$dampenValueByTime(scroll, dragStartTime), $22db1ba098eb3017$var$minScroll);
    };
    var $22db1ba098eb3017$var$getScrollOnAxis = function(_ref) {
        var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
        var thresholds = $22db1ba098eb3017$var$getDistanceThresholds(container, axis);
        var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
        if (isCloserToEnd) return $22db1ba098eb3017$var$getValue({
            distanceToEdge: distanceToEdges[axis.end],
            thresholds: thresholds,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return -1 * $22db1ba098eb3017$var$getValue({
            distanceToEdge: distanceToEdges[axis.start],
            thresholds: thresholds,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var $22db1ba098eb3017$var$adjustForSizeLimits = function(_ref) {
        var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
        var isTooBigVertically = subject.height > container.height;
        var isTooBigHorizontally = subject.width > container.width;
        if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
        if (isTooBigHorizontally && isTooBigVertically) return null;
        return {
            x: isTooBigHorizontally ? 0 : proposedScroll.x,
            y: isTooBigVertically ? 0 : proposedScroll.y
        };
    };
    var $22db1ba098eb3017$var$clean$2 = $22db1ba098eb3017$var$apply(function(value) {
        return value === 0 ? 0 : value;
    });
    var $22db1ba098eb3017$var$getScroll = function(_ref) {
        var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
        var distanceToEdges = {
            top: center.y - container.top,
            right: container.right - center.x,
            bottom: container.bottom - center.y,
            left: center.x - container.left
        };
        var y = $22db1ba098eb3017$var$getScrollOnAxis({
            container: container,
            distanceToEdges: distanceToEdges,
            dragStartTime: dragStartTime,
            axis: $22db1ba098eb3017$var$vertical,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        var x = $22db1ba098eb3017$var$getScrollOnAxis({
            container: container,
            distanceToEdges: distanceToEdges,
            dragStartTime: dragStartTime,
            axis: $22db1ba098eb3017$var$horizontal,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        var required = $22db1ba098eb3017$var$clean$2({
            x: x,
            y: y
        });
        if ($22db1ba098eb3017$var$isEqual(required, $22db1ba098eb3017$var$origin)) return null;
        var limited = $22db1ba098eb3017$var$adjustForSizeLimits({
            container: container,
            subject: subject,
            proposedScroll: required
        });
        if (!limited) return null;
        return $22db1ba098eb3017$var$isEqual(limited, $22db1ba098eb3017$var$origin) ? null : limited;
    };
    var $22db1ba098eb3017$var$smallestSigned = $22db1ba098eb3017$var$apply(function(value) {
        if (value === 0) return 0;
        return value > 0 ? 1 : -1;
    });
    var $22db1ba098eb3017$var$getOverlap = function() {
        var getRemainder = function getRemainder(target, max) {
            if (target < 0) return target;
            if (target > max) return target - max;
            return 0;
        };
        return function(_ref) {
            var current = _ref.current, max = _ref.max, change = _ref.change;
            var targetScroll = $22db1ba098eb3017$var$add(current, change);
            var overlap = {
                x: getRemainder(targetScroll.x, max.x),
                y: getRemainder(targetScroll.y, max.y)
            };
            if ($22db1ba098eb3017$var$isEqual(overlap, $22db1ba098eb3017$var$origin)) return null;
            return overlap;
        };
    }();
    var $22db1ba098eb3017$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
        var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
        var max = {
            x: Math.max(current.x, rawMax.x),
            y: Math.max(current.y, rawMax.y)
        };
        var smallestChange = $22db1ba098eb3017$var$smallestSigned(change);
        var overlap = $22db1ba098eb3017$var$getOverlap({
            max: max,
            current: current,
            change: smallestChange
        });
        if (!overlap) return true;
        if (smallestChange.x !== 0 && overlap.x === 0) return true;
        if (smallestChange.y !== 0 && overlap.y === 0) return true;
        return false;
    };
    var $22db1ba098eb3017$var$canScrollWindow = function canScrollWindow(viewport, change) {
        return $22db1ba098eb3017$var$canPartiallyScroll({
            current: viewport.scroll.current,
            max: viewport.scroll.max,
            change: change
        });
    };
    var $22db1ba098eb3017$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
        if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return null;
        var max = viewport.scroll.max;
        var current = viewport.scroll.current;
        return $22db1ba098eb3017$var$getOverlap({
            current: current,
            max: max,
            change: change
        });
    };
    var $22db1ba098eb3017$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
        var frame = droppable.frame;
        if (!frame) return false;
        return $22db1ba098eb3017$var$canPartiallyScroll({
            current: frame.scroll.current,
            max: frame.scroll.max,
            change: change
        });
    };
    var $22db1ba098eb3017$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
        var frame = droppable.frame;
        if (!frame) return null;
        if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return null;
        return $22db1ba098eb3017$var$getOverlap({
            current: frame.scroll.current,
            max: frame.scroll.max,
            change: change
        });
    };
    var $22db1ba098eb3017$var$getWindowScrollChange = function(_ref) {
        var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
        var scroll = $22db1ba098eb3017$var$getScroll({
            dragStartTime: dragStartTime,
            container: viewport.frame,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return scroll && $22db1ba098eb3017$var$canScrollWindow(viewport, scroll) ? scroll : null;
    };
    var $22db1ba098eb3017$var$getDroppableScrollChange = function(_ref) {
        var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
        var frame = droppable.frame;
        if (!frame) return null;
        var scroll = $22db1ba098eb3017$var$getScroll({
            dragStartTime: dragStartTime,
            container: frame.pageMarginBox,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return scroll && $22db1ba098eb3017$var$canScrollDroppable(droppable, scroll) ? scroll : null;
    };
    var $22db1ba098eb3017$var$scroll$1 = function(_ref) {
        var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
        var center = state.current.page.borderBoxCenter;
        var draggable = state.dimensions.draggables[state.critical.draggable.id];
        var subject = draggable.page.marginBox;
        if (state.isWindowScrollAllowed) {
            var viewport = state.viewport;
            var _change = $22db1ba098eb3017$var$getWindowScrollChange({
                dragStartTime: dragStartTime,
                viewport: viewport,
                subject: subject,
                center: center,
                shouldUseTimeDampening: shouldUseTimeDampening
            });
            if (_change) {
                scrollWindow(_change);
                return;
            }
        }
        var droppable = $22db1ba098eb3017$var$getBestScrollableDroppable({
            center: center,
            destination: $22db1ba098eb3017$var$whatIsDraggedOver(state.impact),
            droppables: state.dimensions.droppables
        });
        if (!droppable) return;
        var change = $22db1ba098eb3017$var$getDroppableScrollChange({
            dragStartTime: dragStartTime,
            droppable: droppable,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (change) scrollDroppable(droppable.descriptor.id, change);
    };
    var $22db1ba098eb3017$var$createFluidScroller = function(_ref) {
        var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
        var scheduleWindowScroll = (0, (0, parcelRequire("crAmF")).default)(scrollWindow);
        var scheduleDroppableScroll = (0, (0, parcelRequire("crAmF")).default)(scrollDroppable);
        var dragging = null;
        var tryScroll = function tryScroll(state) {
            !dragging && $22db1ba098eb3017$var$invariant(false);
            var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
            $22db1ba098eb3017$var$scroll$1({
                state: state,
                scrollWindow: scheduleWindowScroll,
                scrollDroppable: scheduleDroppableScroll,
                dragStartTime: dragStartTime,
                shouldUseTimeDampening: shouldUseTimeDampening
            });
        };
        var start$1 = function start$1(state) {
            $22db1ba098eb3017$var$start('starting fluid scroller');
            !!dragging && $22db1ba098eb3017$var$invariant(false);
            var dragStartTime = (0, ($parcel$interopDefault($3BSY2)))();
            var wasScrollNeeded = false;
            var fakeScrollCallback = function fakeScrollCallback() {
                wasScrollNeeded = true;
            };
            $22db1ba098eb3017$var$scroll$1({
                state: state,
                dragStartTime: 0,
                shouldUseTimeDampening: false,
                scrollWindow: fakeScrollCallback,
                scrollDroppable: fakeScrollCallback
            });
            dragging = {
                dragStartTime: dragStartTime,
                shouldUseTimeDampening: wasScrollNeeded
            };
            $22db1ba098eb3017$var$finish('starting fluid scroller');
            if (wasScrollNeeded) tryScroll(state);
        };
        var stop = function stop() {
            if (!dragging) return;
            scheduleWindowScroll.cancel();
            scheduleDroppableScroll.cancel();
            dragging = null;
        };
        return {
            start: start$1,
            stop: stop,
            scroll: tryScroll
        };
    };
    var $22db1ba098eb3017$var$createJumpScroller = function(_ref) {
        var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
        var moveByOffset = function moveByOffset(state, offset) {
            var client = $22db1ba098eb3017$var$add(state.current.client.selection, offset);
            move({
                client: client
            });
        };
        var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
            if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return change;
            var overlap = $22db1ba098eb3017$var$getDroppableOverlap(droppable, change);
            if (!overlap) {
                scrollDroppable(droppable.descriptor.id, change);
                return null;
            }
            var whatTheDroppableCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
            scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
            var remainder = $22db1ba098eb3017$var$subtract(change, whatTheDroppableCanScroll);
            return remainder;
        };
        var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
            if (!isWindowScrollAllowed) return change;
            if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return change;
            var overlap = $22db1ba098eb3017$var$getWindowOverlap(viewport, change);
            if (!overlap) {
                scrollWindow(change);
                return null;
            }
            var whatTheWindowCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
            scrollWindow(whatTheWindowCanScroll);
            var remainder = $22db1ba098eb3017$var$subtract(change, whatTheWindowCanScroll);
            return remainder;
        };
        var jumpScroller = function jumpScroller(state) {
            var request = state.scrollJumpRequest;
            if (!request) return;
            var destination = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
            !destination && $22db1ba098eb3017$var$invariant(false);
            var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
            if (!droppableRemainder) return;
            var viewport = state.viewport;
            var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
            if (!windowRemainder) return;
            moveByOffset(state, windowRemainder);
        };
        return jumpScroller;
    };
    var $22db1ba098eb3017$var$createAutoScroller = function(_ref) {
        var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
        var fluidScroller = $22db1ba098eb3017$var$createFluidScroller({
            scrollWindow: scrollWindow,
            scrollDroppable: scrollDroppable
        });
        var jumpScroll = $22db1ba098eb3017$var$createJumpScroller({
            move: move,
            scrollWindow: scrollWindow,
            scrollDroppable: scrollDroppable
        });
        var scroll = function scroll(state) {
            if (state.phase !== 'DRAGGING') return;
            if (state.movementMode === 'FLUID') {
                fluidScroller.scroll(state);
                return;
            }
            if (!state.scrollJumpRequest) return;
            jumpScroll(state);
        };
        var scroller = {
            scroll: scroll,
            start: fluidScroller.start,
            stop: fluidScroller.stop
        };
        return scroller;
    };
    var $22db1ba098eb3017$var$prefix$1 = 'data-rbd';
    var $22db1ba098eb3017$var$dragHandle = function() {
        var base = $22db1ba098eb3017$var$prefix$1 + "-drag-handle";
        return {
            base: base,
            draggableId: base + "-draggable-id",
            contextId: base + "-context-id"
        };
    }();
    var $22db1ba098eb3017$var$draggable = function() {
        var base = $22db1ba098eb3017$var$prefix$1 + "-draggable";
        return {
            base: base,
            contextId: base + "-context-id",
            id: base + "-id"
        };
    }();
    var $22db1ba098eb3017$var$droppable = function() {
        var base = $22db1ba098eb3017$var$prefix$1 + "-droppable";
        return {
            base: base,
            contextId: base + "-context-id",
            id: base + "-id"
        };
    }();
    var $22db1ba098eb3017$var$scrollContainer = {
        contextId: $22db1ba098eb3017$var$prefix$1 + "-scroll-container-context-id"
    };
    var $22db1ba098eb3017$var$makeGetSelector = function makeGetSelector(context) {
        return function(attribute) {
            return "[" + attribute + "=\"" + context + "\"]";
        };
    };
    var $22db1ba098eb3017$var$getStyles = function getStyles(rules, property) {
        return rules.map(function(rule) {
            var value = rule.styles[property];
            if (!value) return '';
            return rule.selector + " { " + value + " }";
        }).join(' ');
    };
    var $22db1ba098eb3017$var$noPointerEvents = 'pointer-events: none;';
    var $22db1ba098eb3017$var$getStyles$1 = function(contextId) {
        var getSelector = $22db1ba098eb3017$var$makeGetSelector(contextId);
        var dragHandle$1 = function() {
            var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
            return {
                selector: getSelector($22db1ba098eb3017$var$dragHandle.contextId),
                styles: {
                    always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                    resting: grabCursor,
                    dragging: $22db1ba098eb3017$var$noPointerEvents,
                    dropAnimating: grabCursor
                }
            };
        }();
        var draggable$1 = function() {
            var transition = "\n      transition: " + $22db1ba098eb3017$var$transitions.outOfTheWay + ";\n    ";
            return {
                selector: getSelector($22db1ba098eb3017$var$draggable.contextId),
                styles: {
                    dragging: transition,
                    dropAnimating: transition,
                    userCancel: transition
                }
            };
        }();
        var droppable$1 = {
            selector: getSelector($22db1ba098eb3017$var$droppable.contextId),
            styles: {
                always: "overflow-anchor: none;"
            }
        };
        var body = {
            selector: 'body',
            styles: {
                dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
            }
        };
        var rules = [
            draggable$1,
            dragHandle$1,
            droppable$1,
            body
        ];
        return {
            always: $22db1ba098eb3017$var$getStyles(rules, 'always'),
            resting: $22db1ba098eb3017$var$getStyles(rules, 'resting'),
            dragging: $22db1ba098eb3017$var$getStyles(rules, 'dragging'),
            dropAnimating: $22db1ba098eb3017$var$getStyles(rules, 'dropAnimating'),
            userCancel: $22db1ba098eb3017$var$getStyles(rules, 'userCancel')
        };
    };
    var $22db1ba098eb3017$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);
    var $22db1ba098eb3017$var$getHead = function getHead() {
        var head = document.querySelector('head');
        !head && $22db1ba098eb3017$var$invariant(false);
        return head;
    };
    var $22db1ba098eb3017$var$createStyleEl = function createStyleEl(nonce) {
        var el = document.createElement('style');
        if (nonce) el.setAttribute('nonce', nonce);
        el.type = 'text/css';
        return el;
    };
    function $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce) {
        var styles = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return $22db1ba098eb3017$var$getStyles$1(contextId);
        }, [
            contextId
        ]);
        var alwaysRef = (0, $5uXOq.useRef)(null);
        var dynamicRef = (0, $5uXOq.useRef)(null);
        var setDynamicStyle = (0, (0, parcelRequire("3YMLK")).useCallback)((0, (0, parcelRequire("g7psY")).default)(function(proposed) {
            var el = dynamicRef.current;
            !el && $22db1ba098eb3017$var$invariant(false);
            el.textContent = proposed;
        }), []);
        var setAlwaysStyle = (0, (0, parcelRequire("3YMLK")).useCallback)(function(proposed) {
            var el = alwaysRef.current;
            !el && $22db1ba098eb3017$var$invariant(false);
            el.textContent = proposed;
        }, []);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            !(!alwaysRef.current && !dynamicRef.current) && $22db1ba098eb3017$var$invariant(false);
            var always = $22db1ba098eb3017$var$createStyleEl(nonce);
            var dynamic = $22db1ba098eb3017$var$createStyleEl(nonce);
            alwaysRef.current = always;
            dynamicRef.current = dynamic;
            always.setAttribute($22db1ba098eb3017$var$prefix$1 + "-always", contextId);
            dynamic.setAttribute($22db1ba098eb3017$var$prefix$1 + "-dynamic", contextId);
            $22db1ba098eb3017$var$getHead().appendChild(always);
            $22db1ba098eb3017$var$getHead().appendChild(dynamic);
            setAlwaysStyle(styles.always);
            setDynamicStyle(styles.resting);
            return function() {
                var remove = function remove(ref) {
                    var current = ref.current;
                    !current && $22db1ba098eb3017$var$invariant(false);
                    $22db1ba098eb3017$var$getHead().removeChild(current);
                    ref.current = null;
                };
                remove(alwaysRef);
                remove(dynamicRef);
            };
        }, [
            nonce,
            setAlwaysStyle,
            setDynamicStyle,
            styles.always,
            styles.resting,
            contextId
        ]);
        var dragging = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            return setDynamicStyle(styles.dragging);
        }, [
            setDynamicStyle,
            styles.dragging
        ]);
        var dropping = (0, (0, parcelRequire("3YMLK")).useCallback)(function(reason) {
            if (reason === 'DROP') {
                setDynamicStyle(styles.dropAnimating);
                return;
            }
            setDynamicStyle(styles.userCancel);
        }, [
            setDynamicStyle,
            styles.dropAnimating,
            styles.userCancel
        ]);
        var resting = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            if (!dynamicRef.current) return;
            setDynamicStyle(styles.resting);
        }, [
            setDynamicStyle,
            styles.resting
        ]);
        var marshal = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                dragging: dragging,
                dropping: dropping,
                resting: resting
            };
        }, [
            dragging,
            dropping,
            resting
        ]);
        return marshal;
    }
    var $22db1ba098eb3017$var$getWindowFromEl = function(el) {
        return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
    };
    function $22db1ba098eb3017$var$isHtmlElement(el) {
        return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).HTMLElement;
    }
    function $22db1ba098eb3017$var$findDragHandle(contextId, draggableId) {
        var selector = "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
        var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
        if (!possible.length) return null;
        var handle = $22db1ba098eb3017$var$find(possible, function(el) {
            return el.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) === draggableId;
        });
        if (!handle) return null;
        if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
        return handle;
    }
    function $22db1ba098eb3017$var$useFocusMarshal(contextId) {
        var entriesRef = (0, $5uXOq.useRef)({});
        var recordRef = (0, $5uXOq.useRef)(null);
        var restoreFocusFrameRef = (0, $5uXOq.useRef)(null);
        var isMountedRef = (0, $5uXOq.useRef)(false);
        var register = (0, (0, parcelRequire("3YMLK")).useCallback)(function register(id, focus) {
            var entry = {
                id: id,
                focus: focus
            };
            entriesRef.current[id] = entry;
            return function unregister() {
                var entries = entriesRef.current;
                var current = entries[id];
                if (current !== entry) delete entries[id];
            };
        }, []);
        var tryGiveFocus = (0, (0, parcelRequire("3YMLK")).useCallback)(function tryGiveFocus(tryGiveFocusTo) {
            var handle = $22db1ba098eb3017$var$findDragHandle(contextId, tryGiveFocusTo);
            if (handle && handle !== document.activeElement) handle.focus();
        }, [
            contextId
        ]);
        var tryShiftRecord = (0, (0, parcelRequire("3YMLK")).useCallback)(function tryShiftRecord(previous, redirectTo) {
            if (recordRef.current === previous) recordRef.current = redirectTo;
        }, []);
        var tryRestoreFocusRecorded = (0, (0, parcelRequire("3YMLK")).useCallback)(function tryRestoreFocusRecorded() {
            if (restoreFocusFrameRef.current) return;
            if (!isMountedRef.current) return;
            restoreFocusFrameRef.current = requestAnimationFrame(function() {
                restoreFocusFrameRef.current = null;
                var record = recordRef.current;
                if (record) tryGiveFocus(record);
            });
        }, [
            tryGiveFocus
        ]);
        var tryRecordFocus = (0, (0, parcelRequire("3YMLK")).useCallback)(function tryRecordFocus(id) {
            recordRef.current = null;
            var focused = document.activeElement;
            if (!focused) return;
            if (focused.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) !== id) return;
            recordRef.current = id;
        }, []);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            isMountedRef.current = true;
            return function clearFrameOnUnmount() {
                isMountedRef.current = false;
                var frameId = restoreFocusFrameRef.current;
                if (frameId) cancelAnimationFrame(frameId);
            };
        }, []);
        var marshal = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                register: register,
                tryRecordFocus: tryRecordFocus,
                tryRestoreFocusRecorded: tryRestoreFocusRecorded,
                tryShiftRecord: tryShiftRecord
            };
        }, [
            register,
            tryRecordFocus,
            tryRestoreFocusRecorded,
            tryShiftRecord
        ]);
        return marshal;
    }
    function $22db1ba098eb3017$var$createRegistry() {
        var entries = {
            draggables: {},
            droppables: {}
        };
        var subscribers = [];
        function subscribe(cb) {
            subscribers.push(cb);
            return function unsubscribe() {
                var index = subscribers.indexOf(cb);
                if (index === -1) return;
                subscribers.splice(index, 1);
            };
        }
        function notify(event) {
            if (subscribers.length) subscribers.forEach(function(cb) {
                return cb(event);
            });
        }
        function findDraggableById(id) {
            return entries.draggables[id] || null;
        }
        function getDraggableById(id) {
            var entry = findDraggableById(id);
            !entry && $22db1ba098eb3017$var$invariant(false);
            return entry;
        }
        var draggableAPI = {
            register: function register(entry) {
                entries.draggables[entry.descriptor.id] = entry;
                notify({
                    type: 'ADDITION',
                    value: entry
                });
            },
            update: function update(entry, last) {
                var current = entries.draggables[last.descriptor.id];
                if (!current) return;
                if (current.uniqueId !== entry.uniqueId) return;
                delete entries.draggables[last.descriptor.id];
                entries.draggables[entry.descriptor.id] = entry;
            },
            unregister: function unregister(entry) {
                var draggableId = entry.descriptor.id;
                var current = findDraggableById(draggableId);
                if (!current) return;
                if (entry.uniqueId !== current.uniqueId) return;
                delete entries.draggables[draggableId];
                notify({
                    type: 'REMOVAL',
                    value: entry
                });
            },
            getById: getDraggableById,
            findById: findDraggableById,
            exists: function exists(id) {
                return Boolean(findDraggableById(id));
            },
            getAllByType: function getAllByType(type) {
                return $22db1ba098eb3017$var$values(entries.draggables).filter(function(entry) {
                    return entry.descriptor.type === type;
                });
            }
        };
        function findDroppableById(id) {
            return entries.droppables[id] || null;
        }
        function getDroppableById(id) {
            var entry = findDroppableById(id);
            !entry && $22db1ba098eb3017$var$invariant(false);
            return entry;
        }
        var droppableAPI = {
            register: function register(entry) {
                entries.droppables[entry.descriptor.id] = entry;
            },
            unregister: function unregister(entry) {
                var current = findDroppableById(entry.descriptor.id);
                if (!current) return;
                if (entry.uniqueId !== current.uniqueId) return;
                delete entries.droppables[entry.descriptor.id];
            },
            getById: getDroppableById,
            findById: findDroppableById,
            exists: function exists(id) {
                return Boolean(findDroppableById(id));
            },
            getAllByType: function getAllByType(type) {
                return $22db1ba098eb3017$var$values(entries.droppables).filter(function(entry) {
                    return entry.descriptor.type === type;
                });
            }
        };
        function clean() {
            entries.draggables = {};
            entries.droppables = {};
            subscribers.length = 0;
        }
        return {
            draggable: draggableAPI,
            droppable: droppableAPI,
            subscribe: subscribe,
            clean: clean
        };
    }
    function $22db1ba098eb3017$var$useRegistry() {
        var registry = (0, (0, parcelRequire("3YMLK")).useMemo)($22db1ba098eb3017$var$createRegistry, []);
        (0, $5uXOq.useEffect)(function() {
            return function unmount() {
                requestAnimationFrame(registry.clean);
            };
        }, [
            registry
        ]);
        return registry;
    }
    var $22db1ba098eb3017$var$StoreContext = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    var $22db1ba098eb3017$var$getBodyElement = function() {
        var body = document.body;
        !body && $22db1ba098eb3017$var$invariant(false);
        return body;
    };
    var $22db1ba098eb3017$var$visuallyHidden = {
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        border: '0',
        padding: '0',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        'clip-path': 'inset(100%)'
    };
    var $22db1ba098eb3017$var$getId = function getId(contextId) {
        return "rbd-announcement-" + contextId;
    };
    function $22db1ba098eb3017$var$useAnnouncer(contextId) {
        var id = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return $22db1ba098eb3017$var$getId(contextId);
        }, [
            contextId
        ]);
        var ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(function setup() {
            var el = document.createElement('div');
            ref.current = el;
            el.id = id;
            el.setAttribute('aria-live', 'assertive');
            el.setAttribute('role', 'log');
            el.setAttribute('aria-atomic', 'true');
            (0, ($parcel$interopDefault($4iZOV)))(el.style, $22db1ba098eb3017$var$visuallyHidden);
            $22db1ba098eb3017$var$getBodyElement().appendChild(el);
            return function cleanup() {
                setTimeout(function remove() {
                    $22db1ba098eb3017$var$getBodyElement().removeChild(el);
                    if (el === ref.current) ref.current = null;
                });
            };
        }, [
            id
        ]);
        var announce = (0, (0, parcelRequire("3YMLK")).useCallback)(function(message) {
            var el = ref.current;
            if (el) {
                el.textContent = message;
                return;
            }
        }, []);
        return announce;
    }
    var $22db1ba098eb3017$var$getId$1 = function getId(contextId) {
        return "rbd-lift-instruction-" + contextId;
    };
    function $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction) {
        var id = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return $22db1ba098eb3017$var$getId$1(contextId);
        }, [
            contextId
        ]);
        (0, $5uXOq.useEffect)(function mount() {
            var el = document.createElement('div');
            el.id = id;
            el.textContent = liftInstruction;
            (0, ($parcel$interopDefault($4iZOV)))(el.style, {
                display: 'none'
            });
            $22db1ba098eb3017$var$getBodyElement().appendChild(el);
            return function unmount() {
                $22db1ba098eb3017$var$getBodyElement().removeChild(el);
            };
        }, [
            id,
            liftInstruction
        ]);
        return id;
    }
    var $22db1ba098eb3017$var$AppContext = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    var $22db1ba098eb3017$var$peerDependencies = {
        react: "^16.8.5",
        "react-dom": "^16.8.5"
    };
    var $22db1ba098eb3017$var$semver = /(\d+)\.(\d+)\.(\d+)/;
    var $22db1ba098eb3017$var$getVersion = function getVersion(value) {
        var result = $22db1ba098eb3017$var$semver.exec(value);
        !(result != null) && $22db1ba098eb3017$var$invariant(false);
        var major = Number(result[1]);
        var minor = Number(result[2]);
        var patch = Number(result[3]);
        return {
            major: major,
            minor: minor,
            patch: patch,
            raw: value
        };
    };
    var $22db1ba098eb3017$var$isSatisfied = function isSatisfied(expected, actual) {
        if (actual.major > expected.major) return true;
        if (actual.major < expected.major) return false;
        if (actual.minor > expected.minor) return true;
        if (actual.minor < expected.minor) return false;
        return actual.patch >= expected.patch;
    };
    var $22db1ba098eb3017$var$checkReactVersion = function(peerDepValue, actualValue) {
        var peerDep = $22db1ba098eb3017$var$getVersion(peerDepValue);
        var actual = $22db1ba098eb3017$var$getVersion(actualValue);
        if ($22db1ba098eb3017$var$isSatisfied(peerDep, actual)) return;
    };
    var $22db1ba098eb3017$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
    var $22db1ba098eb3017$var$checkDoctype = function(doc) {
        var doctype = doc.doctype;
        if (!doctype) return;
        doctype.name.toLowerCase();
        doctype.publicId;
    };
    function $22db1ba098eb3017$var$useDev(useHook) {}
    function $22db1ba098eb3017$var$useDevSetupWarning(fn, inputs) {
        $22db1ba098eb3017$var$useDev(function() {
            (0, $5uXOq.useEffect)(function() {
                try {
                    fn();
                } catch (e) {
                    $22db1ba098eb3017$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
                }
            }, inputs);
        });
    }
    function $22db1ba098eb3017$var$useStartupValidation() {
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            $22db1ba098eb3017$var$checkReactVersion($22db1ba098eb3017$var$peerDependencies.react, (0, ($parcel$interopDefault($5uXOq))).version);
            $22db1ba098eb3017$var$checkDoctype(document);
        }, []);
    }
    function $22db1ba098eb3017$var$usePrevious(current) {
        var ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(function() {
            ref.current = current;
        });
        return ref;
    }
    function $22db1ba098eb3017$var$create() {
        var lock = null;
        function isClaimed() {
            return Boolean(lock);
        }
        function isActive(value) {
            return value === lock;
        }
        function claim(abandon) {
            !!lock && $22db1ba098eb3017$var$invariant(false);
            var newLock = {
                abandon: abandon
            };
            lock = newLock;
            return newLock;
        }
        function release() {
            !lock && $22db1ba098eb3017$var$invariant(false);
            lock = null;
        }
        function tryAbandon() {
            if (lock) {
                lock.abandon();
                release();
            }
        }
        return {
            isClaimed: isClaimed,
            isActive: isActive,
            claim: claim,
            release: release,
            tryAbandon: tryAbandon
        };
    }
    var $22db1ba098eb3017$var$tab = 9;
    var $22db1ba098eb3017$var$enter = 13;
    var $22db1ba098eb3017$var$escape = 27;
    var $22db1ba098eb3017$var$space = 32;
    var $22db1ba098eb3017$var$pageUp = 33;
    var $22db1ba098eb3017$var$pageDown = 34;
    var $22db1ba098eb3017$var$end = 35;
    var $22db1ba098eb3017$var$home = 36;
    var $22db1ba098eb3017$var$arrowLeft = 37;
    var $22db1ba098eb3017$var$arrowUp = 38;
    var $22db1ba098eb3017$var$arrowRight = 39;
    var $22db1ba098eb3017$var$arrowDown = 40;
    var $22db1ba098eb3017$var$_preventedKeys;
    var $22db1ba098eb3017$var$preventedKeys = ($22db1ba098eb3017$var$_preventedKeys = {}, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$enter] = true, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$tab] = true, $22db1ba098eb3017$var$_preventedKeys);
    var $22db1ba098eb3017$var$preventStandardKeyEvents = function(event) {
        if ($22db1ba098eb3017$var$preventedKeys[event.keyCode]) event.preventDefault();
    };
    var $22db1ba098eb3017$var$supportedEventName = function() {
        var base = 'visibilitychange';
        if (typeof document === 'undefined') return base;
        var candidates = [
            base,
            "ms" + base,
            "webkit" + base,
            "moz" + base,
            "o" + base
        ];
        var supported = $22db1ba098eb3017$var$find(candidates, function(eventName) {
            return "on" + eventName in document;
        });
        return supported || base;
    }();
    var $22db1ba098eb3017$var$primaryButton = 0;
    var $22db1ba098eb3017$var$sloppyClickThreshold = 5;
    function $22db1ba098eb3017$var$isSloppyClickThresholdExceeded(original, current) {
        return Math.abs(current.x - original.x) >= $22db1ba098eb3017$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $22db1ba098eb3017$var$sloppyClickThreshold;
    }
    var $22db1ba098eb3017$var$idle$1 = {
        type: 'IDLE'
    };
    function $22db1ba098eb3017$var$getCaptureBindings(_ref) {
        var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
        return [
            {
                eventName: 'mousemove',
                fn: function fn(event) {
                    var button = event.button, clientX = event.clientX, clientY = event.clientY;
                    if (button !== $22db1ba098eb3017$var$primaryButton) return;
                    var point = {
                        x: clientX,
                        y: clientY
                    };
                    var phase = getPhase();
                    if (phase.type === 'DRAGGING') {
                        event.preventDefault();
                        phase.actions.move(point);
                        return;
                    }
                    !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
                    var pending = phase.point;
                    if (!$22db1ba098eb3017$var$isSloppyClickThresholdExceeded(pending, point)) return;
                    event.preventDefault();
                    var actions = phase.actions.fluidLift(point);
                    setPhase({
                        type: 'DRAGGING',
                        actions: actions
                    });
                }
            },
            {
                eventName: 'mouseup',
                fn: function fn(event) {
                    var phase = getPhase();
                    if (phase.type !== 'DRAGGING') {
                        cancel();
                        return;
                    }
                    event.preventDefault();
                    phase.actions.drop({
                        shouldBlockNextClick: true
                    });
                    completed();
                }
            },
            {
                eventName: 'mousedown',
                fn: function fn(event) {
                    if (getPhase().type === 'DRAGGING') event.preventDefault();
                    cancel();
                }
            },
            {
                eventName: 'keydown',
                fn: function fn(event) {
                    var phase = getPhase();
                    if (phase.type === 'PENDING') {
                        cancel();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$escape) {
                        event.preventDefault();
                        cancel();
                        return;
                    }
                    $22db1ba098eb3017$var$preventStandardKeyEvents(event);
                }
            },
            {
                eventName: 'resize',
                fn: cancel
            },
            {
                eventName: 'scroll',
                options: {
                    passive: true,
                    capture: false
                },
                fn: function fn() {
                    if (getPhase().type === 'PENDING') cancel();
                }
            },
            {
                eventName: 'webkitmouseforcedown',
                fn: function fn(event) {
                    var phase = getPhase();
                    !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                    if (phase.actions.shouldRespectForcePress()) {
                        cancel();
                        return;
                    }
                    event.preventDefault();
                }
            },
            {
                eventName: $22db1ba098eb3017$var$supportedEventName,
                fn: cancel
            }
        ];
    }
    function $22db1ba098eb3017$var$useMouseSensor(api) {
        var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$1);
        var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
        var startCaptureBinding = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                eventName: 'mousedown',
                fn: function onMouseDown(event) {
                    if (event.defaultPrevented) return;
                    if (event.button !== $22db1ba098eb3017$var$primaryButton) return;
                    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                    var draggableId = api.findClosestDraggableId(event);
                    if (!draggableId) return;
                    var actions = api.tryGetLock(draggableId, stop, {
                        sourceEvent: event
                    });
                    if (!actions) return;
                    event.preventDefault();
                    var point = {
                        x: event.clientX,
                        y: event.clientY
                    };
                    unbindEventsRef.current();
                    startPendingDrag(actions, point);
                }
            };
        }, [
            api
        ]);
        var preventForcePressBinding = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                eventName: 'webkitmouseforcewillbegin',
                fn: function fn(event) {
                    if (event.defaultPrevented) return;
                    var id = api.findClosestDraggableId(event);
                    if (!id) return;
                    var options = api.findOptionsForDraggable(id);
                    if (!options) return;
                    if (options.shouldRespectForcePress) return;
                    if (!api.canGetLock(id)) return;
                    event.preventDefault();
                }
            };
        }, [
            api
        ]);
        var listenForCapture = (0, (0, parcelRequire("3YMLK")).useCallback)(function listenForCapture() {
            var options = {
                passive: false,
                capture: true
            };
            unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
                preventForcePressBinding,
                startCaptureBinding
            ], options);
        }, [
            preventForcePressBinding,
            startCaptureBinding
        ]);
        var stop = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var current = phaseRef.current;
            if (current.type === 'IDLE') return;
            phaseRef.current = $22db1ba098eb3017$var$idle$1;
            unbindEventsRef.current();
            listenForCapture();
        }, [
            listenForCapture
        ]);
        var cancel = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var phase = phaseRef.current;
            stop();
            if (phase.type === 'DRAGGING') phase.actions.cancel({
                shouldBlockNextClick: true
            });
            if (phase.type === 'PENDING') phase.actions.abort();
        }, [
            stop
        ]);
        var bindCapturingEvents = (0, (0, parcelRequire("3YMLK")).useCallback)(function bindCapturingEvents() {
            var options = {
                capture: true,
                passive: false
            };
            var bindings = $22db1ba098eb3017$var$getCaptureBindings({
                cancel: cancel,
                completed: stop,
                getPhase: function getPhase() {
                    return phaseRef.current;
                },
                setPhase: function setPhase(phase) {
                    phaseRef.current = phase;
                }
            });
            unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, bindings, options);
        }, [
            cancel,
            stop
        ]);
        var startPendingDrag = (0, (0, parcelRequire("3YMLK")).useCallback)(function startPendingDrag(actions, point) {
            !(phaseRef.current.type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
            phaseRef.current = {
                type: 'PENDING',
                point: point,
                actions: actions
            };
            bindCapturingEvents();
        }, [
            bindCapturingEvents
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
            listenForCapture();
            return function unmount() {
                unbindEventsRef.current();
            };
        }, [
            listenForCapture
        ]);
    }
    var $22db1ba098eb3017$var$_scrollJumpKeys;
    function $22db1ba098eb3017$var$noop$1() {}
    var $22db1ba098eb3017$var$scrollJumpKeys = ($22db1ba098eb3017$var$_scrollJumpKeys = {}, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageDown] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageUp] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$home] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$end] = true, $22db1ba098eb3017$var$_scrollJumpKeys);
    function $22db1ba098eb3017$var$getDraggingBindings(actions, stop) {
        function cancel() {
            stop();
            actions.cancel();
        }
        function drop() {
            stop();
            actions.drop();
        }
        return [
            {
                eventName: 'keydown',
                fn: function fn(event) {
                    if (event.keyCode === $22db1ba098eb3017$var$escape) {
                        event.preventDefault();
                        cancel();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$space) {
                        event.preventDefault();
                        drop();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$arrowDown) {
                        event.preventDefault();
                        actions.moveDown();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$arrowUp) {
                        event.preventDefault();
                        actions.moveUp();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$arrowRight) {
                        event.preventDefault();
                        actions.moveRight();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$arrowLeft) {
                        event.preventDefault();
                        actions.moveLeft();
                        return;
                    }
                    if ($22db1ba098eb3017$var$scrollJumpKeys[event.keyCode]) {
                        event.preventDefault();
                        return;
                    }
                    $22db1ba098eb3017$var$preventStandardKeyEvents(event);
                }
            },
            {
                eventName: 'mousedown',
                fn: cancel
            },
            {
                eventName: 'mouseup',
                fn: cancel
            },
            {
                eventName: 'click',
                fn: cancel
            },
            {
                eventName: 'touchstart',
                fn: cancel
            },
            {
                eventName: 'resize',
                fn: cancel
            },
            {
                eventName: 'wheel',
                fn: cancel,
                options: {
                    passive: true
                }
            },
            {
                eventName: $22db1ba098eb3017$var$supportedEventName,
                fn: cancel
            }
        ];
    }
    function $22db1ba098eb3017$var$useKeyboardSensor(api) {
        var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop$1);
        var startCaptureBinding = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                eventName: 'keydown',
                fn: function onKeyDown(event) {
                    if (event.defaultPrevented) return;
                    if (event.keyCode !== $22db1ba098eb3017$var$space) return;
                    var draggableId = api.findClosestDraggableId(event);
                    if (!draggableId) return;
                    var preDrag = api.tryGetLock(draggableId, stop, {
                        sourceEvent: event
                    });
                    if (!preDrag) return;
                    event.preventDefault();
                    var isCapturing = true;
                    var actions = preDrag.snapLift();
                    unbindEventsRef.current();
                    function stop() {
                        !isCapturing && $22db1ba098eb3017$var$invariant(false);
                        isCapturing = false;
                        unbindEventsRef.current();
                        listenForCapture();
                    }
                    unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getDraggingBindings(actions, stop), {
                        capture: true,
                        passive: false
                    });
                }
            };
        }, [
            api
        ]);
        var listenForCapture = (0, (0, parcelRequire("3YMLK")).useCallback)(function tryStartCapture() {
            var options = {
                passive: false,
                capture: true
            };
            unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
                startCaptureBinding
            ], options);
        }, [
            startCaptureBinding
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
            listenForCapture();
            return function unmount() {
                unbindEventsRef.current();
            };
        }, [
            listenForCapture
        ]);
    }
    var $22db1ba098eb3017$var$idle$2 = {
        type: 'IDLE'
    };
    var $22db1ba098eb3017$var$timeForLongPress = 120;
    var $22db1ba098eb3017$var$forcePressThreshold = 0.15;
    function $22db1ba098eb3017$var$getWindowBindings(_ref) {
        var cancel = _ref.cancel, getPhase = _ref.getPhase;
        return [
            {
                eventName: 'orientationchange',
                fn: cancel
            },
            {
                eventName: 'resize',
                fn: cancel
            },
            {
                eventName: 'contextmenu',
                fn: function fn(event) {
                    event.preventDefault();
                }
            },
            {
                eventName: 'keydown',
                fn: function fn(event) {
                    if (getPhase().type !== 'DRAGGING') {
                        cancel();
                        return;
                    }
                    if (event.keyCode === $22db1ba098eb3017$var$escape) event.preventDefault();
                    cancel();
                }
            },
            {
                eventName: $22db1ba098eb3017$var$supportedEventName,
                fn: cancel
            }
        ];
    }
    function $22db1ba098eb3017$var$getHandleBindings(_ref2) {
        var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
        return [
            {
                eventName: 'touchmove',
                options: {
                    capture: false
                },
                fn: function fn(event) {
                    var phase = getPhase();
                    if (phase.type !== 'DRAGGING') {
                        cancel();
                        return;
                    }
                    phase.hasMoved = true;
                    var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                    var point = {
                        x: clientX,
                        y: clientY
                    };
                    event.preventDefault();
                    phase.actions.move(point);
                }
            },
            {
                eventName: 'touchend',
                fn: function fn(event) {
                    var phase = getPhase();
                    if (phase.type !== 'DRAGGING') {
                        cancel();
                        return;
                    }
                    event.preventDefault();
                    phase.actions.drop({
                        shouldBlockNextClick: true
                    });
                    completed();
                }
            },
            {
                eventName: 'touchcancel',
                fn: function fn(event) {
                    if (getPhase().type !== 'DRAGGING') {
                        cancel();
                        return;
                    }
                    event.preventDefault();
                    cancel();
                }
            },
            {
                eventName: 'touchforcechange',
                fn: function fn(event) {
                    var phase = getPhase();
                    !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                    var touch = event.touches[0];
                    if (!touch) return;
                    var isForcePress = touch.force >= $22db1ba098eb3017$var$forcePressThreshold;
                    if (!isForcePress) return;
                    var shouldRespect = phase.actions.shouldRespectForcePress();
                    if (phase.type === 'PENDING') {
                        if (shouldRespect) cancel();
                        return;
                    }
                    if (shouldRespect) {
                        if (phase.hasMoved) {
                            event.preventDefault();
                            return;
                        }
                        cancel();
                        return;
                    }
                    event.preventDefault();
                }
            },
            {
                eventName: $22db1ba098eb3017$var$supportedEventName,
                fn: cancel
            }
        ];
    }
    function $22db1ba098eb3017$var$useMouseSensor$1(api) {
        var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$2);
        var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
        var getPhase = (0, (0, parcelRequire("3YMLK")).useCallback)(function getPhase() {
            return phaseRef.current;
        }, []);
        var setPhase = (0, (0, parcelRequire("3YMLK")).useCallback)(function setPhase(phase) {
            phaseRef.current = phase;
        }, []);
        var startCaptureBinding = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                eventName: 'touchstart',
                fn: function onTouchStart(event) {
                    if (event.defaultPrevented) return;
                    var draggableId = api.findClosestDraggableId(event);
                    if (!draggableId) return;
                    var actions = api.tryGetLock(draggableId, stop, {
                        sourceEvent: event
                    });
                    if (!actions) return;
                    var touch = event.touches[0];
                    var clientX = touch.clientX, clientY = touch.clientY;
                    var point = {
                        x: clientX,
                        y: clientY
                    };
                    unbindEventsRef.current();
                    startPendingDrag(actions, point);
                }
            };
        }, [
            api
        ]);
        var listenForCapture = (0, (0, parcelRequire("3YMLK")).useCallback)(function listenForCapture() {
            var options = {
                capture: true,
                passive: false
            };
            unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
                startCaptureBinding
            ], options);
        }, [
            startCaptureBinding
        ]);
        var stop = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var current = phaseRef.current;
            if (current.type === 'IDLE') return;
            if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
            setPhase($22db1ba098eb3017$var$idle$2);
            unbindEventsRef.current();
            listenForCapture();
        }, [
            listenForCapture,
            setPhase
        ]);
        var cancel = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var phase = phaseRef.current;
            stop();
            if (phase.type === 'DRAGGING') phase.actions.cancel({
                shouldBlockNextClick: true
            });
            if (phase.type === 'PENDING') phase.actions.abort();
        }, [
            stop
        ]);
        var bindCapturingEvents = (0, (0, parcelRequire("3YMLK")).useCallback)(function bindCapturingEvents() {
            var options = {
                capture: true,
                passive: false
            };
            var args = {
                cancel: cancel,
                completed: stop,
                getPhase: getPhase
            };
            var unbindTarget = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getHandleBindings(args), options);
            var unbindWindow = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getWindowBindings(args), options);
            unbindEventsRef.current = function unbindAll() {
                unbindTarget();
                unbindWindow();
            };
        }, [
            cancel,
            getPhase,
            stop
        ]);
        var startDragging = (0, (0, parcelRequire("3YMLK")).useCallback)(function startDragging() {
            var phase = getPhase();
            !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
            var actions = phase.actions.fluidLift(phase.point);
            setPhase({
                type: 'DRAGGING',
                actions: actions,
                hasMoved: false
            });
        }, [
            getPhase,
            setPhase
        ]);
        var startPendingDrag = (0, (0, parcelRequire("3YMLK")).useCallback)(function startPendingDrag(actions, point) {
            !(getPhase().type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
            var longPressTimerId = setTimeout(startDragging, $22db1ba098eb3017$var$timeForLongPress);
            setPhase({
                type: 'PENDING',
                point: point,
                actions: actions,
                longPressTimerId: longPressTimerId
            });
            bindCapturingEvents();
        }, [
            bindCapturingEvents,
            getPhase,
            setPhase,
            startDragging
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
            listenForCapture();
            return function unmount() {
                unbindEventsRef.current();
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    clearTimeout(phase.longPressTimerId);
                    setPhase($22db1ba098eb3017$var$idle$2);
                }
            };
        }, [
            getPhase,
            listenForCapture,
            setPhase
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function webkitHack() {
            var unbind = $22db1ba098eb3017$var$bindEvents(window, [
                {
                    eventName: 'touchmove',
                    fn: function fn() {},
                    options: {
                        capture: false,
                        passive: false
                    }
                }
            ]);
            return unbind;
        }, []);
    }
    function $22db1ba098eb3017$var$useValidateSensorHooks(sensorHooks) {
        $22db1ba098eb3017$var$useDev(function() {
            var previousRef = $22db1ba098eb3017$var$usePrevious(sensorHooks);
            $22db1ba098eb3017$var$useDevSetupWarning(function() {
                !(previousRef.current.length === sensorHooks.length) && $22db1ba098eb3017$var$invariant(false);
            });
        });
    }
    var $22db1ba098eb3017$var$interactiveTagNames = {
        input: true,
        button: true,
        textarea: true,
        select: true,
        option: true,
        optgroup: true,
        video: true,
        audio: true
    };
    function $22db1ba098eb3017$var$isAnInteractiveElement(parent, current) {
        if (current == null) return false;
        var hasAnInteractiveTag = Boolean($22db1ba098eb3017$var$interactiveTagNames[current.tagName.toLowerCase()]);
        if (hasAnInteractiveTag) return true;
        var attribute = current.getAttribute('contenteditable');
        if (attribute === 'true' || attribute === '') return true;
        if (current === parent) return false;
        return $22db1ba098eb3017$var$isAnInteractiveElement(parent, current.parentElement);
    }
    function $22db1ba098eb3017$var$isEventInInteractiveElement(draggable, event) {
        var target = event.target;
        if (!$22db1ba098eb3017$var$isHtmlElement(target)) return false;
        return $22db1ba098eb3017$var$isAnInteractiveElement(draggable, target);
    }
    var $22db1ba098eb3017$var$getBorderBoxCenterPosition = function(el) {
        return (0, (0, parcelRequire("3YKxB")).getRect)(el.getBoundingClientRect()).center;
    };
    function $22db1ba098eb3017$var$isElement(el) {
        return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).Element;
    }
    var $22db1ba098eb3017$var$supportedMatchesName = function() {
        var base = 'matches';
        if (typeof document === 'undefined') return base;
        var candidates = [
            base,
            'msMatchesSelector',
            'webkitMatchesSelector'
        ];
        var value = $22db1ba098eb3017$var$find(candidates, function(name) {
            return name in Element.prototype;
        });
        return value || base;
    }();
    function $22db1ba098eb3017$var$closestPonyfill(el, selector) {
        if (el == null) return null;
        if (el[$22db1ba098eb3017$var$supportedMatchesName](selector)) return el;
        return $22db1ba098eb3017$var$closestPonyfill(el.parentElement, selector);
    }
    function $22db1ba098eb3017$var$closest$1(el, selector) {
        if (el.closest) return el.closest(selector);
        return $22db1ba098eb3017$var$closestPonyfill(el, selector);
    }
    function $22db1ba098eb3017$var$getSelector(contextId) {
        return "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    }
    function $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event) {
        var target = event.target;
        if (!$22db1ba098eb3017$var$isElement(target)) return null;
        var selector = $22db1ba098eb3017$var$getSelector(contextId);
        var handle = $22db1ba098eb3017$var$closest$1(target, selector);
        if (!handle) return null;
        if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
        return handle;
    }
    function $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
        var handle = $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event);
        if (!handle) return null;
        return handle.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId);
    }
    function $22db1ba098eb3017$var$findDraggable(contextId, draggableId) {
        var selector = "[" + $22db1ba098eb3017$var$draggable.contextId + "=\"" + contextId + "\"]";
        var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
        var draggable$1 = $22db1ba098eb3017$var$find(possible, function(el) {
            return el.getAttribute($22db1ba098eb3017$var$draggable.id) === draggableId;
        });
        if (!draggable$1) return null;
        if (!$22db1ba098eb3017$var$isHtmlElement(draggable$1)) return null;
        return draggable$1;
    }
    function $22db1ba098eb3017$var$preventDefault(event) {
        event.preventDefault();
    }
    function $22db1ba098eb3017$var$_isActive(_ref) {
        var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
        if (!isLockActive()) {
            shouldWarn;
            return false;
        }
        if (expected !== phase) {
            shouldWarn;
            return false;
        }
        return true;
    }
    function $22db1ba098eb3017$var$canStart(_ref2) {
        var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
        if (lockAPI.isClaimed()) return false;
        var entry = registry.draggable.findById(draggableId);
        if (!entry) return false;
        if (!entry.options.isEnabled) return false;
        if (!$22db1ba098eb3017$var$canStartDrag(store.getState(), draggableId)) return false;
        return true;
    }
    function $22db1ba098eb3017$var$tryStart(_ref3) {
        var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
        var shouldStart = $22db1ba098eb3017$var$canStart({
            lockAPI: lockAPI,
            store: store,
            registry: registry,
            draggableId: draggableId
        });
        if (!shouldStart) return null;
        var entry = registry.draggable.getById(draggableId);
        var el = $22db1ba098eb3017$var$findDraggable(contextId, entry.descriptor.id);
        if (!el) return null;
        if (sourceEvent && !entry.options.canDragInteractiveElements && $22db1ba098eb3017$var$isEventInInteractiveElement(el, sourceEvent)) return null;
        var lock = lockAPI.claim(forceSensorStop || $22db1ba098eb3017$var$noop);
        var phase = 'PRE_DRAG';
        function getShouldRespectForcePress() {
            return entry.options.shouldRespectForcePress;
        }
        function isLockActive() {
            return lockAPI.isActive(lock);
        }
        function tryDispatch(expected, getAction) {
            if ($22db1ba098eb3017$var$_isActive({
                expected: expected,
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: true
            })) store.dispatch(getAction());
        }
        var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
        function lift$1(args) {
            function completed() {
                lockAPI.release();
                phase = 'COMPLETED';
            }
            if (phase !== 'PRE_DRAG') {
                completed();
                !(phase === 'PRE_DRAG') && $22db1ba098eb3017$var$invariant(false);
            }
            store.dispatch($22db1ba098eb3017$var$lift(args.liftActionArgs));
            phase = 'DRAGGING';
            function finish(reason, options) {
                if (options === void 0) options = {
                    shouldBlockNextClick: false
                };
                args.cleanup();
                if (options.shouldBlockNextClick) {
                    var unbind = $22db1ba098eb3017$var$bindEvents(window, [
                        {
                            eventName: 'click',
                            fn: $22db1ba098eb3017$var$preventDefault,
                            options: {
                                once: true,
                                passive: false,
                                capture: true
                            }
                        }
                    ]);
                    setTimeout(unbind);
                }
                completed();
                store.dispatch($22db1ba098eb3017$var$drop({
                    reason: reason
                }));
            }
            return (0, $gzM5u.default)({
                isActive: function isActive() {
                    return $22db1ba098eb3017$var$_isActive({
                        expected: 'DRAGGING',
                        phase: phase,
                        isLockActive: isLockActive,
                        shouldWarn: false
                    });
                },
                shouldRespectForcePress: getShouldRespectForcePress,
                drop: function drop(options) {
                    return finish('DROP', options);
                },
                cancel: function cancel(options) {
                    return finish('CANCEL', options);
                }
            }, args.actions);
        }
        function fluidLift(clientSelection) {
            var move$1 = (0, (0, parcelRequire("crAmF")).default)(function(client) {
                tryDispatchWhenDragging(function() {
                    return $22db1ba098eb3017$var$move({
                        client: client
                    });
                });
            });
            var api = lift$1({
                liftActionArgs: {
                    id: draggableId,
                    clientSelection: clientSelection,
                    movementMode: 'FLUID'
                },
                cleanup: function cleanup() {
                    return move$1.cancel();
                },
                actions: {
                    move: move$1
                }
            });
            return (0, $gzM5u.default)({}, api, {
                move: move$1
            });
        }
        function snapLift() {
            var actions = {
                moveUp: function moveUp$1() {
                    return tryDispatchWhenDragging($22db1ba098eb3017$var$moveUp);
                },
                moveRight: function moveRight$1() {
                    return tryDispatchWhenDragging($22db1ba098eb3017$var$moveRight);
                },
                moveDown: function moveDown$1() {
                    return tryDispatchWhenDragging($22db1ba098eb3017$var$moveDown);
                },
                moveLeft: function moveLeft$1() {
                    return tryDispatchWhenDragging($22db1ba098eb3017$var$moveLeft);
                }
            };
            return lift$1({
                liftActionArgs: {
                    id: draggableId,
                    clientSelection: $22db1ba098eb3017$var$getBorderBoxCenterPosition(el),
                    movementMode: 'SNAP'
                },
                cleanup: $22db1ba098eb3017$var$noop,
                actions: actions
            });
        }
        function abortPreDrag() {
            var shouldRelease = $22db1ba098eb3017$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: true
            });
            if (shouldRelease) lockAPI.release();
        }
        var preDrag = {
            isActive: function isActive() {
                return $22db1ba098eb3017$var$_isActive({
                    expected: 'PRE_DRAG',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            fluidLift: fluidLift,
            snapLift: snapLift,
            abort: abortPreDrag
        };
        return preDrag;
    }
    var $22db1ba098eb3017$var$defaultSensors = [
        $22db1ba098eb3017$var$useMouseSensor,
        $22db1ba098eb3017$var$useKeyboardSensor,
        $22db1ba098eb3017$var$useMouseSensor$1
    ];
    function $22db1ba098eb3017$var$useSensorMarshal(_ref4) {
        var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
        var useSensors = [].concat(enableDefaultSensors ? $22db1ba098eb3017$var$defaultSensors : [], customSensors || []);
        var lockAPI = (0, $5uXOq.useState)(function() {
            return $22db1ba098eb3017$var$create();
        })[0];
        var tryAbandonLock = (0, (0, parcelRequire("3YMLK")).useCallback)(function tryAbandonLock(previous, current) {
            if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
        }, [
            lockAPI
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function listenToStore() {
            var previous = store.getState();
            var unsubscribe = store.subscribe(function() {
                var current = store.getState();
                tryAbandonLock(previous, current);
                previous = current;
            });
            return unsubscribe;
        }, [
            lockAPI,
            store,
            tryAbandonLock
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            return lockAPI.tryAbandon;
        }, [
            lockAPI.tryAbandon
        ]);
        var canGetLock = (0, (0, parcelRequire("3YMLK")).useCallback)(function(draggableId) {
            return $22db1ba098eb3017$var$canStart({
                lockAPI: lockAPI,
                registry: registry,
                store: store,
                draggableId: draggableId
            });
        }, [
            lockAPI,
            registry,
            store
        ]);
        var tryGetLock = (0, (0, parcelRequire("3YMLK")).useCallback)(function(draggableId, forceStop, options) {
            return $22db1ba098eb3017$var$tryStart({
                lockAPI: lockAPI,
                registry: registry,
                contextId: contextId,
                store: store,
                draggableId: draggableId,
                forceSensorStop: forceStop,
                sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
            });
        }, [
            contextId,
            lockAPI,
            registry,
            store
        ]);
        var findClosestDraggableId = (0, (0, parcelRequire("3YMLK")).useCallback)(function(event) {
            return $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event);
        }, [
            contextId
        ]);
        var findOptionsForDraggable = (0, (0, parcelRequire("3YMLK")).useCallback)(function(id) {
            var entry = registry.draggable.findById(id);
            return entry ? entry.options : null;
        }, [
            registry.draggable
        ]);
        var tryReleaseLock = (0, (0, parcelRequire("3YMLK")).useCallback)(lockAPI.tryAbandon, [
            lockAPI
        ]);
        var isLockClaimed = (0, (0, parcelRequire("3YMLK")).useCallback)(lockAPI.isClaimed, [
            lockAPI
        ]);
        var api = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                canGetLock: canGetLock,
                tryGetLock: tryGetLock,
                findClosestDraggableId: findClosestDraggableId,
                findOptionsForDraggable: findOptionsForDraggable,
                tryReleaseLock: tryReleaseLock,
                isLockClaimed: isLockClaimed
            };
        }, [
            canGetLock,
            tryGetLock,
            findClosestDraggableId,
            findOptionsForDraggable,
            tryReleaseLock,
            isLockClaimed
        ]);
        $22db1ba098eb3017$var$useValidateSensorHooks(useSensors);
        for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
    }
    var $22db1ba098eb3017$var$createResponders = function createResponders(props) {
        return {
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragEnd: props.onDragEnd,
            onDragUpdate: props.onDragUpdate
        };
    };
    function $22db1ba098eb3017$var$getStore(lazyRef) {
        !lazyRef.current && $22db1ba098eb3017$var$invariant(false);
        return lazyRef.current;
    }
    function $22db1ba098eb3017$var$App(props) {
        var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
        var lazyStoreRef = (0, $5uXOq.useRef)(null);
        $22db1ba098eb3017$var$useStartupValidation();
        var lastPropsRef = $22db1ba098eb3017$var$usePrevious(props);
        var getResponders = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            return $22db1ba098eb3017$var$createResponders(lastPropsRef.current);
        }, [
            lastPropsRef
        ]);
        var announce = $22db1ba098eb3017$var$useAnnouncer(contextId);
        var liftInstructionId = $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction);
        var styleMarshal = $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce);
        var lazyDispatch = (0, (0, parcelRequire("3YMLK")).useCallback)(function(action) {
            $22db1ba098eb3017$var$getStore(lazyStoreRef).dispatch(action);
        }, []);
        var marshalCallbacks = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return (0, (0, parcelRequire("22j3V")).bindActionCreators)({
                publishWhileDragging: $22db1ba098eb3017$var$publishWhileDragging,
                updateDroppableScroll: $22db1ba098eb3017$var$updateDroppableScroll,
                updateDroppableIsEnabled: $22db1ba098eb3017$var$updateDroppableIsEnabled,
                updateDroppableIsCombineEnabled: $22db1ba098eb3017$var$updateDroppableIsCombineEnabled,
                collectionStarting: $22db1ba098eb3017$var$collectionStarting
            }, lazyDispatch);
        }, [
            lazyDispatch
        ]);
        var registry = $22db1ba098eb3017$var$useRegistry();
        var dimensionMarshal = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return $22db1ba098eb3017$var$createDimensionMarshal(registry, marshalCallbacks);
        }, [
            registry,
            marshalCallbacks
        ]);
        var autoScroller = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return $22db1ba098eb3017$var$createAutoScroller((0, $gzM5u.default)({
                scrollWindow: $22db1ba098eb3017$var$scrollWindow,
                scrollDroppable: dimensionMarshal.scrollDroppable
            }, (0, (0, parcelRequire("22j3V")).bindActionCreators)({
                move: $22db1ba098eb3017$var$move
            }, lazyDispatch)));
        }, [
            dimensionMarshal.scrollDroppable,
            lazyDispatch
        ]);
        var focusMarshal = $22db1ba098eb3017$var$useFocusMarshal(contextId);
        var store = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return $22db1ba098eb3017$var$createStore({
                announce: announce,
                autoScroller: autoScroller,
                dimensionMarshal: dimensionMarshal,
                focusMarshal: focusMarshal,
                getResponders: getResponders,
                styleMarshal: styleMarshal
            });
        }, [
            announce,
            autoScroller,
            dimensionMarshal,
            focusMarshal,
            getResponders,
            styleMarshal
        ]);
        lazyStoreRef.current = store;
        var tryResetStore = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var current = $22db1ba098eb3017$var$getStore(lazyStoreRef);
            var state = current.getState();
            if (state.phase !== 'IDLE') current.dispatch($22db1ba098eb3017$var$flush());
        }, []);
        var isDragging = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var state = $22db1ba098eb3017$var$getStore(lazyStoreRef).getState();
            return state.isDragging || state.phase === 'DROP_ANIMATING';
        }, []);
        var appCallbacks = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                isDragging: isDragging,
                tryAbort: tryResetStore
            };
        }, [
            isDragging,
            tryResetStore
        ]);
        setCallbacks(appCallbacks);
        var getCanLift = (0, (0, parcelRequire("3YMLK")).useCallback)(function(id) {
            return $22db1ba098eb3017$var$canStartDrag($22db1ba098eb3017$var$getStore(lazyStoreRef).getState(), id);
        }, []);
        var getIsMovementAllowed = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            return $22db1ba098eb3017$var$isMovementAllowed($22db1ba098eb3017$var$getStore(lazyStoreRef).getState());
        }, []);
        var appContext = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                marshal: dimensionMarshal,
                focus: focusMarshal,
                contextId: contextId,
                canLift: getCanLift,
                isMovementAllowed: getIsMovementAllowed,
                liftInstructionId: liftInstructionId,
                registry: registry
            };
        }, [
            contextId,
            dimensionMarshal,
            focusMarshal,
            getCanLift,
            getIsMovementAllowed,
            liftInstructionId,
            registry
        ]);
        $22db1ba098eb3017$var$useSensorMarshal({
            contextId: contextId,
            store: store,
            registry: registry,
            customSensors: sensors,
            enableDefaultSensors: props.enableDefaultSensors !== false
        });
        (0, $5uXOq.useEffect)(function() {
            return tryResetStore;
        }, [
            tryResetStore
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AppContext.Provider, {
            value: appContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9bdMd.default), {
            context: $22db1ba098eb3017$var$StoreContext,
            store: store
        }, props.children));
    }
    var $22db1ba098eb3017$var$instanceCount = 0;
    function $22db1ba098eb3017$export$2bfe52350fc0150d() {
        $22db1ba098eb3017$var$instanceCount = 0;
    }
    function $22db1ba098eb3017$export$237bd83162c14364(props) {
        var contextId = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return "" + $22db1ba098eb3017$var$instanceCount++;
        }, []);
        var liftInstruction = props.liftInstruction || $22db1ba098eb3017$var$preset.liftInstruction;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ErrorBoundary, null, function(setCallbacks) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$App, {
                nonce: props.nonce,
                contextId: contextId,
                setCallbacks: setCallbacks,
                liftInstruction: liftInstruction,
                enableDefaultSensors: props.enableDefaultSensors,
                sensors: props.sensors,
                onBeforeCapture: props.onBeforeCapture,
                onBeforeDragStart: props.onBeforeDragStart,
                onDragStart: props.onDragStart,
                onDragUpdate: props.onDragUpdate,
                onDragEnd: props.onDragEnd
            }, props.children);
        });
    }
    var $22db1ba098eb3017$var$isEqual$1 = function isEqual(base) {
        return function(value) {
            return base === value;
        };
    };
    var $22db1ba098eb3017$var$isScroll = $22db1ba098eb3017$var$isEqual$1('scroll');
    var $22db1ba098eb3017$var$isAuto = $22db1ba098eb3017$var$isEqual$1('auto');
    var $22db1ba098eb3017$var$isVisible$1 = $22db1ba098eb3017$var$isEqual$1('visible');
    var $22db1ba098eb3017$var$isEither = function isEither(overflow, fn) {
        return fn(overflow.overflowX) || fn(overflow.overflowY);
    };
    var $22db1ba098eb3017$var$isBoth = function isBoth(overflow, fn) {
        return fn(overflow.overflowX) && fn(overflow.overflowY);
    };
    var $22db1ba098eb3017$var$isElementScrollable = function isElementScrollable(el) {
        var style = window.getComputedStyle(el);
        var overflow = {
            overflowX: style.overflowX,
            overflowY: style.overflowY
        };
        return $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isScroll) || $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isAuto);
    };
    var $22db1ba098eb3017$var$isBodyScrollable = function isBodyScrollable() {
        var body, html, htmlStyle, htmlOverflow;
        return false;
    };
    var $22db1ba098eb3017$var$getClosestScrollable = function getClosestScrollable(el) {
        if (el == null) return null;
        if (el === document.body) return $22db1ba098eb3017$var$isBodyScrollable() ? el : null;
        if (el === document.documentElement) return null;
        if (!$22db1ba098eb3017$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
        return el;
    };
    var $22db1ba098eb3017$var$checkForNestedScrollContainers = function(scrollable) {
        if (!scrollable) return;
        var anotherScrollParent = $22db1ba098eb3017$var$getClosestScrollable(scrollable.parentElement);
        if (!anotherScrollParent) return;
    };
    var $22db1ba098eb3017$var$getScroll$1 = function(el) {
        return {
            x: el.scrollLeft,
            y: el.scrollTop
        };
    };
    var $22db1ba098eb3017$var$getIsFixed = function getIsFixed(el) {
        if (!el) return false;
        var style = window.getComputedStyle(el);
        if (style.position === 'fixed') return true;
        return getIsFixed(el.parentElement);
    };
    var $22db1ba098eb3017$var$getEnv = function(start) {
        var closestScrollable = $22db1ba098eb3017$var$getClosestScrollable(start);
        var isFixedOnPage = $22db1ba098eb3017$var$getIsFixed(start);
        return {
            closestScrollable: closestScrollable,
            isFixedOnPage: isFixedOnPage
        };
    };
    var $22db1ba098eb3017$var$getDroppableDimension = function(_ref) {
        var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
        var frame = function() {
            if (!closest) return null;
            var scrollSize = closest.scrollSize, frameClient = closest.client;
            var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
                scrollHeight: scrollSize.scrollHeight,
                scrollWidth: scrollSize.scrollWidth,
                height: frameClient.paddingBox.height,
                width: frameClient.paddingBox.width
            });
            return {
                pageMarginBox: closest.page.marginBox,
                frameClient: frameClient,
                scrollSize: scrollSize,
                shouldClipSubject: closest.shouldClipSubject,
                scroll: {
                    initial: closest.scroll,
                    current: closest.scroll,
                    max: maxScroll,
                    diff: {
                        value: $22db1ba098eb3017$var$origin,
                        displacement: $22db1ba098eb3017$var$origin
                    }
                }
            };
        }();
        var axis = direction === 'vertical' ? $22db1ba098eb3017$var$vertical : $22db1ba098eb3017$var$horizontal;
        var subject = $22db1ba098eb3017$var$getSubject({
            page: page,
            withPlaceholder: null,
            axis: axis,
            frame: frame
        });
        var dimension = {
            descriptor: descriptor,
            isCombineEnabled: isCombineEnabled,
            isFixedOnPage: isFixedOnPage,
            axis: axis,
            isEnabled: isEnabled,
            client: client,
            page: page,
            frame: frame,
            subject: subject
        };
        return dimension;
    };
    var $22db1ba098eb3017$var$getClient = function getClient(targetRef, closestScrollable) {
        var base = (0, (0, parcelRequire("3YKxB")).getBox)(targetRef);
        if (!closestScrollable) return base;
        if (targetRef !== closestScrollable) return base;
        var top = base.paddingBox.top - closestScrollable.scrollTop;
        var left = base.paddingBox.left - closestScrollable.scrollLeft;
        var bottom = top + closestScrollable.scrollHeight;
        var right = left + closestScrollable.scrollWidth;
        var paddingBox = {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
        var borderBox = (0, (0, parcelRequire("3YKxB")).expand)(paddingBox, base.border);
        var client = (0, (0, parcelRequire("3YKxB")).createBox)({
            borderBox: borderBox,
            margin: base.margin,
            border: base.border,
            padding: base.padding
        });
        return client;
    };
    var $22db1ba098eb3017$var$getDimension = function(_ref) {
        var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
        var closestScrollable = env.closestScrollable;
        var client = $22db1ba098eb3017$var$getClient(ref, closestScrollable);
        var page = (0, (0, parcelRequire("3YKxB")).withScroll)(client, windowScroll);
        var closest = function() {
            if (!closestScrollable) return null;
            var frameClient = (0, (0, parcelRequire("3YKxB")).getBox)(closestScrollable);
            var scrollSize = {
                scrollHeight: closestScrollable.scrollHeight,
                scrollWidth: closestScrollable.scrollWidth
            };
            return {
                client: frameClient,
                page: (0, (0, parcelRequire("3YKxB")).withScroll)(frameClient, windowScroll),
                scroll: $22db1ba098eb3017$var$getScroll$1(closestScrollable),
                scrollSize: scrollSize,
                shouldClipSubject: shouldClipSubject
            };
        }();
        var dimension = $22db1ba098eb3017$var$getDroppableDimension({
            descriptor: descriptor,
            isEnabled: !isDropDisabled,
            isCombineEnabled: isCombineEnabled,
            isFixedOnPage: env.isFixedOnPage,
            direction: direction,
            client: client,
            page: page,
            closest: closest
        });
        return dimension;
    };
    var $22db1ba098eb3017$var$immediate = {
        passive: false
    };
    var $22db1ba098eb3017$var$delayed = {
        passive: true
    };
    var $22db1ba098eb3017$var$getListenerOptions = function(options) {
        return options.shouldPublishImmediately ? $22db1ba098eb3017$var$immediate : $22db1ba098eb3017$var$delayed;
    };
    function $22db1ba098eb3017$var$useRequiredContext(Context) {
        var result = (0, $5uXOq.useContext)(Context);
        !result && $22db1ba098eb3017$var$invariant(false);
        return result;
    }
    var $22db1ba098eb3017$var$count = 0;
    function $22db1ba098eb3017$var$useUniqueId(prefix) {
        var countRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$count++);
        return prefix + "::" + countRef.current;
    }
    var $22db1ba098eb3017$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
        return dragging && dragging.env.closestScrollable || null;
    };
    function $22db1ba098eb3017$var$useDroppablePublisher(args) {
        var whileDraggingRef = (0, $5uXOq.useRef)(null);
        var appContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext);
        var uniqueId = $22db1ba098eb3017$var$useUniqueId('droppable');
        var registry = appContext.registry, marshal = appContext.marshal;
        var previousRef = $22db1ba098eb3017$var$usePrevious(args);
        var descriptor = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                id: args.droppableId,
                type: args.type,
                mode: args.mode
            };
        }, [
            args.droppableId,
            args.mode,
            args.type
        ]);
        var publishedDescriptorRef = (0, $5uXOq.useRef)(descriptor);
        var memoizedUpdateScroll = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return (0, (0, parcelRequire("g7psY")).default)(function(x, y) {
                !whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
                var scroll = {
                    x: x,
                    y: y
                };
                marshal.updateDroppableScroll(descriptor.id, scroll);
            });
        }, [
            descriptor.id,
            marshal
        ]);
        var getClosestScroll = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var dragging = whileDraggingRef.current;
            if (!dragging || !dragging.env.closestScrollable) return $22db1ba098eb3017$var$origin;
            return $22db1ba098eb3017$var$getScroll$1(dragging.env.closestScrollable);
        }, []);
        var updateScroll = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var scroll = getClosestScroll();
            memoizedUpdateScroll(scroll.x, scroll.y);
        }, [
            getClosestScroll,
            memoizedUpdateScroll
        ]);
        var scheduleScrollUpdate = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return (0, (0, parcelRequire("crAmF")).default)(updateScroll);
        }, [
            updateScroll
        ]);
        var onClosestScroll = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var dragging = whileDraggingRef.current;
            var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
            !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
            var options = dragging.scrollOptions;
            if (options.shouldPublishImmediately) {
                updateScroll();
                return;
            }
            scheduleScrollUpdate();
        }, [
            scheduleScrollUpdate,
            updateScroll
        ]);
        var getDimensionAndWatchScroll = (0, (0, parcelRequire("3YMLK")).useCallback)(function(windowScroll, options) {
            !!whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
            var previous = previousRef.current;
            var ref = previous.getDroppableRef();
            !ref && $22db1ba098eb3017$var$invariant(false);
            var env = $22db1ba098eb3017$var$getEnv(ref);
            var dragging = {
                ref: ref,
                descriptor: descriptor,
                env: env,
                scrollOptions: options
            };
            whileDraggingRef.current = dragging;
            var dimension = $22db1ba098eb3017$var$getDimension({
                ref: ref,
                descriptor: descriptor,
                env: env,
                windowScroll: windowScroll,
                direction: previous.direction,
                isDropDisabled: previous.isDropDisabled,
                isCombineEnabled: previous.isCombineEnabled,
                shouldClipSubject: !previous.ignoreContainerClipping
            });
            var scrollable = env.closestScrollable;
            if (scrollable) {
                scrollable.setAttribute($22db1ba098eb3017$var$scrollContainer.contextId, appContext.contextId);
                scrollable.addEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
            }
            return dimension;
        }, [
            appContext.contextId,
            descriptor,
            onClosestScroll,
            previousRef
        ]);
        var getScrollWhileDragging = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var dragging = whileDraggingRef.current;
            var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
            !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
            return $22db1ba098eb3017$var$getScroll$1(closest);
        }, []);
        var dragStopped = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            var dragging = whileDraggingRef.current;
            !dragging && $22db1ba098eb3017$var$invariant(false);
            var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
            whileDraggingRef.current = null;
            if (!closest) return;
            scheduleScrollUpdate.cancel();
            closest.removeAttribute($22db1ba098eb3017$var$scrollContainer.contextId);
            closest.removeEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
        }, [
            onClosestScroll,
            scheduleScrollUpdate
        ]);
        var scroll = (0, (0, parcelRequire("3YMLK")).useCallback)(function(change) {
            var dragging = whileDraggingRef.current;
            !dragging && $22db1ba098eb3017$var$invariant(false);
            var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
            !closest && $22db1ba098eb3017$var$invariant(false);
            closest.scrollTop += change.y;
            closest.scrollLeft += change.x;
        }, []);
        var callbacks = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                getDimensionAndWatchScroll: getDimensionAndWatchScroll,
                getScrollWhileDragging: getScrollWhileDragging,
                dragStopped: dragStopped,
                scroll: scroll
            };
        }, [
            dragStopped,
            getDimensionAndWatchScroll,
            getScrollWhileDragging,
            scroll
        ]);
        var entry = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                uniqueId: uniqueId,
                descriptor: descriptor,
                callbacks: callbacks
            };
        }, [
            callbacks,
            descriptor,
            uniqueId
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            publishedDescriptorRef.current = entry.descriptor;
            registry.droppable.register(entry);
            return function() {
                if (whileDraggingRef.current) dragStopped();
                registry.droppable.unregister(entry);
            };
        }, [
            callbacks,
            descriptor,
            dragStopped,
            entry,
            marshal,
            registry.droppable
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            if (!whileDraggingRef.current) return;
            marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
        }, [
            args.isDropDisabled,
            marshal
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            if (!whileDraggingRef.current) return;
            marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
        }, [
            args.isCombineEnabled,
            marshal
        ]);
    }
    function $22db1ba098eb3017$var$noop$2() {}
    var $22db1ba098eb3017$var$empty = {
        width: 0,
        height: 0,
        margin: $22db1ba098eb3017$var$noSpacing
    };
    var $22db1ba098eb3017$var$getSize = function getSize(_ref) {
        var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
        if (isAnimatingOpenOnMount) return $22db1ba098eb3017$var$empty;
        if (animate === 'close') return $22db1ba098eb3017$var$empty;
        return {
            height: placeholder.client.borderBox.height,
            width: placeholder.client.borderBox.width,
            margin: placeholder.client.margin
        };
    };
    var $22db1ba098eb3017$var$getStyle = function getStyle(_ref2) {
        var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
        var size = $22db1ba098eb3017$var$getSize({
            isAnimatingOpenOnMount: isAnimatingOpenOnMount,
            placeholder: placeholder,
            animate: animate
        });
        return {
            display: placeholder.display,
            boxSizing: 'border-box',
            width: size.width,
            height: size.height,
            marginTop: size.margin.top,
            marginRight: size.margin.right,
            marginBottom: size.margin.bottom,
            marginLeft: size.margin.left,
            flexShrink: '0',
            flexGrow: '0',
            pointerEvents: 'none',
            transition: animate !== 'none' ? $22db1ba098eb3017$var$transitions.placeholder : null
        };
    };
    function $22db1ba098eb3017$var$Placeholder(props) {
        var animateOpenTimerRef = (0, $5uXOq.useRef)(null);
        var tryClearAnimateOpenTimer = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            if (!animateOpenTimerRef.current) return;
            clearTimeout(animateOpenTimerRef.current);
            animateOpenTimerRef.current = null;
        }, []);
        var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
        var _useState = (0, $5uXOq.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
        (0, $5uXOq.useEffect)(function() {
            if (!isAnimatingOpenOnMount) return $22db1ba098eb3017$var$noop$2;
            if (animate !== 'open') {
                tryClearAnimateOpenTimer();
                setIsAnimatingOpenOnMount(false);
                return $22db1ba098eb3017$var$noop$2;
            }
            if (animateOpenTimerRef.current) return $22db1ba098eb3017$var$noop$2;
            animateOpenTimerRef.current = setTimeout(function() {
                animateOpenTimerRef.current = null;
                setIsAnimatingOpenOnMount(false);
            });
            return tryClearAnimateOpenTimer;
        }, [
            animate,
            isAnimatingOpenOnMount,
            tryClearAnimateOpenTimer
        ]);
        var onSizeChangeEnd = (0, (0, parcelRequire("3YMLK")).useCallback)(function(event) {
            if (event.propertyName !== 'height') return;
            onTransitionEnd();
            if (animate === 'close') onClose();
        }, [
            animate,
            onClose,
            onTransitionEnd
        ]);
        var style = $22db1ba098eb3017$var$getStyle({
            isAnimatingOpenOnMount: isAnimatingOpenOnMount,
            animate: props.animate,
            placeholder: props.placeholder
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(props.placeholder.tagName, {
            style: style,
            'data-rbd-placeholder-context-id': contextId,
            onTransitionEnd: onSizeChangeEnd,
            ref: props.innerRef
        });
    }
    var $22db1ba098eb3017$var$Placeholder$1 = (0, ($parcel$interopDefault($5uXOq))).memo($22db1ba098eb3017$var$Placeholder);
    var $22db1ba098eb3017$var$DroppableContext = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    function $22db1ba098eb3017$var$checkIsValidInnerRef(el) {
        !(el && $22db1ba098eb3017$var$isHtmlElement(el)) && $22db1ba098eb3017$var$invariant(false);
    }
    function $22db1ba098eb3017$var$isBoolean(value) {
        return typeof value === 'boolean';
    }
    function $22db1ba098eb3017$var$runChecks(args, checks) {
        checks.forEach(function(check) {
            return check(args);
        });
    }
    var $22db1ba098eb3017$var$shared = [
        function required(_ref) {
            var props = _ref.props;
            !props.droppableId && $22db1ba098eb3017$var$invariant(false);
            !(typeof props.droppableId === 'string') && $22db1ba098eb3017$var$invariant(false);
        },
        function _boolean(_ref2) {
            var props = _ref2.props;
            !$22db1ba098eb3017$var$isBoolean(props.isDropDisabled) && $22db1ba098eb3017$var$invariant(false);
            !$22db1ba098eb3017$var$isBoolean(props.isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
            !$22db1ba098eb3017$var$isBoolean(props.ignoreContainerClipping) && $22db1ba098eb3017$var$invariant(false);
        },
        function ref(_ref3) {
            var getDroppableRef = _ref3.getDroppableRef;
            $22db1ba098eb3017$var$checkIsValidInnerRef(getDroppableRef());
        }
    ];
    var $22db1ba098eb3017$var$standard = [
        function placeholder(_ref4) {
            var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
            if (!props.placeholder) return;
            var ref = getPlaceholderRef();
            if (ref) return;
        }
    ];
    var $22db1ba098eb3017$var$virtual = [
        function hasClone(_ref5) {
            var props = _ref5.props;
            !props.renderClone && $22db1ba098eb3017$var$invariant(false);
        },
        function hasNoPlaceholder(_ref6) {
            var getPlaceholderRef = _ref6.getPlaceholderRef;
            !!getPlaceholderRef() && $22db1ba098eb3017$var$invariant(false);
        }
    ];
    function $22db1ba098eb3017$var$useValidation(args) {
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$shared);
            if (args.props.mode === 'standard') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$standard);
            if (args.props.mode === 'virtual') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$virtual);
        });
    }
    var $22db1ba098eb3017$var$AnimateInOut = function(_React$PureComponent) {
        (0, $1AwyE.default)(AnimateInOut, _React$PureComponent);
        function AnimateInOut() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$PureComponent.call.apply(_React$PureComponent, [
                this
            ].concat(args)) || this;
            _this.state = {
                isVisible: Boolean(_this.props.on),
                data: _this.props.on,
                animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
            };
            _this.onClose = function() {
                if (_this.state.animate !== 'close') return;
                _this.setState({
                    isVisible: false
                });
            };
            return _this;
        }
        AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
            if (!props.shouldAnimate) return {
                isVisible: Boolean(props.on),
                data: props.on,
                animate: 'none'
            };
            if (props.on) return {
                isVisible: true,
                data: props.on,
                animate: 'open'
            };
            if (state.isVisible) return {
                isVisible: true,
                data: state.data,
                animate: 'close'
            };
            return {
                isVisible: false,
                animate: 'close',
                data: null
            };
        };
        var _proto = AnimateInOut.prototype;
        _proto.render = function render() {
            if (!this.state.isVisible) return null;
            var provided = {
                onClose: this.onClose,
                data: this.state.data,
                animate: this.state.animate
            };
            return this.props.children(provided);
        };
        return AnimateInOut;
    }((0, ($parcel$interopDefault($5uXOq))).PureComponent);
    var $22db1ba098eb3017$var$zIndexOptions = {
        dragging: 5000,
        dropAnimating: 4500
    };
    var $22db1ba098eb3017$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
        if (dropping) return $22db1ba098eb3017$var$transitions.drop(dropping.duration);
        if (shouldAnimateDragMovement) return $22db1ba098eb3017$var$transitions.snap;
        return $22db1ba098eb3017$var$transitions.fluid;
    };
    var $22db1ba098eb3017$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
        if (!isCombining) return null;
        return isDropAnimating ? $22db1ba098eb3017$var$combine.opacity.drop : $22db1ba098eb3017$var$combine.opacity.combining;
    };
    var $22db1ba098eb3017$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
        if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
        return dragging.mode === 'SNAP';
    };
    function $22db1ba098eb3017$var$getDraggingStyle(dragging) {
        var dimension = dragging.dimension;
        var box = dimension.client;
        var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
        var isCombining = Boolean(combineWith);
        var shouldAnimate = $22db1ba098eb3017$var$getShouldDraggingAnimate(dragging);
        var isDropAnimating = Boolean(dropping);
        var transform = isDropAnimating ? $22db1ba098eb3017$var$transforms.drop(offset, isCombining) : $22db1ba098eb3017$var$transforms.moveTo(offset);
        var style = {
            position: 'fixed',
            top: box.marginBox.top,
            left: box.marginBox.left,
            boxSizing: 'border-box',
            width: box.borderBox.width,
            height: box.borderBox.height,
            transition: $22db1ba098eb3017$var$getDraggingTransition(shouldAnimate, dropping),
            transform: transform,
            opacity: $22db1ba098eb3017$var$getDraggingOpacity(isCombining, isDropAnimating),
            zIndex: isDropAnimating ? $22db1ba098eb3017$var$zIndexOptions.dropAnimating : $22db1ba098eb3017$var$zIndexOptions.dragging,
            pointerEvents: 'none'
        };
        return style;
    }
    function $22db1ba098eb3017$var$getSecondaryStyle(secondary) {
        return {
            transform: $22db1ba098eb3017$var$transforms.moveTo(secondary.offset),
            transition: secondary.shouldAnimateDisplacement ? null : 'none'
        };
    }
    function $22db1ba098eb3017$var$getStyle$1(mapped) {
        return mapped.type === 'DRAGGING' ? $22db1ba098eb3017$var$getDraggingStyle(mapped) : $22db1ba098eb3017$var$getSecondaryStyle(mapped);
    }
    function $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll) {
        if (windowScroll === void 0) windowScroll = $22db1ba098eb3017$var$origin;
        var computedStyles = window.getComputedStyle(el);
        var borderBox = el.getBoundingClientRect();
        var client = (0, (0, parcelRequire("3YKxB")).calculateBox)(borderBox, computedStyles);
        var page = (0, (0, parcelRequire("3YKxB")).withScroll)(client, windowScroll);
        var placeholder = {
            client: client,
            tagName: el.tagName.toLowerCase(),
            display: computedStyles.display
        };
        var displaceBy = {
            x: client.marginBox.width,
            y: client.marginBox.height
        };
        var dimension = {
            descriptor: descriptor,
            placeholder: placeholder,
            displaceBy: displaceBy,
            client: client,
            page: page
        };
        return dimension;
    }
    function $22db1ba098eb3017$var$useDraggablePublisher(args) {
        var uniqueId = $22db1ba098eb3017$var$useUniqueId('draggable');
        var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
        var options = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            canDragInteractiveElements,
            isEnabled,
            shouldRespectForcePress
        ]);
        var getDimension = (0, (0, parcelRequire("3YMLK")).useCallback)(function(windowScroll) {
            var el = getDraggableRef();
            !el && $22db1ba098eb3017$var$invariant(false);
            return $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll);
        }, [
            descriptor,
            getDraggableRef
        ]);
        var entry = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                uniqueId: uniqueId,
                descriptor: descriptor,
                options: options,
                getDimension: getDimension
            };
        }, [
            descriptor,
            getDimension,
            options,
            uniqueId
        ]);
        var publishedRef = (0, $5uXOq.useRef)(entry);
        var isFirstPublishRef = (0, $5uXOq.useRef)(true);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            registry.draggable.register(publishedRef.current);
            return function() {
                return registry.draggable.unregister(publishedRef.current);
            };
        }, [
            registry.draggable
        ]);
        $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
            if (isFirstPublishRef.current) {
                isFirstPublishRef.current = false;
                return;
            }
            var last = publishedRef.current;
            publishedRef.current = entry;
            registry.draggable.update(entry, last);
        }, [
            entry,
            registry.draggable
        ]);
    }
    function $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef) {
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            function prefix(id) {
                return "Draggable[id: " + id + "]: ";
            }
            var id = props.draggableId;
            !id && $22db1ba098eb3017$var$invariant(false);
            !(typeof id === 'string') && $22db1ba098eb3017$var$invariant(false);
            !(0, ($parcel$interopDefault($1DIXK)))(props.index) && $22db1ba098eb3017$var$invariant(false);
            if (props.mapped.type === 'DRAGGING') return;
            $22db1ba098eb3017$var$checkIsValidInnerRef(getRef());
            if (props.isEnabled) !$22db1ba098eb3017$var$findDragHandle(contextId, id) && $22db1ba098eb3017$var$invariant(false);
        });
    }
    function $22db1ba098eb3017$var$useClonePropValidation(isClone) {
        $22db1ba098eb3017$var$useDev(function() {
            var initialRef = (0, $5uXOq.useRef)(isClone);
            $22db1ba098eb3017$var$useDevSetupWarning(function() {
                !(isClone === initialRef.current) && $22db1ba098eb3017$var$invariant(false);
            }, [
                isClone
            ]);
        });
    }
    function $22db1ba098eb3017$var$preventHtml5Dnd(event) {
        event.preventDefault();
    }
    function $22db1ba098eb3017$var$Draggable(props) {
        var ref = (0, $5uXOq.useRef)(null);
        var setRef = (0, (0, parcelRequire("3YMLK")).useCallback)(function(el) {
            ref.current = el;
        }, []);
        var getRef = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            return ref.current;
        }, []);
        var _useRequiredContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
        var _useRequiredContext2 = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
        var descriptor = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                id: props.draggableId,
                index: props.index,
                type: type,
                droppableId: droppableId
            };
        }, [
            props.draggableId,
            props.index,
            type,
            droppableId
        ]);
        var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
        $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef);
        $22db1ba098eb3017$var$useClonePropValidation(isClone);
        if (!isClone) {
            var forPublisher = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
                return {
                    descriptor: descriptor,
                    registry: registry,
                    getDraggableRef: getRef,
                    canDragInteractiveElements: canDragInteractiveElements,
                    shouldRespectForcePress: shouldRespectForcePress,
                    isEnabled: isEnabled
                };
            }, [
                descriptor,
                registry,
                getRef,
                canDragInteractiveElements,
                shouldRespectForcePress,
                isEnabled
            ]);
            $22db1ba098eb3017$var$useDraggablePublisher(forPublisher);
        }
        var dragHandleProps = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return isEnabled ? {
                tabIndex: 0,
                'data-rbd-drag-handle-draggable-id': draggableId,
                'data-rbd-drag-handle-context-id': contextId,
                'aria-labelledby': liftInstructionId,
                draggable: false,
                onDragStart: $22db1ba098eb3017$var$preventHtml5Dnd
            } : null;
        }, [
            contextId,
            draggableId,
            isEnabled,
            liftInstructionId
        ]);
        var onMoveEnd = (0, (0, parcelRequire("3YMLK")).useCallback)(function(event) {
            if (mapped.type !== 'DRAGGING') return;
            if (!mapped.dropping) return;
            if (event.propertyName !== 'transform') return;
            dropAnimationFinishedAction();
        }, [
            dropAnimationFinishedAction,
            mapped
        ]);
        var provided = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            var style = $22db1ba098eb3017$var$getStyle$1(mapped);
            var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
            var result = {
                innerRef: setRef,
                draggableProps: {
                    'data-rbd-draggable-context-id': contextId,
                    'data-rbd-draggable-id': draggableId,
                    style: style,
                    onTransitionEnd: onTransitionEnd
                },
                dragHandleProps: dragHandleProps
            };
            return result;
        }, [
            contextId,
            dragHandleProps,
            draggableId,
            mapped,
            onMoveEnd,
            setRef
        ]);
        var rubric = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                draggableId: descriptor.id,
                type: descriptor.type,
                source: {
                    index: descriptor.index,
                    droppableId: descriptor.droppableId
                }
            };
        }, [
            descriptor.droppableId,
            descriptor.id,
            descriptor.index,
            descriptor.type
        ]);
        return children(provided, mapped.snapshot, rubric);
    }
    var $22db1ba098eb3017$var$isStrictEqual = function(a, b) {
        return a === b;
    };
    var $22db1ba098eb3017$var$whatIsDraggedOverFromResult = function(result) {
        var combine = result.combine, destination = result.destination;
        if (destination) return destination.droppableId;
        if (combine) return combine.droppableId;
        return null;
    };
    var $22db1ba098eb3017$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
        return result.combine ? result.combine.draggableId : null;
    };
    var $22db1ba098eb3017$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
        return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
    };
    function $22db1ba098eb3017$var$getDraggableSelector() {
        var memoizedOffset = (0, (0, parcelRequire("g7psY")).default)(function(x, y) {
            return {
                x: x,
                y: y
            };
        });
        var getMemoizedSnapshot = (0, (0, parcelRequire("g7psY")).default)(function(mode, isClone, draggingOver, combineWith, dropping) {
            return {
                isDragging: true,
                isClone: isClone,
                isDropAnimating: Boolean(dropping),
                dropAnimation: dropping,
                mode: mode,
                draggingOver: draggingOver,
                combineWith: combineWith,
                combineTargetFor: null
            };
        });
        var getMemoizedProps = (0, (0, parcelRequire("g7psY")).default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
            return {
                mapped: {
                    type: 'DRAGGING',
                    dropping: null,
                    draggingOver: draggingOver,
                    combineWith: combineWith,
                    mode: mode,
                    offset: offset,
                    dimension: dimension,
                    forceShouldAnimate: forceShouldAnimate,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
                }
            };
        });
        var selector = function selector(state, ownProps) {
            if (state.isDragging) {
                if (state.critical.draggable.id !== ownProps.draggableId) return null;
                var offset = state.current.client.offset;
                var dimension = state.dimensions.draggables[ownProps.draggableId];
                var draggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
                var combineWith = $22db1ba098eb3017$var$getCombineWithFromImpact(state.impact);
                var forceShouldAnimate = state.forceShouldAnimate;
                return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
            }
            if (state.phase === 'DROP_ANIMATING') {
                var completed = state.completed;
                if (completed.result.draggableId !== ownProps.draggableId) return null;
                var isClone = ownProps.isClone;
                var _dimension = state.dimensions.draggables[ownProps.draggableId];
                var result = completed.result;
                var mode = result.mode;
                var _draggingOver = $22db1ba098eb3017$var$whatIsDraggedOverFromResult(result);
                var _combineWith = $22db1ba098eb3017$var$getCombineWithFromResult(result);
                var duration = state.dropDuration;
                var dropping = {
                    duration: duration,
                    curve: $22db1ba098eb3017$var$curves.drop,
                    moveTo: state.newHomeClientOffset,
                    opacity: _combineWith ? $22db1ba098eb3017$var$combine.opacity.drop : null,
                    scale: _combineWith ? $22db1ba098eb3017$var$combine.scale.drop : null
                };
                return {
                    mapped: {
                        type: 'DRAGGING',
                        offset: state.newHomeClientOffset,
                        dimension: _dimension,
                        dropping: dropping,
                        draggingOver: _draggingOver,
                        combineWith: _combineWith,
                        mode: mode,
                        forceShouldAnimate: null,
                        snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                    }
                };
            }
            return null;
        };
        return selector;
    }
    function $22db1ba098eb3017$var$getSecondarySnapshot(combineTargetFor) {
        return {
            isDragging: false,
            isDropAnimating: false,
            isClone: false,
            dropAnimation: null,
            mode: null,
            draggingOver: null,
            combineTargetFor: combineTargetFor,
            combineWith: null
        };
    }
    var $22db1ba098eb3017$var$atRest = {
        mapped: {
            type: 'SECONDARY',
            offset: $22db1ba098eb3017$var$origin,
            combineTargetFor: null,
            shouldAnimateDisplacement: true,
            snapshot: $22db1ba098eb3017$var$getSecondarySnapshot(null)
        }
    };
    function $22db1ba098eb3017$var$getSecondarySelector() {
        var memoizedOffset = (0, (0, parcelRequire("g7psY")).default)(function(x, y) {
            return {
                x: x,
                y: y
            };
        });
        var getMemoizedSnapshot = (0, (0, parcelRequire("g7psY")).default)($22db1ba098eb3017$var$getSecondarySnapshot);
        var getMemoizedProps = (0, (0, parcelRequire("g7psY")).default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
            if (combineTargetFor === void 0) combineTargetFor = null;
            return {
                mapped: {
                    type: 'SECONDARY',
                    offset: offset,
                    combineTargetFor: combineTargetFor,
                    shouldAnimateDisplacement: shouldAnimateDisplacement,
                    snapshot: getMemoizedSnapshot(combineTargetFor)
                }
            };
        });
        var getFallback = function getFallback(combineTargetFor) {
            return combineTargetFor ? getMemoizedProps($22db1ba098eb3017$var$origin, combineTargetFor, true) : null;
        };
        var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
            var visualDisplacement = impact.displaced.visible[ownId];
            var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
            var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
            var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
            if (!visualDisplacement) {
                if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
                if (impact.displaced.invisible[ownId]) return null;
                var change = $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point);
                var _offset = memoizedOffset(change.x, change.y);
                return getMemoizedProps(_offset, combineTargetFor, true);
            }
            if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            var displaceBy = impact.displacedBy.point;
            var offset = memoizedOffset(displaceBy.x, displaceBy.y);
            return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
        };
        var selector = function selector(state, ownProps) {
            if (state.isDragging) {
                if (state.critical.draggable.id === ownProps.draggableId) return null;
                return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
            }
            if (state.phase === 'DROP_ANIMATING') {
                var completed = state.completed;
                if (completed.result.draggableId === ownProps.draggableId) return null;
                return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
            }
            return null;
        };
        return selector;
    }
    var $22db1ba098eb3017$var$makeMapStateToProps = function makeMapStateToProps() {
        var draggingSelector = $22db1ba098eb3017$var$getDraggableSelector();
        var secondarySelector = $22db1ba098eb3017$var$getSecondarySelector();
        var selector = function selector(state, ownProps) {
            return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $22db1ba098eb3017$var$atRest;
        };
        return selector;
    };
    var $22db1ba098eb3017$var$mapDispatchToProps = {
        dropAnimationFinished: $22db1ba098eb3017$var$dropAnimationFinished
    };
    var $22db1ba098eb3017$var$ConnectedDraggable = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps, $22db1ba098eb3017$var$mapDispatchToProps, null, {
        context: $22db1ba098eb3017$var$StoreContext,
        pure: true,
        areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
    })($22db1ba098eb3017$var$Draggable);
    function $22db1ba098eb3017$var$PrivateDraggable(props) {
        var droppableContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext);
        var isUsingCloneFor = droppableContext.isUsingCloneFor;
        if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ConnectedDraggable, props);
    }
    function $22db1ba098eb3017$export$f2a139e5d18b9882(props) {
        var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
        var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
        var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, (0, $gzM5u.default)({}, props, {
            isClone: false,
            isEnabled: isEnabled,
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress
        }));
    }
    function $22db1ba098eb3017$var$Droppable(props) {
        var appContext = (0, $5uXOq.useContext)($22db1ba098eb3017$var$AppContext);
        !appContext && $22db1ba098eb3017$var$invariant(false);
        var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
        var droppableRef = (0, $5uXOq.useRef)(null);
        var placeholderRef = (0, $5uXOq.useRef)(null);
        var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
        var getDroppableRef = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            return droppableRef.current;
        }, []);
        var setDroppableRef = (0, (0, parcelRequire("3YMLK")).useCallback)(function(value) {
            droppableRef.current = value;
        }, []);
        var getPlaceholderRef = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            return placeholderRef.current;
        }, []);
        var setPlaceholderRef = (0, (0, parcelRequire("3YMLK")).useCallback)(function(value) {
            placeholderRef.current = value;
        }, []);
        $22db1ba098eb3017$var$useValidation({
            props: props,
            getDroppableRef: getDroppableRef,
            getPlaceholderRef: getPlaceholderRef
        });
        var onPlaceholderTransitionEnd = (0, (0, parcelRequire("3YMLK")).useCallback)(function() {
            if (isMovementAllowed()) updateViewportMaxScroll({
                maxScroll: $22db1ba098eb3017$var$getMaxWindowScroll()
            });
        }, [
            isMovementAllowed,
            updateViewportMaxScroll
        ]);
        $22db1ba098eb3017$var$useDroppablePublisher({
            droppableId: droppableId,
            type: type,
            mode: mode,
            direction: direction,
            isDropDisabled: isDropDisabled,
            isCombineEnabled: isCombineEnabled,
            ignoreContainerClipping: ignoreContainerClipping,
            getDroppableRef: getDroppableRef
        });
        var placeholder = (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, function(_ref) {
            var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            });
        });
        var provided = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                innerRef: setDroppableRef,
                placeholder: placeholder,
                droppableProps: {
                    'data-rbd-droppable-id': droppableId,
                    'data-rbd-droppable-context-id': contextId
                }
            };
        }, [
            contextId,
            droppableId,
            placeholder,
            setDroppableRef
        ]);
        var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
        var droppableContext = (0, (0, parcelRequire("3YMLK")).useMemo)(function() {
            return {
                droppableId: droppableId,
                type: type,
                isUsingCloneFor: isUsingCloneFor
            };
        }, [
            droppableId,
            isUsingCloneFor,
            type
        ]);
        function getClone() {
            if (!useClone) return null;
            var dragging = useClone.dragging, render = useClone.render;
            var node = (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, {
                draggableId: dragging.draggableId,
                index: dragging.source.index,
                isClone: true,
                isEnabled: true,
                shouldRespectForcePress: false,
                canDragInteractiveElements: true
            }, function(draggableProvided, draggableSnapshot) {
                return render(draggableProvided, draggableSnapshot, dragging);
            });
            return (0, ($parcel$interopDefault($7nsd3))).createPortal(node, getContainerForClone());
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$DroppableContext.Provider, {
            value: droppableContext
        }, children(provided, snapshot), getClone());
    }
    var $22db1ba098eb3017$var$isMatchingType = function isMatchingType(type, critical) {
        return type === critical.droppable.type;
    };
    var $22db1ba098eb3017$var$getDraggable = function getDraggable(critical, dimensions) {
        return dimensions.draggables[critical.draggable.id];
    };
    var $22db1ba098eb3017$var$makeMapStateToProps$1 = function makeMapStateToProps() {
        var idleWithAnimation = {
            placeholder: null,
            shouldAnimatePlaceholder: true,
            snapshot: {
                isDraggingOver: false,
                draggingOverWith: null,
                draggingFromThisWith: null,
                isUsingPlaceholder: false
            },
            useClone: null
        };
        var idleWithoutAnimation = (0, $gzM5u.default)({}, idleWithAnimation, {
            shouldAnimatePlaceholder: false
        });
        var getDraggableRubric = (0, (0, parcelRequire("g7psY")).default)(function(descriptor) {
            return {
                draggableId: descriptor.id,
                type: descriptor.type,
                source: {
                    index: descriptor.index,
                    droppableId: descriptor.droppableId
                }
            };
        });
        var getMapProps = (0, (0, parcelRequire("g7psY")).default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
            var draggableId = dragging.descriptor.id;
            var isHome = dragging.descriptor.droppableId === id;
            if (isHome) {
                var useClone = renderClone ? {
                    render: renderClone,
                    dragging: getDraggableRubric(dragging.descriptor)
                } : null;
                var _snapshot = {
                    isDraggingOver: isDraggingOverForConsumer,
                    draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                    draggingFromThisWith: draggableId,
                    isUsingPlaceholder: true
                };
                return {
                    placeholder: dragging.placeholder,
                    shouldAnimatePlaceholder: false,
                    snapshot: _snapshot,
                    useClone: useClone
                };
            }
            if (!isEnabled) return idleWithoutAnimation;
            if (!isDraggingOverForImpact) return idleWithAnimation;
            var snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: draggableId,
                draggingFromThisWith: null,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: true,
                snapshot: snapshot,
                useClone: null
            };
        });
        var selector = function selector(state, ownProps) {
            var id = ownProps.droppableId;
            var type = ownProps.type;
            var isEnabled = !ownProps.isDropDisabled;
            var renderClone = ownProps.renderClone;
            if (state.isDragging) {
                var critical = state.critical;
                if (!$22db1ba098eb3017$var$isMatchingType(type, critical)) return idleWithoutAnimation;
                var dragging = $22db1ba098eb3017$var$getDraggable(critical, state.dimensions);
                var isDraggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact) === id;
                return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
            }
            if (state.phase === 'DROP_ANIMATING') {
                var completed = state.completed;
                if (!$22db1ba098eb3017$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
                var _dragging = $22db1ba098eb3017$var$getDraggable(completed.critical, state.dimensions);
                return getMapProps(id, isEnabled, $22db1ba098eb3017$var$whatIsDraggedOverFromResult(completed.result) === id, $22db1ba098eb3017$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
            }
            if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
                var _completed = state.completed;
                if (!$22db1ba098eb3017$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
                var wasOver = $22db1ba098eb3017$var$whatIsDraggedOver(_completed.impact) === id;
                var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
                var isHome = _completed.critical.droppable.id === id;
                if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
                if (isHome) return idleWithAnimation;
                return idleWithoutAnimation;
            }
            return idleWithoutAnimation;
        };
        return selector;
    };
    var $22db1ba098eb3017$var$mapDispatchToProps$1 = {
        updateViewportMaxScroll: $22db1ba098eb3017$var$updateViewportMaxScroll
    };
    function $22db1ba098eb3017$var$getBody() {
        !document.body && $22db1ba098eb3017$var$invariant(false);
        return document.body;
    }
    var $22db1ba098eb3017$var$defaultProps = {
        mode: 'standard',
        type: 'DEFAULT',
        direction: 'vertical',
        isDropDisabled: false,
        isCombineEnabled: false,
        ignoreContainerClipping: false,
        renderClone: null,
        getContainerForClone: $22db1ba098eb3017$var$getBody
    };
    var $22db1ba098eb3017$export$423ec2075359570a = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps$1, $22db1ba098eb3017$var$mapDispatchToProps$1, null, {
        context: $22db1ba098eb3017$var$StoreContext,
        pure: true,
        areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
    })($22db1ba098eb3017$var$Droppable);
    $22db1ba098eb3017$export$423ec2075359570a.defaultProps = $22db1ba098eb3017$var$defaultProps;
});
parcelRegister("1AwyE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128268946ec0acb0$export$2e2bcd8739ae039);
    var $gIDtq = parcelRequire("gIDtq");
    var $blzS6 = parcelRequire("blzS6");
    function $128268946ec0acb0$export$2e2bcd8739ae039(subClass, superClass) {
        subClass.prototype = (0, ($parcel$interopDefault($gIDtq)))(superClass.prototype);
        subClass.prototype.constructor = subClass;
        (0, $blzS6.default)(subClass, superClass);
    }
});
parcelRegister("gIDtq", function(module, exports) {
    module.exports = (parcelRequire("dG4Ay"));
});
parcelRegister("dG4Ay", function(module, exports) {
    parcelRequire("bAALv");
    var $4KXzV = parcelRequire("4KXzV");
    var $9f52c1cdbf61a0ea$require$$Object = $4KXzV.Object;
    module.exports = function create(P, D) {
        return $9f52c1cdbf61a0ea$require$$Object.create(P, D);
    };
});
parcelRegister("bAALv", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    $fNMIk($fNMIk.S, 'Object', {
        create: (parcelRequire("221nn"))
    });
});
parcelRegister("fNMIk", function(module, exports) {
    var $4tgdI = parcelRequire("4tgdI");
    var $4KXzV = parcelRequire("4KXzV");
    var $85v89 = parcelRequire("85v89");
    var $9TfYC = parcelRequire("9TfYC");
    var $8cV4K = parcelRequire("8cV4K");
    var $b811382cedb7c9d6$var$PROTOTYPE = 'prototype';
    var $b811382cedb7c9d6$var$$export = function(type, name, source) {
        var IS_FORCED = type & $b811382cedb7c9d6$var$$export.F;
        var IS_GLOBAL = type & $b811382cedb7c9d6$var$$export.G;
        var IS_STATIC = type & $b811382cedb7c9d6$var$$export.S;
        var IS_PROTO = type & $b811382cedb7c9d6$var$$export.P;
        var IS_BIND = type & $b811382cedb7c9d6$var$$export.B;
        var IS_WRAP = type & $b811382cedb7c9d6$var$$export.W;
        var exports = IS_GLOBAL ? $4KXzV : $4KXzV[name] || ($4KXzV[name] = {});
        var expProto = exports[$b811382cedb7c9d6$var$PROTOTYPE];
        var target = IS_GLOBAL ? $4tgdI : IS_STATIC ? $4tgdI[name] : ($4tgdI[name] || {})[$b811382cedb7c9d6$var$PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;
        for(key in source){
            own = !IS_FORCED && target && target[key] !== undefined;
            if (own && $8cV4K(exports, key)) continue;
            out = own ? target[key] : source[key];
            exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $85v89(out, $4tgdI) : IS_WRAP && target[key] == out ? function(C) {
                var F = function(a, b, c) {
                    if (this instanceof C) {
                        switch(arguments.length){
                            case 0:
                                return new C();
                            case 1:
                                return new C(a);
                            case 2:
                                return new C(a, b);
                        }
                        return new C(a, b, c);
                    }
                    return C.apply(this, arguments);
                };
                F[$b811382cedb7c9d6$var$PROTOTYPE] = C[$b811382cedb7c9d6$var$PROTOTYPE];
                return F;
            }(out) : IS_PROTO && typeof out == 'function' ? $85v89(Function.call, out) : out;
            if (IS_PROTO) {
                (exports.virtual || (exports.virtual = {}))[key] = out;
                if (type & $b811382cedb7c9d6$var$$export.R && expProto && !expProto[key]) $9TfYC(expProto, key, out);
            }
        }
    };
    $b811382cedb7c9d6$var$$export.F = 1;
    $b811382cedb7c9d6$var$$export.G = 2;
    $b811382cedb7c9d6$var$$export.S = 4;
    $b811382cedb7c9d6$var$$export.P = 8;
    $b811382cedb7c9d6$var$$export.B = 16;
    $b811382cedb7c9d6$var$$export.W = 32;
    $b811382cedb7c9d6$var$$export.U = 64;
    $b811382cedb7c9d6$var$$export.R = 128;
    module.exports = $b811382cedb7c9d6$var$$export;
});
parcelRegister("4tgdI", function(module, exports) {
    var $341673df947a4fac$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
    if (typeof __g == 'number') __g = $341673df947a4fac$var$global;
});
parcelRegister("4KXzV", function(module, exports) {
    var $3769ac535e8faf09$var$core = module.exports = {
        version: '2.6.12'
    };
    if (typeof __e == 'number') __e = $3769ac535e8faf09$var$core;
});
parcelRegister("85v89", function(module, exports) {
    var $6fe4N = parcelRequire("6fe4N");
    module.exports = function(fn, that, length) {
        $6fe4N(fn);
        if (that === undefined) return fn;
        switch(length){
            case 1:
                return function(a) {
                    return fn.call(that, a);
                };
            case 2:
                return function(a, b) {
                    return fn.call(that, a, b);
                };
            case 3:
                return function(a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }
        return function() {
            return fn.apply(that, arguments);
        };
    };
});
parcelRegister("6fe4N", function(module, exports) {
    module.exports = function(it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
    };
});
parcelRegister("9TfYC", function(module, exports) {
    var $2J4Nu = parcelRequire("2J4Nu");
    var $azl1x = parcelRequire("azl1x");
    module.exports = (parcelRequire("aPbfY")) ? function(object, key, value) {
        return $2J4Nu.f(object, key, $azl1x(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
});
parcelRegister("2J4Nu", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$1fc38158650d0be0$export$2d1720544b23b823, (v)=>$1fc38158650d0be0$export$2d1720544b23b823 = v);
    var $1fc38158650d0be0$export$2d1720544b23b823;
    var $1J67F = parcelRequire("1J67F");
    var $7fdxi = parcelRequire("7fdxi");
    var $feF34 = parcelRequire("feF34");
    var $1fc38158650d0be0$var$dP = Object.defineProperty;
    $1fc38158650d0be0$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        $1J67F(O);
        P = $feF34(P, true);
        $1J67F(Attributes);
        if ($7fdxi) try {
            return $1fc38158650d0be0$var$dP(O, P, Attributes);
        } catch (e) {}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
});
parcelRegister("1J67F", function(module, exports) {
    var $dxLeJ = parcelRequire("dxLeJ");
    module.exports = function(it) {
        if (!$dxLeJ(it)) throw TypeError(it + ' is not an object!');
        return it;
    };
});
parcelRegister("dxLeJ", function(module, exports) {
    module.exports = function(it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
    };
});
parcelRegister("7fdxi", function(module, exports) {
    module.exports = !(parcelRequire("aPbfY")) && !(parcelRequire("cKvWG"))(function() {
        return Object.defineProperty((parcelRequire("8IahC"))('div'), 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
});
parcelRegister("aPbfY", function(module, exports) {
    module.exports = !(parcelRequire("cKvWG"))(function() {
        return Object.defineProperty({}, 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
});
parcelRegister("cKvWG", function(module, exports) {
    module.exports = function(exec) {
        try {
            return !!exec();
        } catch (e) {
            return true;
        }
    };
});
parcelRegister("8IahC", function(module, exports) {
    var $dxLeJ = parcelRequire("dxLeJ");
    var $4tgdI = parcelRequire("4tgdI");
    var $657a68d5e7e8fca9$require$document = $4tgdI.document;
    var $657a68d5e7e8fca9$var$is = $dxLeJ($657a68d5e7e8fca9$require$document) && $dxLeJ($657a68d5e7e8fca9$require$document.createElement);
    module.exports = function(it) {
        return $657a68d5e7e8fca9$var$is ? $657a68d5e7e8fca9$require$document.createElement(it) : {};
    };
});
parcelRegister("feF34", function(module, exports) {
    var $dxLeJ = parcelRequire("dxLeJ");
    module.exports = function(it, S) {
        if (!$dxLeJ(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
    };
});
parcelRegister("azl1x", function(module, exports) {
    module.exports = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
});
parcelRegister("8cV4K", function(module, exports) {
    var $5f9bb7be8775a474$var$hasOwnProperty = {}.hasOwnProperty;
    module.exports = function(it, key) {
        return $5f9bb7be8775a474$var$hasOwnProperty.call(it, key);
    };
});
parcelRegister("221nn", function(module, exports) {
    var $1J67F = parcelRequire("1J67F");
    var $aRCm2 = parcelRequire("aRCm2");
    var $8LIl9 = parcelRequire("8LIl9");
    var $17acd5ea8a458e2a$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
    var $17acd5ea8a458e2a$var$Empty = function() {};
    var $17acd5ea8a458e2a$var$PROTOTYPE = 'prototype';
    var $17acd5ea8a458e2a$var$createDict = function() {
        var iframe = (parcelRequire("8IahC"))('iframe');
        var i = $8LIl9.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        (parcelRequire("jcava")).appendChild(iframe);
        iframe.src = 'javascript:';
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        $17acd5ea8a458e2a$var$createDict = iframeDocument.F;
        while(i--)delete $17acd5ea8a458e2a$var$createDict[$17acd5ea8a458e2a$var$PROTOTYPE][$8LIl9[i]];
        return $17acd5ea8a458e2a$var$createDict();
    };
    module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
            $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = $1J67F(O);
            result = new $17acd5ea8a458e2a$var$Empty();
            $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = null;
            result[$17acd5ea8a458e2a$var$IE_PROTO] = O;
        } else result = $17acd5ea8a458e2a$var$createDict();
        return Properties === undefined ? result : $aRCm2(result, Properties);
    };
});
parcelRegister("aRCm2", function(module, exports) {
    var $2J4Nu = parcelRequire("2J4Nu");
    var $1J67F = parcelRequire("1J67F");
    var $iTod0 = parcelRequire("iTod0");
    module.exports = (parcelRequire("aPbfY")) ? Object.defineProperties : function defineProperties(O, Properties) {
        $1J67F(O);
        var keys = $iTod0(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while(length > i)$2J4Nu.f(O, P = keys[i++], Properties[P]);
        return O;
    };
});
parcelRegister("iTod0", function(module, exports) {
    var $vYsY4 = parcelRequire("vYsY4");
    var $8LIl9 = parcelRequire("8LIl9");
    module.exports = Object.keys || function keys(O) {
        return $vYsY4(O, $8LIl9);
    };
});
parcelRegister("vYsY4", function(module, exports) {
    var $8cV4K = parcelRequire("8cV4K");
    var $ehxEQ = parcelRequire("ehxEQ");
    var $0601ccb297d1ed28$var$arrayIndexOf = (parcelRequire("80pUB"))(false);
    var $0601ccb297d1ed28$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
    module.exports = function(object, names) {
        var O = $ehxEQ(object);
        var i = 0;
        var result = [];
        var key;
        for(key in O)if (key != $0601ccb297d1ed28$var$IE_PROTO) $8cV4K(O, key) && result.push(key);
        while(names.length > i)if ($8cV4K(O, key = names[i++])) ~$0601ccb297d1ed28$var$arrayIndexOf(result, key) || result.push(key);
        return result;
    };
});
parcelRegister("ehxEQ", function(module, exports) {
    var $45UmF = parcelRequire("45UmF");
    var $3BBLi = parcelRequire("3BBLi");
    module.exports = function(it) {
        return $45UmF($3BBLi(it));
    };
});
parcelRegister("45UmF", function(module, exports) {
    var $g8809 = parcelRequire("g8809");
    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
        return $g8809(it) == 'String' ? it.split('') : Object(it);
    };
});
parcelRegister("g8809", function(module, exports) {
    var $bbe399a4209a50a6$var$toString = {}.toString;
    module.exports = function(it) {
        return $bbe399a4209a50a6$var$toString.call(it).slice(8, -1);
    };
});
parcelRegister("3BBLi", function(module, exports) {
    module.exports = function(it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
    };
});
parcelRegister("80pUB", function(module, exports) {
    var $ehxEQ = parcelRequire("ehxEQ");
    var $fVjkK = parcelRequire("fVjkK");
    var $eh5pH = parcelRequire("eh5pH");
    module.exports = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = $ehxEQ($this);
            var length = $fVjkK(O.length);
            var index = $eh5pH(fromIndex, length);
            var value;
            if (IS_INCLUDES && el != el) while(length > index){
                value = O[index++];
                if (value != value) return true;
            }
            else for(; length > index; index++)if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };
});
parcelRegister("fVjkK", function(module, exports) {
    var $9E260 = parcelRequire("9E260");
    var $b97b2d25065ac7b9$var$min = Math.min;
    module.exports = function(it) {
        return it > 0 ? $b97b2d25065ac7b9$var$min($9E260(it), 0x1fffffffffffff) : 0;
    };
});
parcelRegister("9E260", function(module, exports) {
    var $705979a7eeb2722c$var$ceil = Math.ceil;
    var $705979a7eeb2722c$var$floor = Math.floor;
    module.exports = function(it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? $705979a7eeb2722c$var$floor : $705979a7eeb2722c$var$ceil)(it);
    };
});
parcelRegister("eh5pH", function(module, exports) {
    var $9E260 = parcelRequire("9E260");
    var $a646da372e065330$var$max = Math.max;
    var $a646da372e065330$var$min = Math.min;
    module.exports = function(index, length) {
        index = $9E260(index);
        return index < 0 ? $a646da372e065330$var$max(index + length, 0) : $a646da372e065330$var$min(index, length);
    };
});
parcelRegister("fZhMi", function(module, exports) {
    var $ba3a57d696ea3f5e$var$shared = (parcelRequire("51eCU"))('keys');
    var $6oFvJ = parcelRequire("6oFvJ");
    module.exports = function(key) {
        return $ba3a57d696ea3f5e$var$shared[key] || ($ba3a57d696ea3f5e$var$shared[key] = $6oFvJ(key));
    };
});
parcelRegister("51eCU", function(module, exports) {
    var $4KXzV = parcelRequire("4KXzV");
    var $4tgdI = parcelRequire("4tgdI");
    var $3a78644a27e09ff7$var$SHARED = '__core-js_shared__';
    var $3a78644a27e09ff7$var$store = $4tgdI[$3a78644a27e09ff7$var$SHARED] || ($4tgdI[$3a78644a27e09ff7$var$SHARED] = {});
    (module.exports = function(key, value) {
        return $3a78644a27e09ff7$var$store[key] || ($3a78644a27e09ff7$var$store[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: $4KXzV.version,
        mode: (parcelRequire("fQqAk")) ? 'pure' : 'global',
        copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
    });
});
parcelRegister("fQqAk", function(module, exports) {
    module.exports = true;
});
parcelRegister("6oFvJ", function(module, exports) {
    var $4a852f27f31a7144$var$id = 0;
    var $4a852f27f31a7144$var$px = Math.random();
    module.exports = function(key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$4a852f27f31a7144$var$id + $4a852f27f31a7144$var$px).toString(36));
    };
});
parcelRegister("8LIl9", function(module, exports) {
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
});
parcelRegister("jcava", function(module, exports) {
    var $4tgdI = parcelRequire("4tgdI");
    var $df9748b6b5115090$require$document = $4tgdI.document;
    module.exports = $df9748b6b5115090$require$document && $df9748b6b5115090$require$document.documentElement;
});
parcelRegister("blzS6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0221c40d50c91a18$export$2e2bcd8739ae039);
    var $XfZ8C = parcelRequire("XfZ8C");
    function $0221c40d50c91a18$export$2e2bcd8739ae039(o, p) {
        $0221c40d50c91a18$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($XfZ8C))) ? (0, ($parcel$interopDefault($XfZ8C))).bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $0221c40d50c91a18$export$2e2bcd8739ae039(o, p);
    }
});
parcelRegister("XfZ8C", function(module, exports) {
    module.exports = (parcelRequire("54tg9"));
});
parcelRegister("54tg9", function(module, exports) {
    parcelRequire("lLIVa");
    module.exports = (parcelRequire("4KXzV")).Object.setPrototypeOf;
});
parcelRegister("lLIVa", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    $fNMIk($fNMIk.S, 'Object', {
        setPrototypeOf: (parcelRequire("j14FP")).set
    });
});
parcelRegister("j14FP", function(module, exports) {
    var $dxLeJ = parcelRequire("dxLeJ");
    var $1J67F = parcelRequire("1J67F");
    var $dd81bc62c5518cb8$var$check = function(O, proto) {
        $1J67F(O);
        if (!$dxLeJ(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
    };
    module.exports = {
        set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
            try {
                set = (parcelRequire("85v89"))(Function.call, (parcelRequire("fZ4ki")).f(Object.prototype, '__proto__').set, 2);
                set(test, []);
                buggy = !(test instanceof Array);
            } catch (e) {
                buggy = true;
            }
            return function setPrototypeOf(O, proto) {
                $dd81bc62c5518cb8$var$check(O, proto);
                if (buggy) O.__proto__ = proto;
                else set(O, proto);
                return O;
            };
        }({}, false) : undefined),
        check: $dd81bc62c5518cb8$var$check
    };
});
parcelRegister("fZ4ki", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$ba2fe8a7b47b04c8$export$2d1720544b23b823, (v)=>$ba2fe8a7b47b04c8$export$2d1720544b23b823 = v);
    var $ba2fe8a7b47b04c8$export$2d1720544b23b823;
    var $1paSc = parcelRequire("1paSc");
    var $azl1x = parcelRequire("azl1x");
    var $ehxEQ = parcelRequire("ehxEQ");
    var $feF34 = parcelRequire("feF34");
    var $8cV4K = parcelRequire("8cV4K");
    var $7fdxi = parcelRequire("7fdxi");
    var $ba2fe8a7b47b04c8$var$gOPD = Object.getOwnPropertyDescriptor;
    $ba2fe8a7b47b04c8$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? $ba2fe8a7b47b04c8$var$gOPD : function getOwnPropertyDescriptor(O, P) {
        O = $ehxEQ(O);
        P = $feF34(P, true);
        if ($7fdxi) try {
            return $ba2fe8a7b47b04c8$var$gOPD(O, P);
        } catch (e) {}
        if ($8cV4K(O, P)) return $azl1x(!$1paSc.f.call(O, P), O[P]);
    };
});
parcelRegister("1paSc", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$10608f6e292983ab$export$2d1720544b23b823, (v)=>$10608f6e292983ab$export$2d1720544b23b823 = v);
    var $10608f6e292983ab$export$2d1720544b23b823;
    $10608f6e292983ab$export$2d1720544b23b823 = ({}).propertyIsEnumerable;
});
parcelRegister("gzM5u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c115376b03ce6805$export$2e2bcd8739ae039);
    var $4iZOV = parcelRequire("4iZOV");
    function $c115376b03ce6805$export$2e2bcd8739ae039() {
        $c115376b03ce6805$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($4iZOV))) ? (0, ($parcel$interopDefault($4iZOV))).bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return $c115376b03ce6805$export$2e2bcd8739ae039.apply(this, arguments);
    }
});
parcelRegister("4iZOV", function(module, exports) {
    module.exports = (parcelRequire("jSAle"));
});
parcelRegister("jSAle", function(module, exports) {
    parcelRequire("gGoAI");
    module.exports = (parcelRequire("4KXzV")).Object.assign;
});
parcelRegister("gGoAI", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    $fNMIk($fNMIk.S + $fNMIk.F, 'Object', {
        assign: (parcelRequire("f40xK"))
    });
});
parcelRegister("f40xK", function(module, exports) {
    'use strict';
    var $aPbfY = parcelRequire("aPbfY");
    var $iTod0 = parcelRequire("iTod0");
    var $8SJ8c = parcelRequire("8SJ8c");
    var $1paSc = parcelRequire("1paSc");
    var $llAOy = parcelRequire("llAOy");
    var $45UmF = parcelRequire("45UmF");
    var $af77a69d8871d271$var$$assign = Object.assign;
    module.exports = !$af77a69d8871d271$var$$assign || (parcelRequire("cKvWG"))(function() {
        var A = {};
        var B = {};
        var S = Symbol();
        var K = 'abcdefghijklmnopqrst';
        A[S] = 7;
        K.split('').forEach(function(k) {
            B[k] = k;
        });
        return $af77a69d8871d271$var$$assign({}, A)[S] != 7 || Object.keys($af77a69d8871d271$var$$assign({}, B)).join('') != K;
    }) ? function assign(target, source) {
        var T = $llAOy(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = $8SJ8c.f;
        var isEnum = $1paSc.f;
        while(aLen > index){
            var S = $45UmF(arguments[index++]);
            var keys = getSymbols ? $iTod0(S).concat(getSymbols(S)) : $iTod0(S);
            var length = keys.length;
            var j = 0;
            var key;
            while(length > j){
                key = keys[j++];
                if (!$aPbfY || isEnum.call(S, key)) T[key] = S[key];
            }
        }
        return T;
    } : $af77a69d8871d271$var$$assign;
});
parcelRegister("8SJ8c", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$67765ffbebba3db3$export$2d1720544b23b823, (v)=>$67765ffbebba3db3$export$2d1720544b23b823 = v);
    var $67765ffbebba3db3$export$2d1720544b23b823;
    $67765ffbebba3db3$export$2d1720544b23b823 = Object.getOwnPropertySymbols;
});
parcelRegister("llAOy", function(module, exports) {
    var $3BBLi = parcelRequire("3BBLi");
    module.exports = function(it) {
        return Object($3BBLi(it));
    };
});
parcelRegister("22j3V", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$17ba8e0cb3c50187$export$f51a9068ac82ea43);
    $parcel$export(module.exports, "combineReducers", ()=>$17ba8e0cb3c50187$export$66e4520cdb265d18);
    $parcel$export(module.exports, "bindActionCreators", ()=>$17ba8e0cb3c50187$export$aea084d96e84da92);
    $parcel$export(module.exports, "compose", ()=>$17ba8e0cb3c50187$export$f672e0b6f7222cd7);
    $parcel$export(module.exports, "applyMiddleware", ()=>$17ba8e0cb3c50187$export$9ff26e0402cc7b7);
    var $d56Hw = parcelRequire("d56Hw");
    function $17ba8e0cb3c50187$var$formatProdErrorMessage(code) {
        return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
    }
    var $17ba8e0cb3c50187$var$$$observable = function() {
        return typeof Symbol === 'function' && Symbol.observable || '@@observable';
    }();
    var $17ba8e0cb3c50187$var$randomString = function randomString() {
        return Math.random().toString(36).substring(7).split('').join('.');
    };
    var $17ba8e0cb3c50187$export$4219e499db7ca678 = {
        INIT: "@@redux/INIT" + $17ba8e0cb3c50187$var$randomString(),
        REPLACE: "@@redux/REPLACE" + $17ba8e0cb3c50187$var$randomString(),
        PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
            return "@@redux/PROBE_UNKNOWN_ACTION" + $17ba8e0cb3c50187$var$randomString();
        }
    };
    function $17ba8e0cb3c50187$var$isPlainObject(obj) {
        if (typeof obj !== 'object' || obj === null) return false;
        var proto = obj;
        while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
        return Object.getPrototypeOf(obj) === proto;
    }
    function $17ba8e0cb3c50187$var$miniKindOf(val) {
        if (val === void 0) return 'undefined';
        if (val === null) return 'null';
        var type = typeof val;
        switch(type){
            case 'boolean':
            case 'string':
            case 'number':
            case 'symbol':
            case 'function':
                return type;
        }
        if (Array.isArray(val)) return 'array';
        if ($17ba8e0cb3c50187$var$isDate(val)) return 'date';
        if ($17ba8e0cb3c50187$var$isError(val)) return 'error';
        var constructorName = $17ba8e0cb3c50187$var$ctorName(val);
        switch(constructorName){
            case 'Symbol':
            case 'Promise':
            case 'WeakMap':
            case 'WeakSet':
            case 'Map':
            case 'Set':
                return constructorName;
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
    }
    function $17ba8e0cb3c50187$var$ctorName(val) {
        return typeof val.constructor === 'function' ? val.constructor.name : null;
    }
    function $17ba8e0cb3c50187$var$isError(val) {
        return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
    }
    function $17ba8e0cb3c50187$var$isDate(val) {
        if (val instanceof Date) return true;
        return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
    }
    function $17ba8e0cb3c50187$var$kindOf(val) {
        var typeOfVal = typeof val;
        return typeOfVal;
    }
    function $17ba8e0cb3c50187$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
        var _ref2;
        if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(0));
        if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
            enhancer = preloadedState;
            preloadedState = undefined;
        }
        if (typeof enhancer !== 'undefined') {
            if (typeof enhancer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(1));
            return enhancer($17ba8e0cb3c50187$export$f51a9068ac82ea43)(reducer, preloadedState);
        }
        if (typeof reducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(2));
        var currentReducer = reducer;
        var currentState = preloadedState;
        var currentListeners = [];
        var nextListeners = currentListeners;
        var isDispatching = false;
        function ensureCanMutateNextListeners() {
            if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
        }
        function getState() {
            if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(3));
            return currentState;
        }
        function subscribe(listener) {
            if (typeof listener !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(4));
            if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(5));
            var isSubscribed = true;
            ensureCanMutateNextListeners();
            nextListeners.push(listener);
            return function unsubscribe() {
                if (!isSubscribed) return;
                if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(6));
                isSubscribed = false;
                ensureCanMutateNextListeners();
                var index = nextListeners.indexOf(listener);
                nextListeners.splice(index, 1);
                currentListeners = null;
            };
        }
        function dispatch(action) {
            if (!$17ba8e0cb3c50187$var$isPlainObject(action)) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(7));
            if (typeof action.type === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(8));
            if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(9));
            try {
                isDispatching = true;
                currentState = currentReducer(currentState, action);
            } finally{
                isDispatching = false;
            }
            var listeners = currentListeners = nextListeners;
            for(var i = 0; i < listeners.length; i++){
                var listener = listeners[i];
                listener();
            }
            return action;
        }
        function replaceReducer(nextReducer) {
            if (typeof nextReducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(10));
            currentReducer = nextReducer;
            dispatch({
                type: $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE
            });
        }
        function observable() {
            var _ref;
            var outerSubscribe = subscribe;
            return _ref = {
                subscribe: function subscribe(observer) {
                    if (typeof observer !== 'object' || observer === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(11));
                    function observeState() {
                        if (observer.next) observer.next(getState());
                    }
                    observeState();
                    var unsubscribe = outerSubscribe(observeState);
                    return {
                        unsubscribe: unsubscribe
                    };
                }
            }, _ref[$17ba8e0cb3c50187$var$$$observable] = function() {
                return this;
            }, _ref;
        }
        dispatch({
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
        });
        return _ref2 = {
            dispatch: dispatch,
            subscribe: subscribe,
            getState: getState,
            replaceReducer: replaceReducer
        }, _ref2[$17ba8e0cb3c50187$var$$$observable] = observable, _ref2;
    }
    var $17ba8e0cb3c50187$export$8928921ea2d3b126 = $17ba8e0cb3c50187$export$f51a9068ac82ea43;
    function $17ba8e0cb3c50187$var$warning(message) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
    function $17ba8e0cb3c50187$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
        var reducerKeys = Object.keys(reducers);
        var argumentName = action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
        if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
        if (!$17ba8e0cb3c50187$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $17ba8e0cb3c50187$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
        var unexpectedKeys = Object.keys(inputState).filter(function(key) {
            return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
        });
        unexpectedKeys.forEach(function(key) {
            unexpectedKeyCache[key] = true;
        });
        if (action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE) return;
        if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
    }
    function $17ba8e0cb3c50187$var$assertReducerShape(reducers) {
        Object.keys(reducers).forEach(function(key) {
            var reducer = reducers[key];
            var initialState = reducer(undefined, {
                type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
            });
            if (typeof initialState === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(12));
            if (typeof reducer(undefined, {
                type: $17ba8e0cb3c50187$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
            }) === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(13));
        });
    }
    function $17ba8e0cb3c50187$export$66e4520cdb265d18(reducers) {
        var reducerKeys = Object.keys(reducers);
        var finalReducers = {};
        for(var i = 0; i < reducerKeys.length; i++){
            var key = reducerKeys[i];
            if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
        }
        var finalReducerKeys = Object.keys(finalReducers);
        var unexpectedKeyCache;
        var shapeAssertionError;
        try {
            $17ba8e0cb3c50187$var$assertReducerShape(finalReducers);
        } catch (e) {
            shapeAssertionError = e;
        }
        return function combination(state, action) {
            if (state === void 0) state = {};
            if (shapeAssertionError) throw shapeAssertionError;
            var warningMessage;
            var hasChanged = false;
            var nextState = {};
            for(var _i = 0; _i < finalReducerKeys.length; _i++){
                var _key = finalReducerKeys[_i];
                var reducer = finalReducers[_key];
                var previousStateForKey = state[_key];
                var nextStateForKey = reducer(previousStateForKey, action);
                if (typeof nextStateForKey === 'undefined') {
                    var actionType = action && action.type;
                    throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(14));
                }
                nextState[_key] = nextStateForKey;
                hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
            }
            hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
            return hasChanged ? nextState : state;
        };
    }
    function $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch) {
        return function() {
            return dispatch(actionCreator.apply(this, arguments));
        };
    }
    function $17ba8e0cb3c50187$export$aea084d96e84da92(actionCreators, dispatch) {
        if (typeof actionCreators === 'function') return $17ba8e0cb3c50187$var$bindActionCreator(actionCreators, dispatch);
        if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(16));
        var boundActionCreators = {};
        for(var key in actionCreators){
            var actionCreator = actionCreators[key];
            if (typeof actionCreator === 'function') boundActionCreators[key] = $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch);
        }
        return boundActionCreators;
    }
    function $17ba8e0cb3c50187$export$f672e0b6f7222cd7() {
        for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
        if (funcs.length === 0) return function(arg) {
            return arg;
        };
        if (funcs.length === 1) return funcs[0];
        return funcs.reduce(function(a, b) {
            return function() {
                return a(b.apply(void 0, arguments));
            };
        });
    }
    function $17ba8e0cb3c50187$export$9ff26e0402cc7b7() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
        return function(createStore) {
            return function() {
                var store = createStore.apply(void 0, arguments);
                var _dispatch = function dispatch() {
                    throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(15));
                };
                var middlewareAPI = {
                    getState: store.getState,
                    dispatch: function dispatch() {
                        return _dispatch.apply(void 0, arguments);
                    }
                };
                var chain = middlewares.map(function(middleware) {
                    return middleware(middlewareAPI);
                });
                _dispatch = $17ba8e0cb3c50187$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
                return (0, $d56Hw.default)((0, $d56Hw.default)({}, store), {}, {
                    dispatch: _dispatch
                });
            };
        };
    }
});
parcelRegister("d56Hw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9860f0a512598bc6$export$2e2bcd8739ae039);
    var $eHiP8 = parcelRequire("eHiP8");
    function $9860f0a512598bc6$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $9860f0a512598bc6$export$2e2bcd8739ae039(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $9860f0a512598bc6$var$ownKeys(Object(t), !0).forEach(function(r) {
                (0, $eHiP8.default)(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9860f0a512598bc6$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
});
parcelRegister("i6AsN", function(module, exports) {
    $parcel$export(module.exports, "connect", ()=>(parcelRequire("AuRrZ")).default);
    $parcel$export(module.exports, "Provider", ()=>(parcelRequire("9bdMd")).default);
    $parcel$export(module.exports, "useDispatch", ()=>(parcelRequire("616sH")).useDispatch);
    $parcel$export(module.exports, "useSelector", ()=>(parcelRequire("6S8MB")).useSelector);
    parcelRequire("dDvQ8");
    parcelRequire("8mhVE");
    var $7nsd3 = parcelRequire("7nsd3");
    var $297cv = parcelRequire("297cv");
    (0, $297cv.setBatch)((0, $7nsd3.unstable_batchedUpdates));
});
parcelRegister("dDvQ8", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>(parcelRequire("9bdMd")).default);
    $parcel$export(module.exports, "connect", ()=>(parcelRequire("AuRrZ")).default);
    $parcel$export(module.exports, "useDispatch", ()=>(parcelRequire("616sH")).useDispatch);
    $parcel$export(module.exports, "useSelector", ()=>(parcelRequire("6S8MB")).useSelector);
    var $9bdMd = parcelRequire("9bdMd");
    var $evQWN = parcelRequire("evQWN");
    var $eZhPT = parcelRequire("eZhPT");
    var $AuRrZ = parcelRequire("AuRrZ");
    var $616sH = parcelRequire("616sH");
    var $6S8MB = parcelRequire("6S8MB");
    var $5sekt = parcelRequire("5sekt");
    var $ggTLx = parcelRequire("ggTLx");
});
parcelRegister("9bdMd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6aefd3e4140316d1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZhPT = parcelRequire("eZhPT");
    var $arhzp = parcelRequire("arhzp");
    var $gneWW = parcelRequire("gneWW");
    function $6aefd3e4140316d1$var$Provider(_ref) {
        var store = _ref.store, context = _ref.context, children = _ref.children;
        var contextValue = (0, $5uXOq.useMemo)(function() {
            var subscription = (0, $arhzp.createSubscription)(store);
            return {
                store: store,
                subscription: subscription
            };
        }, [
            store
        ]);
        var previousState = (0, $5uXOq.useMemo)(function() {
            return store.getState();
        }, [
            store
        ]);
        (0, $gneWW.useIsomorphicLayoutEffect)(function() {
            var subscription = contextValue.subscription;
            subscription.onStateChange = subscription.notifyNestedSubs;
            subscription.trySubscribe();
            if (previousState !== store.getState()) subscription.notifyNestedSubs();
            return function() {
                subscription.tryUnsubscribe();
                subscription.onStateChange = null;
            };
        }, [
            contextValue,
            previousState
        ]);
        var Context = context || (0, $eZhPT.ReactReduxContext);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: contextValue
        }, children);
    }
    var $6aefd3e4140316d1$export$2e2bcd8739ae039 = $6aefd3e4140316d1$var$Provider;
});
parcelRegister("eZhPT", function(module, exports) {
    $parcel$export(module.exports, "ReactReduxContext", ()=>$ae9499069f1e06d6$export$cc80c08dc91f1c00);
    var $5uXOq = parcelRequire("5uXOq");
    var $ae9499069f1e06d6$export$cc80c08dc91f1c00 = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    var $ae9499069f1e06d6$export$2e2bcd8739ae039 = $ae9499069f1e06d6$export$cc80c08dc91f1c00;
});
parcelRegister("arhzp", function(module, exports) {
    $parcel$export(module.exports, "createSubscription", ()=>$799a0e0be31b1662$export$d567d2b9af322f8f);
    var $297cv = parcelRequire("297cv");
    function $799a0e0be31b1662$var$createListenerCollection() {
        var batch = (0, $297cv.getBatch)();
        var first = null;
        var last = null;
        return {
            clear: function clear() {
                first = null;
                last = null;
            },
            notify: function notify() {
                batch(function() {
                    var listener = first;
                    while(listener){
                        listener.callback();
                        listener = listener.next;
                    }
                });
            },
            get: function get() {
                var listeners = [];
                var listener = first;
                while(listener){
                    listeners.push(listener);
                    listener = listener.next;
                }
                return listeners;
            },
            subscribe: function subscribe(callback) {
                var isSubscribed = true;
                var listener = last = {
                    callback: callback,
                    next: null,
                    prev: last
                };
                if (listener.prev) listener.prev.next = listener;
                else first = listener;
                return function unsubscribe() {
                    if (!isSubscribed || first === null) return;
                    isSubscribed = false;
                    if (listener.next) listener.next.prev = listener.prev;
                    else last = listener.prev;
                    if (listener.prev) listener.prev.next = listener.next;
                    else first = listener.next;
                };
            }
        };
    }
    var $799a0e0be31b1662$var$nullListeners = {
        notify: function notify() {},
        get: function get() {
            return [];
        }
    };
    function $799a0e0be31b1662$export$d567d2b9af322f8f(store, parentSub) {
        var unsubscribe;
        var listeners = $799a0e0be31b1662$var$nullListeners;
        function addNestedSub(listener) {
            trySubscribe();
            return listeners.subscribe(listener);
        }
        function notifyNestedSubs() {
            listeners.notify();
        }
        function handleChangeWrapper() {
            if (subscription.onStateChange) subscription.onStateChange();
        }
        function isSubscribed() {
            return Boolean(unsubscribe);
        }
        function trySubscribe() {
            if (!unsubscribe) {
                unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
                listeners = $799a0e0be31b1662$var$createListenerCollection();
            }
        }
        function tryUnsubscribe() {
            if (unsubscribe) {
                unsubscribe();
                unsubscribe = undefined;
                listeners.clear();
                listeners = $799a0e0be31b1662$var$nullListeners;
            }
        }
        var subscription = {
            addNestedSub: addNestedSub,
            notifyNestedSubs: notifyNestedSubs,
            handleChangeWrapper: handleChangeWrapper,
            isSubscribed: isSubscribed,
            trySubscribe: trySubscribe,
            tryUnsubscribe: tryUnsubscribe,
            getListeners: function getListeners() {
                return listeners;
            }
        };
        return subscription;
    }
});
parcelRegister("297cv", function(module, exports) {
    $parcel$export(module.exports, "setBatch", ()=>$190201f2d37d6502$export$4b9874722d0da7bc);
    $parcel$export(module.exports, "getBatch", ()=>$190201f2d37d6502$export$fc47d4c0ba3bd2c6);
    function $190201f2d37d6502$var$defaultNoopBatch(callback) {
        callback();
    }
    var $190201f2d37d6502$var$batch = $190201f2d37d6502$var$defaultNoopBatch;
    var $190201f2d37d6502$export$4b9874722d0da7bc = function setBatch(newBatch) {
        return $190201f2d37d6502$var$batch = newBatch;
    };
    var $190201f2d37d6502$export$fc47d4c0ba3bd2c6 = function getBatch() {
        return $190201f2d37d6502$var$batch;
    };
});
parcelRegister("gneWW", function(module, exports) {
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$beba64068692f8ee$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $beba64068692f8ee$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);
});
parcelRegister("evQWN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a90d08332793f660$export$2e2bcd8739ae039);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $dY8Js = parcelRequire("dY8Js");
    var $5uXOq = parcelRequire("5uXOq");
    var $bCzx0 = parcelRequire("bCzx0");
    var $arhzp = parcelRequire("arhzp");
    var $gneWW = parcelRequire("gneWW");
    var $eZhPT = parcelRequire("eZhPT");
    var $a90d08332793f660$var$_excluded = [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ], $a90d08332793f660$var$_excluded2 = [
        "reactReduxForwardedRef"
    ];
    var $a90d08332793f660$var$EMPTY_ARRAY = [];
    var $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY = [
        null,
        null
    ];
    var $a90d08332793f660$var$stringifyComponent = function stringifyComponent(Comp) {
        try {
            return JSON.stringify(Comp);
        } catch (err) {
            return String(Comp);
        }
    };
    function $a90d08332793f660$var$storeStateUpdatesReducer(state, action) {
        var updateCount = state[1];
        return [
            action.payload,
            updateCount + 1
        ];
    }
    function $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
        (0, $gneWW.useIsomorphicLayoutEffect)(function() {
            return effectFunc.apply(void 0, effectArgs);
        }, dependencies);
    }
    function $a90d08332793f660$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
        lastWrapperProps.current = wrapperProps;
        lastChildProps.current = actualChildProps;
        renderIsScheduled.current = false;
        if (childPropsFromStoreUpdate.current) {
            childPropsFromStoreUpdate.current = null;
            notifyNestedSubs();
        }
    }
    function $a90d08332793f660$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
        if (!shouldHandleStateChanges) return;
        var didUnsubscribe = false;
        var lastThrownError = null;
        var checkForUpdates = function checkForUpdates() {
            if (didUnsubscribe) return;
            var latestStoreState = store.getState();
            var newChildProps, error;
            try {
                newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
            } catch (e) {
                error = e;
                lastThrownError = e;
            }
            if (!error) lastThrownError = null;
            if (newChildProps === lastChildProps.current) {
                if (!renderIsScheduled.current) notifyNestedSubs();
            } else {
                lastChildProps.current = newChildProps;
                childPropsFromStoreUpdate.current = newChildProps;
                renderIsScheduled.current = true;
                forceComponentUpdateDispatch({
                    type: 'STORE_UPDATED',
                    payload: {
                        error: error
                    }
                });
            }
        };
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        var unsubscribeWrapper = function unsubscribeWrapper() {
            didUnsubscribe = true;
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
            if (lastThrownError) throw lastThrownError;
        };
        return unsubscribeWrapper;
    }
    var $a90d08332793f660$var$initStateUpdates = function initStateUpdates() {
        return [
            null,
            0
        ];
    };
    function $a90d08332793f660$export$2e2bcd8739ae039(selectorFactory, _ref) {
        if (_ref === void 0) _ref = {};
        var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
            return "ConnectAdvanced(" + name + ")";
        } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $eZhPT.ReactReduxContext) : _ref2$context, connectOptions = (0, $ddEsc.default)(_ref2, $a90d08332793f660$var$_excluded);
        var customStoreWarningMessage;
        var Context = context;
        return function wrapWithConnect(WrappedComponent) {
            var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
            var displayName = getDisplayName(wrappedComponentName);
            var selectorFactoryOptions = (0, $bS32t.default)({}, connectOptions, {
                getDisplayName: getDisplayName,
                methodName: methodName,
                renderCountProp: renderCountProp,
                shouldHandleStateChanges: shouldHandleStateChanges,
                storeKey: storeKey,
                displayName: displayName,
                wrappedComponentName: wrappedComponentName,
                WrappedComponent: WrappedComponent
            });
            var pure = connectOptions.pure;
            function createChildSelector(store) {
                return selectorFactory(store.dispatch, selectorFactoryOptions);
            }
            var usePureOnlyMemo = pure ? (0, $5uXOq.useMemo) : function(callback) {
                return callback();
            };
            function ConnectFunction(props) {
                var _useMemo = (0, $5uXOq.useMemo)(function() {
                    var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $ddEsc.default)(props, $a90d08332793f660$var$_excluded2);
                    return [
                        props.context,
                        reactReduxForwardedRef,
                        wrapperProps
                    ];
                }, [
                    props
                ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
                var ContextToUse = (0, $5uXOq.useMemo)(function() {
                    return propsContext && propsContext.Consumer && (0, $bCzx0.isContextConsumer)((0, ($parcel$interopDefault($5uXOq))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
                }, [
                    propsContext,
                    Context
                ]);
                var contextValue = (0, $5uXOq.useContext)(ContextToUse);
                var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
                var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
                var store = didStoreComeFromProps ? props.store : contextValue.store;
                var childPropsSelector = (0, $5uXOq.useMemo)(function() {
                    return createChildSelector(store);
                }, [
                    store
                ]);
                var _useMemo2 = (0, $5uXOq.useMemo)(function() {
                    if (!shouldHandleStateChanges) return $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY;
                    var subscription = (0, $arhzp.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription);
                    var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                    return [
                        subscription,
                        notifyNestedSubs
                    ];
                }, [
                    store,
                    didStoreComeFromProps,
                    contextValue
                ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1];
                var overriddenContextValue = (0, $5uXOq.useMemo)(function() {
                    if (didStoreComeFromProps) return contextValue;
                    return (0, $bS32t.default)({}, contextValue, {
                        subscription: subscription
                    });
                }, [
                    didStoreComeFromProps,
                    contextValue,
                    subscription
                ]);
                var _useReducer = (0, $5uXOq.useReducer)($a90d08332793f660$var$storeStateUpdatesReducer, $a90d08332793f660$var$EMPTY_ARRAY, $a90d08332793f660$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1];
                if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
                var lastChildProps = (0, $5uXOq.useRef)();
                var lastWrapperProps = (0, $5uXOq.useRef)(wrapperProps);
                var childPropsFromStoreUpdate = (0, $5uXOq.useRef)();
                var renderIsScheduled = (0, $5uXOq.useRef)(false);
                var actualChildProps = usePureOnlyMemo(function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                }, [
                    store,
                    previousStateUpdateResult,
                    wrapperProps
                ]);
                $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$captureWrapperProps, [
                    lastWrapperProps,
                    lastChildProps,
                    renderIsScheduled,
                    wrapperProps,
                    actualChildProps,
                    childPropsFromStoreUpdate,
                    notifyNestedSubs
                ]);
                $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$subscribeUpdates, [
                    shouldHandleStateChanges,
                    store,
                    subscription,
                    childPropsSelector,
                    lastWrapperProps,
                    lastChildProps,
                    renderIsScheduled,
                    childPropsFromStoreUpdate,
                    notifyNestedSubs,
                    forceComponentUpdateDispatch
                ], [
                    store,
                    subscription,
                    childPropsSelector
                ]);
                var renderedWrappedComponent = (0, $5uXOq.useMemo)(function() {
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, (0, $bS32t.default)({}, actualChildProps, {
                        ref: reactReduxForwardedRef
                    }));
                }, [
                    reactReduxForwardedRef,
                    WrappedComponent,
                    actualChildProps
                ]);
                var renderedChild = (0, $5uXOq.useMemo)(function() {
                    if (shouldHandleStateChanges) return (0, ($parcel$interopDefault($5uXOq))).createElement(ContextToUse.Provider, {
                        value: overriddenContextValue
                    }, renderedWrappedComponent);
                    return renderedWrappedComponent;
                }, [
                    ContextToUse,
                    renderedWrappedComponent,
                    overriddenContextValue
                ]);
                return renderedChild;
            }
            var Connect = pure ? (0, ($parcel$interopDefault($5uXOq))).memo(ConnectFunction) : ConnectFunction;
            Connect.WrappedComponent = WrappedComponent;
            Connect.displayName = ConnectFunction.displayName = displayName;
            if (forwardRef) {
                var forwarded = (0, ($parcel$interopDefault($5uXOq))).forwardRef(function forwardConnectRef(props, ref) {
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(Connect, (0, $bS32t.default)({}, props, {
                        reactReduxForwardedRef: ref
                    }));
                });
                forwarded.displayName = displayName;
                forwarded.WrappedComponent = WrappedComponent;
                return (0, ($parcel$interopDefault($dY8Js)))(forwarded, WrappedComponent);
            }
            return (0, ($parcel$interopDefault($dY8Js)))(Connect, WrappedComponent);
        };
    }
});
parcelRegister("bCzx0", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("dJaa4"));
});
parcelRegister("dJaa4", function(module, exports) {
    $parcel$export(module.exports, "ContextConsumer", ()=>$9fe75c2c5f477da2$export$a7c73072b1a182ae, (v)=>$9fe75c2c5f477da2$export$a7c73072b1a182ae = v);
    $parcel$export(module.exports, "ContextProvider", ()=>$9fe75c2c5f477da2$export$9f27bc3417b4524d, (v)=>$9fe75c2c5f477da2$export$9f27bc3417b4524d = v);
    $parcel$export(module.exports, "Element", ()=>$9fe75c2c5f477da2$export$db77ccec0bb4ccac, (v)=>$9fe75c2c5f477da2$export$db77ccec0bb4ccac = v);
    $parcel$export(module.exports, "ForwardRef", ()=>$9fe75c2c5f477da2$export$8392c0c9d3dcbd35, (v)=>$9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = v);
    $parcel$export(module.exports, "Fragment", ()=>$9fe75c2c5f477da2$export$ffb0004e005737fa, (v)=>$9fe75c2c5f477da2$export$ffb0004e005737fa = v);
    $parcel$export(module.exports, "Lazy", ()=>$9fe75c2c5f477da2$export$b624eff549462981, (v)=>$9fe75c2c5f477da2$export$b624eff549462981 = v);
    $parcel$export(module.exports, "Memo", ()=>$9fe75c2c5f477da2$export$7897aa7841a5380c, (v)=>$9fe75c2c5f477da2$export$7897aa7841a5380c = v);
    $parcel$export(module.exports, "Portal", ()=>$9fe75c2c5f477da2$export$602eac185826482c, (v)=>$9fe75c2c5f477da2$export$602eac185826482c = v);
    $parcel$export(module.exports, "Profiler", ()=>$9fe75c2c5f477da2$export$e2c29f18771995cb, (v)=>$9fe75c2c5f477da2$export$e2c29f18771995cb = v);
    $parcel$export(module.exports, "StrictMode", ()=>$9fe75c2c5f477da2$export$5f8d39834fd61797, (v)=>$9fe75c2c5f477da2$export$5f8d39834fd61797 = v);
    $parcel$export(module.exports, "Suspense", ()=>$9fe75c2c5f477da2$export$74bf444e3cd11ea5, (v)=>$9fe75c2c5f477da2$export$74bf444e3cd11ea5 = v);
    $parcel$export(module.exports, "isAsyncMode", ()=>$9fe75c2c5f477da2$export$92387174baf9b227, (v)=>$9fe75c2c5f477da2$export$92387174baf9b227 = v);
    $parcel$export(module.exports, "isConcurrentMode", ()=>$9fe75c2c5f477da2$export$ec112efeb987d9c6, (v)=>$9fe75c2c5f477da2$export$ec112efeb987d9c6 = v);
    $parcel$export(module.exports, "isContextConsumer", ()=>$9fe75c2c5f477da2$export$b706b080d889d2c9, (v)=>$9fe75c2c5f477da2$export$b706b080d889d2c9 = v);
    $parcel$export(module.exports, "isContextProvider", ()=>$9fe75c2c5f477da2$export$5be5a87408f70ddc, (v)=>$9fe75c2c5f477da2$export$5be5a87408f70ddc = v);
    $parcel$export(module.exports, "isElement", ()=>$9fe75c2c5f477da2$export$45a5e7f76e0caa8d, (v)=>$9fe75c2c5f477da2$export$45a5e7f76e0caa8d = v);
    $parcel$export(module.exports, "isForwardRef", ()=>$9fe75c2c5f477da2$export$455c2e768291efa6, (v)=>$9fe75c2c5f477da2$export$455c2e768291efa6 = v);
    $parcel$export(module.exports, "isFragment", ()=>$9fe75c2c5f477da2$export$9522e17588c12572, (v)=>$9fe75c2c5f477da2$export$9522e17588c12572 = v);
    $parcel$export(module.exports, "isLazy", ()=>$9fe75c2c5f477da2$export$2110ac352bb060b9, (v)=>$9fe75c2c5f477da2$export$2110ac352bb060b9 = v);
    $parcel$export(module.exports, "isMemo", ()=>$9fe75c2c5f477da2$export$56885ab8b9c456ab, (v)=>$9fe75c2c5f477da2$export$56885ab8b9c456ab = v);
    $parcel$export(module.exports, "isPortal", ()=>$9fe75c2c5f477da2$export$d927fcb6adf8f9de, (v)=>$9fe75c2c5f477da2$export$d927fcb6adf8f9de = v);
    $parcel$export(module.exports, "isProfiler", ()=>$9fe75c2c5f477da2$export$b82d16f27459e05a, (v)=>$9fe75c2c5f477da2$export$b82d16f27459e05a = v);
    $parcel$export(module.exports, "isStrictMode", ()=>$9fe75c2c5f477da2$export$522c17b4f5e123e8, (v)=>$9fe75c2c5f477da2$export$522c17b4f5e123e8 = v);
    $parcel$export(module.exports, "isSuspense", ()=>$9fe75c2c5f477da2$export$1aabd8a0274ecfd6, (v)=>$9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = v);
    $parcel$export(module.exports, "isValidElementType", ()=>$9fe75c2c5f477da2$export$9b621391a187a31a, (v)=>$9fe75c2c5f477da2$export$9b621391a187a31a = v);
    $parcel$export(module.exports, "typeOf", ()=>$9fe75c2c5f477da2$export$f5bbd400c2f4426f, (v)=>$9fe75c2c5f477da2$export$f5bbd400c2f4426f = v);
    var $9fe75c2c5f477da2$export$a7c73072b1a182ae;
    var $9fe75c2c5f477da2$export$9f27bc3417b4524d;
    var $9fe75c2c5f477da2$export$db77ccec0bb4ccac;
    var $9fe75c2c5f477da2$export$8392c0c9d3dcbd35;
    var $9fe75c2c5f477da2$export$ffb0004e005737fa;
    var $9fe75c2c5f477da2$export$b624eff549462981;
    var $9fe75c2c5f477da2$export$7897aa7841a5380c;
    var $9fe75c2c5f477da2$export$602eac185826482c;
    var $9fe75c2c5f477da2$export$e2c29f18771995cb;
    var $9fe75c2c5f477da2$export$5f8d39834fd61797;
    var $9fe75c2c5f477da2$export$74bf444e3cd11ea5;
    var $9fe75c2c5f477da2$export$92387174baf9b227;
    var $9fe75c2c5f477da2$export$ec112efeb987d9c6;
    var $9fe75c2c5f477da2$export$b706b080d889d2c9;
    var $9fe75c2c5f477da2$export$5be5a87408f70ddc;
    var $9fe75c2c5f477da2$export$45a5e7f76e0caa8d;
    var $9fe75c2c5f477da2$export$455c2e768291efa6;
    var $9fe75c2c5f477da2$export$9522e17588c12572;
    var $9fe75c2c5f477da2$export$2110ac352bb060b9;
    var $9fe75c2c5f477da2$export$56885ab8b9c456ab;
    var $9fe75c2c5f477da2$export$d927fcb6adf8f9de;
    var $9fe75c2c5f477da2$export$b82d16f27459e05a;
    var $9fe75c2c5f477da2$export$522c17b4f5e123e8;
    var $9fe75c2c5f477da2$export$1aabd8a0274ecfd6;
    var $9fe75c2c5f477da2$export$9b621391a187a31a;
    var $9fe75c2c5f477da2$export$f5bbd400c2f4426f;
    'use strict';
    var $9fe75c2c5f477da2$var$b = 60103, $9fe75c2c5f477da2$var$c = 60106, $9fe75c2c5f477da2$var$d = 60107, $9fe75c2c5f477da2$var$e = 60108, $9fe75c2c5f477da2$var$f = 60114, $9fe75c2c5f477da2$var$g = 60109, $9fe75c2c5f477da2$var$h = 60110, $9fe75c2c5f477da2$var$k = 60112, $9fe75c2c5f477da2$var$l = 60113, $9fe75c2c5f477da2$var$m = 60120, $9fe75c2c5f477da2$var$n = 60115, $9fe75c2c5f477da2$var$p = 60116, $9fe75c2c5f477da2$var$q = 60121, $9fe75c2c5f477da2$var$r = 60122, $9fe75c2c5f477da2$var$u = 60117, $9fe75c2c5f477da2$var$v = 60129, $9fe75c2c5f477da2$var$w = 60131;
    if ("function" === typeof Symbol && Symbol.for) {
        var $9fe75c2c5f477da2$var$x = Symbol.for;
        $9fe75c2c5f477da2$var$b = $9fe75c2c5f477da2$var$x("react.element");
        $9fe75c2c5f477da2$var$c = $9fe75c2c5f477da2$var$x("react.portal");
        $9fe75c2c5f477da2$var$d = $9fe75c2c5f477da2$var$x("react.fragment");
        $9fe75c2c5f477da2$var$e = $9fe75c2c5f477da2$var$x("react.strict_mode");
        $9fe75c2c5f477da2$var$f = $9fe75c2c5f477da2$var$x("react.profiler");
        $9fe75c2c5f477da2$var$g = $9fe75c2c5f477da2$var$x("react.provider");
        $9fe75c2c5f477da2$var$h = $9fe75c2c5f477da2$var$x("react.context");
        $9fe75c2c5f477da2$var$k = $9fe75c2c5f477da2$var$x("react.forward_ref");
        $9fe75c2c5f477da2$var$l = $9fe75c2c5f477da2$var$x("react.suspense");
        $9fe75c2c5f477da2$var$m = $9fe75c2c5f477da2$var$x("react.suspense_list");
        $9fe75c2c5f477da2$var$n = $9fe75c2c5f477da2$var$x("react.memo");
        $9fe75c2c5f477da2$var$p = $9fe75c2c5f477da2$var$x("react.lazy");
        $9fe75c2c5f477da2$var$q = $9fe75c2c5f477da2$var$x("react.block");
        $9fe75c2c5f477da2$var$r = $9fe75c2c5f477da2$var$x("react.server.block");
        $9fe75c2c5f477da2$var$u = $9fe75c2c5f477da2$var$x("react.fundamental");
        $9fe75c2c5f477da2$var$v = $9fe75c2c5f477da2$var$x("react.debug_trace_mode");
        $9fe75c2c5f477da2$var$w = $9fe75c2c5f477da2$var$x("react.legacy_hidden");
    }
    function $9fe75c2c5f477da2$var$y(a) {
        if ("object" === typeof a && null !== a) {
            var t = a.$$typeof;
            switch(t){
                case $9fe75c2c5f477da2$var$b:
                    switch(a = a.type, a){
                        case $9fe75c2c5f477da2$var$d:
                        case $9fe75c2c5f477da2$var$f:
                        case $9fe75c2c5f477da2$var$e:
                        case $9fe75c2c5f477da2$var$l:
                        case $9fe75c2c5f477da2$var$m:
                            return a;
                        default:
                            switch(a = a && a.$$typeof, a){
                                case $9fe75c2c5f477da2$var$h:
                                case $9fe75c2c5f477da2$var$k:
                                case $9fe75c2c5f477da2$var$p:
                                case $9fe75c2c5f477da2$var$n:
                                case $9fe75c2c5f477da2$var$g:
                                    return a;
                                default:
                                    return t;
                            }
                    }
                case $9fe75c2c5f477da2$var$c:
                    return t;
            }
        }
    }
    var $9fe75c2c5f477da2$var$z = $9fe75c2c5f477da2$var$g, $9fe75c2c5f477da2$var$A = $9fe75c2c5f477da2$var$b, $9fe75c2c5f477da2$var$B = $9fe75c2c5f477da2$var$k, $9fe75c2c5f477da2$var$C = $9fe75c2c5f477da2$var$d, $9fe75c2c5f477da2$var$D = $9fe75c2c5f477da2$var$p, $9fe75c2c5f477da2$var$E = $9fe75c2c5f477da2$var$n, $9fe75c2c5f477da2$var$F = $9fe75c2c5f477da2$var$c, $9fe75c2c5f477da2$var$G = $9fe75c2c5f477da2$var$f, $9fe75c2c5f477da2$var$H = $9fe75c2c5f477da2$var$e, $9fe75c2c5f477da2$var$I = $9fe75c2c5f477da2$var$l;
    $9fe75c2c5f477da2$export$a7c73072b1a182ae = $9fe75c2c5f477da2$var$h;
    $9fe75c2c5f477da2$export$9f27bc3417b4524d = $9fe75c2c5f477da2$var$z;
    $9fe75c2c5f477da2$export$db77ccec0bb4ccac = $9fe75c2c5f477da2$var$A;
    $9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = $9fe75c2c5f477da2$var$B;
    $9fe75c2c5f477da2$export$ffb0004e005737fa = $9fe75c2c5f477da2$var$C;
    $9fe75c2c5f477da2$export$b624eff549462981 = $9fe75c2c5f477da2$var$D;
    $9fe75c2c5f477da2$export$7897aa7841a5380c = $9fe75c2c5f477da2$var$E;
    $9fe75c2c5f477da2$export$602eac185826482c = $9fe75c2c5f477da2$var$F;
    $9fe75c2c5f477da2$export$e2c29f18771995cb = $9fe75c2c5f477da2$var$G;
    $9fe75c2c5f477da2$export$5f8d39834fd61797 = $9fe75c2c5f477da2$var$H;
    $9fe75c2c5f477da2$export$74bf444e3cd11ea5 = $9fe75c2c5f477da2$var$I;
    $9fe75c2c5f477da2$export$92387174baf9b227 = function() {
        return !1;
    };
    $9fe75c2c5f477da2$export$ec112efeb987d9c6 = function() {
        return !1;
    };
    $9fe75c2c5f477da2$export$b706b080d889d2c9 = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$h;
    };
    $9fe75c2c5f477da2$export$5be5a87408f70ddc = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$g;
    };
    $9fe75c2c5f477da2$export$45a5e7f76e0caa8d = function(a) {
        return "object" === typeof a && null !== a && a.$$typeof === $9fe75c2c5f477da2$var$b;
    };
    $9fe75c2c5f477da2$export$455c2e768291efa6 = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$k;
    };
    $9fe75c2c5f477da2$export$9522e17588c12572 = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$d;
    };
    $9fe75c2c5f477da2$export$2110ac352bb060b9 = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$p;
    };
    $9fe75c2c5f477da2$export$56885ab8b9c456ab = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$n;
    };
    $9fe75c2c5f477da2$export$d927fcb6adf8f9de = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$c;
    };
    $9fe75c2c5f477da2$export$b82d16f27459e05a = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$f;
    };
    $9fe75c2c5f477da2$export$522c17b4f5e123e8 = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$e;
    };
    $9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = function(a) {
        return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$l;
    };
    $9fe75c2c5f477da2$export$9b621391a187a31a = function(a) {
        return "string" === typeof a || "function" === typeof a || a === $9fe75c2c5f477da2$var$d || a === $9fe75c2c5f477da2$var$f || a === $9fe75c2c5f477da2$var$v || a === $9fe75c2c5f477da2$var$e || a === $9fe75c2c5f477da2$var$l || a === $9fe75c2c5f477da2$var$m || a === $9fe75c2c5f477da2$var$w || "object" === typeof a && null !== a && (a.$$typeof === $9fe75c2c5f477da2$var$p || a.$$typeof === $9fe75c2c5f477da2$var$n || a.$$typeof === $9fe75c2c5f477da2$var$g || a.$$typeof === $9fe75c2c5f477da2$var$h || a.$$typeof === $9fe75c2c5f477da2$var$k || a.$$typeof === $9fe75c2c5f477da2$var$u || a.$$typeof === $9fe75c2c5f477da2$var$q || a[0] === $9fe75c2c5f477da2$var$r) ? !0 : !1;
    };
    $9fe75c2c5f477da2$export$f5bbd400c2f4426f = $9fe75c2c5f477da2$var$y;
});
parcelRegister("AuRrZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06db4d47a421a2eb$export$2e2bcd8739ae039);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $evQWN = parcelRequire("evQWN");
    var $ggTLx = parcelRequire("ggTLx");
    var $aRR2I = parcelRequire("aRR2I");
    var $li0D7 = parcelRequire("li0D7");
    var $3zSL8 = parcelRequire("3zSL8");
    var $aQWN9 = parcelRequire("aQWN9");
    var $06db4d47a421a2eb$var$_excluded = [
        "pure",
        "areStatesEqual",
        "areOwnPropsEqual",
        "areStatePropsEqual",
        "areMergedPropsEqual"
    ];
    function $06db4d47a421a2eb$var$match(arg, factories, name) {
        for(var i = factories.length - 1; i >= 0; i--){
            var result = factories[i](arg);
            if (result) return result;
        }
        return function(dispatch, options) {
            throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
        };
    }
    function $06db4d47a421a2eb$var$strictEqual(a, b) {
        return a === b;
    }
    function $06db4d47a421a2eb$export$9f9feb656dec1fc4(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $evQWN.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $li0D7.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $aRR2I.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $3zSL8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $aQWN9.default) : _ref$selectorFactory;
        return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
            if (_ref2 === void 0) _ref2 = {};
            var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $06db4d47a421a2eb$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $ggTLx.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $ggTLx.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $ggTLx.default) : _ref3$areMergedPropsE, extraOptions = (0, $ddEsc.default)(_ref3, $06db4d47a421a2eb$var$_excluded);
            var initMapStateToProps = $06db4d47a421a2eb$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
            var initMapDispatchToProps = $06db4d47a421a2eb$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
            var initMergeProps = $06db4d47a421a2eb$var$match(mergeProps, mergePropsFactories, 'mergeProps');
            return connectHOC(selectorFactory, (0, $bS32t.default)({
                methodName: 'connect',
                getDisplayName: function getDisplayName(name) {
                    return "Connect(" + name + ")";
                },
                shouldHandleStateChanges: Boolean(mapStateToProps),
                initMapStateToProps: initMapStateToProps,
                initMapDispatchToProps: initMapDispatchToProps,
                initMergeProps: initMergeProps,
                pure: pure,
                areStatesEqual: areStatesEqual,
                areOwnPropsEqual: areOwnPropsEqual,
                areStatePropsEqual: areStatePropsEqual,
                areMergedPropsEqual: areMergedPropsEqual
            }, extraOptions));
        };
    }
    var $06db4d47a421a2eb$export$2e2bcd8739ae039 = $06db4d47a421a2eb$export$9f9feb656dec1fc4();
});
parcelRegister("ggTLx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd8965e05453892e$export$2e2bcd8739ae039);
    function $bd8965e05453892e$var$is(x, y) {
        if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
        else return x !== x && y !== y;
    }
    function $bd8965e05453892e$export$2e2bcd8739ae039(objA, objB) {
        if ($bd8965e05453892e$var$is(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
        for(var i = 0; i < keysA.length; i++){
            if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$bd8965e05453892e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
});
parcelRegister("aRR2I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e97ffd151087114$export$2e2bcd8739ae039);
    var $a37gJ = parcelRequire("a37gJ");
    var $8EqLJ = parcelRequire("8EqLJ");
    function $7e97ffd151087114$export$a9f27b4b187c1166(mapDispatchToProps) {
        return typeof mapDispatchToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
    }
    function $7e97ffd151087114$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
        return !mapDispatchToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
            return {
                dispatch: dispatch
            };
        }) : undefined;
    }
    function $7e97ffd151087114$export$94a6e55709d4d961(mapDispatchToProps) {
        return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
            return (0, $a37gJ.default)(mapDispatchToProps, dispatch);
        }) : undefined;
    }
    var $7e97ffd151087114$export$2e2bcd8739ae039 = [
        $7e97ffd151087114$export$a9f27b4b187c1166,
        $7e97ffd151087114$export$ba20d1a7aa0c4a90,
        $7e97ffd151087114$export$94a6e55709d4d961
    ];
});
parcelRegister("a37gJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$750fd2a673ba963c$export$2e2bcd8739ae039);
    function $750fd2a673ba963c$export$2e2bcd8739ae039(actionCreators, dispatch) {
        var boundActionCreators = {};
        var _loop = function _loop(key) {
            var actionCreator = actionCreators[key];
            if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
                return dispatch(actionCreator.apply(void 0, arguments));
            };
        };
        for(var key in actionCreators)_loop(key);
        return boundActionCreators;
    }
});
parcelRegister("8EqLJ", function(module, exports) {
    $parcel$export(module.exports, "wrapMapToPropsConstant", ()=>$64c6d2e3c8e9f263$export$710f7c60f68acd3e);
    $parcel$export(module.exports, "wrapMapToPropsFunc", ()=>$64c6d2e3c8e9f263$export$8d46c7f53c8c602f);
    parcelRequire("1prLO");
    function $64c6d2e3c8e9f263$export$710f7c60f68acd3e(getConstant) {
        return function initConstantSelector(dispatch, options) {
            var constant = getConstant(dispatch, options);
            function constantSelector() {
                return constant;
            }
            constantSelector.dependsOnOwnProps = false;
            return constantSelector;
        };
    }
    function $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps) {
        return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
    }
    function $64c6d2e3c8e9f263$export$8d46c7f53c8c602f(mapToProps, methodName) {
        return function initProxySelector(dispatch, _ref) {
            var displayName = _ref.displayName;
            var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
                return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
            };
            proxy.dependsOnOwnProps = true;
            proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
                proxy.mapToProps = mapToProps;
                proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps);
                var props = proxy(stateOrDispatch, ownProps);
                if (typeof props === 'function') {
                    proxy.mapToProps = props;
                    proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(props);
                    props = proxy(stateOrDispatch, ownProps);
                }
                return props;
            };
            return proxy;
        };
    }
});
parcelRegister("1prLO", function(module, exports) {
    var $im3MO = parcelRequire("im3MO");
    var $kb4xC = parcelRequire("kb4xC");
    function $106daad597fc23e6$export$2e2bcd8739ae039(value, displayName, methodName) {
        if (!(0, $im3MO.default)(value)) (0, $kb4xC.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
    }
});
parcelRegister("im3MO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5cd37f6759c7272$export$2e2bcd8739ae039);
    function $d5cd37f6759c7272$export$2e2bcd8739ae039(obj) {
        if (typeof obj !== 'object' || obj === null) return false;
        var proto = Object.getPrototypeOf(obj);
        if (proto === null) return true;
        var baseProto = proto;
        while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
        return proto === baseProto;
    }
});
parcelRegister("kb4xC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb085b81b2733980$export$2e2bcd8739ae039);
    function $eb085b81b2733980$export$2e2bcd8739ae039(message) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
});
parcelRegister("li0D7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7fbc484b4e9d2ee$export$2e2bcd8739ae039);
    var $8EqLJ = parcelRequire("8EqLJ");
    function $f7fbc484b4e9d2ee$export$23fc470827b14aa(mapStateToProps) {
        return typeof mapStateToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
    }
    function $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66(mapStateToProps) {
        return !mapStateToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function() {
            return {};
        }) : undefined;
    }
    var $f7fbc484b4e9d2ee$export$2e2bcd8739ae039 = [
        $f7fbc484b4e9d2ee$export$23fc470827b14aa,
        $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66
    ];
});
parcelRegister("3zSL8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29af1e0b3bc3959e$export$2e2bcd8739ae039);
    var $bS32t = parcelRequire("bS32t");
    parcelRequire("1prLO");
    function $29af1e0b3bc3959e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
        return (0, $bS32t.default)({}, ownProps, stateProps, dispatchProps);
    }
    function $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) {
        return function initMergePropsProxy(dispatch, _ref) {
            var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
            var hasRunOnce = false;
            var mergedProps;
            return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
                var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
                if (hasRunOnce) {
                    if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
                } else {
                    hasRunOnce = true;
                    mergedProps = nextMergedProps;
                }
                return mergedProps;
            };
        };
    }
    function $29af1e0b3bc3959e$export$d61b680184bc3f00(mergeProps) {
        return typeof mergeProps === 'function' ? $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) : undefined;
    }
    function $29af1e0b3bc3959e$export$a13ba70ef50dda6d(mergeProps) {
        return !mergeProps ? function() {
            return $29af1e0b3bc3959e$export$691c327fc30bc857;
        } : undefined;
    }
    var $29af1e0b3bc3959e$export$2e2bcd8739ae039 = [
        $29af1e0b3bc3959e$export$d61b680184bc3f00,
        $29af1e0b3bc3959e$export$a13ba70ef50dda6d
    ];
});
parcelRegister("aQWN9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e6c5d8bc061ff2f$export$2e2bcd8739ae039);
    var $ddEsc = parcelRequire("ddEsc");
    parcelRequire("8XVVW");
    var $7e6c5d8bc061ff2f$var$_excluded = [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ];
    function $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
        return function impureFinalPropsSelector(state, ownProps) {
            return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
        };
    }
    function $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
        var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
        var hasRunAtLeastOnce = false;
        var state;
        var ownProps;
        var stateProps;
        var dispatchProps;
        var mergedProps;
        function handleFirstCall(firstState, firstOwnProps) {
            state = firstState;
            ownProps = firstOwnProps;
            stateProps = mapStateToProps(state, ownProps);
            dispatchProps = mapDispatchToProps(dispatch, ownProps);
            mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            hasRunAtLeastOnce = true;
            return mergedProps;
        }
        function handleNewPropsAndNewState() {
            stateProps = mapStateToProps(state, ownProps);
            if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
            mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            return mergedProps;
        }
        function handleNewProps() {
            if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
            if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
            mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            return mergedProps;
        }
        function handleNewState() {
            var nextStateProps = mapStateToProps(state, ownProps);
            var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
            stateProps = nextStateProps;
            if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            return mergedProps;
        }
        function handleSubsequentCalls(nextState, nextOwnProps) {
            var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
            var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
            state = nextState;
            ownProps = nextOwnProps;
            if (propsChanged && stateChanged) return handleNewPropsAndNewState();
            if (propsChanged) return handleNewProps();
            if (stateChanged) return handleNewState();
            return mergedProps;
        }
        return function pureFinalPropsSelector(nextState, nextOwnProps) {
            return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
        };
    }
    function $7e6c5d8bc061ff2f$export$2e2bcd8739ae039(dispatch, _ref2) {
        var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $ddEsc.default)(_ref2, $7e6c5d8bc061ff2f$var$_excluded);
        var mapStateToProps = initMapStateToProps(dispatch, options);
        var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
        var mergeProps = initMergeProps(dispatch, options);
        var selectorFactory = options.pure ? $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f : $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0;
        return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
    }
});
parcelRegister("8XVVW", function(module, exports) {
    var $kb4xC = parcelRequire("kb4xC");
    function $6870c5d2f9dd91da$var$verify(selector, methodName, displayName) {
        if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
        else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
            if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $kb4xC.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
        }
    }
    function $6870c5d2f9dd91da$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
        $6870c5d2f9dd91da$var$verify(mapStateToProps, 'mapStateToProps', displayName);
        $6870c5d2f9dd91da$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
        $6870c5d2f9dd91da$var$verify(mergeProps, 'mergeProps', displayName);
    }
});
parcelRegister("616sH", function(module, exports) {
    $parcel$export(module.exports, "useDispatch", ()=>$4617d947d89cb783$export$8ad76b76a4c905f8);
    var $eZhPT = parcelRequire("eZhPT");
    var $5sekt = parcelRequire("5sekt");
    function $4617d947d89cb783$export$bc9b55530897c558(context) {
        if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
        var useStore = context === (0, $eZhPT.ReactReduxContext) ? (0, $5sekt.useStore) : (0, $5sekt.createStoreHook)(context);
        return function useDispatch() {
            var store = useStore();
            return store.dispatch;
        };
    }
    var $4617d947d89cb783$export$8ad76b76a4c905f8 = $4617d947d89cb783$export$bc9b55530897c558();
});
parcelRegister("5sekt", function(module, exports) {
    $parcel$export(module.exports, "createStoreHook", ()=>$3f8aaec7bfa91a5f$export$671dba69185d0304);
    $parcel$export(module.exports, "useStore", ()=>$3f8aaec7bfa91a5f$export$6ccbb43953eebf8);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZhPT = parcelRequire("eZhPT");
    var $i2tgo = parcelRequire("i2tgo");
    function $3f8aaec7bfa91a5f$export$671dba69185d0304(context) {
        if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
        var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
            return (0, $5uXOq.useContext)(context);
        };
        return function useStore() {
            var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
            return store;
        };
    }
    var $3f8aaec7bfa91a5f$export$6ccbb43953eebf8 = $3f8aaec7bfa91a5f$export$671dba69185d0304();
});
parcelRegister("i2tgo", function(module, exports) {
    $parcel$export(module.exports, "useReduxContext", ()=>$d21f1d0198d74b68$export$c1275ca9a6fd3ec5);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZhPT = parcelRequire("eZhPT");
    function $d21f1d0198d74b68$export$c1275ca9a6fd3ec5() {
        var contextValue = (0, $5uXOq.useContext)((0, $eZhPT.ReactReduxContext));
        return contextValue;
    }
});
parcelRegister("6S8MB", function(module, exports) {
    $parcel$export(module.exports, "useSelector", ()=>$500e9950191b49f8$export$2105062e25df4afe);
    var $5uXOq = parcelRequire("5uXOq");
    var $i2tgo = parcelRequire("i2tgo");
    var $arhzp = parcelRequire("arhzp");
    var $gneWW = parcelRequire("gneWW");
    var $eZhPT = parcelRequire("eZhPT");
    var $500e9950191b49f8$var$refEquality = function refEquality(a, b) {
        return a === b;
    };
    function $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
        var _useReducer = (0, $5uXOq.useReducer)(function(s) {
            return s + 1;
        }, 0), forceRender = _useReducer[1];
        var subscription = (0, $5uXOq.useMemo)(function() {
            return (0, $arhzp.createSubscription)(store, contextSub);
        }, [
            store,
            contextSub
        ]);
        var latestSubscriptionCallbackError = (0, $5uXOq.useRef)();
        var latestSelector = (0, $5uXOq.useRef)();
        var latestStoreState = (0, $5uXOq.useRef)();
        var latestSelectedState = (0, $5uXOq.useRef)();
        var storeState = store.getState();
        var selectedState;
        try {
            if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
                var newSelectedState = selector(storeState);
                if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
                else selectedState = latestSelectedState.current;
            } else selectedState = latestSelectedState.current;
        } catch (err) {
            if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
            throw err;
        }
        (0, $gneWW.useIsomorphicLayoutEffect)(function() {
            latestSelector.current = selector;
            latestStoreState.current = storeState;
            latestSelectedState.current = selectedState;
            latestSubscriptionCallbackError.current = undefined;
        });
        (0, $gneWW.useIsomorphicLayoutEffect)(function() {
            function checkForUpdates() {
                try {
                    var newStoreState = store.getState();
                    if (newStoreState === latestStoreState.current) return;
                    var _newSelectedState = latestSelector.current(newStoreState);
                    if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                    latestSelectedState.current = _newSelectedState;
                    latestStoreState.current = newStoreState;
                } catch (err) {
                    latestSubscriptionCallbackError.current = err;
                }
                forceRender();
            }
            subscription.onStateChange = checkForUpdates;
            subscription.trySubscribe();
            checkForUpdates();
            return function() {
                return subscription.tryUnsubscribe();
            };
        }, [
            store,
            subscription
        ]);
        return selectedState;
    }
    function $500e9950191b49f8$export$2b53f90d2bd1cbfb(context) {
        if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
        var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
            return (0, $5uXOq.useContext)(context);
        };
        return function useSelector(selector, equalityFn) {
            if (equalityFn === void 0) equalityFn = $500e9950191b49f8$var$refEquality;
            var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
            var selectedState = $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
            (0, $5uXOq.useDebugValue)(selectedState);
            return selectedState;
        };
    }
    var $500e9950191b49f8$export$2105062e25df4afe = $500e9950191b49f8$export$2b53f90d2bd1cbfb();
});
parcelRegister("8mhVE", function(module, exports) {
    $parcel$export(module.exports, "unstable_batchedUpdates", ()=>(parcelRequire("7nsd3")).unstable_batchedUpdates);
    var $7nsd3 = parcelRequire("7nsd3");
});
parcelRegister("3YKxB", function(module, exports) {
    $parcel$export(module.exports, "getRect", ()=>$2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
    $parcel$export(module.exports, "expand", ()=>$2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "createBox", ()=>$2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
    $parcel$export(module.exports, "offset", ()=>$2e5b13c1f6ee9f8a$export$cc800923e997bb8);
    $parcel$export(module.exports, "withScroll", ()=>$2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
    $parcel$export(module.exports, "calculateBox", ()=>$2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
    $parcel$export(module.exports, "getBox", ()=>$2e5b13c1f6ee9f8a$export$34928e660d2a8702);
    var $3joPi = parcelRequire("3joPi");
    var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
        var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
        var width = right - left;
        var height = bottom - top;
        var rect = {
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height,
            x: left,
            y: top,
            center: {
                x: (right + left) / 2,
                y: (bottom + top) / 2
            }
        };
        return rect;
    };
    var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
        return {
            top: target.top - expandBy.top,
            left: target.left - expandBy.left,
            bottom: target.bottom + expandBy.bottom,
            right: target.right + expandBy.right
        };
    };
    var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
        return {
            top: target.top + shrinkBy.top,
            left: target.left + shrinkBy.left,
            bottom: target.bottom - shrinkBy.bottom,
            right: target.right - shrinkBy.right
        };
    };
    var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
        return {
            top: target.top + shiftBy.y,
            left: target.left + shiftBy.x,
            bottom: target.bottom + shiftBy.y,
            right: target.right + shiftBy.x
        };
    };
    var $2e5b13c1f6ee9f8a$var$noSpacing = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
        var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
        var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
        var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
        var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
        return {
            marginBox: marginBox,
            borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
            paddingBox: paddingBox,
            contentBox: contentBox,
            margin: margin,
            border: border,
            padding: padding
        };
    };
    var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
        var value = raw.slice(0, -2);
        var suffix = raw.slice(-2);
        if (suffix !== 'px') return 0;
        var result = Number(value);
        !!isNaN(result) && (0, $3joPi.default)(false);
        return result;
    };
    var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    };
    var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
        var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
        var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
        return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
            borderBox: shifted,
            border: border,
            margin: margin,
            padding: padding
        });
    };
    var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
        if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
        return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
    };
    var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
        var margin = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
        };
        var padding = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
        };
        var border = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
        };
        return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
            borderBox: borderBox,
            margin: margin,
            padding: padding,
            border: border
        });
    };
    var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
        var borderBox = el.getBoundingClientRect();
        var styles = window.getComputedStyle(el);
        return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
    };
});
parcelRegister("g7psY", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$bbc10ddfc67bca56$export$2e2bcd8739ae039);
    var $bbc10ddfc67bca56$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
    function $bbc10ddfc67bca56$var$isEqual(first, second) {
        if (first === second) return true;
        if ($bbc10ddfc67bca56$var$safeIsNaN(first) && $bbc10ddfc67bca56$var$safeIsNaN(second)) return true;
        return false;
    }
    function $bbc10ddfc67bca56$var$areInputsEqual(newInputs, lastInputs) {
        if (newInputs.length !== lastInputs.length) return false;
        for(var i = 0; i < newInputs.length; i++){
            if (!$bbc10ddfc67bca56$var$isEqual(newInputs[i], lastInputs[i])) return false;
        }
        return true;
    }
    function $bbc10ddfc67bca56$var$memoizeOne(resultFn, isEqual) {
        if (isEqual === void 0) isEqual = $bbc10ddfc67bca56$var$areInputsEqual;
        var lastThis;
        var lastArgs = [];
        var lastResult;
        var calledOnce = false;
        function memoized() {
            var newArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
            if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
            lastResult = resultFn.apply(this, newArgs);
            calledOnce = true;
            lastThis = this;
            lastArgs = newArgs;
            return lastResult;
        }
        return memoized;
    }
    var $bbc10ddfc67bca56$export$2e2bcd8739ae039 = $bbc10ddfc67bca56$var$memoizeOne;
});
parcelRegister("i2aN7", function(module, exports) {
    module.exports = (parcelRequire("jptOl"));
});
parcelRegister("jptOl", function(module, exports) {
    parcelRequire("a0Ixs");
    module.exports = (parcelRequire("4KXzV")).Object.values;
});
parcelRegister("a0Ixs", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    var $749c73ef0828bdd4$var$$values = (parcelRequire("kQXku"))(false);
    $fNMIk($fNMIk.S, 'Object', {
        values: function values(it) {
            return $749c73ef0828bdd4$var$$values(it);
        }
    });
});
parcelRegister("kQXku", function(module, exports) {
    var $aPbfY = parcelRequire("aPbfY");
    var $iTod0 = parcelRequire("iTod0");
    var $ehxEQ = parcelRequire("ehxEQ");
    var $1paSc = parcelRequire("1paSc");
    var $f2e6af8f0a9cbb36$require$isEnum = $1paSc.f;
    module.exports = function(isEntries) {
        return function(it) {
            var O = $ehxEQ(it);
            var keys = $iTod0(O);
            var length = keys.length;
            var i = 0;
            var result = [];
            var key;
            while(length > i){
                key = keys[i++];
                if (!$aPbfY || $f2e6af8f0a9cbb36$require$isEnum.call(O, key)) result.push(isEntries ? [
                    key,
                    O[key]
                ] : O[key]);
            }
            return result;
        };
    };
});
parcelRegister("cs3hJ", function(module, exports) {
    module.exports = (parcelRequire("gtqo2"));
});
parcelRegister("gtqo2", function(module, exports) {
    parcelRequire("jgnqd");
    module.exports = (parcelRequire("4KXzV")).Object.keys;
});
parcelRegister("jgnqd", function(module, exports) {
    var $llAOy = parcelRequire("llAOy");
    var $iTod0 = parcelRequire("iTod0");
    (parcelRequire("4BA40"))('keys', function() {
        return function keys(it) {
            return $iTod0($llAOy(it));
        };
    });
});
parcelRegister("4BA40", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    var $4KXzV = parcelRequire("4KXzV");
    var $cKvWG = parcelRequire("cKvWG");
    module.exports = function(KEY, exec) {
        var fn = ($4KXzV.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $fNMIk($fNMIk.S + $fNMIk.F * $cKvWG(function() {
            fn(1);
        }), 'Object', exp);
    };
});
parcelRegister("crAmF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90f436e32f3db886$export$2e2bcd8739ae039);
    var $90f436e32f3db886$var$rafSchd = function rafSchd(fn) {
        var lastArgs = [];
        var frameId = null;
        var wrapperFn = function wrapperFn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            lastArgs = args;
            if (frameId) return;
            frameId = requestAnimationFrame(function() {
                frameId = null;
                fn.apply(void 0, lastArgs);
            });
        };
        wrapperFn.cancel = function() {
            if (!frameId) return;
            cancelAnimationFrame(frameId);
            frameId = null;
        };
        return wrapperFn;
    };
    var $90f436e32f3db886$export$2e2bcd8739ae039 = $90f436e32f3db886$var$rafSchd;
});
parcelRegister("3BSY2", function(module, exports) {
    module.exports = (parcelRequire("4JOv4"));
});
parcelRegister("4JOv4", function(module, exports) {
    parcelRequire("ixUy6");
    module.exports = (parcelRequire("4KXzV")).Date.now;
});
parcelRegister("ixUy6", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    $fNMIk($fNMIk.S, 'Date', {
        now: function() {
            return new Date().getTime();
        }
    });
});
parcelRegister("1DIXK", function(module, exports) {
    module.exports = (parcelRequire("izccK"));
});
parcelRegister("izccK", function(module, exports) {
    parcelRequire("bwyHq");
    module.exports = (parcelRequire("4KXzV")).Number.isInteger;
});
parcelRegister("bwyHq", function(module, exports) {
    var $fNMIk = parcelRequire("fNMIk");
    $fNMIk($fNMIk.S, 'Number', {
        isInteger: (parcelRequire("dFLKl"))
    });
});
parcelRegister("dFLKl", function(module, exports) {
    var $dxLeJ = parcelRequire("dxLeJ");
    var $9f4424297502c7e8$var$floor = Math.floor;
    module.exports = function isInteger(it) {
        return !$dxLeJ(it) && isFinite(it) && $9f4424297502c7e8$var$floor(it) === it;
    };
});
parcelRegister("lL5b5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07c2532655d93687$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j0xEB;
    var $j2Jlg;
    var $07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
        const { href: href = null } = (0, (0, parcelRequire("j0xEB")).default)() || {};
        if (href && !href.includes('login.jsp')) {
            const encodedRedirectUrl = encodeURIComponent(href);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j2Jlg")).default), {
                url: `/login.jsp?os_destination=${encodedRedirectUrl}`
            });
        }
        return null;
    };
});
parcelRegister("j0xEB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b1198aeec732ce1$export$2e2bcd8739ae039);
    var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
        if (typeof window !== 'undefined') return window.location;
        return undefined;
    };
});
parcelRegister("j2Jlg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$773e6f988af77e5c$export$2e2bcd8739ae039);
    var $773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
        window.location.assign(url);
        return null;
    };
});
parcelRegister("duhqo", function(module, exports) {
    $parcel$export(module.exports, "DeprecationBanner", ()=>$76f52a94495cb7a6$export$35ae8bd48b5aa255);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $JIPqS;
    var $eOQrC;
    var $l6TQP;
    var $7YQcX;
    const $76f52a94495cb7a6$var$DEPRECATION_BANNERS = {
        endeavour_gadget_deprecation_banner_v1: {
            version: (0, (0, parcelRequire("JIPqS")).DEPRECATION_BANNER_V1),
            component: (0, (0, parcelRequire("7YQcX")).DeprecationBannerV1)
        }
    };
    const $76f52a94495cb7a6$export$35ae8bd48b5aa255 = ({ gadgets: gadgets, gadgetId: gadgetId })=>{
        const { dashboardHasDeprecatedGadget: dashboardHasDeprecatedGadget } = (0, (0, parcelRequire("eOQrC")).useDashboardHasDeprecatedGadget)(gadgets);
        const featureGatedBannerVersion = 'endeavour_gadget_deprecation_banner_v1';
        let hasDeprecationBannerFGon = false;
        if ((0, (0, parcelRequire("4R6GH")).fg)('endeavour_gadget_deprecation_banner_v1')) hasDeprecationBannerFGon = true;
        const BannerComponent = $76f52a94495cb7a6$var$DEPRECATION_BANNERS[featureGatedBannerVersion].component;
        const { isDeprecationBannerDismissed: isDeprecationBannerDismissed, onDeprecationBannerDismiss: onDeprecationBannerDismiss } = (0, (0, parcelRequire("l6TQP")).useDeprecationBannerState)($76f52a94495cb7a6$var$DEPRECATION_BANNERS[featureGatedBannerVersion].version, gadgetId);
        return hasDeprecationBannerFGon && !isDeprecationBannerDismissed && dashboardHasDeprecatedGadget ? (0, ($parcel$interopDefault($5uXOq))).createElement(BannerComponent, {
            onDismiss: onDeprecationBannerDismiss
        }) : null;
    };
});
parcelRegister("eOQrC", function(module, exports) {
    $parcel$export(module.exports, "useDashboardHasDeprecatedGadget", ()=>$aef4a1d59628b665$export$3b0936c4a7671adc);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGdg6;
    const $aef4a1d59628b665$export$3b0936c4a7671adc = (gadgets)=>{
        const [dashboardHasDeprecatedGadget, setDashboardHasDeprecatedGadget] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setDashboardHasDeprecatedGadget($aef4a1d59628b665$var$checkDashboardHasDeprecatedGadget(gadgets));
        }, [
            gadgets
        ]);
        return {
            dashboardHasDeprecatedGadget: dashboardHasDeprecatedGadget
        };
    };
    const $aef4a1d59628b665$var$checkDashboardHasDeprecatedGadget = (gadgets)=>{
        return gadgets.some((gadget)=>(0, (0, parcelRequire("hGdg6")).isDeprecatedGadget)(gadget.amdModule));
    };
});
parcelRegister("hGdg6", function(module, exports) {
    $parcel$export(module.exports, "isDeprecatedGadget", ()=>$ea8c7aa113f400f7$export$4b6bff4e9074989);
    var $JIPqS;
    const $ea8c7aa113f400f7$export$4b6bff4e9074989 = (gadgetResource)=>{
        return gadgetResource !== undefined && (gadgetResource in (0, (0, parcelRequire("JIPqS")).DEPRECATED_GADGETS_MAP) || Object.values((0, (0, parcelRequire("JIPqS")).DEPRECATED_GADGETS_MAP)).includes(gadgetResource));
    };
});
parcelRegister("l6TQP", function(module, exports) {
    $parcel$export(module.exports, "useDeprecationBannerState", ()=>$61287e76e54d4874$export$ce2c61270a55779b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSSG7;
    const $61287e76e54d4874$export$ce2c61270a55779b = (dashboardBannerStorageKey, dashboardId)=>{
        const [isDeprecationBannerDismissed, setIsDeprecationBannerDismissed] = (0, $5uXOq.useState)(false);
        const store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira-dashboard-deprecation-banner-state');
        (0, $5uXOq.useEffect)(()=>{
            const localDeprecatedBannersState = store.get(dashboardBannerStorageKey);
            if (localDeprecatedBannersState) {
                const bannerIsDismissed = localDeprecatedBannersState.includes(dashboardId);
                setIsDeprecationBannerDismissed(bannerIsDismissed);
            }
        }, [
            dashboardId,
            dashboardBannerStorageKey,
            store
        ]);
        const onDeprecationBannerDismiss = ()=>{
            setIsDeprecationBannerDismissed(true);
            const localDeprecatedBannersState = store.get(dashboardBannerStorageKey);
            if (localDeprecatedBannersState) {
                localDeprecatedBannersState.push(dashboardId);
                store.set(dashboardBannerStorageKey, localDeprecatedBannersState);
            } else store.set(dashboardBannerStorageKey, [
                dashboardId
            ]);
        };
        return {
            isDeprecationBannerDismissed: isDeprecationBannerDismissed,
            onDeprecationBannerDismiss: onDeprecationBannerDismiss
        };
    };
});
parcelRegister("7YQcX", function(module, exports) {
    $parcel$export(module.exports, "DeprecationBannerV1", ()=>$fb1cba861a89581f$export$b10eedc6ae25381c);
    var $5uXOq = parcelRequire("5uXOq");
    var $92Z2l;
    var $ctz0s;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $2O7o7;
    const $fb1cba861a89581f$export$b10eedc6ae25381c = ({ onDismiss: onDismiss })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning",
            actions: [
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctz0s")).default), {
                    key: "gadgetDeprecationBannerDimissV1",
                    onClick: onDismiss
                }, formatMessage((0, (0, parcelRequire("2O7o7")).default).gadgetDeprecationMessageDismissV1))
            ],
            title: formatMessage((0, (0, parcelRequire("2O7o7")).default).gadgetDeprecationTitleV1)
        }, formatMessage((0, (0, parcelRequire("2O7o7")).default).gadgetDeprecationMessageV1, {
            Link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
                    href: "https://community.atlassian.com/t5/Jira-articles/Update-We-re-ending-support-for-five-dashboard-gadgets-in-May/ba-p/2844556"
                }, chunks),
            br: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null))
        }));
    };
});
parcelRegister("ctz0s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e844da07d79ea04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    const $2e844da07d79ea04$var$SectionMessageAction = (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
        return onClick || href ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
    $2e844da07d79ea04$var$SectionMessageAction.displayName = 'SectionMessageAction';
    var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;
});
parcelRegister("2O7o7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$681e6c098aed09e5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $681e6c098aed09e5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        gadgetDeprecationTitleV1: {
            "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-title.non-final",
            "defaultMessage": "Extended timeline: We're no longer supporting five of your gadgets starting May 2025"
        },
        gadgetDeprecationMessageV1: {
            "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message.non-final",
            "defaultMessage": "Starting May 2025, we're removing the functionality of the Jira Road Map, Bubble Chart, Heat Map, Projects, and Labels gadgets. If you don't delete them before then, they'll no longer work, and you won't be able to reference them for the available alternatives. <Link>More about the gadgets and the extended timeline</Link>"
        },
        gadgetDeprecationMessageDismissV1: {
            "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message-dismiss.non-final",
            "defaultMessage": "Dismiss"
        }
    });
});
parcelRegister("iyrll", function(module, exports) {
    $parcel$export(module.exports, "DashboardControllerContextProvider", ()=>$669a1fafb8f4566e$export$36eb228a17cae64d);
    $parcel$export(module.exports, "DashboardControllerContextConsumer", ()=>$669a1fafb8f4566e$export$4ce01c0dbab5bb18);
    $parcel$export(module.exports, "useDashboardRefresh", ()=>$669a1fafb8f4566e$export$71d14892f68b2430);
    $parcel$export(module.exports, "useOnAddedGadget", ()=>$669a1fafb8f4566e$export$2471f3ee3e3601fe);
    var $jnkfq;
    const { createUseContextField: $669a1fafb8f4566e$export$3fb47a2904db1f37, Provider: $669a1fafb8f4566e$export$36eb228a17cae64d, Consumer: $669a1fafb8f4566e$export$4ce01c0dbab5bb18 } = (0, (0, parcelRequire("jnkfq")).createRendererContext)();
    const $669a1fafb8f4566e$export$71d14892f68b2430 = $669a1fafb8f4566e$export$3fb47a2904db1f37('onRefresh');
    const $669a1fafb8f4566e$export$2471f3ee3e3601fe = $669a1fafb8f4566e$export$3fb47a2904db1f37('onAddedGadget');
});
parcelRegister("jnkfq", function(module, exports) {
    $parcel$export(module.exports, "createRendererContext", ()=>$2cbc9584a68b4b0d$export$ac09db0e74937f7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $9pe79;
    const $2cbc9584a68b4b0d$export$ac09db0e74937f7f = ()=>{
        const _UnmemoisedContext = (0, $5uXOq.createContext)(undefined);
        const { Provider: UnmemoisedProvider, Consumer: Consumer } = _UnmemoisedContext;
        const Provider = (0, $5uXOq.memo)(UnmemoisedProvider, ({ value: valueA, ...propsA }, { value: valueB, ...propsB })=>(0, (0, parcelRequire("9pe79")).default)(valueA, valueB) && (0, (0, parcelRequire("9pe79")).default)(propsA, propsB));
        const createRenderFunction = (children)=>(value)=>children != null ? (0, ($parcel$interopDefault($5uXOq))).createElement(Provider, {
                    value: value
                }, typeof children === 'function' ? (0, ($parcel$interopDefault($5uXOq))).createElement(Consumer, null, children) : children) : null;
        const createUseContextField = (key)=>()=>{
                const value = (0, $5uXOq.useContext)(_UnmemoisedContext);
                if (value == null) throw new Error('context not found');
                return value[key];
            };
        return {
            _UnmemoisedContext: _UnmemoisedContext,
            Provider: Provider,
            Consumer: Consumer,
            createRenderFunction: createRenderFunction,
            createUseContextField: createUseContextField
        };
    };
});
parcelRegister("9pe79", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06cb96a92cdfd43f$export$2e2bcd8739ae039);
    var $0xdyK;
    var $06cb96a92cdfd43f$export$2e2bcd8739ae039 = (obj1, obj2)=>{
        if (obj1 === obj2) return true;
        if (!obj1 || !obj2) return false;
        const item1Keys = Object.keys(obj1).sort();
        const item2Keys = Object.keys(obj2).sort();
        if (!(0, (0, parcelRequire("0xdyK")).default)(item1Keys, item2Keys)) return false;
        const areValuesEqual = item2Keys.every((key)=>{
            const value = obj1[key];
            const nextValue = obj2[key];
            if (value === nextValue) return true;
            return Array.isArray(nextValue) && Array.isArray(value) && (0, (0, parcelRequire("0xdyK")).default)(value, nextValue);
        });
        return areValuesEqual;
    };
});
parcelRegister("0xdyK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c50cb723ebf4f109$export$2e2bcd8739ae039);
    var $c50cb723ebf4f109$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
        if (array1 === array2) return true;
        return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
    };
});
parcelRegister("32Vhm", function(module, exports) {
    $parcel$export(module.exports, "DashboardController", ()=>$5e7fb5d7d6929ddb$export$b9771780c6ecf3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3v45P;
    var $flEgL;
    var $JIPqS;
    var $iyrll;
    const $5e7fb5d7d6929ddb$export$d7eb50fb85f631d = ({ automaticRefreshMs: automaticRefreshMs })=>{
        const [refreshId, setRefreshId] = (0, $5uXOq.useState)(Date.now());
        const [, setMostRecentlyAddedGadgetId] = (0, $5uXOq.useState)(null);
        const onRefresh = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("3v45P")).emit)((0, (0, parcelRequire("JIPqS")).FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), {
                origin: 'dashboard'
            });
            (0, (0, parcelRequire("flEgL")).default)((0, (0, parcelRequire("JIPqS")).CONNECT_GADGET_REFRESH_REQUEST_EVENT), {}, {
                origin: 'dashboard'
            });
            setRefreshId(Date.now());
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (automaticRefreshMs == null || automaticRefreshMs < 1) return ()=>undefined;
            const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
            const interval = setInterval(onRefresh, refreshIntervalMs);
            return ()=>{
                clearInterval(interval);
            };
        }, [
            automaticRefreshMs,
            onRefresh
        ]);
        const onMount = (0, $5uXOq.useCallback)((gadgetId, focusCallback)=>{
            setMostRecentlyAddedGadgetId((mostRecentlyAddedGadgetId)=>{
                if (gadgetId === mostRecentlyAddedGadgetId) {
                    focusCallback();
                    return null;
                }
                return mostRecentlyAddedGadgetId;
            });
        }, []);
        return {
            onRefresh: onRefresh,
            refreshId: refreshId,
            onAddedGadget: setMostRecentlyAddedGadgetId,
            onMount: onMount
        };
    };
    const $5e7fb5d7d6929ddb$export$b9771780c6ecf3f = ({ children: children, ...props })=>{
        const value = $5e7fb5d7d6929ddb$export$d7eb50fb85f631d(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iyrll")).DashboardControllerContextProvider), {
            value: value
        }, children);
    };
});
parcelRegister("3v45P", function(module, exports) {
    $parcel$export(module.exports, "on", ()=>$b978cb322a482db9$export$af631764ddc44097);
    $parcel$export(module.exports, "emit", ()=>$b978cb322a482db9$export$8f35fbd5db0f3634);
    const $b978cb322a482db9$var$EVENT_PREFIX = 'forge.bridge.';
    function $b978cb322a482db9$export$af631764ddc44097(event, callback, extension) {
        const wrappedCallback = (e)=>{
            if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
        };
        window.document.addEventListener(`${$b978cb322a482db9$var$EVENT_PREFIX}${event}`, wrappedCallback);
        return {
            unsubscribe: ()=>window.document.removeEventListener(`${$b978cb322a482db9$var$EVENT_PREFIX}${event}`, wrappedCallback)
        };
    }
    function $b978cb322a482db9$export$8f35fbd5db0f3634(event, payload, extension) {
        const newEvent = new CustomEvent(`${$b978cb322a482db9$var$EVENT_PREFIX}${event}`, {
            detail: {
                extension: extension,
                payload: payload
            }
        });
        window.document.dispatchEvent(newEvent);
    }
});
parcelRegister("flEgL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d28f43dbb1e0cb29$export$2e2bcd8739ae039);
    var $hrlU6;
    var $d28f43dbb1e0cb29$export$2e2bcd8739ae039 = (eventName, addonFilter, eventData)=>{
        (0, (0, parcelRequire("hrlU6")).withConnectHost)((host)=>{
            host && host.broadcastEvent(eventName, addonFilter, eventData);
        });
    };
});
parcelRegister("hrlU6", function(module, exports) {
    $parcel$export(module.exports, "withConnectHost", ()=>$9316db67541b8a94$export$970e2411dd8601c8);
    $parcel$export(module.exports, "getConnectHost", ()=>$9316db67541b8a94$export$186d423c00af146c);
    $parcel$export(module.exports, "isConnectDialogWebItem", ()=>$9316db67541b8a94$export$920fb4b46d4f2eec);
    var $dJZWD;
    const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
        const connectHost = await (0, (0, parcelRequire("dJZWD")).setupConnectJs)();
        action(connectHost);
    };
    const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
    const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');
});
parcelRegister("dJZWD", function(module, exports) {
    $parcel$export(module.exports, "setupConnectJs", ()=>$762ba9fa524ea8e6$export$891414b605e5f038);
    var $6BZYo;
    var $dH9DT;
    const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
        await (0, (0, parcelRequire("dH9DT")).waitForJQuery)();
        const loader = await (parcelRequire("gRUhY"));
        await loader.performSideEffects();
        return window.connectHost;
    };
    let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
    const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
        if (window.__SPA__) {
            if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
            return $762ba9fa524ea8e6$var$installConnectJsPromise;
        }
        await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'ac/create',
            wrmKeys: [
                'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ]
        });
        return window.connectHost;
    };
});
parcelRegister("dH9DT", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$a78c52ec7ed5d025$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "getJQuery", ()=>$a78c52ec7ed5d025$export$7232a6dc780f9887);
    $parcel$export(module.exports, "getGlobalAP", ()=>$a78c52ec7ed5d025$export$fbc82125a6bd8012);
    $parcel$export(module.exports, "isObject", ()=>$a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "escapeSelector", ()=>$a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
    $parcel$export(module.exports, "waitForJQuery", ()=>$a78c52ec7ed5d025$export$97214de9c546981c);
    $parcel$export(module.exports, "ErrorDebugAddonKeys", ()=>$a78c52ec7ed5d025$export$d690da9bc8146677);
    var $jcw0u;
    const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
        const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
        return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
    };
    const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
    const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>window._AP;
    const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
    const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
        if (!s) throw new Error('No selector to escape');
        return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
    };
    const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
    const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
            const interval = setInterval(()=>{
                if (window.AJS?.$) {
                    clearInterval(interval);
                    resolve();
                }
            }, 10);
            setTimeout(()=>{
                clearInterval(interval);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'connect-jquery-timeout',
                        packageName: 'jiraConnect'
                    },
                    error: new Error('Timeout when waiting for jQuery to be available on the page'),
                    skipSentry: true
                });
                reject();
            }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
        });
    const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
    const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
    const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
        $a78c52ec7ed5d025$export$cb954c21735b28e4,
        $a78c52ec7ed5d025$export$7315c38dc71bd41f
    ];
});
parcelRegister("gRUhY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aVR4N").then(()=>parcelRequire('8vJyT'));
});
parcelRegister("1rce7", function(module, exports) {
    $parcel$export(module.exports, "DashboardPageContainer", ()=>$e6660bef9b59d455$export$8aeaeff803e753cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $2i4sA;
    var $ew1Lk;
    var $iXVV6;
    var $9dbF6;
    var $bVDE5;
    var $9OXo1;
    var $cRaE8;
    var $he6UQ;
    var $cwRtG;
    const $e6660bef9b59d455$export$8aeaeff803e753cd = ({ children: children, analyticsSourceName: analyticsSourceName, analyticsExperience: analyticsExperience, unauthenticatedFallback: unauthenticatedFallback, unauthorisedFallback: unauthorisedFallback, documentTitle: documentTitle, resourceData: resourceData })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: data, loading: loading } = resourceData;
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const ref = (0, (0, parcelRequire("he6UQ")).useDashboardRef)();
        if (!tenantContext) return null;
        if (!tenantContext.atlassianAccountId && !loading && !data) return unauthenticatedFallback;
        if (unauthorisedFallback != null && data && !data.writable) return unauthorisedFallback;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: analyticsSourceName,
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            containerId: data?.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: documentTitle
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "platform"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwRtG")).PageLayout), {
            ref: ref
        }, !isInitialRender && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cRaE8")).PrefetchLinks), {
            dashboardId: data?.id ?? 'pending'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "dashboard",
            className: "dashboard",
            "data-testid": "dashboard-internal-common.ui.container.div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experienceId: data?.id,
            experience: analyticsExperience,
            analyticsSource: "dashboard",
            edition: null,
            application: null
        }, children))));
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $6BZYo;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("6BZYo")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cRaE8", function(module, exports) {
    $parcel$export(module.exports, "PrefetchLinks", ()=>$956d4da8aa4ae614$export$b64797ad00b7bd3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $83oax;
    var $gh1hi;
    var $bVDE5;
    const $956d4da8aa4ae614$export$b64797ad00b7bd3c = ({ dashboardId: dashboardId })=>{
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const { data: data } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const prefetches = (0, $5uXOq.useMemo)(()=>data ? (0, (0, parcelRequire("83oax")).getPrefetches)(data) : [], [
            data
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!isInitialRender && window && window[0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY]) delete window[0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY];
        }, [
            isInitialRender
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, prefetches.map((prefetch)=>(0, ($parcel$interopDefault($5uXOq))).createElement("link", {
                key: `${dashboardId}-${prefetch.url}`,
                rel: isInitialRender ? prefetch.priority : 'prefetch',
                as: "fetch",
                href: prefetch.url
            })));
    };
});
parcelRegister("he6UQ", function(module, exports) {
    $parcel$export(module.exports, "useDashboardRef", ()=>$7859c7156387c1ba$export$a52b4118d451e93c);
    var $5uXOq = parcelRequire("5uXOq");
    const $7859c7156387c1ba$export$a52b4118d451e93c = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            const originalGetDashboard = window.AG?.DashboardManager?.getDashboard;
            return ()=>{
                window.AG = {
                    ...window.AG,
                    DashboardManager: {
                        ...window.AG?.DashboardManager,
                        getDashboard: originalGetDashboard
                    }
                };
            };
        }, []);
        return (0, $5uXOq.useCallback)((node)=>{
            window.AG = {
                ...window.AG,
                DashboardManager: {
                    ...window.AG?.DashboardManager,
                    getDashboard: ()=>node
                }
            };
        }, []);
    };
});
parcelRegister("cwRtG", function(module, exports) {
    $parcel$export(module.exports, "PageLayout", ()=>$a3f1ff5d07230114$export$6d1402fb58384e4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $a3f1ff5d07230114$export$6d1402fb58384e4f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zdiv _kqswh2mm _1pbyb4wl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1CEw6", function(module, exports) {
    $parcel$export(module.exports, "EngagementBanners", ()=>$ea6f1e008ef29904$export$eaa8218767cf0103);
    var $5uXOq = parcelRequire("5uXOq");
    const $ea6f1e008ef29904$export$eaa8218767cf0103 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
});
parcelRegister("5HxxK", function(module, exports) {
    $parcel$export(module.exports, "ColumnPlaceholderContextConsumer", ()=>$42fb06f36f97089d$export$efa1c423df3eb8d9);
    $parcel$export(module.exports, "ColumnLayout", ()=>$42fb06f36f97089d$export$c7e5bac7049eee2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bJcWY;
    var $aZdfU;
    var $bbkUF;
    var $6hp8I;
    var $1oaeD;
    var $jnkfq;
    var $6fab6;
    var $bfdYn;
    var $9bw66;
    var $h6EHU;
    const { createRenderFunction: $42fb06f36f97089d$var$createPlaceholderRender, Provider: $42fb06f36f97089d$export$e3a62d26c35df0c2, Consumer: $42fb06f36f97089d$export$efa1c423df3eb8d9 } = (0, (0, parcelRequire("jnkfq")).createRendererContext)();
    const { createRenderFunction: $42fb06f36f97089d$var$createGadgetRender, Provider: $42fb06f36f97089d$export$de8f6456a7a635a7, Consumer: $42fb06f36f97089d$export$599894a5533c31ef } = (0, (0, parcelRequire("jnkfq")).createRendererContext)();
    const $42fb06f36f97089d$export$c7e5bac7049eee2a = ({ data: data, dnd: dnd, columnPlaceholder: columnPlaceholder, layoutPlaceholder: layoutPlaceholder, onLayoutReposition: onLayoutReposition, children: children })=>{
        const { layout: layout, writable: writable, gadgets: gadgets } = data;
        const { DragDropContext: DragDropContext = (0, (0, parcelRequire("bfdYn")).DegenerateDragDropContext), Draggable: Draggable = (0, (0, parcelRequire("bfdYn")).DegenerateDraggable), Droppable: Droppable = (0, (0, parcelRequire("bfdYn")).DegenerateDroppable) } = dnd ?? {};
        const { getPropsByGadgetId: getPropsByGadgetId, getPropsByColumnIndex: getPropsByColumnIndex } = (0, (0, parcelRequire("1oaeD")).useMaximizedGadget)(gadgets);
        const [isAnyDragging, setIsAnyDragging] = (0, $5uXOq.useState)(false);
        const columns = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6fab6")).toColumns)(gadgets, layout), [
            gadgets,
            layout
        ]);
        const width = (0, (0, parcelRequire("bbkUF")).useDebouncedWindowWidth)();
        const onDragEnd = (0, $5uXOq.useCallback)((result)=>{
            if (!writable || !onLayoutReposition) return;
            const { destination: destination, source: source } = result;
            if (destination && destination.droppableId != null) {
                const moved = columns[+source.droppableId].splice(source.index, 1)[0];
                columns[+destination.droppableId].splice(destination.index, 0, moved);
                moved.column = +destination.droppableId;
            }
            onLayoutReposition(layout, columns);
            setIsAnyDragging(false);
        }, [
            columns,
            layout,
            writable,
            onLayoutReposition
        ]);
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            setIsAnyDragging(true);
        }, []);
        const renderColumnPlaceholder = $42fb06f36f97089d$var$createPlaceholderRender(columnPlaceholder);
        const renderGadget = $42fb06f36f97089d$var$createGadgetRender(children);
        if (!gadgets.length && layoutPlaceholder != null) return layoutPlaceholder;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DragDropContext, {
            onDragEnd: onDragEnd,
            onDragStart: onDragStart
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9bw66")).ContainerWrapper), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.layout.container-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6hp8I")).DimensionsProvider), {
            value: `${layout}-${width}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), {
            layout: "fluid"
        }, columns.map((items, columnIndex)=>{
            const columnWidth = (0, (0, parcelRequire("h6EHU")).getColumnWidth)(columnIndex, layout, getPropsByColumnIndex(columnIndex).display);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), {
                key: columnIndex,
                medium: columnWidth,
                testId: "dashboard-internal-common.ui.dashboard-content.layout.column"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Droppable, {
                droppableId: columnIndex.toString()
            }, ({ innerRef: columnRef, droppableProps: droppableProps, placeholder: dndPlaceholder }, { isDraggingOver: isDraggingOver })=>{
                const isNonEmptyCol = items.length > 0;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9bw66")).ContentWrapper), {
                    ...droppableProps,
                    ref: columnRef,
                    isDimmed: isNonEmptyCol && isDraggingOver,
                    isHidden: columnWidth === 0
                }, isNonEmptyCol ? items.map((gadgetData, rowIndex)=>{
                    const { isDraggable: isMaybeDraggable, ...gadgetProps } = getPropsByGadgetId(gadgetData.id);
                    const isDraggable = dnd != null && isMaybeDraggable;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(Draggable, {
                        key: gadgetData.id,
                        draggableId: gadgetData.id,
                        index: rowIndex,
                        isDragDisabled: !isDraggable
                    }, ({ innerRef: rowRef, dragHandleProps: dragHandleProps, draggableProps: draggableProps }, { isDragging: isDragging })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            ...draggableProps,
                            ref: rowRef
                        }, renderGadget({
                            data: gadgetData,
                            dragHandleProps: dragHandleProps,
                            isDraggable: isDraggable,
                            isDragging: isDragging,
                            isAnyDragging: isAnyDragging,
                            ...gadgetProps
                        })));
                }) : renderColumnPlaceholder({
                    columnIndex: columnIndex,
                    isDraggingOver: isDraggingOver
                }), dndPlaceholder);
            }));
        })))));
    };
});
parcelRegister("bJcWY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08fe944bdcd177c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    var $itnZ9;
    var $aZdfU;
    var $ephoW;
    const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("aZdfU")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("f1WIN")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("f1WIN")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ephoW")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itnZ9")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;
});
parcelRegister("f1WIN", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$196a11a7b8c2fbef$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$196a11a7b8c2fbef$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$196a11a7b8c2fbef$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$196a11a7b8c2fbef$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$196a11a7b8c2fbef$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$196a11a7b8c2fbef$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$196a11a7b8c2fbef$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$196a11a7b8c2fbef$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$196a11a7b8c2fbef$export$936829b4511db3e4);
    const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
    const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
    const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
    const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
        comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
        cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
        compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
    };
    const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
    const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
    const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
    const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
    const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
    const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("itnZ9", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$92e4fcbfc398e3a4$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $92e4fcbfc398e3a4$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}) * ${(0, (0, parcelRequire("f1WIN")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $92e4fcbfc398e3a4$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`
    });
    const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("f1WIN")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $92e4fcbfc398e3a4$var$gridStyles,
                $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
                isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("f1WIN")).varGridSpacing)]: `${(0, (0, parcelRequire("f1WIN")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("ephoW", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$529bf77650fbff0f$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    const $529bf77650fbff0f$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("f1WIN")).defaultSpacing),
        columns: (0, (0, parcelRequire("f1WIN")).defaultGridColumns)
    });
});
parcelRegister("aZdfU", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$11b791725219e059$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$11b791725219e059$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    var $11b791725219e059$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($11b791725219e059$var$ColumnVariant || ($11b791725219e059$var$ColumnVariant = {}));
    const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("f1WIN")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $11b791725219e059$var$availableWidth = '99.9999%';
    const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}))`;
    const $11b791725219e059$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $11b791725219e059$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("f1WIN")).varColumnSpan)}) - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $11b791725219e059$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("f1WIN")).defaultMedium)
    });
    const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("f1WIN")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $11b791725219e059$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $11b791725219e059$var$gridColumnStyles,
                $11b791725219e059$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;
});
parcelRegister("bbkUF", function(module, exports) {
    $parcel$export(module.exports, "useDebouncedWindowWidth", ()=>$c482c1c1fc6dfb26$export$4b69c5ad33ff59ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    const $c482c1c1fc6dfb26$export$4b69c5ad33ff59ee = (ms = 100)=>{
        const [width, setWidth] = (0, $5uXOq.useState)(window.innerWidth);
        const debounced = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($lFKmC)))((w)=>setWidth(w), ms));
        (0, $5uXOq.useEffect)(()=>{
            const handleResize = ()=>{
                const { innerWidth: innerWidth } = window;
                if (innerWidth !== width) debounced.current(innerWidth);
            };
            window.addEventListener('resize', handleResize);
            return ()=>{
                window.removeEventListener('resize', handleResize);
            };
        }, [
            width
        ]);
        return width;
    };
});
parcelRegister("6hp8I", function(module, exports) {
    $parcel$export(module.exports, "DimensionsProvider", ()=>$096975c907c9ee30$export$a31e22a91fd34dd9);
    $parcel$export(module.exports, "useDimensions", ()=>$096975c907c9ee30$export$d04af0e501fb729f);
    var $5uXOq = parcelRequire("5uXOq");
    const $096975c907c9ee30$var$DimensionsContext = (0, $5uXOq.createContext)('');
    const $096975c907c9ee30$export$a31e22a91fd34dd9 = $096975c907c9ee30$var$DimensionsContext.Provider;
    const $096975c907c9ee30$export$d04af0e501fb729f = ()=>(0, $5uXOq.useContext)($096975c907c9ee30$var$DimensionsContext);
});
parcelRegister("1oaeD", function(module, exports) {
    $parcel$export(module.exports, "useMaximizedGadget", ()=>$3f7e0a0376bf6236$export$23a0742f39986cba);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $4oDnX;
    var $dIdda = parcelRequire("dIdda");
    const $3f7e0a0376bf6236$export$23a0742f39986cba = (gadgetsData)=>{
        const [{ location: { hash: hash } }] = (0, $dIdda.useRouter)();
        const [maximizedQueryParam, setMaximizedQueryParam] = (0, $dIdda.useQueryParam)((0, (0, parcelRequire("JIPqS")).MAXIMIZED_PARAM));
        const [, { setAppReady: setAppReady }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const decodedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
        const idFromHashOrQuery = maximizedQueryParam != null ? maximizedQueryParam : decodedId;
        const gadget = idFromHashOrQuery != null && gadgetsData?.find(({ id: id })=>id === idFromHashOrQuery) || null;
        const maximizedId = gadget?.isMaximizable ? idFromHashOrQuery : null;
        const getMaximisedGadgetId = (0, $5uXOq.useMemo)(()=>maximizedId, [
            maximizedId
        ]);
        const getPropsByColumnIndex = (0, $5uXOq.useCallback)((column)=>{
            const maximizedGadget = maximizedId !== null ? gadgetsData?.find(({ id: id })=>id === maximizedId) : null;
            const { column: maximizedColumn = null } = maximizedGadget ?? {};
            const display = maximizedColumn === null && (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).NORMAL || maximizedColumn === column && (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).MAXIMIZED || (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).HIDDEN;
            return {
                display: display
            };
        }, [
            maximizedId,
            gadgetsData
        ]);
        const maximizedLookup = (0, $5uXOq.useMemo)(()=>Object.fromEntries(gadgetsData?.filter(({ isMaximizable: isMaximizable })=>isMaximizable).map((data)=>[
                    data.id,
                    (doMaximizeNotRestore)=>{
                        if (maximizedId === (doMaximizeNotRestore ? data.id : null)) return;
                        setMaximizedQueryParam(doMaximizeNotRestore ? data.id : undefined);
                        setTimeout(setAppReady);
                    }
                ]) ?? []), [
            gadgetsData,
            maximizedId,
            setAppReady,
            setMaximizedQueryParam
        ]);
        const getPropsByGadgetId = (0, $5uXOq.useCallback)((id)=>{
            const display = maximizedId === null && (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).NORMAL || maximizedId === id && (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).MAXIMIZED || (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).HIDDEN;
            const isDraggable = id !== maximizedId;
            const onMaximizeOrRestore = maximizedLookup[id] ?? (()=>undefined);
            return {
                display: display,
                isDraggable: isDraggable,
                onMaximizeOrRestore: onMaximizeOrRestore
            };
        }, [
            maximizedId,
            maximizedLookup
        ]);
        return {
            getMaximisedGadgetId: getMaximisedGadgetId,
            getPropsByGadgetId: getPropsByGadgetId,
            getPropsByColumnIndex: getPropsByColumnIndex
        };
    };
});
parcelRegister("6fab6", function(module, exports) {
    $parcel$export(module.exports, "toColumns", ()=>$78db23f50316c14c$export$755ca66aa40344da);
    const $78db23f50316c14c$export$755ca66aa40344da = (gadgets, layout)=>{
        const getGadgetsForCol = (col)=>gadgets.filter((gadget)=>gadget.column === col);
        switch(layout){
            case 'A':
                return [
                    getGadgetsForCol(0)
                ];
            case 'AA':
            case 'AB':
            case 'BA':
                return [
                    getGadgetsForCol(0),
                    getGadgetsForCol(1)
                ];
            case 'AAA':
                return [
                    getGadgetsForCol(0),
                    getGadgetsForCol(1),
                    getGadgetsForCol(2)
                ];
            default:
                throw new Error('Unexpected layout was provided');
        }
    };
});
parcelRegister("bfdYn", function(module, exports) {
    $parcel$export(module.exports, "DegenerateDragDropContext", ()=>$b11313e6244f86bc$export$cc74aca994b0ed41);
    $parcel$export(module.exports, "DegenerateDraggable", ()=>$b11313e6244f86bc$export$c114e58211833c77);
    $parcel$export(module.exports, "DegenerateDroppable", ()=>$b11313e6244f86bc$export$50925b5bb72c3049);
    const $b11313e6244f86bc$var$providedDraggable = {
        innerRef: ()=>undefined,
        draggableProps: {},
        dragHandleProps: undefined
    };
    const $b11313e6244f86bc$var$snapshotDraggable = {
        isDragging: false,
        isDropAnimating: false,
        dropAnimation: undefined,
        draggingOver: undefined,
        combineWith: undefined,
        combineTargetFor: undefined,
        mode: undefined,
        isClone: false
    };
    const $b11313e6244f86bc$var$providedDroppable = {
        innerRef: ()=>undefined,
        placeholder: undefined,
        droppableProps: {}
    };
    const $b11313e6244f86bc$var$snapshotDroppable = {
        isDraggingOver: false,
        draggingOverWith: undefined,
        draggingFromThisWith: undefined,
        isUsingPlaceholder: false
    };
    const $b11313e6244f86bc$var$rubricDraggable = {};
    const $b11313e6244f86bc$export$cc74aca994b0ed41 = ({ children: children })=>children;
    const $b11313e6244f86bc$export$c114e58211833c77 = ({ children: children })=>children($b11313e6244f86bc$var$providedDraggable, $b11313e6244f86bc$var$snapshotDraggable, $b11313e6244f86bc$var$rubricDraggable);
    const $b11313e6244f86bc$export$50925b5bb72c3049 = ({ children: children })=>children($b11313e6244f86bc$var$providedDroppable, $b11313e6244f86bc$var$snapshotDroppable);
});
parcelRegister("9bw66", function(module, exports) {
    $parcel$export(module.exports, "ContentWrapper", ()=>$53e240ce7384f76f$export$6ce170286acaa8d3);
    $parcel$export(module.exports, "ContainerWrapper", ()=>$53e240ce7384f76f$export$1312e4658e616d9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $53e240ce7384f76f$export$6ce170286acaa8d3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isDimmed: isDimmed, isHidden: isHidden, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _2rkoftgi _v564mfn2",
                __cmplp.isDimmed ? "_11q7hri9" : "_11q7vuon",
                __cmplp.isHidden && "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
    const $53e240ce7384f76f$export$1312e4658e616d9d = (0, $5uXOq.forwardRef)(({ as: C = "main", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _otyridpf _18u0mgjw _2hwxmgjw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h6EHU", function(module, exports) {
    $parcel$export(module.exports, "getColumnWidth", ()=>$3e20f2a7b6f0ea06$export$dfa11a34ceba822);
    var $JIPqS;
    const $3e20f2a7b6f0ea06$export$dfa11a34ceba822 = (index, layout, display)=>{
        if (display === (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).HIDDEN) return 0;
        if (layout === 'A' || display === (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).MAXIMIZED) return 12;
        if (layout === 'AA') return 6;
        if (layout === 'AAA') return 4;
        if (layout === 'AB') return index === 0 ? 8 : 4;
        return index === 0 ? 4 : 8;
    };
});
parcelRegister("4kIa4", function(module, exports) {
    $parcel$export(module.exports, "DashboardContentContainer", ()=>$e519b350b77b4296$export$b49692a976fb3d05);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $g0Gtc;
    var $dJl1T;
    var $beRD7;
    var $gh1hi;
    var $1yBXu;
    var $i7Ldp;
    var $bOnpg;
    var $8h45R;
    var $6IxJi;
    var $h5Jym;
    var $5jJ3W;
    var $1Bx5m;
    var $7v0Ei;
    var $fxC6K;
    var $kUwqK;
    var $hwuTz;
    const $e519b350b77b4296$var$HALF_HOUR = 1800000;
    const $e519b350b77b4296$export$d3a4cb300c572c66 = ({ data: { id: id, gadgets: gadgets, layout: layout }, saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
        (0, (0, parcelRequire("h5Jym")).useSpaStatePageReady)();
        (0, (0, parcelRequire("kUwqK")).usePageStatusLogger)($e519b350b77b4296$var$HALF_HOUR);
        (0, (0, parcelRequire("6IxJi")).useGadgetMetricsBridge)(id, gadgets, layout);
        (0, (0, parcelRequire("i7Ldp")).useConnectApi)({
            saveCustomGadgetTitle: saveCustomGadgetTitle
        });
        return null;
    };
    const $e519b350b77b4296$var$AMD_RESOURCE_RETRY_LIMIT = 2;
    const $e519b350b77b4296$export$b49692a976fb3d05 = ({ children: children, customHeight: customHeight, analyticsExperience: analyticsExperience, saveCustomGadgetTitle: saveCustomGadgetTitle = ()=>Promise.resolve(), resourceData: resourceData, permissionErrorFallback: permissionErrorFallback })=>{
        const { data: configData, error: configError, loading: configLoading } = resourceData;
        const { loading: amdLoading, data: amdData, error: amdError, refresh: amdRefresh } = (0, (0, parcelRequire("gh1hi")).useDashboardAMDModulesResource)();
        const [amdResourceRetries, setAmdResourceRetries] = (0, $5uXOq.useState)(0);
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const eventSent = (0, $5uXOq.useRef)(null);
        const isAmdResourceUnhealthy = configData != null && amdData == null && amdError != null || amdData?.amdModules != null && Object.values(amdData?.amdModules).some((v)=>v == null);
        const isAmdResourceRetriesExceeded = !amdLoading && amdResourceRetries >= $e519b350b77b4296$var$AMD_RESOURCE_RETRY_LIMIT;
        (0, $5uXOq.useEffect)(()=>{
            if (false || configLoading || configData == null || eventSent.current === Number(configData.id)) return;
            fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
                actionSubjectId: 'dashboard',
                actionSubject: 'dashboardScreen',
                action: 'viewed'
            });
            (0, (0, parcelRequire("5jJ3W")).addDashboardToRecents)(configData.id);
            eventSent.current = Number(configData.id);
        }, [
            configData,
            fireAnalytics,
            configLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (false) return;
            if (amdLoading) {
                !isAmdResourceUnhealthy && setAmdResourceRetries(0);
                return;
            }
            if (!isAmdResourceUnhealthy) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.content-container', `AMD resource loaded, after retries [${amdResourceRetries}]`);
            else if (isAmdResourceRetriesExceeded) {
                const [failedCount, totalCount] = Object.values(amdData?.amdModules ?? []).reduce(([f], v, i, arr)=>[
                        f + (v == null ? 1 : 0),
                        arr.length
                    ], [
                    0,
                    0
                ]);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.content-container', amdError ? `AMD resource error [${String(amdError.message)}]` : `AMD resource degraded, failed [${failedCount}] of [${totalCount}] gadgets`);
            } else {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('spa-apps.dashboard.content-container', `Retrying AMD resource, retry [${amdResourceRetries + 1}]`);
                setAmdResourceRetries((n)=>n + 1);
                amdRefresh();
            }
        }, [
            amdResourceRetries,
            amdLoading,
            amdError,
            amdData,
            isAmdResourceUnhealthy,
            isAmdResourceRetriesExceeded,
            amdRefresh
        ]);
        if (false || configLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1yBXu")).GenericLoadingView), {
            customHeight: customHeight
        });
        if (configError != null || configData == null) {
            const errorCode = Number(configError?.message?.substring(configError.message.length - 3));
            if ((0, (0, parcelRequire("fxC6K")).DASHBOARD_PERMISSION_ERROR_CODE_LIST).includes(errorCode)) return permissionErrorFallback;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceFailureTracker), {
                location: analyticsExperience,
                failureEventAttributes: {
                    error: configError ? configError.message : 'unknown error'
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).JSErrorPageAsync), null));
        }
        if (isAmdResourceRetriesExceeded && amdError != null && amdData == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: `AMD resource error [${String(amdError.message)}]`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).JSErrorPageAsync), null));
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
            theme: {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceSuccessTracker), {
            location: analyticsExperience
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7v0Ei")).AmdGadgetMonolithOverrideStyles), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Bx5m")).AboveTheFoldContainer), {
            dashboardId: configData.id,
            layout: configData.layout,
            gadgets: configData.gadgets
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8h45R")).GadgetAdditionalStateContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($e519b350b77b4296$export$d3a4cb300c572c66, {
            data: configData,
            saveCustomGadgetTitle: saveCustomGadgetTitle
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwuTz")).RouteResourceValidator), null), children)))));
    };
});
parcelRegister("1yBXu", function(module, exports) {
    $parcel$export(module.exports, "GenericLoadingView", ()=>$1052d375f7549967$export$901c7e24ef786b0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fNobW;
    var $44v1T;
    const $1052d375f7549967$export$901c7e24ef786b0f = ({ customHeight: customHeight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "generic-loading-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Title, null), (0, ($parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Button, null), (0, ($parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Button, null)), (0, ($parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$ContainerWrapper, {
            customHeight: customHeight
        })));
    const $1052d375f7549967$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1y6m _1e0c1txw _1n261g80 _p12f1osq _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
    const $1052d375f7549967$var$ContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { customHeight: customHeight, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_6y8cer": (0, (0, parcelRequire("lD23V")).default)(__cmplp.customHeight),
                "--_1s93bfy": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71aqf _1bsb1osq _1pbyb4wl",
                __cmplp.customHeight != null ? "_4t3i1hh3" : "_4t3inb68",
                __cmplp.className
            ])
        });
    });
    const $1052d375f7549967$var$Header = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _18s8gx6n _1okqidpf _142fidpf _kdjlidpf _1octidpf",
                __cmplp.className
            ])
        });
    });
    const $1052d375f7549967$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1wug _11q71aqf _4t3izwfg _1bsbclpc",
                __cmplp.className
            ])
        });
    });
    const $1052d375f7549967$var$Button = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc _11q71aqf _4t3izwfg _1bsbzwfg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i7Ldp", function(module, exports) {
    $parcel$export(module.exports, "useConnectApi", ()=>$5ce347994b87c55a$export$521765443e759ceb);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $JIPqS;
    var $gh1hi;
    var $19nfo;
    var $8h45R;
    const $5ce347994b87c55a$export$521765443e759ceb = ({ saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
        const { data: data, update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const debouncedHeightRef = (0, $5uXOq.useRef)({});
        const [, { addNonRenamable: addNonRenamable, addForcedHeight: addForcedHeight }] = (0, (0, parcelRequire("8h45R")).useGadgetAdditionalStateActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (!data) return;
            const setGadgetTitle = async (id, title)=>{
                if (data.gadgets.some((g)=>g.id === id)) {
                    saveCustomGadgetTitle(id, title);
                    addNonRenamable(id);
                }
            };
            const setGadgetHeight = (id, height)=>{
                if (debouncedHeightRef.current[id] == null) debouncedHeightRef.current[id] = (0, ($parcel$interopDefault($lFKmC)))((debouncedHeight)=>{
                    (0, (0, parcelRequire("19nfo")).updateLocalStorageHeight)(data.id, id, debouncedHeight);
                    addForcedHeight(id, debouncedHeight);
                }, (0, (0, parcelRequire("JIPqS")).GADGET_HEIGHT_UPDATE_WAIT_TIME));
                debouncedHeightRef.current[id](height);
            };
            const isGadgetConfigurable = (id)=>{
                const gadget = data.gadgets.find((g)=>g.id === id);
                const { configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl } = gadget || {};
                return data.writable && (configurable || hasNonHiddenUserPrefs || Boolean(renderedGadgetUrl));
            };
            window.dashboardSpaBridge = {
                setGadgetTitle: setGadgetTitle,
                setGadgetHeight: setGadgetHeight,
                isGadgetConfigurable: isGadgetConfigurable
            };
        }, [
            data,
            addNonRenamable,
            addForcedHeight,
            saveCustomGadgetTitle,
            update
        ]);
    };
});
parcelRegister("19nfo", function(module, exports) {
    $parcel$export(module.exports, "getGadgetDataFromLocalStorage", ()=>$bf0cad76c08ceb09$export$9d44840cd06e000d);
    $parcel$export(module.exports, "putGadgetDataFromLocalStorage", ()=>$bf0cad76c08ceb09$export$bfbe102b0a9ddb0b);
    $parcel$export(module.exports, "deleteGadgetDataFromLocalStorage", ()=>$bf0cad76c08ceb09$export$d0ed0cab2f2757a9);
    $parcel$export(module.exports, "updateLocalStorageHeight", ()=>$bf0cad76c08ceb09$export$2e93c23f060e835b);
    $parcel$export(module.exports, "getLocalStorageHeight", ()=>$bf0cad76c08ceb09$export$e31e30011965d5e7);
    $parcel$export(module.exports, "getAllLocalStorageHeights", ()=>$bf0cad76c08ceb09$export$2590d76ae5192a56);
    var $bSSG7;
    var $JIPqS;
    const $bf0cad76c08ceb09$export$6bac6bdc21b646b4 = (cookieData)=>{
        if (!cookieData) return {};
        const cookieInfos = cookieData.split('|').filter((cookieInfo)=>cookieInfo.trim().length);
        return cookieInfos.reduce((acc, cookieInfo)=>{
            const COOKIE_INFO_PATTERN = /(?<cookieKey>.*)=(?<cookieValue>.*)/;
            const matchRes = cookieInfo.match(COOKIE_INFO_PATTERN);
            if (!matchRes) return acc;
            const { cookieKey: cookieKey, cookieValue: cookieValue } = matchRes.groups;
            if (cookieKey.includes(':')) {
                const [gadgetId, gadgetAttributeName] = cookieKey.split(':');
                acc[gadgetId] = acc[gadgetId] || {};
                acc[gadgetId][gadgetAttributeName] = cookieValue;
            } else if (cookieKey.includes('-')) {
                const [, gadgetId, gadgetAttributeName] = cookieKey.split('-');
                acc[gadgetId] = acc[gadgetId] || {};
                acc[gadgetId][gadgetAttributeName] = cookieValue;
            }
            return acc;
        }, {});
    };
    const $bf0cad76c08ceb09$export$20a3a47cb251067e = (mappedCookieInfo)=>{
        let res = '';
        if (typeof mappedCookieInfo !== 'object') return res;
        Object.keys(mappedCookieInfo).forEach((id)=>{
            const attributeNames = mappedCookieInfo[id];
            if (typeof attributeNames !== 'object') return;
            Object.keys(attributeNames).forEach((attributeName)=>{
                const attributeValue = attributeNames[attributeName];
                if (!attributeValue) return;
                if (res.length) res += '|';
                if (attributeName.includes('fh')) res += `gadget-${id}-${attributeName}=${attributeValue}`;
                else res += `${id}:${attributeName}=${attributeValue}`;
            });
        });
        return res;
    };
    const $bf0cad76c08ceb09$export$ad3e452a397f8ecc = ()=>{
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('');
        const cookieData = localStorage.get((0, (0, parcelRequire("JIPqS")).GADGET_LOCAL_STORAGE_NAME));
        if (typeof cookieData !== 'string') return '';
        return cookieData.replace(/"/g, '');
    };
    const $bf0cad76c08ceb09$export$9d44840cd06e000d = (id, gadgetDataKey)=>{
        const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
        const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
        const gadgetInfo = mappedCookieInfo[id];
        return gadgetInfo?.[gadgetDataKey];
    };
    const $bf0cad76c08ceb09$export$bfbe102b0a9ddb0b = (id, gadgetDataKey, value)=>{
        const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
        const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
        mappedCookieInfo[id] = mappedCookieInfo[id] ?? {};
        if (mappedCookieInfo[id]) mappedCookieInfo[id][gadgetDataKey] = value;
        const updatedCookieData = $bf0cad76c08ceb09$export$20a3a47cb251067e(mappedCookieInfo);
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('');
        localStorage.set((0, (0, parcelRequire("JIPqS")).GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
    };
    const $bf0cad76c08ceb09$export$d0ed0cab2f2757a9 = (id, gadgetDataKey)=>{
        const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
        const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
        if (mappedCookieInfo[id]) delete mappedCookieInfo[id][gadgetDataKey];
        const updatedCookieData = $bf0cad76c08ceb09$export$20a3a47cb251067e(mappedCookieInfo);
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('');
        localStorage.set((0, (0, parcelRequire("JIPqS")).GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
    };
    const $bf0cad76c08ceb09$export$2e93c23f060e835b = (dashboardId, gadgetId, height)=>{
        if (dashboardId == null || height == null) return;
        const heightAsInt = Math.round(height);
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('');
        const dashboardLocalData = localStorage.get((0, (0, parcelRequire("JIPqS")).DASHBOARD_LOCAL_STORAGE_KEY_NAME)) ?? {};
        dashboardLocalData[dashboardId] = dashboardLocalData[dashboardId] ?? {};
        const dashboardData = dashboardLocalData[dashboardId];
        dashboardData[gadgetId] = dashboardData[gadgetId] ?? {};
        const gadgetData = dashboardData[gadgetId];
        const storedHeight = gadgetData.height;
        if (storedHeight === heightAsInt) return;
        gadgetData.height = heightAsInt;
        localStorage.set((0, (0, parcelRequire("JIPqS")).DASHBOARD_LOCAL_STORAGE_KEY_NAME), dashboardLocalData);
    };
    const $bf0cad76c08ceb09$export$e31e30011965d5e7 = (dashboardId, gadgetId)=>{
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('');
        const dashboardLocalData = localStorage.get((0, (0, parcelRequire("JIPqS")).DASHBOARD_LOCAL_STORAGE_KEY_NAME));
        const gadgetLocalHeight = dashboardLocalData?.[dashboardId]?.[gadgetId]?.height;
        return gadgetLocalHeight !== 0 && gadgetLocalHeight != null ? gadgetLocalHeight : (0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT);
    };
    const $bf0cad76c08ceb09$export$2590d76ae5192a56 = (dashboardId)=>{
        const localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('');
        const dashboardLocalData = localStorage.get((0, (0, parcelRequire("JIPqS")).DASHBOARD_LOCAL_STORAGE_KEY_NAME));
        return dashboardLocalData?.[dashboardId] ?? {};
    };
});
parcelRegister("8h45R", function(module, exports) {
    $parcel$export(module.exports, "useIsRenamable", ()=>$424d7b25bd304486$export$99680f47796b1368);
    $parcel$export(module.exports, "useForcedHeight", ()=>$424d7b25bd304486$export$6286e5c3de90c7ce);
    $parcel$export(module.exports, "useGadgetAdditionalStateActions", ()=>$424d7b25bd304486$export$7050d853cb5c3b12);
    $parcel$export(module.exports, "GadgetAdditionalStateContainer", ()=>$424d7b25bd304486$export$c59b94948beb035f);
    var $7JoAD = parcelRequire("7JoAD");
    const $424d7b25bd304486$var$actions = {
        addNonRenamable: (id)=>({ setState: setState, getState: getState })=>{
                const gadgetIdToStateMap = getState().idToStateMap;
                const newIds = new Map(gadgetIdToStateMap.set(id, {
                    ...gadgetIdToStateMap.get(id),
                    isNonRenamable: true
                }));
                setState({
                    idToStateMap: newIds
                });
            },
        addForcedHeight: (id, forcedHeight)=>({ setState: setState, getState: getState })=>{
                const gadgetIdToStateMap = getState().idToStateMap;
                const newGadgetIdToStateMap = new Map(gadgetIdToStateMap.set(id, {
                    ...gadgetIdToStateMap.get(id),
                    forcedHeight: forcedHeight
                }));
                setState({
                    idToStateMap: newGadgetIdToStateMap
                });
            },
        remove: (id)=>({ setState: setState, getState: getState })=>{
                if (!getState().idToStateMap.has(id)) return;
                const newGadgetIdToStateMap = new Map(getState().idToStateMap);
                newGadgetIdToStateMap.delete(id);
                setState({
                    idToStateMap: newGadgetIdToStateMap
                });
            }
    };
    const $424d7b25bd304486$var$Store = (0, $7JoAD.createStore)({
        name: 'gadget-additional-state',
        initialState: {
            idToStateMap: new Map()
        },
        actions: $424d7b25bd304486$var$actions
    });
    const $424d7b25bd304486$export$b8a31aa234db5dc9 = (hook)=>(args)=>{
            const [value] = hook(args);
            return value;
        };
    const $424d7b25bd304486$export$99680f47796b1368 = $424d7b25bd304486$export$b8a31aa234db5dc9((0, $7JoAD.createHook)($424d7b25bd304486$var$Store, {
        selector: (state, id)=>!state.idToStateMap.get(id)?.isNonRenamable
    }));
    const $424d7b25bd304486$export$6286e5c3de90c7ce = $424d7b25bd304486$export$b8a31aa234db5dc9((0, $7JoAD.createHook)($424d7b25bd304486$var$Store, {
        selector: (state, id)=>state.idToStateMap.get(id)?.forcedHeight
    }));
    const $424d7b25bd304486$export$7050d853cb5c3b12 = (0, $7JoAD.createHook)($424d7b25bd304486$var$Store, {
        selector: null
    });
    const $424d7b25bd304486$export$c59b94948beb035f = (0, $7JoAD.createContainer)($424d7b25bd304486$var$Store);
});
parcelRegister("bOnpg", function(module, exports) {
    $parcel$export(module.exports, "useDashboardAnalytics", ()=>$d2709a7a4ffbbf0c$export$6da6d2b3a61f8861);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8zOmE;
    var $2NMNM;
    const $d2709a7a4ffbbf0c$export$6da6d2b3a61f8861 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(({ eventType: eventType, actionSubject: actionSubject, action: action, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
            let fireAnalytics = (0, ($parcel$interopDefault($8Rkzz)));
            switch(eventType){
                case 0, $4d5e0871c06cee03$export$947dac6c72b26f81:
                    fireAnalytics = (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics);
                    break;
                case 0, $4d5e0871c06cee03$export$12346a674644c156:
                    fireAnalytics = (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics);
                    break;
                case 0, $4d5e0871c06cee03$export$a1562d08625f5d7e:
                    fireAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics);
                    break;
                case 0, $4d5e0871c06cee03$export$f1d537d508d2945a:
                    fireAnalytics = (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics);
                    break;
                default:
                    fireAnalytics = (0, ($parcel$interopDefault($8Rkzz)));
            }
            fireAnalytics(createAnalyticsEvent({}), `${actionSubject} ${action}`, actionSubjectId, attributes);
        }, [
            createAnalyticsEvent
        ]);
    };
});
parcelRegister("6IxJi", function(module, exports) {
    $parcel$export(module.exports, "useGadgetMetricsBridge", ()=>$d46d9a3e27973a8e$export$a81a90ecebb273c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $JIPqS;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $bVDE5;
    var $6fab6;
    var $8UPoO;
    var $1oaeD;
    var $i0rkS;
    var $5TsWX;
    var $7FHsN;
    var $gW6vr;
    const $d46d9a3e27973a8e$var$OVERALL_TIMEOUT = 60000;
    const $d46d9a3e27973a8e$var$buildEventKey = (event)=>{
        if (event.eventType !== (0, (0, parcelRequire("5TsWX")).GADGET_MARK_EVENT_PREFIX) || event.markName == null || event.markStage == null) return event.eventType;
        return `${0, (0, parcelRequire("5TsWX")).GADGET_MARK_EVENT_PREFIX}-${event.markName}-${event.markStage}`;
    };
    const $d46d9a3e27973a8e$export$b70b6efb2347a731 = (gadgetMetricsEvents, gadgetId, event)=>{
        let recorded = gadgetMetricsEvents.get(gadgetId);
        if (recorded == null) {
            recorded = {
                contentType: 'Unspecified',
                source: event.source,
                events: new Map()
            };
            gadgetMetricsEvents.set(gadgetId, recorded);
        }
        if (recorded.contentType !== 'ErrorMessage' && event.contentType !== 'Unspecified') recorded.contentType = event.contentType;
        const record = {
            spaTime: Date.now()
        };
        if (!recorded.events.has($d46d9a3e27973a8e$var$buildEventKey(event))) recorded.events.set($d46d9a3e27973a8e$var$buildEventKey(event), record);
    };
    const $d46d9a3e27973a8e$export$8aed66d0a3a7041d = (gadgets)=>gadgets.filter((item)=>item.amdModule != null || item.forge != null || item.reactKey != null).filter((item)=>item.forge != null || item.reactKey != null || (0, (0, parcelRequire("gW6vr")).GADGETS_TO_REPORT).has(item.amdModule ?? '')).map((gadget)=>gadget.id);
    const $d46d9a3e27973a8e$export$b2ee8eefeb9c97ce = (gadgets)=>gadgets.filter((item)=>item.amdModule != null).filter((item)=>!(0, (0, parcelRequire("5TsWX")).CONNECT_MODULE_PATTERN).test(item.amdModule || '')).filter((item)=>!(0, (0, parcelRequire("gW6vr")).GADGETS_TO_REPORT).has(item.amdModule ?? '') && !(0, (0, parcelRequire("gW6vr")).GADGETS_IGNORED).has(item.amdModule ?? ''));
    const $d46d9a3e27973a8e$var$shouldSendGadgetMetrics = (event)=>!(event.source === (0, (0, parcelRequire("5TsWX")).WRM_GADGET_METRICS) && event.contentType === 'Config');
    const $d46d9a3e27973a8e$export$a81a90ecebb273c6 = (dashboardId, gadgets, layout)=>{
        const currentDashboardId = (0, $5uXOq.useRef)(null);
        const dashboardMetricsContext = (0, $5uXOq.useRef)(null);
        const [, { registerListener: registerMessageListener, unregisterListener: unregisterMessageListener, broadcastMessage: broadcastMessageListener }] = (0, (0, parcelRequire("i0rkS")).useMessageBus)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { sendGadgetMetrics: sendGadgetMetrics, sendOverallGadgetMetrics: sendOverallGadgetMetrics, onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender, resetScrollStartMetrics: resetScrollStartMetrics } = (0, (0, parcelRequire("7FHsN")).useGadgetMetricsAnalytics)(dashboardId);
        const [, { onGadgetRender: onGadgetRender }] = (0, (0, parcelRequire("8UPoO")).useRenderAboveTheFold)();
        const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const { name: routeName } = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, (0, parcelRequire("1oaeD")).useMaximizedGadget)(gadgets);
        const maximizedId = getMaximisedGadgetId;
        if (currentDashboardId.current == null || currentDashboardId.current !== dashboardId) {
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'dashboardMetricsContext renewed', {
                dashboardId: dashboardId,
                previousDashboardId: currentDashboardId.current,
                currentPageId: currentPageId
            });
            resetScrollStartMetrics();
            currentDashboardId.current = dashboardId;
            if (dashboardMetricsContext.current?.metricsTimeout != null) clearTimeout(dashboardMetricsContext.current.metricsTimeout);
            const extractedGadgets = $d46d9a3e27973a8e$export$8aed66d0a3a7041d(maximizedId ? gadgets.filter((gadget)=>gadget.id === maximizedId) : gadgets);
            const allAboveTheFoldGadgets = (0, (0, parcelRequire("8UPoO")).getAboveTheFoldGadgets)((0, (0, parcelRequire("6fab6")).toColumns)(gadgets, layout), dashboardId);
            dashboardMetricsContext.current = {
                gadgetMetricsEvents: new Map(),
                gadgetIdsInOverallAnalytics: extractedGadgets,
                gadgetIdsInTti: extractedGadgets.filter((gadgetId)=>allAboveTheFoldGadgets.has(gadgetId)),
                allGadgetIds: gadgets.map((item)=>item.id),
                overallMetricsSent: false,
                atfMetricsSent: false,
                implicitlyIgnoredGadgetLogged: false,
                gadgetRenderStartTime: Date.now(),
                metricsTimeout: setTimeout(()=>{
                    broadcastMessageListener((0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).TIMEOUT, {}, {});
                }, $d46d9a3e27973a8e$var$OVERALL_TIMEOUT),
                timestamps: {
                    created: Date.now(),
                    pnow: performance?.now(),
                    currentPageId: currentPageId,
                    lastTransitionStartTime: lastTransitionStartTime,
                    navigationStart: navigationStart,
                    navStart: (0, (0, parcelRequire("7FHsN")).getNavStart)(isInitialRender, lastTransitionStartTime, navigationStart)
                }
            };
        }
        const gadgetMetricsTimeout = (0, $5uXOq.useCallback)(()=>{
            const context = dashboardMetricsContext.current;
            if (context == null) return;
            if (context.overallMetricsSent) return;
            context.metricsTimeout = undefined;
            context.overallMetricsSent = true;
            context.gadgetMetricsEvents.forEach((item, id)=>{
                if (item.allEventHandled !== true) {
                    item.timedOut = true;
                    sendGadgetMetrics(id, item);
                }
            });
            context.gadgetIdsInOverallAnalytics.filter((id)=>!context.gadgetMetricsEvents.has(id)).forEach((id)=>{
                sendGadgetMetrics(id, {
                    source: (0, (0, parcelRequire("5TsWX")).IDLE_GADGET_SOURCE),
                    timedOut: true,
                    events: new Map()
                });
            });
            onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, true);
            sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, true);
        }, [
            sendGadgetMetrics,
            sendOverallGadgetMetrics,
            onAboveTheFoldGadgetsRender
        ]);
        const onAllGadgetHandled = (0, $5uXOq.useCallback)(()=>{
            const context = dashboardMetricsContext.current;
            if (context == null) return;
            context.overallMetricsSent = true;
            if (context.metricsTimeout != null) {
                clearTimeout(context.metricsTimeout);
                context.metricsTimeout = undefined;
            }
            sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, false);
        }, [
            sendOverallGadgetMetrics
        ]);
        const onAboveTheFoldGadgetsHandled = (0, $5uXOq.useCallback)(()=>{
            const context = dashboardMetricsContext.current;
            if (context == null) return;
            onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, false);
            context.atfMetricsSent = true;
        }, [
            onAboveTheFoldGadgetsRender
        ]);
        const gadgetMetricsListener = (0, $5uXOq.useCallback)((gid, command, ...args)=>{
            if (command !== 'metrics_event' || !args[0]) return;
            const context = dashboardMetricsContext.current;
            if (context == null) return;
            if (context.overallMetricsSent) return;
            const eventData = args[0];
            const eventsPerGadget = (0, (0, parcelRequire("7FHsN")).getAllEventHandlers)(eventData.source, eventData.contentType);
            const { pageId: pageIdInEvent } = eventData;
            if (currentPageId !== pageIdInEvent || context.allGadgetIds.every((id)=>id !== gid)) {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `Page [${currentPageId ?? ''}] recieved staled gadget metrics event [${eventData.eventType}] from gadget [${gid}] in page [${pageIdInEvent ?? ''}]`);
                return;
            }
            const isAllGadgetEventsHandled = (gadgetEvents)=>gadgetEvents?.allEventHandled === true || gadgetEvents?.timedOut === true || eventsPerGadget.every((e)=>gadgetEvents?.events.has(e));
            const isAllGadgetHandled = (gadgetIds)=>gadgetIds.every((id)=>context.gadgetMetricsEvents.get(id)?.allEventHandled);
            if (context.gadgetMetricsEvents.has(gid)) {
                if (isAllGadgetEventsHandled(context.gadgetMetricsEvents.get(gid))) return;
                if (context.gadgetMetricsEvents.get(gid)?.events.has($d46d9a3e27973a8e$var$buildEventKey(eventData))) return;
            }
            $d46d9a3e27973a8e$export$b70b6efb2347a731(context.gadgetMetricsEvents, gid, eventData);
            const event = context.gadgetMetricsEvents.get(gid);
            if (event != null && isAllGadgetEventsHandled(event)) {
                event.allEventHandled = true;
                if ($d46d9a3e27973a8e$var$shouldSendGadgetMetrics(event)) {
                    onGadgetRender(gid);
                    sendGadgetMetrics(gid, event);
                }
                if (context.atfMetricsSent === false) {
                    if (isAllGadgetHandled(context.gadgetIdsInTti)) onAboveTheFoldGadgetsHandled();
                }
                if (isAllGadgetHandled(context.gadgetIdsInOverallAnalytics)) {
                    onAllGadgetHandled();
                    if (context.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
                }
            }
        }, [
            currentPageId,
            onAboveTheFoldGadgetsHandled,
            onAllGadgetHandled,
            sendGadgetMetrics,
            onGadgetRender
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (routeName === 'dashboard-wallboard') return;
                if (dashboardMetricsContext.current?.metricsTimeout != null) {
                    clearTimeout(dashboardMetricsContext.current.metricsTimeout);
                    dashboardMetricsContext.current.metricsTimeout = undefined;
                }
            }, [
            routeName
        ]);
        const gadgetMetricsMessageBusListenerAdaptor = (0, $5uXOq.useCallback)((type, message, context)=>{
            if (type !== (0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).REPORT) return;
            const { gadgetId: gid, pageId: pageId } = context;
            if (gid == null) return;
            gadgetMetricsListener(gid, 'metrics_event', {
                ...message,
                pageId: pageId
            });
        }, [
            gadgetMetricsListener
        ]);
        const timeoutMessageBusListenerAdaptor = (0, $5uXOq.useCallback)((type)=>{
            if (type !== (0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).TIMEOUT) return;
            gadgetMetricsTimeout();
        }, [
            gadgetMetricsTimeout
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (routeName === 'dashboard-wallboard') return ()=>{};
            registerMessageListener(gadgetMetricsMessageBusListenerAdaptor);
            registerMessageListener(timeoutMessageBusListenerAdaptor);
            return ()=>{
                unregisterMessageListener(gadgetMetricsMessageBusListenerAdaptor);
                unregisterMessageListener(timeoutMessageBusListenerAdaptor);
            };
        }, [
            gadgetMetricsMessageBusListenerAdaptor,
            gadgetMetricsListener,
            registerMessageListener,
            timeoutMessageBusListenerAdaptor,
            unregisterMessageListener,
            routeName
        ]);
        if (routeName === 'dashboard-wallboard') return;
        if (dashboardMetricsContext.current == null || dashboardMetricsContext.current.overallMetricsSent === true) return;
        if (dashboardMetricsContext.current?.gadgetIdsInOverallAnalytics.length === 0) {
            onAboveTheFoldGadgetsHandled();
            onAllGadgetHandled();
        } else if (dashboardMetricsContext.current?.gadgetIdsInTti.length === 0 && dashboardMetricsContext.current?.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
        if (dashboardMetricsContext.current != null && !dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged) {
            dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged = true;
            $d46d9a3e27973a8e$export$b2ee8eefeb9c97ce(gadgets).forEach((item)=>{
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics for gadget [${item.amdModule ?? 'unknown'}] is ignored implicitly.`);
            });
        }
    };
});
parcelRegister("8UPoO", function(module, exports) {
    $parcel$export(module.exports, "getAboveTheFoldGadgets", ()=>$149138b232138cbc$export$e12eddecf5e86fe5);
    $parcel$export(module.exports, "useRenderAboveTheFold", ()=>$149138b232138cbc$export$16f58cfd4c8ccf70);
    $parcel$export(module.exports, "RenderAboveTheFoldContainer", ()=>$149138b232138cbc$export$9710049f7f21917b);
    $parcel$export(module.exports, "useOnGadgetRender", ()=>$149138b232138cbc$export$c127791d148e941c);
    $parcel$export(module.exports, "useOnGadgetRenderEffect", ()=>$149138b232138cbc$export$1f28971b410f9e3);
    $parcel$export(module.exports, "useShouldRenderGadget", ()=>$149138b232138cbc$export$428a5d740650db3e);
    $parcel$export(module.exports, "useLocalStorageGadgetHeight", ()=>$149138b232138cbc$export$94d0a966fb813ab7);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $7JoAD = parcelRequire("7JoAD");
    var $19nfo;
    const $149138b232138cbc$var$TOP_NAVIGATION_HEIGHT = 56;
    const $149138b232138cbc$var$DASHBOARD_HEADER_HEIGHT = 80;
    const $149138b232138cbc$var$GADGET_HEADER_AND_FOOTER_HEIGHT = 84;
    const $149138b232138cbc$var$PRIORITISED_RENDERING_TIMEOUT = 7000;
    const $149138b232138cbc$export$e12eddecf5e86fe5 = (columns, dashboardId)=>{
        const aboveTheFoldGadgets = new Set();
        const availableViewportHeight = window.innerHeight - $149138b232138cbc$var$TOP_NAVIGATION_HEIGHT - $149138b232138cbc$var$DASHBOARD_HEADER_HEIGHT;
        columns.forEach((column)=>{
            let occupiedViewportHeight = 0;
            column.some((gadget)=>{
                if (occupiedViewportHeight < availableViewportHeight) {
                    const gadgetHeight = (0, (0, parcelRequire("19nfo")).getLocalStorageHeight)(dashboardId, gadget.id) + $149138b232138cbc$var$GADGET_HEADER_AND_FOOTER_HEIGHT;
                    aboveTheFoldGadgets.add(gadget.id);
                    occupiedViewportHeight += gadgetHeight;
                    return false;
                }
                return true;
            });
        });
        return aboveTheFoldGadgets;
    };
    const $149138b232138cbc$export$e324594224ef24da = {
        onGadgetRender: (gadgetId, height)=>({ setState: setState, getState: getState })=>{
                const { dashboardId: dashboardId, loadingAboveTheFold: hasAboveTheFold, timeoutId: timeoutLast } = getState();
                if (dashboardId === null) return;
                if (height != null) {
                    (0, (0, parcelRequire("19nfo")).updateLocalStorageHeight)(dashboardId, gadgetId, height);
                    setState({
                        localStorageGadgetHeights: {
                            ...(0, (0, parcelRequire("19nfo")).getAllLocalStorageHeights)(dashboardId),
                            [gadgetId]: {
                                height: height
                            }
                        }
                    });
                }
                if (!hasAboveTheFold) return;
                const remainingAboveTheFoldGadgets = new Set(getState().remainingAboveTheFoldGadgets);
                remainingAboveTheFoldGadgets.delete(gadgetId);
                const loadingAboveTheFold = Boolean(remainingAboveTheFoldGadgets.size);
                const timeoutId = loadingAboveTheFold ? timeoutLast : null;
                if (timeoutLast && !timeoutId) clearTimeout(timeoutLast);
                setState({
                    remainingAboveTheFoldGadgets: remainingAboveTheFoldGadgets,
                    loadingAboveTheFold: loadingAboveTheFold,
                    timeoutId: timeoutId
                });
            }
    };
    const $149138b232138cbc$var$Store = (0, $7JoAD.createStore)({
        name: 'RenderAboveTheFold',
        initialState: {
            dashboardId: null,
            loadingAboveTheFold: true,
            aboveTheFoldGadgets: new Set(),
            remainingAboveTheFoldGadgets: new Set(),
            timeoutId: null,
            timeout: false,
            localStorageGadgetHeights: {}
        },
        actions: $149138b232138cbc$export$e324594224ef24da
    });
    const $149138b232138cbc$export$16f58cfd4c8ccf70 = (0, $7JoAD.createHook)($149138b232138cbc$var$Store);
    const $149138b232138cbc$export$f0ff1fd44503e803 = (0, $7JoAD.createHook)($149138b232138cbc$var$Store, {
        selector: null
    });
    const $149138b232138cbc$export$9710049f7f21917b = (0, $7JoAD.createContainer)($149138b232138cbc$var$Store, {
        onInit: ()=>({ setState: setState, getState: getState }, { columns: columns, dashboardId: dashboardId, maximizedGadgetId: maximizedGadgetId })=>{
                if (getState().dashboardId !== dashboardId && dashboardId != null) {
                    const loadingAboveTheFoldTimeout = ()=>{
                        setState({
                            remainingAboveTheFoldGadgets: new Set(),
                            loadingAboveTheFold: false,
                            timeout: true
                        });
                    };
                    const aboveTheFoldGadgets = maximizedGadgetId ? new Set([
                        maximizedGadgetId
                    ]) : $149138b232138cbc$export$e12eddecf5e86fe5(columns, dashboardId);
                    setState({
                        dashboardId: dashboardId,
                        aboveTheFoldGadgets: aboveTheFoldGadgets,
                        remainingAboveTheFoldGadgets: new Set(aboveTheFoldGadgets),
                        loadingAboveTheFold: Boolean(aboveTheFoldGadgets.size),
                        timeoutId: setTimeout(loadingAboveTheFoldTimeout, $149138b232138cbc$var$PRIORITISED_RENDERING_TIMEOUT),
                        timeout: false,
                        localStorageGadgetHeights: (0, (0, parcelRequire("19nfo")).getAllLocalStorageHeights)(dashboardId)
                    });
                }
            }
    });
    const $149138b232138cbc$export$c127791d148e941c = (id)=>{
        const [, { onGadgetRender: onGadgetRender }] = $149138b232138cbc$export$f0ff1fd44503e803();
        return (0, $5uXOq.useCallback)((height)=>onGadgetRender(id, height), [
            id,
            onGadgetRender
        ]);
    };
    const $149138b232138cbc$export$1f28971b410f9e3 = (id, gadgetRef)=>{
        const onGadgetRender = $149138b232138cbc$export$c127791d148e941c(id);
        (0, $5uXOq.useEffect)(()=>{
            onGadgetRender(gadgetRef?.getBoundingClientRect().height);
        }, [
            onGadgetRender,
            gadgetRef
        ]);
    };
    const $149138b232138cbc$export$b8a31aa234db5dc9 = (hook)=>(args)=>{
            const [value] = hook(args);
            return value;
        };
    const $149138b232138cbc$export$428a5d740650db3e = $149138b232138cbc$export$b8a31aa234db5dc9((0, $7JoAD.createHook)($149138b232138cbc$var$Store, {
        selector: ({ loadingAboveTheFold: loadingAboveTheFold, aboveTheFoldGadgets: aboveTheFoldGadgets, dashboardId: dashboardId }, gadgetId)=>{
            if (dashboardId === null) return true;
            return !loadingAboveTheFold || aboveTheFoldGadgets.has(gadgetId);
        }
    }));
    const $149138b232138cbc$export$94d0a966fb813ab7 = $149138b232138cbc$export$b8a31aa234db5dc9((0, $7JoAD.createHook)($149138b232138cbc$var$Store, {
        selector: ({ localStorageGadgetHeights: localStorageGadgetHeights }, gadgetId)=>localStorageGadgetHeights[gadgetId]?.height ?? (0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT)
    }));
});
parcelRegister("i0rkS", function(module, exports) {
    $parcel$export(module.exports, "useMessageBus", ()=>$f812b795237bfc34$export$69241ffa7d4e8d8d);
    var $7JoAD = parcelRequire("7JoAD");
    const $f812b795237bfc34$var$actions = {
        registerListener: (listener)=>({ setState: setState, getState: getState })=>{
                const { listeners: listeners } = getState();
                setState({
                    listeners: [
                        ...listeners,
                        listener
                    ]
                });
            },
        unregisterListener: (listener)=>({ setState: setState, getState: getState })=>{
                const { listeners: listeners } = getState();
                setState({
                    listeners: listeners.filter((cb)=>cb !== listener)
                });
            },
        broadcastMessage: (type, message, context)=>({ getState: getState })=>{
                getState().listeners.forEach((listener)=>listener(type, message, context));
            }
    };
    const $f812b795237bfc34$var$Store = (0, $7JoAD.createStore)({
        name: 'dashboard-message-bus',
        initialState: {
            listeners: []
        },
        actions: $f812b795237bfc34$var$actions
    });
    const $f812b795237bfc34$export$69241ffa7d4e8d8d = (0, $7JoAD.createHook)($f812b795237bfc34$var$Store);
});
parcelRegister("5TsWX", function(module, exports) {
    $parcel$export(module.exports, "UNKNOWN_GADGET_TYPE", ()=>$3975f005d3e53b97$export$4db4c2521224b627);
    $parcel$export(module.exports, "CONNECT_MODULE_PATTERN", ()=>$3975f005d3e53b97$export$c1ee01d79441a123);
    $parcel$export(module.exports, "FORGE_MODULE_PATTERN", ()=>$3975f005d3e53b97$export$216b1f7517647987);
    $parcel$export(module.exports, "WRM_GADGET_METRICS", ()=>$3975f005d3e53b97$export$747c046b02db553e);
    $parcel$export(module.exports, "FORGE_GADGET_METRICS", ()=>$3975f005d3e53b97$export$fd11359c208e3b3d);
    $parcel$export(module.exports, "REACT_GADGET_METRICS", ()=>$3975f005d3e53b97$export$e6e5910bcc3a541f);
    $parcel$export(module.exports, "FALLBACK_GADGET_SOURCE", ()=>$3975f005d3e53b97$export$b17b847ae2e73914);
    $parcel$export(module.exports, "IDLE_GADGET_SOURCE", ()=>$3975f005d3e53b97$export$8e7a356fc2e45e1);
    $parcel$export(module.exports, "GADGET_MARK_EVENT_PREFIX", ()=>$3975f005d3e53b97$export$deb23548f6bb4aa6);
    $parcel$export(module.exports, "GADGET_MARK_EVENT_PATTERN", ()=>$3975f005d3e53b97$export$dc82d3f06c18522e);
    $parcel$export(module.exports, "GADGET_RENDER_CONTAINER_EVENT", ()=>$3975f005d3e53b97$export$479474c5d2f30a0a);
    $parcel$export(module.exports, "GADGET_START_EVENT", ()=>$3975f005d3e53b97$export$76b0ea781056f8d3);
    $parcel$export(module.exports, "GADGET_RENDERING_FINISHED_EVENT", ()=>$3975f005d3e53b97$export$b9c9f3ffa9290059);
    $parcel$export(module.exports, "DEFAULT_WRM_GADGET_EVENTS", ()=>$3975f005d3e53b97$export$f34d5b0533833e95);
    const $3975f005d3e53b97$export$4db4c2521224b627 = 'unknown';
    const $3975f005d3e53b97$export$c1ee01d79441a123 = /^atlassian-connect\/.*/;
    const $3975f005d3e53b97$export$216b1f7517647987 = /^ari:cloud:ecosystem::extension\/.*/;
    const $3975f005d3e53b97$export$747c046b02db553e = 'wrm_gadget_metrics';
    const $3975f005d3e53b97$export$fd11359c208e3b3d = 'forge_gadget_metrics';
    const $3975f005d3e53b97$export$e6e5910bcc3a541f = 'react_gadget_metrics';
    const $3975f005d3e53b97$export$b17b847ae2e73914 = 'fallback_gadget';
    const $3975f005d3e53b97$export$8e7a356fc2e45e1 = 'idle_gadget';
    const $3975f005d3e53b97$export$deb23548f6bb4aa6 = 'gadget-mark';
    const $3975f005d3e53b97$export$dc82d3f06c18522e = new RegExp(`^${$3975f005d3e53b97$export$deb23548f6bb4aa6}-(.+)-(start|end)$`);
    const $3975f005d3e53b97$export$479474c5d2f30a0a = 'gadget-render-container';
    const $3975f005d3e53b97$export$593632c36804eee0 = 'gadget-dom-ready';
    const $3975f005d3e53b97$export$c10c3db63be202d5 = 'gadget-loaded';
    const $3975f005d3e53b97$export$76b0ea781056f8d3 = 'gadget-start';
    const $3975f005d3e53b97$export$b9c9f3ffa9290059 = 'gadget-rendering-finished';
    const $3975f005d3e53b97$export$eebee3f00d7d097d = 'gadget-sync-rendering-finished';
    const $3975f005d3e53b97$export$f34d5b0533833e95 = [
        $3975f005d3e53b97$export$479474c5d2f30a0a,
        $3975f005d3e53b97$export$76b0ea781056f8d3,
        $3975f005d3e53b97$export$b9c9f3ffa9290059
    ];
});
parcelRegister("7FHsN", function(module, exports) {
    $parcel$export(module.exports, "getAllEventHandlers", ()=>$f42b084586d299a2$export$835bb833cb903f59);
    $parcel$export(module.exports, "getNavStart", ()=>$f42b084586d299a2$export$f409d0aa399347ac);
    $parcel$export(module.exports, "useGadgetMetricsAnalytics", ()=>$f42b084586d299a2$export$ea517a7cfce02895);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $99gkn;
    var $bFU4G;
    var $hh0bW;
    var $dJl1T;
    var $JIPqS;
    var $hGdg6;
    var $co1wz;
    var $j8DrX;
    var $8zOmE;
    var $2NMNM;
    var $iAWa3;
    var $3B7oW;
    var $gh1hi;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    var $7cLxq;
    var $8UDz8;
    var $trHKK;
    var $hmyfM;
    var $8UPoO;
    var $5TsWX;
    const $f42b084586d299a2$var$getSSRFeatureFlags = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        try {
            const metaTagValue = (0, (0, parcelRequire("j8DrX")).default)('spa-service-flags');
            return metaTagValue != null && JSON.parse(metaTagValue) || {};
        } catch (e) {
            return null;
        }
    });
    const $f42b084586d299a2$var$expAttributes = {
        analyticsSource: 'dashboard',
        application: null,
        edition: null,
        additionalAttributes: {},
        wasExperienceSuccesful: true
    };
    const $f42b084586d299a2$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS = [
        (0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT)
    ];
    const $f42b084586d299a2$var$IMMEDIATE_FINISH_GADGET_EVENTS = [
        (0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT)
    ];
    const $f42b084586d299a2$var$GADGET_CONTAINER_EVENTS = new Set([
        (0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT)
    ]);
    const $f42b084586d299a2$export$835bb833cb903f59 = (eventSource, contentType = 'View')=>{
        if (eventSource === (0, (0, parcelRequire("5TsWX")).WRM_GADGET_METRICS) || eventSource === (0, (0, parcelRequire("5TsWX")).FORGE_GADGET_METRICS) || eventSource === (0, (0, parcelRequire("5TsWX")).REACT_GADGET_METRICS)) return contentType === 'Config' ? $f42b084586d299a2$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS : (0, (0, parcelRequire("5TsWX")).DEFAULT_WRM_GADGET_EVENTS);
        return $f42b084586d299a2$var$IMMEDIATE_FINISH_GADGET_EVENTS;
    };
    const $f42b084586d299a2$var$isIdle = (gadgetEventRecord)=>{
        if (gadgetEventRecord == null) return false;
        if (gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).IDLE_GADGET_SOURCE)) return true;
        const eventEntries = Array.from(gadgetEventRecord.events.entries());
        return eventEntries.length === $f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.size && eventEntries.every((entry)=>$f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.has(entry[0]));
    };
    const $f42b084586d299a2$export$b1f29dd0b70f467b = (events)=>{
        const customMarksMap = {};
        const customMarksList = [];
        events.forEach((event, eventKey)=>{
            const parts = (0, (0, parcelRequire("5TsWX")).GADGET_MARK_EVENT_PATTERN).exec(eventKey);
            if (parts == null) return;
            const key = parts[1];
            const stage = parts[2];
            const customMark = customMarksMap[key];
            if (customMark == null) {
                const newCustomMark = {
                    name: `gadgetMark_${key}`,
                    [stage]: event.spaTime
                };
                customMarksMap[key] = newCustomMark;
                customMarksList.push(newCustomMark);
            } else customMark[stage] = event.spaTime;
        });
        return customMarksList;
    };
    const $f42b084586d299a2$var$getInitialMarks = (context)=>({
            TTI: Date.now() - Number(context.navStart),
            isInitialRender: context.isInitialRender,
            isWritable: context.isWritable,
            isRouteReplaced: context.isRouteReplaced,
            currentPageId: context.currentPageId,
            pageVisible: !window?.document?.hidden,
            ssrFeatureFlags: $f42b084586d299a2$var$getSSRFeatureFlags(),
            featureFlags: (0, (0, parcelRequire("7cLxq")).getDashboardFeatureFlags)(),
            featureGates: (0, (0, parcelRequire("8UDz8")).getDashboardFeatureGates)(),
            centralised: true
        });
    const $f42b084586d299a2$export$f409d0aa399347ac = (isInitialRender, lastTransitionStartTime, navigationStart)=>{
        const sessionStart = navigationStart != null ? new Date(navigationStart).getTime() : 0;
        return !isInitialRender && lastTransitionStartTime != null ? lastTransitionStartTime : sessionStart;
    };
    const $f42b084586d299a2$var$isInvalidContextState = (metricsContextTimeStamp, currentNavStart, currentPageId)=>{
        if (metricsContextTimeStamp.currentPageId !== currentPageId) return true;
        if (metricsContextTimeStamp.created < metricsContextTimeStamp.navStart) return true;
        const now = Date.now();
        if (now < metricsContextTimeStamp.navStart) return true;
        if (now < Number(currentNavStart)) return true;
        return false;
    };
    const $f42b084586d299a2$export$ea517a7cfce02895 = (dashboardId)=>{
        const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId = 'unknown' }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const [{ aboveTheFoldGadgets: aboveTheFoldGadgets }] = (0, (0, parcelRequire("8UPoO")).useRenderAboveTheFold)();
        const [routerState] = (0, $dIdda.useRouter)();
        const navStart = $f42b084586d299a2$export$f409d0aa399347ac(isInitialRender, lastTransitionStartTime, navigationStart);
        const dashboardData = (0, (0, parcelRequire("gh1hi")).useDashboardResource)().data;
        const { scrollStartTimestamp: scrollStartTimestamp, resetScrollStartTime: resetScrollStartTime } = (0, (0, parcelRequire("hmyfM")).useDashboardScrollAnalytics)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const newContext = {
            dashboardId: dashboardId,
            isInitialRender: isInitialRender,
            isRouteReplaced: routerState.action === 'REPLACE',
            lastTransitionStartTime: lastTransitionStartTime,
            navigationStart: navigationStart,
            currentPageId: currentPageId,
            navStart: navStart,
            gadgets: dashboardData?.gadgets,
            isWritable: dashboardData?.writable ?? false,
            scrollStartTimestamp: scrollStartTimestamp,
            aboveTheFoldGadgets: aboveTheFoldGadgets,
            resetScrollStartTime: resetScrollStartTime
        };
        const context = (0, $5uXOq.useRef)(newContext);
        context.current = newContext;
        const sendGadgetMetrics = (0, $5uXOq.useCallback)((gadgetId, gadgetEventRecord)=>{
            if (context.current.navigationStart == null) return;
            const gadgetModel = context.current.gadgets?.find((item)=>item.id === gadgetId) || null;
            const customMarks = {
                ...$f42b084586d299a2$var$getInitialMarks(context.current),
                timeout: gadgetEventRecord.timedOut === true,
                gadgetContentType: gadgetEventRecord.contentType,
                isAboveTheFold: context.current.aboveTheFoldGadgets.has(gadgetId)
            };
            if (gadgetEventRecord.timedOut === true) {
                if ($f42b084586d299a2$var$isIdle(gadgetEventRecord)) customMarks.timeout_idle = true;
                else $f42b084586d299a2$export$835bb833cb903f59(gadgetEventRecord.source, gadgetEventRecord.contentType).filter((event)=>!$f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.has(event)).filter((event)=>!gadgetEventRecord.events.has(event)).forEach((event)=>{
                    customMarks[`timeout_${event}`] = true;
                });
            }
            if (gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).WRM_GADGET_METRICS) || gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).FORGE_GADGET_METRICS) || gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).REACT_GADGET_METRICS)) {
                customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || gadgetModel?.reactKey || (0, (0, parcelRequire("5TsWX")).UNKNOWN_GADGET_TYPE);
                const renderContainer = gadgetEventRecord.events.get((0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT));
                const start = gadgetEventRecord.events.get((0, (0, parcelRequire("5TsWX")).GADGET_START_EVENT));
                if (renderContainer != null) customMarks.gadgetRenderContainer = renderContainer.spaTime - Number(context.current.navStart);
                if (start != null) {
                    customMarks.gadgetStartTime = start.spaTime - Number(context.current.navStart);
                    customMarks.gadgetDuration = Date.now() - start.spaTime;
                }
            } else if (gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).IDLE_GADGET_SOURCE) || gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).FALLBACK_GADGET_SOURCE)) customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || (0, (0, parcelRequire("5TsWX")).UNKNOWN_GADGET_TYPE);
            $f42b084586d299a2$export$b1f29dd0b70f467b(gadgetEventRecord.events).forEach((gadgetMark)=>{
                if (gadgetMark.start != null) customMarks[`${gadgetMark.name}-start`] = gadgetMark.start - Number(context.current.navStart);
                if (gadgetMark.start != null && gadgetMark.end != null) customMarks[`${gadgetMark.name}-duration`] = gadgetMark.end - gadgetMark.start;
            });
            const gadgetLoadIdentifier = `gadget-${context.current.dashboardId ?? 'no-dashboard-id'}-${gadgetId}`;
            (0, (0, parcelRequire("trHKK")).gadgetLoad)(gadgetLoadIdentifier).start({
                startTime: context.current.navStart
            });
            (0, (0, parcelRequire("trHKK")).gadgetLoad)(gadgetLoadIdentifier).stop({
                customData: customMarks,
                stopTime: Date.now()
            });
            if (gadgetEventRecord.source === (0, (0, parcelRequire("5TsWX")).WRM_GADGET_METRICS) && gadgetEventRecord.contentType !== 'View' && gadgetEventRecord.contentType !== 'Config') (0, (0, parcelRequire("hh0bW")).default)({
                ...$f42b084586d299a2$var$expAttributes,
                experience: (0, (0, parcelRequire("JIPqS")).VIEW_WRM_GADGET_EXPERIENCE),
                wasExperienceSuccesful: false
            });
        }, []);
        const sendOverallGadgetMetrics = (0, $5uXOq.useCallback)((gadgetIds, gadgetMetricsEvents, timeout)=>{
            const metricToReport = {
                timeout: timeout,
                fullDashboardTTI: Date.now() - Number(context.current.navStart),
                dashboardScrollStartTime: context.current.scrollStartTimestamp.current != null ? context.current.scrollStartTimestamp.current - Number(context.current.navStart) : 'unknown',
                belowTheFoldTTI: Date.now() - (context.current.scrollStartTimestamp.current != null && (context.current.gadgets?.length || 0) - context.current.aboveTheFoldGadgets.size > 0 ? context.current.scrollStartTimestamp.current : Date.now())
            };
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'fullDashboard loaded', metricToReport);
        }, [
            createAnalyticsEvent
        ]);
        const onAboveTheFoldGadgetsRender = (0, $5uXOq.useCallback)((gadgetIds, gadgetMetricsEvents, gadgetRenderStartTime, contextTimeStamps, timeout)=>{
            const totalGadgetsCount = context.current.gadgets?.length || 0;
            const connectGadgetCount = context.current.gadgets?.filter((item)=>(0, (0, parcelRequire("5TsWX")).CONNECT_MODULE_PATTERN).test(item.amdModule || '')).length || 0;
            const forgeGadgetCount = context.current.gadgets?.filter((item)=>(0, (0, parcelRequire("5TsWX")).FORGE_MODULE_PATTERN).test(item.forge?.key || '')).length || 0;
            const internalGadgetCount = totalGadgetsCount - connectGadgetCount - forgeGadgetCount;
            const untrackedGadgetCount = context.current.gadgets?.filter((item)=>gadgetIds.every((id)=>id !== item.id)).length || 0;
            const deprecatedGadgetsCount = context.current.gadgets ? context.current.gadgets.filter((gadget)=>(0, (0, parcelRequire("hGdg6")).isDeprecatedGadget)(gadget.amdModule)).length : 0;
            const initialMarks = $f42b084586d299a2$var$getInitialMarks(context.current);
            const gadgetRenderStart = gadgetRenderStartTime - Number(context.current.navStart);
            const invalidContextState = $f42b084586d299a2$var$isInvalidContextState(contextTimeStamps, context.current.navStart, context.current.currentPageId) || initialMarks.TTI < 0 || gadgetRenderStart < 0;
            if (invalidContextState) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics context state is invalid for dashboard [${context.current.currentPageId ?? 'null'}]: { contextTimestamps: ${JSON?.stringify(contextTimeStamps)}, now:${Date.now()}, pnow:${performance?.now()}, navStart:${context.current.navStart} }`);
            const customData = {
                ...initialMarks,
                gadgetRenderStart: gadgetRenderStart,
                gadgetCount_Total: totalGadgetsCount,
                gadgetCount_Internal: internalGadgetCount,
                gadgetCount_Connect: connectGadgetCount,
                gadgetCount_Forge: forgeGadgetCount,
                gadgetCount_Unknown: untrackedGadgetCount - connectGadgetCount,
                timeout: timeout,
                gadgetCount_AboveTheFold: context.current.aboveTheFoldGadgets.size,
                gadgetCount_Deprecated: deprecatedGadgetsCount,
                isStaled: invalidContextState
            };
            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(customData);
            (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)((0, (0, parcelRequire("trHKK")).dashboardLoad));
            (0, (0, parcelRequire("bFU4G")).addApdexToAll)({
                key: (0, (0, parcelRequire("trHKK")).dashboardLoad).key,
                stopTime: performance.now()
            });
            if ((0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences')) (0, (0, parcelRequire("iAWa3")).afterPaintEmit)((stopTime)=>{
                (0, (0, parcelRequire("trHKK")).dashboardLoad).stop({
                    stopTime: stopTime,
                    customData: customData
                });
            }, (0, (0, parcelRequire("trHKK")).dashboardLoad));
            else (0, (0, parcelRequire("trHKK")).dashboardLoad).stop({
                customData: customData
            });
        }, []);
        const resetScrollStartMetrics = (0, $5uXOq.useCallback)(()=>{
            context.current.resetScrollStartTime();
        }, []);
        const sendDebuggingAnalytics = (0, $5uXOq.useCallback)((contextTimeStamps)=>{
            const attributes = {
                isStale: $f42b084586d299a2$var$isInvalidContextState(contextTimeStamps, context.current.navStart, context.current.currentPageId),
                tti: Date.now() - Number(context.current.navStart),
                currentPageId: context.current.currentPageId
            };
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'tti sent', attributes);
        }, [
            createAnalyticsEvent
        ]);
        return {
            sendGadgetMetrics: sendGadgetMetrics,
            sendOverallGadgetMetrics: sendOverallGadgetMetrics,
            onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender,
            resetScrollStartMetrics: resetScrollStartMetrics,
            sendDebuggingAnalytics: sendDebuggingAnalytics
        };
    };
});
parcelRegister("iAWa3", function(module, exports) {
    $parcel$export(module.exports, "afterPaintEmit", ()=>$8ad29d98765af503$export$dc4c3408669b8f4e);
    var $x9xyg;
    const $8ad29d98765af503$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
        const stopTime = performance.now();
        setTimeout(()=>{
            metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
            setTimeout(()=>{
                emitMetrics(stopTime);
            }, 500);
        });
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("7cLxq", function(module, exports) {
    $parcel$export(module.exports, "getDashboardFeatureFlags", ()=>$9b049cc4dacaaa3a$export$5f260d38da0c0462);
    var $8QpSo;
    var $y7eb2;
    const $9b049cc4dacaaa3a$var$DASHBOARD_ADDITIONAL_FLAGS = [];
    const $9b049cc4dacaaa3a$var$DASHBOARD_FEATURE_FLAG_SCHEMA = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
    const $9b049cc4dacaaa3a$export$5f260d38da0c0462 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        try {
            const allFFs = (0, (0, parcelRequire("y7eb2")).default)() || {};
            return Object.fromEntries(Object.keys(allFFs).filter((key)=>$9b049cc4dacaaa3a$var$DASHBOARD_FEATURE_FLAG_SCHEMA.test(key) || $9b049cc4dacaaa3a$var$DASHBOARD_ADDITIONAL_FLAGS.includes(key)).sort((a, b)=>a.localeCompare(b, undefined, {
                    ignorePunctuation: true
                })).map((key)=>[
                    key,
                    allFFs[key].value
                ]));
        } catch (e) {
            return null;
        }
    });
});
parcelRegister("8UDz8", function(module, exports) {
    $parcel$export(module.exports, "getDashboardFeatureGates", ()=>$0c1208fe9722c23a$export$7cf9f66e85966b7);
    var $8QpSo;
    var $4R6GH;
    const $0c1208fe9722c23a$export$7cf9f66e85966b7 = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            endeavour_nin_assigned_to_me_gadget: (0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_assigned_to_me_gadget'),
            endeavour_nin_issues_in_progress_gadget: (0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_issues_in_progress_gadget'),
            endeavour_nin_filter_results_gadget: (0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget'),
            endeavour_nin_watched_issues_gadget: (0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_watched_issues_gadget'),
            endeavour_nin_voted_issues_gadget: (0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_voted_issues_gadget'),
            endeavour_gadget_deprecation_banner_v1: (0, (0, parcelRequire("4R6GH")).fg)('endeavour_gadget_deprecation_banner_v1')
        }));
});
parcelRegister("trHKK", function(module, exports) {
    $parcel$export(module.exports, "gadgetLoad", ()=>$b46e477904ae8756$export$4de73f6aec94634c);
    $parcel$export(module.exports, "dashboardLoad", ()=>$b46e477904ae8756$export$2b2c4cbb9844d8cb);
    var $dGrdR;
    const $b46e477904ae8756$export$4de73f6aec94634c = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: 'dashboard.gadget',
        featureFlags: []
    });
    const $b46e477904ae8756$export$2b2c4cbb9844d8cb = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'dashboard',
        featureFlags: []
    });
});
parcelRegister("hmyfM", function(module, exports) {
    $parcel$export(module.exports, "useDashboardScrollAnalytics", ()=>$03a594e6b9b8c3c6$export$83af525d5e7538fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $8zOmE;
    var $2NMNM;
    var $eNjJm;
    var $bVDE5;
    const $03a594e6b9b8c3c6$export$83af525d5e7538fa = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const currentPage = (0, (0, parcelRequire("eNjJm")).useCurrentPage)();
        const [{ isInitialRender: isInitialRender, currentPageId: currentPageId }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const { startTime: startTime } = currentPage;
        const scrollStartTimestamp = (0, $5uXOq.useRef)(null);
        const debounceSendAnalytics = (0, ($parcel$interopDefault($lFKmC)))((_scrollStartTimestamp)=>{
            if (scrollStartTimestamp.current != null) return;
            const percentageOfPageScrolled = window.scrollY / window.innerHeight;
            if (percentageOfPageScrolled < 0.2) return;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'scrolled',
                actionSubject: 'page'
            }), 'dashboardScroll', {
                isInitialRender: isInitialRender,
                scrollStartTimeFromPageLoad: _scrollStartTimestamp - startTime,
                percentageOfPageScrolled: percentageOfPageScrolled,
                currentPageId: currentPageId
            });
            scrollStartTimestamp.current = _scrollStartTimestamp;
        }, 500);
        (0, $5uXOq.useEffect)(()=>{
            const fireScrollAnalytics = ()=>{
                debounceSendAnalytics(Date.now());
            };
            const resetScrollPosition = ()=>{
                window.scrollTo(0, 0);
            };
            window.addEventListener('scroll', fireScrollAnalytics);
            window.addEventListener('unload', resetScrollPosition);
            return ()=>{
                window.removeEventListener('scroll', fireScrollAnalytics);
                window.removeEventListener('unload', resetScrollPosition);
            };
        }, [
            debounceSendAnalytics
        ]);
        const resetScrollStartTime = (0, $5uXOq.useCallback)(()=>{
            scrollStartTimestamp.current = null;
        }, []);
        return {
            scrollStartTimestamp: scrollStartTimestamp,
            resetScrollStartTime: resetScrollStartTime
        };
    };
});
parcelRegister("eNjJm", function(module, exports) {
    $parcel$export(module.exports, "useCurrentPage", ()=>$a69ad6f74a66de9c$export$6faff8ed5e305ed3);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $a69ad6f74a66de9c$var$useSweetStateCurrentPage = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: (state)=>state.currentPage
    });
    const $a69ad6f74a66de9c$export$6faff8ed5e305ed3 = ()=>{
        const [currentPage] = $a69ad6f74a66de9c$var$useSweetStateCurrentPage();
        return currentPage;
    };
});
parcelRegister("gW6vr", function(module, exports) {
    $parcel$export(module.exports, "GADGETS_TO_REPORT", ()=>$a70b755fbe2a81b5$export$2c28b0760818db72);
    $parcel$export(module.exports, "GADGETS_IGNORED", ()=>$a70b755fbe2a81b5$export$c1d730ac3dcf5785);
    const $a70b755fbe2a81b5$export$2c28b0760818db72 = new Set([
        'jira-dashboard-items/assigned-to-me',
        'jira-dashboard-items/bubble-chart-dashboard-item',
        'jira-dashboard-items/createdvsresolved',
        'jira-dashboard-items/favourite-filters',
        'jira-dashboard-items/filter-results',
        'jira-dashboard-items/in-progress',
        'jira-dashboard-items/labels',
        'jira-dashboard-items/piechart',
        'jira-dashboard-items/stats',
        'jira-dashboard-items/two-dimensional-stats',
        'jira-dashboard-items/voted',
        'jira-dashboard-items/watched',
        'jira-dashboard-items/issuescalendar',
        'jira-dashboard-items/projects',
        'jira-dashboard-items/activitystream',
        'jira-dashboard-items/recently-created',
        'jira-dashboard-items/workload-pie-chart',
        'jira-dashboard-items/roadmap',
        'jira-dashboard-items/average-age-chart',
        'jira-dashboard-items/average-time-in-status-chart',
        'jira-dashboard-items/average-number-of-times-in-status-chart',
        'jira-dashboard-items/heat-map',
        'jira-dashboard-items/time-to-first-response',
        'jira-dashboard-items/sprint-burndown',
        'jira-dashboard-items/resolution-time',
        'jira-dashboard-items/timesince',
        'jira-dashboard-items/spacer',
        'jira-dashboard-items/rapid-view',
        'jira-dashboard-items/version-report',
        'rest/gadgets/1.0/g/com.atlassian.bonfire.plugin:bonfire-test-sessions-gadget/gadget/bonfire-sessions-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.ext.calendar:issuescalendar-gadget/templates/plugins/jira/portlets/calendar/gadget/calendar-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:firstresponse-gadget/com/atlassian/jira/ext/charting/gadget/firstresponse-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:numberoftimesinstatus-gadget/com/atlassian/jira/ext/charting/gadget/numberoftimesinstatus-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:timeinstatus-gadget/com/atlassian/jira/ext/charting/gadget/timeinstatus-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:workloadpie-gadget/com/atlassian/jira/ext/charting/gadget/workloadpie-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:average-age-chart-gadget/gadgets/average-age-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:recently-created-chart-gadget/gadgets/recently-created-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:resolution-time-gadget/gadgets/resolution-time-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:time-since-chart-gadget/gadgets/timesince-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:crucible-charting-gadget/gadgets/crucible-charting-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-charting-gadget/gadgets/fisheye-charting-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-recent-commits-gadget/gadgets/fisheye-recent-commits-gadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.jirawallboard.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml',
        'rest/gadgets/1.0/g/com.atlassian.streams.streams-jira-plugin:activitystream-gadget/gadgets/activitystream-gadget.xml',
        'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-rapid-view/gadgets/greenhopper-rapid-view.xml',
        'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-burndown/gadgets/greenhopper-sprint-burndown.xml',
        'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-version-report/gadgets/greenhopper-version-report.xml'
    ]);
    const $a70b755fbe2a81b5$export$c1d730ac3dcf5785 = new Set([
        'jira-dashboard-items/sprint-days-remaining',
        'jira-dashboard-items/sprint-health',
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item',
        'servicedesk/internal/dashboard-items/filter/filter-dashboard-item'
    ]);
});
parcelRegister("h5Jym", function(module, exports) {
    $parcel$export(module.exports, "useSpaStatePageReady", ()=>$80ca19e1fa573e80$export$ea2491906b753456);
    var $5uXOq = parcelRequire("5uXOq");
    var $x9xyg;
    var $JIPqS;
    var $gh1hi;
    var $4oDnX;
    var $i0rkS;
    const $80ca19e1fa573e80$var$isAmdGadget = (gadget)=>gadget.amdModule != null && gadget.amdModule !== (0, (0, parcelRequire("JIPqS")).CONNECT_ITEM_AMD_MODULE);
    const $80ca19e1fa573e80$var$isWaitableGadget = (gadget)=>$80ca19e1fa573e80$var$isAmdGadget(gadget);
    const $80ca19e1fa573e80$var$getWaitableGadgetSet = (gadgets)=>new Set(gadgets.filter($80ca19e1fa573e80$var$isWaitableGadget).map(({ id: id })=>id));
    const $80ca19e1fa573e80$export$ea2491906b753456 = ()=>{
        const { data: data, loading: loading } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const [, { registerListener: registerListener, unregisterListener: unregisterListener }] = (0, (0, parcelRequire("i0rkS")).useMessageBus)();
        const lastDashboardId = (0, $5uXOq.useRef)();
        const pendingGadgetSet = (0, $5uXOq.useRef)(new Set());
        const [, { setAppReady: setAppReady }] = (0, (0, parcelRequire("4oDnX")).useSpaStateActions)();
        const callback = (0, $5uXOq.useCallback)((type, _, { gadgetId: gadgetId })=>{
            if (type !== (0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).REPORT) return;
            if (!pendingGadgetSet.current.has(gadgetId)) return;
            pendingGadgetSet.current.delete(gadgetId);
            if (pendingGadgetSet.current.size > 0) return;
            unregisterListener(callback);
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("JIPqS")).PAGE_READY_METRIC_KEY));
            setAppReady();
        }, [
            setAppReady,
            unregisterListener
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (loading || data == null || data.id === lastDashboardId.current) return ()=>{};
            lastDashboardId.current = data.id;
            pendingGadgetSet.current = $80ca19e1fa573e80$var$getWaitableGadgetSet(data.gadgets);
            if (pendingGadgetSet.current.size === 0) {
                (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("JIPqS")).PAGE_READY_METRIC_KEY));
                setAppReady();
                return ()=>{};
            }
            registerListener(callback);
            return ()=>{
                unregisterListener(callback);
            };
        }, [
            callback,
            data,
            loading,
            registerListener,
            setAppReady,
            unregisterListener
        ]);
    };
});
parcelRegister("5jJ3W", function(module, exports) {
    $parcel$export(module.exports, "addDashboardToRecents", ()=>$f6e4dfdb0385e67e$export$9f034829a82f8a11);
    const $f6e4dfdb0385e67e$export$9f034829a82f8a11 = (dashboardId)=>fetch(`/rest/internal/latest/dashboards/history/${dashboardId}`, {
            method: 'POST'
        });
});
parcelRegister("1Bx5m", function(module, exports) {
    $parcel$export(module.exports, "AboveTheFoldContainer", ()=>$c6a764536e1ff0c0$export$60c1d52f3e30a1cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $8UPoO;
    var $1oaeD;
    var $6fab6;
    const $c6a764536e1ff0c0$export$60c1d52f3e30a1cd = ({ gadgets: gadgets, dashboardId: dashboardId, layout: layout, children: children })=>{
        const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, (0, parcelRequire("1oaeD")).useMaximizedGadget)(gadgets);
        const columns = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6fab6")).toColumns)(gadgets, layout), [
            gadgets,
            layout
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UPoO")).RenderAboveTheFoldContainer), {
            columns: columns,
            dashboardId: dashboardId,
            scope: dashboardId,
            maximizedGadgetId: getMaximisedGadgetId
        }, children);
    };
});
parcelRegister("7v0Ei", function(module, exports) {
    $parcel$export(module.exports, "AmdGadgetMonolithOverrideStyles", ()=>$c5037e48649c048f$export$17921465e6f60e58);
    var $5uXOq = parcelRequire("5uXOq");
    const $c5037e48649c048f$var$styles = `.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #5e6c84)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #0049b0)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #ebecf0)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #172b4d)"};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #5e6c84)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0049b0)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: 400;
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
    const $c5037e48649c048f$export$17921465e6f60e58 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", null, $c5037e48649c048f$var$styles);
});
parcelRegister("fxC6K", function(module, exports) {
    $parcel$export(module.exports, "DASHBOARD_PERMISSION_ERROR_CODE_LIST", ()=>$525e26e500bd2620$export$f33202be19a062b9);
    const $525e26e500bd2620$export$f33202be19a062b9 = [
        401,
        403,
        404
    ];
});
parcelRegister("kUwqK", function(module, exports) {
    $parcel$export(module.exports, "usePageStatusLogger", ()=>$994ab79b91cbaa2e$export$8b3b053e4f10e669);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $bVDE5;
    var $bOnpg;
    var $7cLxq;
    const $994ab79b91cbaa2e$var$TEN_MIN = 600000;
    const $994ab79b91cbaa2e$var$sanitiseKeys = (featureFlags)=>Object.fromEntries(Object.entries(featureFlags || {}).map(([key, value])=>[
                key.replace(/\./g, '_'),
                value
            ]));
    const $994ab79b91cbaa2e$export$8b3b053e4f10e669 = (interval)=>{
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const [{ isInitialRender: isInitialRender, currentPageId: currentPageId, lastTransition: lastTransition }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        (0, $5uXOq.useEffect)(()=>{
            const logFeatureFlags = ()=>{
                const featureFlags = JSON.stringify($994ab79b91cbaa2e$var$sanitiseKeys((0, (0, parcelRequire("7cLxq")).getDashboardFeatureFlags)()));
                const attributes = {
                    isInitialRender: isInitialRender,
                    lastTransition: lastTransition,
                    currentPageId: currentPageId,
                    featureFlags: featureFlags
                };
                (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.page-status', Object.entries(attributes).map(([k, v])=>`${k} [${String(v ?? null)}]`).join(' '));
                fireAnalytics({
                    eventType: (0, $4d5e0871c06cee03$export$12346a674644c156),
                    actionSubject: 'dashboard.page-status',
                    actionSubjectId: 'featureFlags',
                    action: 'logged',
                    attributes: attributes
                });
            };
            logFeatureFlags();
            const logInterval = setInterval(logFeatureFlags, Math.max($994ab79b91cbaa2e$var$TEN_MIN, interval) || $994ab79b91cbaa2e$var$TEN_MIN);
            return ()=>clearInterval(logInterval);
        }, [
            interval,
            fireAnalytics,
            isInitialRender,
            currentPageId,
            lastTransition
        ]);
    };
});
parcelRegister("hwuTz", function(module, exports) {
    $parcel$export(module.exports, "RouteResourceValidator", ()=>$79eff52e66ba4eb8$export$1d8835c03b47dfbd);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $gh1hi;
    var $bVDE5;
    const $79eff52e66ba4eb8$export$1d8835c03b47dfbd = ()=>{
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const { promise: promise, loading: loading, data: data, error: error } = (0, (0, parcelRequire("gh1hi")).useDashboardAMDModulesResource)();
        const [hasRendered, setHasRendered] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!loading) setHasRendered(true);
        }, [
            loading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (false) return;
            const prefix = `Resource validation [${isInitialRender ? 'initial' : 'transition'}][${hasRendered ? 'rerender' : 'original'}]`;
            if (!promise) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource may be missing`);
            else if (loading) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} loading`);
            else if (data) {
                const { amdModules: amdModules, sharedValue: sharedValue } = data;
                if (sharedValue == null || sharedValue instanceof Error) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource shared value [${String(sharedValue)}]`);
                else if (!sharedValue?.isPreloaded && isInitialRender && !hasRendered) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, config+wrm resource did not run in SSR`);
                else if (amdModules === null) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, WRM resources failed to load`);
                else {
                    const [failedCount, totalCount] = Object.values(amdModules).reduce(([f], v, i, arr)=>[
                            f + (v == null ? 1 : 0),
                            arr.length
                        ], [
                        0,
                        0
                    ]);
                    if (failedCount > 0) {
                        const failedNames = Object.entries(amdModules).filter(([, v])=>v == null).map(([k])=>k).join(',');
                        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD evaluation failed [${failedCount}] of [${totalCount}], failed modules [${failedNames}]`);
                    } else (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} success`);
                }
            } else if (error) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed with AMD resource error [${error instanceof Error ? error.message : String(error)}]`, error);
        }, [
            promise,
            loading,
            data,
            error
        ]);
        return null;
    };
});
parcelRegister("h7J1E", function(module, exports) {
    $parcel$export(module.exports, "useGadgetTitle", ()=>$9f983f20098b68ef$export$dba832fc7432cba1);
    $parcel$export(module.exports, "useConnectGadgetTitles", ()=>$9f983f20098b68ef$export$66e677fcbdac9c95);
    var $5uXOq = parcelRequire("5uXOq");
    function $9f983f20098b68ef$export$dba832fc7432cba1({ defaultTitle: initialDefaultTitle, title: title, onSave: onSave }) {
        const [defaultTitle, setDefaultTitle] = (0, $5uXOq.useState)(initialDefaultTitle);
        const [userTitle, setUserTitle] = (0, $5uXOq.useState)(title);
        const setTitle = (0, $5uXOq.useCallback)(async (newTitle)=>{
            const previousTitle = userTitle;
            setUserTitle(newTitle);
            onSave?.(newTitle).catch(()=>{
                setUserTitle(previousTitle);
            });
        }, [
            userTitle,
            onSave
        ]);
        const setDefaultTitleWithInitialTitle = (0, $5uXOq.useCallback)((defaultTitleUpdaterOrValue)=>{
            setDefaultTitle(typeof defaultTitleUpdaterOrValue === 'function' ? defaultTitleUpdaterOrValue(initialDefaultTitle) : defaultTitleUpdaterOrValue);
        }, [
            initialDefaultTitle
        ]);
        return {
            title: userTitle || defaultTitle,
            setDefaultTitle: setDefaultTitleWithInitialTitle,
            setTitle: setTitle
        };
    }
    const $9f983f20098b68ef$export$66e677fcbdac9c95 = ()=>{
        const [connectGadgets, setConnectGadgets] = (0, $5uXOq.useState)({});
        const registerConnectGadget = (0, $5uXOq.useCallback)((id, setTitle)=>{
            setConnectGadgets((gadgets)=>({
                    ...gadgets,
                    [id]: setTitle
                }));
        }, []);
        const unregisterConnectGadget = (0, $5uXOq.useCallback)((id)=>{
            setConnectGadgets((gadgets)=>{
                const { [id]: _, ...rest } = gadgets;
                return rest;
            });
        }, []);
        const setCustomTitle = (0, $5uXOq.useCallback)((id, title)=>{
            const setTitle = connectGadgets[id];
            if (!setTitle) throw new Error(`Unable to set custom title on Connect gadget. No gadget with id ${id} found. Available ids: ${Object.keys(connectGadgets).join(', ')}`);
            return setTitle(title);
        }, [
            connectGadgets
        ]);
        return {
            registerConnectGadget: registerConnectGadget,
            setCustomTitle: setCustomTitle,
            unregisterConnectGadget: unregisterConnectGadget
        };
    };
});
parcelRegister("dWAHS", function(module, exports) {
    $parcel$export(module.exports, "RightPanelLayoutContainer", ()=>$dd693cdfa657686b$export$b0b99b1b479c37c2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $bgrar;
    var $8CUq3;
    var $44v1T;
    var $gwIPs;
    var $GQeXq;
    const $dd693cdfa657686b$var$RIGHT_PANEL_WIDTH = (0, (0, parcelRequire("gwIPs")).gridSize) * 46;
    const $dd693cdfa657686b$export$b0b99b1b479c37c2 = ({ isOpenByDefault: isOpenByDefault = false, defaultPanelId: defaultPanelId, rightContent: rightContent, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("GQeXq")).RightPanelContainer), {
            isOpenByDefault: isOpenByDefault,
            defaultPanelId: defaultPanelId,
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dd693cdfa657686b$var$Panels, {
            rightContent: rightContent
        }, children));
    const $dd693cdfa657686b$var$Panels = ({ rightContent: rightContent, children: children })=>{
        const { isOpen: isRightPanelOpen } = (0, (0, parcelRequire("GQeXq")).useRightPanelState)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bgrar")).default), {
            templateColumns: isRightPanelOpen ? `1fr ${$dd693cdfa657686b$var$RIGHT_PANEL_WIDTH}px` : '1fr 0',
            gap: isRightPanelOpen ? 'space.500' : 'space.0',
            xcss: $dd693cdfa657686b$var$gridStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $dd693cdfa657686b$var$leftPanelStyles
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "aside",
            xcss: $dd693cdfa657686b$var$rightPanelStyles
        }, rightContent));
    };
    const $dd693cdfa657686b$var$rightPanelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        top: `calc(${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)})`,
        alignSelf: 'start',
        marginRight: 'space.negative.400'
    });
    const $dd693cdfa657686b$var$leftPanelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '0'
    });
    const $dd693cdfa657686b$var$gridStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        transition: 'grid-template-columns 300ms cubic-bezier(0.2, 0, 0, 1) 0s'
    });
});
parcelRegister("GQeXq", function(module, exports) {
    $parcel$export(module.exports, "useRightPanelToggle", ()=>$3a63146a91b26595$export$898b0b9e6647aa1a);
    $parcel$export(module.exports, "useRightPanelState", ()=>$3a63146a91b26595$export$44f374c6fe8a17ef);
    $parcel$export(module.exports, "RightPanelContainer", ()=>$3a63146a91b26595$export$e37cfb5282d612c2);
    var $7JoAD = parcelRequire("7JoAD");
    const $3a63146a91b26595$var$initialState = {
        isOpen: false,
        focusKey: 0,
        panelId: null,
        isTriggerFocused: false
    };
    const $3a63146a91b26595$var$openPanel = (panelId)=>({ setState: setState, getState: getState })=>{
            if (getState().isOpen === false) setState({
                isOpen: true,
                focusKey: getState().focusKey + 1,
                panelId: panelId,
                isTriggerFocused: false
            });
            else setState({
                focusKey: getState().focusKey + 1
            });
        };
    const $3a63146a91b26595$var$closePanel = ()=>({ setState: setState, getState: getState })=>{
            if (getState().isOpen === true) setState({
                ...$3a63146a91b26595$var$initialState,
                isTriggerFocused: true
            });
        };
    const $3a63146a91b26595$var$focusTrigger = (focusTriggerCallback)=>({ setState: setState, getState: getState })=>{
            if (getState().isTriggerFocused) focusTriggerCallback();
            setState({
                isTriggerFocused: false
            });
        };
    const $3a63146a91b26595$var$focusPanel = (focusPanelCallback)=>({ getState: getState })=>{
            if (getState().focusKey > 0) focusPanelCallback();
        };
    const $3a63146a91b26595$var$Store = (0, $7JoAD.createStore)({
        initialState: $3a63146a91b26595$var$initialState,
        actions: {
            openPanel: $3a63146a91b26595$var$openPanel,
            closePanel: $3a63146a91b26595$var$closePanel,
            focusTrigger: $3a63146a91b26595$var$focusTrigger,
            focusPanel: $3a63146a91b26595$var$focusPanel
        },
        name: 'right-side-panel'
    });
    const $3a63146a91b26595$var$useRightPanel = (0, $7JoAD.createHook)($3a63146a91b26595$var$Store);
    const $3a63146a91b26595$var$useRightPanelActions = (0, $7JoAD.createHook)($3a63146a91b26595$var$Store, {
        selector: null
    });
    const $3a63146a91b26595$export$898b0b9e6647aa1a = ()=>{
        const [, actions] = $3a63146a91b26595$var$useRightPanelActions();
        return {
            onCloseRightPanel: actions.closePanel,
            onOpenRightPanel: actions.openPanel,
            onFocusTrigger: actions.focusTrigger,
            onFocusPanel: actions.focusPanel
        };
    };
    const $3a63146a91b26595$export$44f374c6fe8a17ef = ()=>$3a63146a91b26595$var$useRightPanel()[0];
    const $3a63146a91b26595$export$e37cfb5282d612c2 = (0, $7JoAD.createContainer)($3a63146a91b26595$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpenByDefault: isOpenByDefault, defaultPanelId: defaultPanelId })=>{
                if (isOpenByDefault === true && defaultPanelId != null) setState({
                    isOpen: true,
                    panelId: defaultPanelId
                });
            }
    });
});
parcelRegister("fkN9I", function(module, exports) {
    $parcel$export(module.exports, "useLayoutChange", ()=>$809cf51522b3607b$export$13f16b0ff83cf772);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $JIPqS;
    var $jcw0u;
    var $eusud;
    var $gh1hi;
    const $809cf51522b3607b$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).CHANGE_LAYOUT_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    const $809cf51522b3607b$export$755ca66aa40344da = (gadgets)=>[
            gadgets.filter((gadget)=>gadget.column === 0),
            gadgets.filter((gadget)=>gadget.column === 1),
            gadgets.filter((gadget)=>gadget.column === 2)
        ];
    const $809cf51522b3607b$export$3ef0a75b350ea007 = (currentColumns, currentLayout, newLayout)=>{
        if (currentLayout.length <= newLayout.length) return currentColumns;
        if (currentLayout.length > newLayout.length) {
            const newColumns = currentColumns.slice(0, newLayout.length);
            const leftOver = currentColumns.slice(newLayout.length).flat().map((gadget)=>({
                    ...gadget,
                    column: newColumns.length - 1
                }));
            newColumns[newColumns.length - 1] = newColumns[newColumns.length - 1].concat(leftOver);
            return newColumns;
        }
        return currentColumns;
    };
    const $809cf51522b3607b$export$13f16b0ff83cf772 = ()=>{
        const { data: data, update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        return (0, $5uXOq.useCallback)(async (layout, explicitColumns)=>{
            if (!data) return;
            const columns = explicitColumns ?? $809cf51522b3607b$export$3ef0a75b350ea007($809cf51522b3607b$export$755ca66aa40344da(data.gadgets), data.layout, layout);
            const payload = columns.map((column)=>column.map((gadget)=>gadget.id));
            const url = `${data.resourceUrl}/layout`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
                    body: JSON.stringify({
                        '0': payload[0],
                        '1': payload[1],
                        '2': payload[2],
                        layout: layout
                    })
                });
                update((currentData)=>currentData && {
                        ...currentData,
                        gadgets: columns.flat(),
                        layout: layout
                    });
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$809cf51522b3607b$var$expAttributes,
                    wasExperienceSuccesful: true
                });
            } catch (error) {
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$809cf51522b3607b$var$expAttributes,
                    wasExperienceSuccesful: false
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, (0, parcelRequire("JIPqS")).CHANGE_LAYOUT_EXPERIENCE),
                        packageName: 'jiraDashboardEdit'
                    }
                });
                throw error;
            }
        }, [
            data,
            update
        ]);
    };
});
parcelRegister("1WOL5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b8cddaae8b1bfa7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9b8cddaae8b1bfa7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pageTitleFallback: {
            "id": "dashboard-edit.page-title-fallback",
            "defaultMessage": "Edit dashboard"
        },
        pageTitle: {
            "id": "dashboard-edit.page-title",
            "defaultMessage": "Edit - {dashboardName}"
        },
        editingInfo: {
            "id": "dashboard-edit.editing-info",
            "defaultMessage": "You are currently editing your dashboard. Changes will be saved automatically."
        }
    });
});
parcelRegister("57x9W", function(module, exports) {
    $parcel$export(module.exports, "GadgetEditable", ()=>$6ea73e60c5d315b8$export$9ea8e07be9334eb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $JIPqS;
    var $eXVsp;
    var $hGdg6;
    var $c1XZn;
    var $8h45R;
    var $8FVKN;
    var $2XTsA;
    var $9TUxn;
    var $83NgX;
    var $chUx7;
    var $lwPtc;
    var $4ozF0;
    var $j3C3s;
    var $gFWXX;
    var $1yhBH;
    var $iIi7d;
    var $cmgca;
    var $jATTU;
    var $fJpBG;
    var $4R6GH;
    var $koVbs;
    var $gh1hi;
    var $hzLxu;
    var $lB5Qw;
    var $8VGwU;
    var $clqf8;
    var $hWMwQ;
    var $4zy27;
    var $g5A8z;
    var $jbkj1;
    var $49IUu;
    const $6ea73e60c5d315b8$export$c52d8ff08351976f = ({ data: { id: id, userPrefs: userPrefs, reactKey: reactKey, configurable: configurable, refreshable: isRefreshableByJira, connect: connect, forge: forge, ...data }, display: display, isConnectDisabled: isConnectDisabled, dashboardRefreshId: dashboardRefreshId, children: children })=>{
        const isRenamable = (0, (0, parcelRequire("8h45R")).useIsRenamable)(id);
        const saveTitleById = (0, (0, parcelRequire("clqf8")).useSaveCustomGadgetTitleById)(id);
        const showSaveTitleFlag = (0, (0, parcelRequire("49IUu")).useGadgetTitleChangeErrorFlag)();
        const localStorageService = (0, (0, parcelRequire("83NgX")).useLocalStorageService)(id);
        const { update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const userPreferencesService = (0, (0, parcelRequire("chUx7")).useUserPreferencesService)(id, update);
        const { reinitialise: onGadgetKeyChange, isEditable: isReactEditable, isLoading: isReactLoading } = (0, (0, parcelRequire("9TUxn")).useReactGadget)(id, reactKey);
        const automaticRefreshMs = (0, $5uXOq.useMemo)(()=>{
            const { refresh: refresh } = (0, (0, parcelRequire("fJpBG")).decodeUserPreferences)(userPrefs?.fields);
            return parseInt(refresh, 10) * 60000 || null;
        }, [
            userPrefs?.fields
        ]);
        const saveTitle = (0, $5uXOq.useCallback)((...args)=>saveTitleById(...args).catch((error)=>{
                showSaveTitleFlag();
                throw error;
            }), [
            saveTitleById,
            showSaveTitleFlag
        ]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const { isInEditMode: isInEditMode, ...editable } = (0, (0, parcelRequire("hzLxu")).useGadgetEditableController)({
            id: id,
            userPrefs: userPrefs,
            configurable: isReactEditable ?? configurable,
            reactKey: reactKey,
            isRenamable: isRenamable,
            isConnectDisabled: isConnectDisabled,
            saveTitle: saveTitle,
            userPreferencesAction: userPrefs?.action,
            userPreferencesService: userPreferencesService,
            ...data
        });
        const ignoreGlobalDashboardRefresh = !isRefreshableByJira;
        const { onRefresh: onRefresh, ...common } = (0, (0, parcelRequire("2XTsA")).useGadgetCommonController)({
            id: id,
            display: display,
            automaticRefreshMs: isInEditMode ? null : automaticRefreshMs,
            localStorageService: localStorageService,
            dashboardRefreshId: ignoreGlobalDashboardRefresh ? null : dashboardRefreshId,
            onGadgetKeyChange: onGadgetKeyChange
        });
        const ecosystemRefresh = (0, (0, parcelRequire("jATTU")).useEcosystemRefresh)({
            id: id,
            connect: connect,
            forge: forge
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FVKN")).GadgetControllerContextProvider), {
            value: {
                ...common,
                ...editable,
                isLoading: isReactLoading ?? isLoading,
                setIsLoading: reactKey ? ()=>undefined : setIsLoading,
                isInEditMode: isInEditMode,
                isRenamable: isRenamable,
                onRefresh: isRefreshableByJira ? onRefresh : ecosystemRefresh.onRefresh ?? onRefresh
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ecosystemRefresh.wrapperRef
        }, children));
    };
    const $6ea73e60c5d315b8$export$9ea8e07be9334eb3 = ({ dashboardId: dashboardId, data: data, display: display, isDraggable: isDraggable = false, isDragging: isDragging = false, isConnectDisabled: isConnectDisabled = false, dragHandleProps: dragHandleProps, refreshId: refreshId, onMaximizeOrRestore: onMaximizeOrRestore, onMount: onMount, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
        const { id: id, isMaximizable: isMaximizable, color: color, forge: forge, customisedTitle: customisedTitle, title: defaultTitle } = data;
        const saveColor = (0, (0, parcelRequire("hWMwQ")).useSaveGadgetColor)(id);
        const deleteGadget = (0, (0, parcelRequire("lB5Qw")).useDeleteGadget)(id, customisedTitle || defaultTitle);
        const duplicateGadget = (0, (0, parcelRequire("8VGwU")).useDuplicateGadget)(id);
        const gadgetHeaderRef = (0, $5uXOq.useRef)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isFirstPartyGadget = !(0, (0, parcelRequire("cmgca")).isConnectGadget)(data) && !forge;
        const isDeprecated = (0, (0, parcelRequire("hGdg6")).isDeprecatedGadget)(data.amdModule);
        (0, $5uXOq.useEffect)(()=>onMount?.(id, ()=>gadgetHeaderRef.current?.focus()), [
            onMount,
            id
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6ea73e60c5d315b8$export$c52d8ff08351976f, {
            data: data,
            display: display,
            isConnectDisabled: isConnectDisabled,
            dashboardRefreshId: refreshId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FVKN")).GadgetControllerContextConsumer), null, ({ isDisplayed: isDisplayed, isMaximized: isMaximized, isMinimized: isMinimized, onMinimizeOrRestore: onMinimizeOrRestore, shouldUseCache: shouldUseCache, isLoading: isLoading, setIsLoading: setIsLoading, lastRefreshed: lastRefreshed, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isEditButtonDisabled: isEditButtonDisabled, isInEditMode: isInEditMode, onEditModeTrigger: onEditModeTrigger, onEditModeCancel: onEditModeCancel, title: title, isRenamable: isRenamable, isRenaming: isRenaming, setDefaultTitle: setDefaultTitle, onRenameTrigger: onRenameTrigger, onRenameSave: onRenameSave, onRenameCancel: onRenameCancel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ozF0")).GadgetLayoutWithAnalytics), {
                gadgetData: data,
                isDisplayed: isDisplayed,
                isContentHidden: isMinimized,
                customWrapperStyles: [
                    isDraggable && isDragging && $6ea73e60c5d315b8$var$gadgetDraggingStyles
                ],
                customPlaceholder: isDragging && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), {
                    customHeight: `${(0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT)}px`,
                    isPulsing: false
                }),
                header: (0, ($parcel$interopDefault($5uXOq))).createElement("div", dragHandleProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                    alignItems: "center",
                    xcss: [
                        isDraggable && $6ea73e60c5d315b8$var$draggableHeaderStyles
                    ]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3C3s")).GadgetTitleWrapper), {
                    isRenaming: isRenaming,
                    id: `gadget-title-${id}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbkj1")).TitleEditor), {
                    isRenamable: isRenamable,
                    isRenaming: isRenaming,
                    title: title,
                    onEdit: onRenameTrigger,
                    editButtonLabel: formatMessage((0, (0, parcelRequire("g5A8z")).default).rename, {
                        gadgetName: title
                    }),
                    onConfirmEdit: onRenameSave,
                    onCancelEdit: onRenameCancel
                }, isDeprecated && (0, (0, parcelRequire("4R6GH")).fg)('endeavour_gadget_deprecation_banner_v1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $6ea73e60c5d315b8$var$titleStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFWXX")).TitleReadOnly), {
                    title: title,
                    titleUrl: undefined,
                    forgeEnvironment: forge?.environment,
                    forgeEnvironmentKey: forge?.environmentKey
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $6ea73e60c5d315b8$var$tooltipStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eXVsp")).DeprecationTooltip), null))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFWXX")).TitleReadOnly), {
                    title: title,
                    titleUrl: undefined,
                    forgeEnvironment: forge?.environment,
                    forgeEnvironmentKey: forge?.environmentKey
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1yhBH")).GadgetToolbar), {
                    gadgetId: id,
                    title: title,
                    onMinimizeOrRestore: onMinimizeOrRestore,
                    isMinimized: isMinimized,
                    isMaximizable: isMaximizable,
                    onMaximizeOrRestore: onMaximizeOrRestore,
                    isMaximized: isMaximized,
                    additionalToolbarItems: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4zy27")).ConfigDropdown), {
                        isEditable: isEditModeEnabled,
                        isEditDisabled: isLoading || isEditButtonDisabled,
                        gadgetId: id,
                        gadgetTitle: title,
                        gadgetColor: color,
                        onSaveColor: saveColor,
                        onEditModeClick: onEditModeTrigger,
                        onDeleteGadget: deleteGadget,
                        onDuplicateGadget: duplicateGadget
                    })
                }))),
                footer: isFirstPartyGadget && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIi7d")).LastRefreshed), {
                    lastRefreshed: lastRefreshed,
                    updateInterval: (0, (0, parcelRequire("JIPqS")).REFRESH_LABEL_UPDATE_INTERVAL)
                })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "dashboard-edit.ui.gadget-editable.gadget-editable"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lwPtc")).GadgetInner), {
                dashboardId: dashboardId,
                data: data,
                isUnconfigured: isUnconfigured,
                isEditModeEnabled: isEditModeEnabled,
                isLoading: isLoading,
                isInEditMode: isInEditMode,
                shouldUseCache: shouldUseCache,
                setIsLoading: setIsLoading,
                setDefaultTitle: setDefaultTitle,
                setTitle: onRenameSave,
                onEditModeCancel: onEditModeCancel,
                isMaximized: isMaximized,
                onRegisterConnectGadget: onRegisterConnectGadget,
                onUnregisterConnectGadget: onUnregisterConnectGadget
            })))));
    };
    const $6ea73e60c5d315b8$var$draggableHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'grab'
    });
    const $6ea73e60c5d315b8$var$gadgetDraggingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: `${(0, (0, parcelRequire("JIPqS")).GADGET_DRAG_CONTAINER_HEIGHT)}px !important`
    });
    const $6ea73e60c5d315b8$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'row'
    });
    const $6ea73e60c5d315b8$var$tooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.025'
    });
});
parcelRegister("eXVsp", function(module, exports) {
    $parcel$export(module.exports, "DeprecationTooltip", ()=>$a9bfc6bd944fc87c$export$3afd8bd60d8bcdb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yUsV;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $cM8Sm;
    const $a9bfc6bd944fc87c$export$3afd8bd60d8bcdb8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a9bfc6bd944fc87c$var$tooltipStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6yUsV")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("cM8Sm")).default).gadgetDeprecationTooltip, {
            Link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
                    href: "https://community.atlassian.com/t5/Jira-articles/Update-We-re-ending-support-for-five-dashboard-gadgets-in-May/ba-p/2844556"
                }, chunks),
            br: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null))
        })));
    };
    const $a9bfc6bd944fc87c$var$tooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.050'
    });
});
parcelRegister("6yUsV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2c43b93305034f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fVnbM;
    var $ctg8C;
    var $f5TWP;
    var $cgL5K;
    var $60LNO;
    function $e2c43b93305034f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e2c43b93305034f0$var$rootStyles = {
        name: "ssyr0c",
        styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
    };
    const $e2c43b93305034f0$var$iconColor = (appearance)=>{
        switch(appearance){
            case 'connectivity':
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
            case 'confirmation':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$747d86715d4175de})`;
            case 'info':
                return `var(--ds-icon-discovery, ${0, $829f609a65d26a98$export$a7175d4e9206bc80})`;
            case 'warning':
                return `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$5aae31392d72caaa})`;
            case 'error':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$4a7404f376229999})`;
        }
    };
    const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const toggleDialog = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((oldState)=>!oldState);
        }, [
            setIsOpen
        ]);
        const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        if (!appearance) appearance = type;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $e2c43b93305034f0$var$rootStyles,
            style: {
                '--icon-accent-color': $e2c43b93305034f0$var$iconColor(appearance)
            },
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ctg8C")).default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            "data-ds--inline-message--button": true,
            appearance: "subtle-link",
            onClick: toggleDialog,
            spacing: "none",
            testId: testId && `${testId}--button`,
            "aria-expanded": isOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("60LNO")).default), {
            isOpen: isOpen,
            appearance: appearance,
            label: iconLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, title && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            testId: testId && `${testId}--title`
        }, title), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "color.text.subtlest",
            maxLines: 1,
            testId: testId && `${testId}--text`
        }, secondaryText))))));
    };
    var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("60LNO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$474777c4d72d6c07$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $jfSgx;
    function $474777c4d72d6c07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $474777c4d72d6c07$var$iconColor = (appearance)=>{
        switch(appearance){
            case 'connectivity':
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            case 'confirmation':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$940e1f69e873f202})`;
            case 'info':
                return `var(--ds-icon-discovery, ${0, $829f609a65d26a98$export$b48405b95304b5a1})`;
            case 'warning':
                return `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$c6930421db9fa514})`;
            case 'error':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
        }
    };
    const $474777c4d72d6c07$var$iconWrapperStyles = {
        name: "kw6wgo",
        styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
    };
    const $474777c4d72d6c07$var$iconColorStyles = {
        name: "1iy94md",
        styles: "color:var(--icon-accent-color)"
    };
    const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
        const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, (0, parcelRequire("jfSgx")).typesMapping);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-ds--inline-message--icon": true,
            style: {
                '--icon-color': $474777c4d72d6c07$var$iconColor(appearance)
            },
            css: [
                $474777c4d72d6c07$var$iconWrapperStyles,
                isOpen && $474777c4d72d6c07$var$iconColorStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious"
        }));
    };
    var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;
});
parcelRegister("jfSgx", function(module, exports) {
    $parcel$export(module.exports, "typesMapping", ()=>$e3da74fa628ddd87$export$4d111645c0b39d5d);
    var $dD7Zc;
    var $1jWct;
    var $c2i4s;
    var $bU3PY;
    const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
        connectivity: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            defaultLabel: 'connectivity inline message'
        },
        confirmation: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))),
            defaultLabel: 'confirmation inline message'
        },
        info: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))),
            defaultLabel: 'info inline message'
        },
        warning: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            defaultLabel: 'warning inline message'
        },
        error: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))),
            defaultLabel: 'error inline message'
        }
    };
});
parcelRegister("1jWct", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
    function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f64b62884a9bedb$var$InformationIcon = (props)=>$0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
        }, props));
    $0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
    var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;
});
parcelRegister("c2i4s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));
    var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
    function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c33b074f80a91d5$var$SuccessIcon = (props)=>$8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
        }, props));
    $8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;
});
parcelRegister("cM8Sm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c54fb5c971a7e8c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5c54fb5c971a7e8c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        gadgetDeprecationTooltip: {
            "id": "dashboard-internal-common.common.gadget.deprecation-tooltip.gadget-deprecation-tooltip.non-final",
            "defaultMessage": "Starting May 2025, we're no longer supporting this gadget. Delete it before then to reference its data in the available alternatives.<br></br><Link>More about the gadgets and the extended timeline</Link>"
        }
    });
});
parcelRegister("c1XZn", function(module, exports) {
    $parcel$export(module.exports, "SkeletonGadgetContent", ()=>$5d9b139cc9647a02$export$8609a145e570faa1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7Wo16;
    var $fNobW;
    var $44v1T;
    var $koVbs;
    var $19nfo;
    var $kZxfg;
    const $5d9b139cc9647a02$export$8609a145e570faa1 = ({ dashboardId: dashboardId, gadgetId: gadgetId, customHeight: customHeight, isPulsing: isPulsing = true, isLimitedToScreenHeight: isLimitedToScreenHeight = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const gadgetLocalHeight = customHeight ?? `${(0, (0, parcelRequire("19nfo")).getLocalStorageHeight)(dashboardId, gadgetId)}px`;
        const heightIsZero = gadgetLocalHeight.match(/^0[^.0-9]*$/);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "skeleton-gadget-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5d9b139cc9647a02$var$SkeletonContent, {
            height: gadgetLocalHeight,
            isLimitedToScreenHeight: isLimitedToScreenHeight,
            isPulsing: isPulsing,
            "data-testid": "dashboard-internal-common.common.gadget.gadget-skeleton.skeleton-content",
            role: "status",
            "aria-label": "Loading"
        }, !heightIsZero && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7Wo16"))))), {
            LEGACY_size: "large",
            label: formatMessage((0, (0, parcelRequire("kZxfg")).default).genericPlaceholderIcon),
            color: "currentColor"
        })));
    };
    const $5d9b139cc9647a02$var$PulseAnimation = null;
    const $5d9b139cc9647a02$var$SkeletonContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isLimitedToScreenHeight: isLimitedToScreenHeight, isPulsing: isPulsing, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1kmmpls": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height ?? '100%'),
                "--_1s93bfy": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i101j _bfhk1s4m _2rko1y44 _1e0c1txw _4cvr1h6o _1bah1h6o _1nj11i4r _v4q31yy8 _nhwa12c5 _1qzz10vm _8em7p3kn",
                __cmplp.isLimitedToScreenHeight && "_c71lve9e",
                __cmplp.isPulsing ? "_h82i9cwz" : "_h82iidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7Wo16", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c80946547c07390$var$_react = $5c80946547c07390$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5c80946547c07390$var$_chartBar = $5c80946547c07390$var$_interopRequireDefault((parcelRequire("fDskX")));
    var $5c80946547c07390$var$_presentation = $5c80946547c07390$var$_interopRequireDefault((parcelRequire("dRtil")));
    function $5c80946547c07390$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c80946547c07390$var$ChartBarIcon = (props)=>$5c80946547c07390$var$_react.default.createElement($5c80946547c07390$var$_chartBar.default, Object.assign({
            LEGACY_fallbackIcon: $5c80946547c07390$var$_presentation.default
        }, props));
    $5c80946547c07390$var$ChartBarIcon.Name = 'ChartBarIconMigration';
    var $5c80946547c07390$var$_default = module.exports.default = $5c80946547c07390$var$ChartBarIcon;
});
parcelRegister("fDskX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b6207aa8debd29f4$var$_UNSAFE_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>$b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.917 9.75H1.75V13c0 .69.56 1.25 1.25 1.25h2.917m0-4.5v4.5m0-4.5v-4h4.166m-4.166 8.5h4.166m0-8.5v-4h4.167V13c0 .69-.56 1.25-1.25 1.25h-2.917m0-8.5v8.5"/>`
        }, props));
    $b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
    var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;
});
parcelRegister("dRtil", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a176f2f205c06729$var$_react = $a176f2f205c06729$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a176f2f205c06729$var$_chartBar = $a176f2f205c06729$var$_interopRequireDefault((parcelRequire("fDskX")));
    function $a176f2f205c06729$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a176f2f205c06729$var$MediaServicesPresentationIcon = (props)=>$a176f2f205c06729$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="2" height="3" x="8" y="12" fill="inherit" rx="1"/><rect width="2" height="5" x="11" y="10" fill="inherit" rx="1"/><rect width="2" height="7" x="14" y="8" fill="inherit" rx="1"/></g></svg>`
        }, props, {
            newIcon: $a176f2f205c06729$var$_chartBar.default
        }));
    $a176f2f205c06729$var$MediaServicesPresentationIcon.displayName = 'MediaServicesPresentationIcon';
    var $a176f2f205c06729$var$_default = module.exports.default = $a176f2f205c06729$var$MediaServicesPresentationIcon;
});
parcelRegister("kZxfg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cfdcaba3d94c905$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4cfdcaba3d94c905$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericPlaceholderIcon: {
            "id": "dashboard-internal-common.common.gadget.gadget-skeleton.generic-placeholder-icon",
            "defaultMessage": "Placeholder icon"
        }
    });
});
parcelRegister("8FVKN", function(module, exports) {
    $parcel$export(module.exports, "GadgetControllerContextProvider", ()=>$34f96cfa0524cd59$export$4de1bad6b03d7763);
    $parcel$export(module.exports, "GadgetControllerContextConsumer", ()=>$34f96cfa0524cd59$export$4d4eb85e0f24da5c);
    $parcel$export(module.exports, "useGadgetRefresh", ()=>$34f96cfa0524cd59$export$9e5c8ef16417c38e);
    $parcel$export(module.exports, "useGadgetRenderKey", ()=>$34f96cfa0524cd59$export$b4c09774e3d2cd2d);
    $parcel$export(module.exports, "useIsConnectDisabled", ()=>$34f96cfa0524cd59$export$2afbda65cda4cd52);
    $parcel$export(module.exports, "useGadgetSetPreferences", ()=>$34f96cfa0524cd59$export$263d54a76be27f46);
    var $jnkfq;
    const { createUseContextField: $34f96cfa0524cd59$export$56fb4dd71461f98e, Provider: $34f96cfa0524cd59$export$4de1bad6b03d7763, Consumer: $34f96cfa0524cd59$export$4d4eb85e0f24da5c } = (0, (0, parcelRequire("jnkfq")).createRendererContext)();
    const $34f96cfa0524cd59$export$9e5c8ef16417c38e = $34f96cfa0524cd59$export$56fb4dd71461f98e('onRefresh');
    const $34f96cfa0524cd59$export$b4c09774e3d2cd2d = $34f96cfa0524cd59$export$56fb4dd71461f98e('renderKey');
    const $34f96cfa0524cd59$export$2afbda65cda4cd52 = $34f96cfa0524cd59$export$56fb4dd71461f98e('isConnectDisabled');
    const $34f96cfa0524cd59$export$263d54a76be27f46 = $34f96cfa0524cd59$export$56fb4dd71461f98e('setPreferences');
});
parcelRegister("2XTsA", function(module, exports) {
    $parcel$export(module.exports, "useGadgetCommonController", ()=>$369e7d9cc957d88d$export$3db154a5767b2bd0);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    const $369e7d9cc957d88d$export$3db154a5767b2bd0 = ({ id: id, display: display, automaticRefreshMs: automaticRefreshMs, localStorageService: { get: localStorageServiceGet, put: localStorageServicePut, del: localStorageServiceDel }, dashboardRefreshId: dashboardRefreshId, onGadgetKeyChange: onGadgetKeyChange })=>{
        const isDisplayed = display !== (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).HIDDEN;
        const isMaximized = display === (0, (0, parcelRequire("JIPqS")).GADGET_DISPLAY).MAXIMIZED;
        const [isMinimized, setIsMinimized] = (0, $5uXOq.useState)(()=>localStorageServiceGet('minimized') === 'true');
        const onMinimizeOrRestore = (0, $5uXOq.useCallback)((doMinimize)=>{
            if (doMinimize !== isMinimized) {
                if (doMinimize) localStorageServicePut('minimized', 'true');
                else localStorageServiceDel('minimized');
                setIsMinimized(doMinimize);
            }
        }, [
            isMinimized,
            setIsMinimized,
            localStorageServicePut,
            localStorageServiceDel
        ]);
        const [shouldUseCache, setShouldUseCache] = (0, $5uXOq.useState)(true);
        const [refreshId, setRefreshId] = (0, $5uXOq.useState)(Date.now());
        const renderKey = `${id}-${refreshId}-${dashboardRefreshId}-${isMaximized ? 'canvas' : 'default'}`;
        const prevRenderKey = (0, $5uXOq.useRef)(renderKey);
        const onRefresh = (0, $5uXOq.useCallback)(()=>{
            setShouldUseCache(false);
            setRefreshId(Date.now());
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (automaticRefreshMs == null || automaticRefreshMs <= 0) return ()=>{};
            const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
            const interval = setInterval(onRefresh, refreshIntervalMs);
            return ()=>{
                clearInterval(interval);
            };
        }, [
            automaticRefreshMs,
            onRefresh
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (prevRenderKey.current !== renderKey) {
                prevRenderKey.current = renderKey;
                onGadgetKeyChange();
            }
        }, [
            renderKey,
            onGadgetKeyChange
        ]);
        const lastRefreshed = Math.max(Number(dashboardRefreshId), refreshId);
        return {
            isDisplayed: isDisplayed,
            isMaximized: isMaximized,
            isMinimized: isMinimized,
            onMinimizeOrRestore: onMinimizeOrRestore,
            renderKey: renderKey,
            shouldUseCache: shouldUseCache,
            onRefresh: onRefresh,
            lastRefreshed: lastRefreshed
        };
    };
});
parcelRegister("9TUxn", function(module, exports) {
    $parcel$export(module.exports, "useReactGadget", ()=>$f21126f6c18da11d$export$a821269bdacf74ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $kspzT;
    var $gh1hi;
    var $iXzvf;
    const $f21126f6c18da11d$export$a821269bdacf74ba = (gadgetId, reactKey)=>{
        const { update: update, refresh: refresh, loading: loading } = (0, (0, parcelRequire("gh1hi")).useDashboardReactGadgetsResource)();
        const [resetId, setResetId] = (0, $5uXOq.useState)(null);
        const [namedState, setNamedState] = (0, $5uXOq.useState)('idle');
        const isReactGadget = (0, (0, parcelRequire("kspzT")).isReactKey)(reactKey);
        const reinitialise = (0, $5uXOq.useCallback)(()=>{
            if (namedState === 'idle') {
                if (loading) {
                    setResetId(gadgetId);
                    setNamedState('update');
                } else {
                    update((0, (0, parcelRequire("iXzvf")).lensReactGadget)(gadgetId, null));
                    setNamedState('refresh');
                }
            }
        }, [
            gadgetId,
            loading,
            update,
            namedState
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!loading && resetId != null && namedState === 'update') {
                setResetId(null);
                update((0, (0, parcelRequire("iXzvf")).lensReactGadget)(resetId, null));
                setNamedState('refresh');
            }
        }, [
            loading,
            update,
            resetId,
            namedState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (namedState === 'refresh') {
                setNamedState('loading');
                refresh();
            }
        }, [
            refresh,
            namedState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && namedState === 'loading') setNamedState('idle');
        }, [
            loading,
            namedState
        ]);
        if (!isReactGadget) return {
            reinitialise: ()=>undefined,
            isEditable: null,
            isLoading: null
        };
        const { componentEdit: componentEdit } = (0, (0, parcelRequire("kspzT")).default)[reactKey];
        return {
            reinitialise: reinitialise,
            isEditable: Boolean(componentEdit),
            isLoading: namedState === 'loading' || loading && namedState === 'idle'
        };
    };
});
parcelRegister("iXzvf", function(module, exports) {
    $parcel$export(module.exports, "lensReactGadget", ()=>$18ff57dda50a1c7b$export$703ae6d6d75e47f1);
    const $18ff57dda50a1c7b$export$bada82ca295a26d5 = (updateGadgets)=>(resource)=>resource && {
                ...resource,
                reactGadgetsState: updateGadgets(resource.reactGadgetsState)
            };
    const $18ff57dda50a1c7b$export$703ae6d6d75e47f1 = (id, setterOrValue)=>{
        const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
        return $18ff57dda50a1c7b$export$bada82ca295a26d5((reactGadgetsState)=>{
            if (!reactGadgetsState || !(id in reactGadgetsState)) return reactGadgetsState;
            const prevStateOrError = reactGadgetsState[id];
            const newState = setter(prevStateOrError);
            const prevState = prevStateOrError === null || prevStateOrError instanceof Error ? {} : prevStateOrError;
            return {
                ...reactGadgetsState,
                [id]: newState === null ? null : {
                    ...prevState,
                    ...newState
                }
            };
        });
    };
});
parcelRegister("83NgX", function(module, exports) {
    $parcel$export(module.exports, "useLocalStorageService", ()=>$d6a2211d9def985e$export$aae02958650bede0);
    var $5uXOq = parcelRequire("5uXOq");
    var $19nfo;
    const $d6a2211d9def985e$export$d4655e9fae202a89 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, (0, parcelRequire("19nfo")).getGadgetDataFromLocalStorage)(id, ...args), [
            id
        ]);
    const $d6a2211d9def985e$export$3bf5aef0d5c5f925 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, (0, parcelRequire("19nfo")).putGadgetDataFromLocalStorage)(id, ...args), [
            id
        ]);
    const $d6a2211d9def985e$export$84a14851141ef231 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, (0, parcelRequire("19nfo")).deleteGadgetDataFromLocalStorage)(id, ...args), [
            id
        ]);
    const $d6a2211d9def985e$export$aae02958650bede0 = (id)=>{
        const get = $d6a2211d9def985e$export$d4655e9fae202a89(id);
        const put = $d6a2211d9def985e$export$3bf5aef0d5c5f925(id);
        const del = $d6a2211d9def985e$export$84a14851141ef231(id);
        return {
            get: get,
            put: put,
            del: del
        };
    };
});
parcelRegister("chUx7", function(module, exports) {
    $parcel$export(module.exports, "useUserPreferencesService", ()=>$e28e888e5ec2023e$export$f1180a44ef60f9a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $fJpBG;
    var $04NWZ;
    var $7JoAD = parcelRequire("7JoAD");
    var $cmJHP;
    const $e28e888e5ec2023e$export$f1180a44ef60f9a2 = (id, update)=>{
        const refresh = (0, $5uXOq.useCallback)((action, onUpdate)=>(0, (0, parcelRequire("fJpBG")).getUserPreferences)(action).then((userPrefs)=>new Promise((resolve)=>{
                    (0, $7JoAD.batch)(()=>{
                        update((0, (0, parcelRequire("cmJHP")).lensGadget)(id, {
                            userPrefs: userPrefs
                        }));
                        onUpdate && onUpdate();
                        resolve(userPrefs);
                    });
                })), [
            id,
            update
        ]);
        return {
            get: (0, (0, parcelRequire("fJpBG")).getUserPreferences),
            put: (0, (0, parcelRequire("04NWZ")).putUserPreferences),
            refresh: refresh
        };
    };
});
parcelRegister("04NWZ", function(module, exports) {
    $parcel$export(module.exports, "putUserPreferences", ()=>$4633a504d8696aa1$export$4af73e9957d3b620);
    var $eusud;
    const $4633a504d8696aa1$export$46db0cded8c5f9ba = (preferences)=>{
        const userPreferences = {
            up_isConfigured: true
        };
        if (preferences) Object.keys(preferences).forEach((key)=>{
            userPreferences[`up_${key}`] = preferences[key];
        });
        return userPreferences;
    };
    const $4633a504d8696aa1$export$4af73e9957d3b620 = (action, preferences)=>{
        if (Object.entries(preferences).length === 0) return null;
        const body = JSON.stringify($4633a504d8696aa1$export$46db0cded8c5f9ba(preferences));
        return (0, (0, parcelRequire("eusud")).performPutRequest)(action, {
            body: body
        });
    };
});
parcelRegister("cmJHP", function(module, exports) {
    $parcel$export(module.exports, "lensGadgetsList", ()=>$3155a2d52607ee02$export$20e5dac1cf24abd6);
    $parcel$export(module.exports, "lensGadget", ()=>$3155a2d52607ee02$export$fd99d53e8db9addf);
    const $3155a2d52607ee02$export$20e5dac1cf24abd6 = (updateGadgets)=>(config)=>config && {
                ...config,
                gadgets: updateGadgets(config.gadgets)
            };
    const $3155a2d52607ee02$export$fd99d53e8db9addf = (id, setterOrValue)=>{
        const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
        return $3155a2d52607ee02$export$20e5dac1cf24abd6((gadgets)=>gadgets.map((item)=>item.id === id ? {
                    ...item,
                    ...setter(item)
                } : item));
    };
});
parcelRegister("lwPtc", function(module, exports) {
    $parcel$export(module.exports, "GadgetInner", ()=>$1be6d64e8f66591c$export$9bb8ef6d23720658);
    var $5uXOq = parcelRequire("5uXOq");
    var $kspzT;
    var $l8ruj;
    var $8UPoO;
    var $gc2JH;
    var $cmgca;
    var $eW8ji;
    var $1NzHy;
    var $9sF5P;
    var $k3y1k;
    var $ce1BZ;
    const $1be6d64e8f66591c$export$9bb8ef6d23720658 = ({ dashboardId: dashboardId, data: data, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, setTitle: setTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel, unconfiguredFallback: unconfiguredFallback, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
        const enhancedContext = (0, (0, parcelRequire("gc2JH")).useGadgetDataContextEnhancer)(data.context);
        const onGadgetRender = (0, (0, parcelRequire("8UPoO")).useOnGadgetRender)(data.id);
        const unconfiguredModernGadgetInViewMode = !isInEditMode && isUnconfigured && !(0, (0, parcelRequire("cmgca")).isConnectGadget)(data);
        const localStorageHeight = (0, (0, parcelRequire("8UPoO")).useLocalStorageGadgetHeight)(data.id);
        if (unconfiguredFallback != null && unconfiguredModernGadgetInViewMode) return unconfiguredFallback;
        if ((0, (0, parcelRequire("cmgca")).isConnectGadget)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "gadget-inner-connect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NzHy")).Connect), {
            dashboardId: dashboardId,
            gadgetId: data.id,
            inlineHtml: data.inlineHtml,
            isLoading: isLoading,
            isInEditMode: isInEditMode,
            setIsLoading: setIsLoading,
            onEditModeCancel: onEditModeCancel,
            onRegister: onRegisterConnectGadget,
            onUnregister: onUnregisterConnectGadget,
            setTitle: setTitle
        }));
        if (data.amdModule != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "gadget-inner-amd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eW8ji")).Amd), {
            dashboardId: dashboardId,
            gadgetId: data.id,
            amdModule: data.amdModule,
            context: enhancedContext,
            defaultTitle: data.title,
            userPrefs: data.userPrefs,
            inlineHtml: data.inlineHtml,
            isEditable: isEditModeEnabled,
            isLoading: isLoading,
            isInEditMode: isInEditMode,
            setIsLoading: setIsLoading,
            setDefaultTitle: setDefaultTitle,
            shouldUseCache: shouldUseCache,
            isMaximized: isMaximized,
            onEditModeCancel: onEditModeCancel
        }));
        if (data.inlineHtml != null && data.renderedGadgetUrl == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "gadget-inner-inline-html"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3y1k")).InlineHtml), {
            id: data.id,
            inlineHtml: data.inlineHtml,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }));
        if (data.forge != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "gadget-inner-forge"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9sF5P")).Forge), {
            forgeKey: data.forge.key,
            gadgetData: data,
            isInEditMode: isInEditMode,
            onEditModeCancel: onEditModeCancel,
            setIsLoading: setIsLoading
        }));
        if ((0, (0, parcelRequire("kspzT")).isReactKey)(data.reactKey)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "gadget-inner-react"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ce1BZ")).ReactGadget), {
            id: data.id,
            reactKey: data.reactKey,
            onEditModeCancel: onEditModeCancel,
            isInEditMode: isInEditMode,
            userPrefs: data.userPrefs,
            onRenderComplete: onGadgetRender,
            setDefaultTitle: setDefaultTitle,
            customSkeletonHeightInPx: localStorageHeight
        }));
        throw new Error(`Unrecognised gadget type [${data.title}, ${data?.gadgetSpecUrl}]`);
    };
});
parcelRegister("gc2JH", function(module, exports) {
    $parcel$export(module.exports, "useGadgetDataContextEnhancer", ()=>$ef0abc66ae6c989f$export$c9b763726c221f0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $90yGq;
    var $8wYJI;
    const $ef0abc66ae6c989f$export$191677f0ab656833 = ({ user: user, ...context }, enhancedUser)=>({
            ...context,
            user: {
                ...user,
                ...enhancedUser
            }
        });
    const $ef0abc66ae6c989f$export$c9b763726c221f0f = (data)=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const languageTag = (0, (0, parcelRequire("8wYJI")).useLanguageTag)();
        return (0, $5uXOq.useMemo)(()=>$ef0abc66ae6c989f$export$191677f0ab656833(data, {
                accountId: accountId,
                languageTag: languageTag
            }), [
            accountId,
            data,
            languageTag
        ]);
    };
});
parcelRegister("8wYJI", function(module, exports) {
    $parcel$export(module.exports, "useLanguageTag", ()=>$98f5b4da7049a1e2$export$dbb9c2c3f6b09f02);
    var $9OXo1;
    const $98f5b4da7049a1e2$export$271af7ea6b55125e = 'en-US';
    const $98f5b4da7049a1e2$export$dbb9c2c3f6b09f02 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.languageTag || $98f5b4da7049a1e2$export$271af7ea6b55125e;
    };
});
parcelRegister("cmgca", function(module, exports) {
    $parcel$export(module.exports, "isConnectGadget", ()=>$d6e9d4b1bec846d6$export$d4464474d72c938d);
    var $JIPqS;
    const $d6e9d4b1bec846d6$export$d4464474d72c938d = ({ amdModule: amdModule })=>amdModule === (0, (0, parcelRequire("JIPqS")).CONNECT_ITEM_AMD_MODULE);
});
parcelRegister("eW8ji", function(module, exports) {
    $parcel$export(module.exports, "Amd", ()=>$f71dbcea44b19d9c$export$f7e1ea694836dc0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $dJl1T;
    var $JIPqS;
    var $fJpBG;
    var $jcw0u;
    var $gh1hi;
    var $bVDE5;
    var $4uQB7;
    var $c1XZn;
    var $jszBL;
    var $8FVKN;
    var $ih7Bj;
    var $7vg9b;
    var $i0rkS;
    var $5TsWX;
    var $ikoXd;
    var $WIEWs;
    const $f71dbcea44b19d9c$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).VIEW_WRM_GADGET_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    const $f71dbcea44b19d9c$var$reportError = (gadgetId, reportGadgetMetrics, error)=>{
        reportGadgetMetrics(gadgetId, (0, (0, parcelRequire("5TsWX")).GADGET_START_EVENT), 'ErrorMessage');
        reportGadgetMetrics(gadgetId, (0, (0, parcelRequire("5TsWX")).GADGET_RENDERING_FINISHED_EVENT), 'ErrorMessage');
        (0, (0, parcelRequire("hh0bW")).default)({
            ...$f71dbcea44b19d9c$var$expAttributes,
            wasExperienceSuccesful: false
        });
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: (0, (0, parcelRequire("JIPqS")).VIEW_WRM_GADGET_EXPERIENCE),
                packageName: 'jiraDashboardInternalCommon'
            }
        });
    };
    const $f71dbcea44b19d9c$export$f7e1ea694836dc0c = ({ dashboardId: dashboardId, gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, userPrefs: userPrefs, inlineHtml: inlineHtml, isEditable: isEditable, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel })=>{
        const [{ currentPageId: currentPageId }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const { loading: loadingB, data: data } = (0, (0, parcelRequire("gh1hi")).useDashboardAMDModulesResource)();
        const { amdModules: amdModules = null } = data ?? {};
        const setPreferences = (0, (0, parcelRequire("8FVKN")).useGadgetSetPreferences)();
        const preference = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("fJpBG")).decodeUserPreferences)(userPrefs?.fields), [
            userPrefs?.fields
        ]);
        const module = (0, $5uXOq.useRef)(null);
        const divRef = (0, $5uXOq.useRef)(null);
        const { addEventHandler: addEventHandler, triggerEvent: triggerEvent, removeEventHandlers: removeEventHandlers } = (0, (0, parcelRequire("jszBL")).useEventPublisher)();
        const isGlobalsReady = (0, (0, parcelRequire("ih7Bj")).useIsGlobalsReady)();
        const isRenderable = isGlobalsReady && !loadingB && amdModules?.[amdModule ?? ''] != null || module.current != null;
        const isSkeleton = isLoading && !isInEditMode;
        const [, { broadcastMessage: broadcastMessageBusListener }] = (0, (0, parcelRequire("i0rkS")).useMessageBus)();
        const [gadgetError, setGadgetError] = (0, $5uXOq.useState)(null);
        (0, (0, parcelRequire("7vg9b")).useLinkInterceptor)(divRef.current, isLoading);
        const reportGadgetMetrics = (0, $5uXOq.useCallback)((gid, eventType, contentType, markName, markStage)=>{
            broadcastMessageBusListener((0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).REPORT, {
                eventType: eventType,
                contentType: contentType,
                markName: markName,
                markStage: markStage,
                source: (0, (0, parcelRequire("5TsWX")).WRM_GADGET_METRICS)
            }, {
                gadgetId: gid,
                pageId: currentPageId
            });
        }, [
            broadcastMessageBusListener,
            currentPageId
        ]);
        const gadgetApi = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("ikoXd")).getInlineGadgetApi)({
                gadgetId: gadgetId,
                amdModule: amdModule ?? '',
                context: context,
                defaultTitle: defaultTitle,
                isEditable: isEditable,
                closeEdit: onEditModeCancel,
                setIsLoading: setIsLoading,
                ref: divRef,
                setDefaultTitle: setDefaultTitle,
                reportGadgetMetrics: reportGadgetMetrics,
                dashboardId: dashboardId,
                addEventHandler: addEventHandler,
                removeEventHandlers: removeEventHandlers,
                triggerEvent: triggerEvent,
                setPreferences: setPreferences,
                shouldUseCache: shouldUseCache,
                view: isMaximized ? 'canvas' : 'default',
                setError: setGadgetError
            }), []);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (inlineHtml == null || divRef.current == null) return;
            divRef.current.innerHTML = '';
            divRef.current.appendChild(document.createRange().createContextualFragment(inlineHtml));
        }, [
            inlineHtml
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            (async ()=>{
                if (!isRenderable || amdModule == null) return;
                if (module.current == null) {
                    const Module = amdModules[amdModule];
                    try {
                        module.current = new Module(gadgetApi);
                    } catch (error) {
                        $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, error);
                        setGadgetError((0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR);
                        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Failed to instantiate AMD module [${amdModule}]`, error);
                    }
                }
                if (module.current != null) {
                    (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] in ${isInEditMode ? 'Edit' : 'View'} mode`);
                    reportGadgetMetrics(gadgetId, (0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT), isInEditMode ? 'Config' : 'View', undefined, undefined);
                    const render = isInEditMode && module.current?.renderEdit || preference.isConfigured && module.current?.render || null;
                    if (render == null) {
                        $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, new Error('gadget render is null'));
                        setGadgetError((0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR);
                        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method missing`);
                    } else {
                        try {
                            render.call(module.current, window.jQuery(divRef.current), preference);
                            setGadgetError(null);
                            (0, (0, parcelRequire("hh0bW")).default)({
                                ...$f71dbcea44b19d9c$var$expAttributes,
                                wasExperienceSuccesful: true
                            });
                        } catch (error) {
                            $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, error);
                            setGadgetError((0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR);
                            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method throws error`, error);
                        }
                        triggerEvent('afterRender');
                    }
                }
            })();
        }, [
            isInEditMode,
            preference,
            isRenderable
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (module.current) module.current = null;
            }, []);
        return gadgetError != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQB7")).GadgetErrorFallback), {
            errorType: gadgetError,
            id: gadgetId
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("WIEWs")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("WIEWs")).GadgetContainer), {
            id: `gadget-${gadgetId}`,
            ref: divRef,
            isHidden: isSkeleton
        }), isSkeleton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("WIEWs")).SkeletonWrapper), {
            "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.amd.loading-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), {
            dashboardId: dashboardId,
            gadgetId: gadgetId
        })));
    };
});
parcelRegister("4uQB7", function(module, exports) {
    $parcel$export(module.exports, "GadgetErrorFallbackBase", ()=>$73c4c8c0862da954$export$f9edce43cd0e391a);
    $parcel$export(module.exports, "GadgetErrorFallback", ()=>$73c4c8c0862da954$export$6de1d4202af2589f);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $gtreQ;
    var $koVbs;
    var $8FVKN;
    var $ii3gE;
    var $2n7g7;
    var $e0K9l;
    const $73c4c8c0862da954$export$f9edce43cd0e391a = ({ id: id, message: message, isRefresh: isRefresh = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onRefreshClick = (0, (0, parcelRequire("8FVKN")).useGadgetRefresh)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ii3gE")).GadgetFallback), {
            id: id,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: formatMessage((0, (0, parcelRequire("2n7g7")).default).errorTitle),
                primaryColor: `var(--ds-text-warning, ${(0, $829f609a65d26a98$exports).Y300})`
            }),
            action: isRefresh && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "default",
                spacing: "default",
                onClick: onRefreshClick
            }, formatMessage((0, (0, parcelRequire("2n7g7")).default).refreshButtonText))
        }, message);
    };
    const $73c4c8c0862da954$export$6de1d4202af2589f = ({ id: id, errorType: errorType })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($73c4c8c0862da954$export$f9edce43cd0e391a, {
            message: formatMessage((0, (0, parcelRequire("e0K9l")).MESSAGES_BY_ERROR)[errorType]),
            isRefresh: (0, (0, parcelRequire("e0K9l")).IS_REFRESH_BY_ERROR)[errorType],
            id: id
        });
    };
});
parcelRegister("ii3gE", function(module, exports) {
    $parcel$export(module.exports, "GadgetFallback", ()=>$b7e4ec4cca3d9de1$export$5c6c3d588eda4d74);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $8UPoO;
    const $b7e4ec4cca3d9de1$export$5c6c3d588eda4d74 = ({ icon: icon, action: action, id: id, children: children })=>{
        const ref = (0, $5uXOq.useRef)(null);
        const onGadgetRender = (0, (0, parcelRequire("8UPoO")).useOnGadgetRender)(id);
        (0, $5uXOq.useEffect)(()=>{
            const measuredHeight = ref.current?.getBoundingClientRect().height;
            onGadgetRender(measuredHeight === 0 ? undefined : measuredHeight);
        }, [
            onGadgetRender
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b7e4ec4cca3d9de1$var$GadgetFallbackWrapper, {
            ref: ref
        }, icon, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b7e4ec4cca3d9de1$var$contentStyles
        }, children), action);
    };
    const $b7e4ec4cca3d9de1$var$GadgetFallbackWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41ejb _bfhk11bn _2rkoiti9 _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _syaz1dyx _vchhusvi _y3gn1h6o _4t3i1kw7",
                __cmplp.className
            ])
        });
    });
    const $b7e4ec4cca3d9de1$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        margin: 'space.100'
    });
});
parcelRegister("2n7g7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8791e45dc80d54b0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8791e45dc80d54b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-message",
            "defaultMessage": "We're having some trouble displaying this gadget. It's probably a temporary problem. Try refreshing the gadget."
        },
        errorTitle: {
            "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-title",
            "defaultMessage": "Warning"
        },
        configErrorMessage: {
            "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.config-error-message",
            "defaultMessage": "Something went wrong. We could not save your gadget configuration. Refresh this gadget to update its configuration and try again."
        },
        refreshButtonText: {
            "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.refresh-button-text",
            "defaultMessage": "Refresh"
        },
        notSupportedErrorMessage: {
            "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.not-supported-error-message",
            "defaultMessage": "This gadget is no longer supported by Jira."
        }
    });
});
parcelRegister("e0K9l", function(module, exports) {
    $parcel$export(module.exports, "MESSAGES_BY_ERROR", ()=>$96b21687e2fe8cc8$export$8c49a4613a61ecc1);
    $parcel$export(module.exports, "IS_REFRESH_BY_ERROR", ()=>$96b21687e2fe8cc8$export$1b18ce488a22b856);
    var $JIPqS;
    var $2n7g7;
    const $96b21687e2fe8cc8$export$8c49a4613a61ecc1 = {
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).CONFIG_ERROR]: (0, (0, parcelRequire("2n7g7")).default).configErrorMessage,
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR]: (0, (0, parcelRequire("2n7g7")).default).errorMessage,
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).EDIT_ERROR]: (0, (0, parcelRequire("2n7g7")).default).errorMessage,
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: (0, (0, parcelRequire("2n7g7")).default).notSupportedErrorMessage
    };
    const $96b21687e2fe8cc8$export$1b18ce488a22b856 = {
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).CONFIG_ERROR]: true,
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR]: true,
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).EDIT_ERROR]: true,
        [(0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: false
    };
});
parcelRegister("jszBL", function(module, exports) {
    $parcel$export(module.exports, "useEventPublisher", ()=>$4e63d8ae41297db4$export$15f587a36eadd076);
    var $5uXOq = parcelRequire("5uXOq");
    const $4e63d8ae41297db4$export$15f587a36eadd076 = ()=>{
        const eventHandlers = (0, $5uXOq.useRef)(new Map()).current;
        const singleUseEventHandlers = (0, $5uXOq.useRef)(new Map()).current;
        const addEventHandler = (0, $5uXOq.useCallback)((eventName, handler, isSingleUse = false)=>{
            const handlers = isSingleUse ? singleUseEventHandlers : eventHandlers;
            handlers.has(eventName) ? handlers.get(eventName)?.add(handler) : handlers.set(eventName, new Set([
                handler
            ]));
        }, [
            eventHandlers,
            singleUseEventHandlers
        ]);
        const removeEventHandlers = (0, $5uXOq.useCallback)((eventName, handler)=>{
            if (eventName == null) {
                eventHandlers.clear();
                singleUseEventHandlers.clear();
                return;
            }
            if (!handler) {
                eventHandlers.delete(eventName);
                singleUseEventHandlers.delete(eventName);
                return;
            }
            eventHandlers.get(eventName)?.delete(handler);
            singleUseEventHandlers.get(eventName)?.delete(handler);
        }, [
            eventHandlers,
            singleUseEventHandlers
        ]);
        const triggerEvent = (0, $5uXOq.useCallback)((eventName)=>{
            eventHandlers.get(eventName)?.forEach((handler)=>{
                handler();
            });
            singleUseEventHandlers.get(eventName)?.forEach((handler)=>{
                handler();
            });
            singleUseEventHandlers.delete(eventName);
        }, [
            eventHandlers,
            singleUseEventHandlers
        ]);
        return {
            addEventHandler: addEventHandler,
            removeEventHandlers: removeEventHandlers,
            triggerEvent: triggerEvent
        };
    };
});
parcelRegister("ih7Bj", function(module, exports) {
    $parcel$export(module.exports, "useIsGlobalsReady", ()=>$6d5b1af24dce0aaf$export$676419e1d49cf911);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $jU6q7;
    var $4P2OM;
    let $6d5b1af24dce0aaf$var$pollingSingleton = null;
    const $6d5b1af24dce0aaf$export$ef596e2a3bce12f6 = ()=>{
        $6d5b1af24dce0aaf$var$pollingSingleton = null;
    };
    class $6d5b1af24dce0aaf$var$PollingTimedOutError extends Error {
        constructor(){
            super('Timed out polling for globals');
            this.skipSentry = true;
        }
    }
    const $6d5b1af24dce0aaf$export$676419e1d49cf911 = ()=>{
        try {
            $6d5b1af24dce0aaf$var$pollingSingleton = $6d5b1af24dce0aaf$var$pollingSingleton ?? new (0, (0, parcelRequire("jU6q7")).default)(100, (0, (0, parcelRequire("4P2OM")).POLLING_TIMEOUT_MS), (0, (0, parcelRequire("dJl1T")).default));
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('spa-apps.dashboard.common', 'error creating globals polling singleton', error);
        }
        const [isGlobalsReady, setIsGlobalsReady] = (0, $5uXOq.useState)(()=>$6d5b1af24dce0aaf$var$pollingSingleton?.isReady ?? false);
        const [isTimedOut, setIsTimedOut] = (0, $5uXOq.useState)(()=>$6d5b1af24dce0aaf$var$pollingSingleton?.isTimedOut ?? false);
        (0, $5uXOq.useEffect)(()=>{
            const setGlobalsReady = ()=>{
                setIsGlobalsReady(true);
            };
            const setTimedOut = ()=>{
                setIsTimedOut(true);
            };
            $6d5b1af24dce0aaf$var$pollingSingleton?.addEventListener('onReady', setGlobalsReady);
            $6d5b1af24dce0aaf$var$pollingSingleton?.addEventListener('onTimeout', setTimedOut);
            return ()=>{
                $6d5b1af24dce0aaf$var$pollingSingleton?.removeEventListener('onReady', setGlobalsReady);
                $6d5b1af24dce0aaf$var$pollingSingleton?.removeEventListener('onTimeout', setTimedOut);
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (isTimedOut) throw new $6d5b1af24dce0aaf$var$PollingTimedOutError();
        }, [
            isTimedOut
        ]);
        return $6d5b1af24dce0aaf$var$pollingSingleton !== null ? isGlobalsReady : (0, (0, parcelRequire("4P2OM")).DEPENDENCIES).every((dep)=>window[dep]);
    };
});
parcelRegister("jU6q7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6560cd8e50818359$export$2e2bcd8739ae039);
    var $4P2OM;
    var $euXBp;
    const $6560cd8e50818359$var$formatGlobals = (deps)=>deps.map((dep)=>`window.${dep}`).join(', ');
    const $6560cd8e50818359$var$EventTargetUniversal = typeof EventTarget === 'undefined' ? (0, (0, parcelRequire("euXBp")).default) : EventTarget;
    class $6560cd8e50818359$export$2e2bcd8739ae039 extends $6560cd8e50818359$var$EventTargetUniversal {
        #intervalID;
        #timeoutID;
        #startTime;
        constructor(pollingMs, timeoutMs, logger){
            super();
            this.isReady = false;
            this.isTimedOut = false;
            this.missingDeps = [];
            this.#intervalID = null;
            this.#timeoutID = null;
            this.#startTime = Date.now();
            this.#constructPolling = (pollingMs, timeoutMs, logger)=>{
                this.#intervalID = setInterval(()=>{
                    const newReadyDeps = (0, (0, parcelRequire("4P2OM")).DEPENDENCIES).filter((dep)=>window[dep] && this.missingDeps.includes(dep));
                    if (newReadyDeps.length !== 0) {
                        this.missingDeps = this.missingDeps.filter((dep)=>!newReadyDeps.includes(dep));
                        logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `globals [${$6560cd8e50818359$var$formatGlobals(newReadyDeps)}] ready after ${(Date.now() - this.#startTime) / 1000}s, missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                    }
                    if (this.missingDeps.length === 0) {
                        this.isReady = true;
                        this.destroy();
                        this.dispatchEvent(new CustomEvent('onReady'));
                        logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$6560cd8e50818359$var$formatGlobals((0, (0, parcelRequire("4P2OM")).DEPENDENCIES))}] ready after ${(Date.now() - this.#startTime) / 1000}s`);
                    }
                }, pollingMs);
                this.#timeoutID = setTimeout(()=>{
                    this.destroy();
                    if (!this.isReady) {
                        this.isTimedOut = true;
                        this.dispatchEvent(new CustomEvent('onTimeout'));
                        logger.safeErrorWithoutCustomerData('spa-apps.dashboard.common', `timed out polling globals, missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                    }
                }, timeoutMs);
            };
            this.destroy = ()=>{
                if (this.#intervalID != null) {
                    clearInterval(this.#intervalID);
                    this.#intervalID = null;
                }
                if (this.#timeoutID != null) {
                    clearTimeout(this.#timeoutID);
                    this.#timeoutID = null;
                }
            };
            this.missingDeps = (0, (0, parcelRequire("4P2OM")).DEPENDENCIES).filter((dep)=>!window[dep]);
            if (this.missingDeps.length === 0) {
                logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$6560cd8e50818359$var$formatGlobals((0, (0, parcelRequire("4P2OM")).DEPENDENCIES))}] ready on initialisation`);
                this.isReady = true;
            } else {
                logger.safeWarnWithoutCustomerData('spa-apps.dashboard.common', `missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                this.#constructPolling(pollingMs, timeoutMs, logger);
            }
        }
        #constructPolling;
    }
});
parcelRegister("4P2OM", function(module, exports) {
    $parcel$export(module.exports, "DEPENDENCIES", ()=>$f910f3784745e897$export$db362e2d293fe52e);
    $parcel$export(module.exports, "POLLING_TIMEOUT_MS", ()=>$f910f3784745e897$export$560b5415aba6175);
    const $f910f3784745e897$export$db362e2d293fe52e = [
        'require',
        'jQuery'
    ];
    const $f910f3784745e897$export$560b5415aba6175 = 60000;
});
parcelRegister("euXBp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ae767f7162d54de$export$2e2bcd8739ae039);
    class $9ae767f7162d54de$export$2e2bcd8739ae039 {
        constructor(){
            throw new Error('EventTarget is not defined');
        }
    }
});
parcelRegister("7vg9b", function(module, exports) {
    $parcel$export(module.exports, "useLinkInterceptor", ()=>$403995a50b1fa001$export$d6b75f959ce086c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $7HGHK;
    var $pa9q9;
    var $dIdda = parcelRequire("dIdda");
    var $cdUgf;
    var $2SLmH;
    const $403995a50b1fa001$export$ad8ccaa587ef5e2e = 3984;
    const $403995a50b1fa001$var$EXCLUDED_PATHS_OLD = [
        /^\/rest\/(?:gadget|api)\/1\.0\//,
        /^\/plugins\/servlet\/gadgets\/ifr/
    ];
    const $403995a50b1fa001$var$EXCLUDED_ISSUE_TABLE_PATHS = [
        /^\/secure\/AssignIssue!default\.jspa/,
        /^\/secure\/AssignIssue\.jspa/,
        /^\/secure\/VoteOrWatchIssue\.jspa/,
        /^\/secure\/RankTop\.jspa/,
        /^\/secure\/RankBottom\.jspa/,
        /^\/secure\/CreateSubTaskIssue!default\.jspa/,
        /^\/notimportant/
    ];
    const $403995a50b1fa001$var$EXCLUDED_PATHS_NEW = [
        /^\/rest\/(?:gadget|api)\/1\.0\//,
        /^\/plugins\/servlet\/gadgets\/ifr/,
        ...$403995a50b1fa001$var$EXCLUDED_ISSUE_TABLE_PATHS
    ];
    const $403995a50b1fa001$var$isExcludedPath = (path)=>{
        const EXCLUDED_PATHS_WITH_FG = (0, (0, parcelRequire("4R6GH")).fg)('endeavour_announce_options_on_issue_table_gadgets') ? $403995a50b1fa001$var$EXCLUDED_PATHS_NEW : $403995a50b1fa001$var$EXCLUDED_PATHS_OLD;
        return EXCLUDED_PATHS_WITH_FG.some((regex)=>regex.test(path));
    };
    const $403995a50b1fa001$export$d6b75f959ce086c3 = (element, isLoading)=>{
        const { push: push } = (0, $dIdda.useRouterActions)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        (0, $5uXOq.useEffect)(()=>{
            if (isLoading) return ()=>{};
            const linkClickHandler = (event)=>{
                const anchor = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest?.('a');
                if (anchor == null || window.location.hostname !== anchor.hostname) return;
                if (anchor.href && anchor.href.length > $403995a50b1fa001$export$ad8ccaa587ef5e2e) {
                    event.preventDefault();
                    const flagConfig = {
                        key: (0, (0, parcelRequire("7HGHK")).toFlagId)('urlTooLongWarning'),
                        type: 'error',
                        title: (0, (0, parcelRequire("2SLmH")).default).linkInterceptorUrlTooLongTitle,
                        description: (0, (0, parcelRequire("2SLmH")).default).linkInterceptorUrlTooLongDescription
                    };
                    showFlag(flagConfig);
                } else if (anchor.pathname && !(0, (0, parcelRequire("cdUgf")).clickedWithShortcutKeys)(event) && !event.defaultPrevented && !$403995a50b1fa001$var$isExcludedPath(anchor.pathname)) {
                    event.preventDefault();
                    push(anchor.href);
                }
            };
            element?.addEventListener('click', linkClickHandler);
            return ()=>{
                element?.removeEventListener('click', linkClickHandler);
            };
        }, [
            element,
            isLoading,
            push,
            showFlag
        ]);
    };
});
parcelRegister("cdUgf", function(module, exports) {
    $parcel$export(module.exports, "clickedWithShortcutKeys", ()=>$330ad2eb7d232df1$export$141f1be6ae7df96b);
    const $330ad2eb7d232df1$export$141f1be6ae7df96b = (e)=>{
        if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return true;
        return false;
    };
});
parcelRegister("2SLmH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e234c15db6f6ac4a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e234c15db6f6ac4a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        linkInterceptorUrlTooLongTitle: {
            "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-title",
            "defaultMessage": "Requested URL too large"
        },
        linkInterceptorUrlTooLongDescription: {
            "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-description",
            "defaultMessage": "Try shortening the JQL of your saved filter."
        }
    });
});
parcelRegister("ikoXd", function(module, exports) {
    $parcel$export(module.exports, "getInlineGadgetApi", ()=>$f1aaef72e172dd4d$export$a7c3539038fb2c0);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hh0bW;
    var $dJl1T;
    var $JIPqS;
    var $jcw0u;
    var $19nfo;
    const $f1aaef72e172dd4d$export$a7c3539038fb2c0 = ({ gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, isEditable: isEditable, closeEdit: closeEdit, ref: ref, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, reportGadgetMetrics: reportGadgetMetrics = (0, ($parcel$interopDefault($8Rkzz))), dashboardId: dashboardId, setPreferences: setPreferences, addEventHandler: addEventHandler, removeEventHandlers: removeEventHandlers, triggerEvent: triggerEvent, shouldUseCache: shouldUseCache, view: view, setError: setError })=>{
        const resize = ()=>{
            if (!dashboardId || !gadgetId) return;
            const height = ref.current?.getBoundingClientRect().height;
            (0, (0, parcelRequire("19nfo")).updateLocalStorageHeight)(dashboardId, gadgetId, height);
        };
        const moduleAPI = {
            on: (id, handler)=>addEventHandler(id, handler),
            once: (id, handler)=>addEventHandler(id, handler, true),
            off: (id, handler)=>removeEventHandlers(id, handler),
            trigger: (id)=>triggerEvent(id)
        };
        const expAttributes = {
            analyticsSource: 'dashboard',
            experience: (0, (0, parcelRequire("JIPqS")).SAVE_AMD_GADGET_CONFIG_PREFERENCES),
            application: null,
            edition: null,
            additionalAttributes: {}
        };
        return {
            gadget: {
                amdModule: amdModule,
                context: context,
                moduleAPI: moduleAPI
            },
            showLoadingBar: ()=>{
                setIsLoading(true);
            },
            resize: resize,
            isEditable: ()=>isEditable,
            savePreferences: async (preferences)=>{
                const maybePromise = setPreferences(preferences, ()=>{
                    setError(null);
                    closeEdit();
                });
                if (!maybePromise) return;
                try {
                    await maybePromise;
                    (0, (0, parcelRequire("hh0bW")).default)({
                        ...expAttributes,
                        wasExperienceSuccesful: true
                    });
                } catch (e) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd.api', `${e.message} [${defaultTitle}]`);
                    setError((0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).CONFIG_ERROR);
                    (0, (0, parcelRequire("hh0bW")).default)({
                        ...expAttributes,
                        wasExperienceSuccesful: false
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e,
                        meta: {
                            id: (0, (0, parcelRequire("JIPqS")).SAVE_AMD_GADGET_CONFIG_PREFERENCES),
                            packageName: 'jiraDashboardInternalCommon'
                        }
                    });
                }
            },
            setTitle: setDefaultTitle,
            hideLoadingBar: ()=>setIsLoading(false),
            initRefresh: (0, ($parcel$interopDefault($8Rkzz))),
            getRefreshFieldValue: (fieldName)=>{
                const input = ref.current?.querySelector(`input[name=${fieldName || 'refresh'}]`);
                if (input == null || !(input instanceof HTMLInputElement) || !input.checked) return 'false';
                return input.value;
            },
            getGadgetId: ()=>gadgetId,
            closeEdit: closeEdit,
            forceLayoutRefresh: ()=>{
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'deprecated forceLayoutRefresh() is called');
                resize();
            },
            publicInstace: ()=>(0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'Unexpected public instance called'),
            _preparePreferencesToBeSaved: (preference)=>{
                let preferenceStr = '';
                try {
                    preferenceStr = JSON.stringify(preference);
                } catch (e) {
                    preferenceStr = 'non-stringifiable type';
                }
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', `Unexpected prepare preferences called with ${preferenceStr} for ${defaultTitle}`);
            },
            getContext: ()=>context,
            ...moduleAPI,
            listenTo: (0, ($parcel$interopDefault($8Rkzz))),
            stopListening: (0, ($parcel$interopDefault($8Rkzz))),
            listenToOnce: (0, ($parcel$interopDefault($8Rkzz))),
            reportGadgetMetrics: reportGadgetMetrics,
            shouldUseCache: shouldUseCache,
            view: view
        };
    };
});
parcelRegister("WIEWs", function(module, exports) {
    $parcel$export(module.exports, "styleOverrideFromMonolith", ()=>$ab2b4dcf374b66f3$export$a135452a315aaac8);
    $parcel$export(module.exports, "editModeStyleOverrideFromMonolith", ()=>$ab2b4dcf374b66f3$export$5dd19c8cd0b42775);
    $parcel$export(module.exports, "Container", ()=>$ab2b4dcf374b66f3$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SkeletonWrapper", ()=>$ab2b4dcf374b66f3$export$6069cbe61f690103);
    $parcel$export(module.exports, "GadgetContainer", ()=>$ab2b4dcf374b66f3$export$3f9afbcf9557b0b4);
    $parcel$export(module.exports, "ConfigureButton", ()=>$ab2b4dcf374b66f3$export$b95d78b6ea7efb0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    const $ab2b4dcf374b66f3$export$a135452a315aaac8 = `
.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #5e6c84)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #0049b0)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #dfe1e6)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #ebecf0)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #172b4d)"};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #5e6c84)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0065ff)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0049b0)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: 400;
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
    const $ab2b4dcf374b66f3$export$5dd19c8cd0b42775 = `
form.aui .buttons-container .buttons, form.aui .submit-cancel-controls {
    text-align: end;
}
.piechart-gadget .dashboard-item-preferences-config {
    margin: -20px
}
`;
    const $ab2b4dcf374b66f3$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $ab2b4dcf374b66f3$export$6069cbe61f690103 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _11q7vuon",
                __cmplp.className
            ])
        });
    });
    const $ab2b4dcf374b66f3$export$3f9afbcf9557b0b4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isHidden && "_3um015vq _kqsw7079",
                __cmplp.className
            ])
        });
    });
    const $ab2b4dcf374b66f3$export$b95d78b6ea7efb0b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1NzHy", function(module, exports) {
    $parcel$export(module.exports, "Connect", ()=>$e94ecec6e18bdb3d$export$59e6910693f047c2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $dJZWD;
    var $c1XZn;
    var $8UPoO;
    var $8h45R;
    var $8FVKN;
    var $ih7Bj;
    var $19nfo;
    var $cra1f;
    const $e94ecec6e18bdb3d$export$59e6910693f047c2 = ({ dashboardId: dashboardId, gadgetId: gadgetId, inlineHtml: inlineHtml, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, onEditModeCancel: onEditModeCancel, onRegister: onRegister, onUnregister: onUnregister, setTitle: setTitle })=>{
        const divRef = (0, $5uXOq.useRef)(null);
        const isGlobalsReady = (0, (0, parcelRequire("ih7Bj")).useIsGlobalsReady)();
        const isDisabled = (0, (0, parcelRequire("8FVKN")).useIsConnectDisabled)();
        const forcedHeightFromState = (0, (0, parcelRequire("8h45R")).useForcedHeight)(gadgetId);
        const forcedHeight = (0, $5uXOq.useMemo)(()=>forcedHeightFromState ?? (0, (0, parcelRequire("19nfo")).getLocalStorageHeight)(dashboardId, gadgetId), [
            forcedHeightFromState,
            dashboardId,
            gadgetId
        ]);
        const onGadgetRender = (0, (0, parcelRequire("8UPoO")).useOnGadgetRender)(gadgetId);
        const onRefresh = (0, (0, parcelRequire("8FVKN")).useGadgetRefresh)();
        const showSkeleton = isLoading && !isInEditMode;
        (0, $5uXOq.useEffect)(()=>{
            if (!isGlobalsReady || inlineHtml == null) return;
            (0, (0, parcelRequire("dJZWD")).setupConnectJs)().then(()=>{
                const slotHtml = document.createRange().createContextualFragment(inlineHtml);
                if (divRef.current) {
                    divRef.current.innerHTML = '';
                    divRef.current.appendChild(slotHtml);
                    setIsLoading(false);
                    onGadgetRender();
                }
            }).catch((error)=>{
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.connect', 'Failed to render Connect gadget', error);
            });
        }, [
            isGlobalsReady,
            inlineHtml,
            onGadgetRender,
            setIsLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onRegister(gadgetId, setTitle);
            return ()=>{
                onUnregister(gadgetId);
            };
        }, [
            gadgetId,
            setTitle,
            onRegister,
            onUnregister
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const target = divRef.current?.getElementsByTagName('iframe')[0];
            if (!target || !isInEditMode || isLoading) return;
            window.connectHost?.broadcastEvent('jira_dashboard_item_edit', {
                id: target.getAttribute('id')
            });
        }, [
            isInEditMode,
            isLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const connectEventHandler = (event)=>{
                const eventData = event.data;
                const target = divRef.current?.getElementsByTagName('iframe')[0];
                if (target == null || eventData == null || eventData.eid !== target.getAttribute('id')) return;
                if (eventData.type === 'unload') onRefresh();
                else onEditModeCancel();
            };
            window.addEventListener('message', connectEventHandler, false);
            return ()=>{
                window.removeEventListener('message', connectEventHandler);
            };
        }, [
            dashboardId,
            gadgetId,
            inlineHtml,
            isGlobalsReady,
            onRefresh,
            onEditModeCancel
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cra1f")).Container), {
            minHeight: forcedHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cra1f")).GadgetContainer), {
            id: `gadget-${gadgetId}`,
            "data-gadget-id": gadgetId,
            "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.connect",
            ref: divRef,
            isHidden: showSkeleton,
            isDisabled: isDisabled
        }), showSkeleton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cra1f")).SkeletonWrapper), {
            "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.loading-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), {
            dashboardId: dashboardId,
            gadgetId: gadgetId
        })));
    };
});
parcelRegister("cra1f", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$46b4db80fb140a91$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SkeletonWrapper", ()=>$46b4db80fb140a91$export$6069cbe61f690103);
    $parcel$export(module.exports, "GadgetContainer", ()=>$46b4db80fb140a91$export$3f9afbcf9557b0b4);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    const $46b4db80fb140a91$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { minHeight: minHeight, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1l1bpbj": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.minHeight}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1tkemu0a",
                __cmplp.className
            ])
        });
    });
    const $46b4db80fb140a91$export$6069cbe61f690103 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ltvidpf _154iidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1sen",
                __cmplp.className
            ])
        });
    });
    const $46b4db80fb140a91$var$GadgetContainerComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isHidden: isHidden, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1kw7",
                __cmplp.isDisabled ? "_lcxvglyw" : "_lcxv1kw7",
                __cmplp.className
            ])
        });
    });
    const $46b4db80fb140a91$export$3f9afbcf9557b0b4 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($46b4db80fb140a91$var$GadgetContainerComponent, {
            className: "connect-gadget",
            ...props,
            ref: ref
        }));
});
parcelRegister("9sF5P", function(module, exports) {
    $parcel$export(module.exports, "Forge", ()=>$ce96d098a49d18cb$export$4b9c9e62f20bbcd0);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $5ow89;
    var $aABmH;
    var $9k8XP;
    var $e0AC8;
    var $lfTZh;
    var $gh1hi;
    var $bVDE5;
    var $4uQB7;
    var $c1XZn;
    var $8FVKN;
    var $i0rkS;
    var $5TsWX;
    var $dg9na;
    const $ce96d098a49d18cb$export$4b36646b2dadb9ee = ({ gadgetData: gadgetData, forgeKey: forgeKey, isInEditMode: isInEditMode, onEditModeCancel: onEditModeCancel, setIsLoading: setIsLoading })=>{
        const [{ currentPageId: currentPageId }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const { data: dashboardData } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const { data: forgeResourceData, loading: isDashboardForgeResourceLoading, error: resourceError } = (0, (0, parcelRequire("gh1hi")).useDashboardForgeResource)();
        const setPreferences = (0, (0, parcelRequire("8FVKN")).useGadgetSetPreferences)();
        const [, { broadcastMessage: broadcastMessageBusListener }] = (0, (0, parcelRequire("i0rkS")).useMessageBus)();
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [isUpdatePending, setIsUpdatePending] = (0, $5uXOq.useState)(false);
        const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType, contentType, markName, markStage)=>{
            broadcastMessageBusListener((0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).REPORT, {
                eventType: eventType,
                contentType: contentType,
                markName: markName,
                markStage: markStage,
                source: (0, (0, parcelRequire("5TsWX")).FORGE_GADGET_METRICS)
            }, {
                gadgetId: gadgetData.id,
                pageId: currentPageId
            });
        }, [
            gadgetData.id,
            broadcastMessageBusListener,
            currentPageId
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            reportGadgetMetrics((0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT), 'View');
        }, [
            reportGadgetMetrics
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isDashboardForgeResourceLoading) setIsLoading(false);
        }, [
            isDashboardForgeResourceLoading,
            setIsLoading
        ]);
        const onConfigurationSave = (0, $5uXOq.useCallback)((dataToSave)=>{
            (0, (0, parcelRequire("5ow89")).fireUiTriggerClickEvent)('dashboardGadgetEdit');
            setIsUpdatePending(true);
            return (0, (0, parcelRequire("dg9na")).savePreferences)(gadgetData, dataToSave, setPreferences, setError, ()=>{
                setIsUpdatePending(false);
            });
        }, [
            gadgetData,
            setPreferences,
            setError,
            setIsUpdatePending
        ]);
        const dashboardId = dashboardData?.id || '';
        const extensionData = (0, $5uXOq.useMemo)(()=>({
                gadgetConfiguration: (0, (0, parcelRequire("dg9na")).transformUserPrefsForForgeAppConsumption)(gadgetData.userPrefs?.fields),
                dashboard: {
                    id: dashboardId
                },
                gadget: {
                    id: gadgetData.id
                }
            }), [
            gadgetData.userPrefs?.fields,
            dashboardId,
            gadgetData.id
        ]);
        if (isDashboardForgeResourceLoading || isUpdatePending) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), null);
        const forgeGadget = forgeResourceData?.gadgets.find((gadget)=>gadget.id === forgeKey);
        if (resourceError || error || !forgeGadget || !dashboardId) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQB7")).GadgetErrorFallback), {
            errorType: error ?? (0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR,
            id: gadgetData.id
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-dashboard-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), null)
        }, isInEditMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9k8XP")).AsyncDashboardGadgetEdit), {
            extension: forgeGadget,
            extensionData: extensionData,
            onReportGadgetMetrics: reportGadgetMetrics,
            loadingComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), null),
            onEditModeCancel: onEditModeCancel,
            onConfigurationSave: onConfigurationSave
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9k8XP")).AsyncDashboardGadgetView), {
            extension: forgeGadget,
            extensionData: extensionData,
            onReportGadgetMetrics: reportGadgetMetrics,
            loadingComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), null)
        })));
    };
    const $ce96d098a49d18cb$export$4b9c9e62f20bbcd0 = (props)=>{
        const { gadgetData: { id: id }, isInEditMode: isInEditMode } = props;
        const envType = props.gadgetData.forge?.environment;
        const forgeKey = props.gadgetData.forge?.key;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aABmH")).AnalyticsWrapper), {
            attributes: {
                envType: envType,
                ...forgeKey ? (0, (0, parcelRequire("e0AC8")).parseExtensionId)(forgeKey) : {}
            },
            key: `${id}__${isInEditMode}`,
            isInEditMode: isInEditMode,
            errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQB7")).GadgetErrorFallback), {
                    errorType: (0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR,
                    id: id
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce96d098a49d18cb$export$4b36646b2dadb9ee, props));
    };
});
parcelRegister("5ow89", function(module, exports) {
    $parcel$export(module.exports, "fireTrackEditedEvent", ()=>$5a2adb89750e5a75$export$1798d320c6527c08);
    $parcel$export(module.exports, "fireOperationalEditFailedEvent", ()=>$5a2adb89750e5a75$export$762dee9e981de3e1);
    $parcel$export(module.exports, "fireUiTriggerClickEvent", ()=>$5a2adb89750e5a75$export$cfefb608fbbf02c9);
    var $k2DRb;
    var $9BrHy;
    var $8uOa6;
    var $hBuqR;
    const $5a2adb89750e5a75$var$moduleEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION),
        entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)
    });
    const $5a2adb89750e5a75$var$triggerEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
        entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)
    });
    const $5a2adb89750e5a75$export$1798d320c6527c08 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).EDITED, {
            id: $5a2adb89750e5a75$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $5a2adb89750e5a75$export$762dee9e981de3e1 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).EDIT_FAILED, {
            id: $5a2adb89750e5a75$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $5a2adb89750e5a75$export$cfefb608fbbf02c9 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).CLICKED, {
            id: $5a2adb89750e5a75$var$triggerEventId,
            source: source,
            attributes: attributes
        });
});
parcelRegister("aABmH", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsWrapper", ()=>$576e3e741fcaaea4$export$63b55d605f8a2340);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    const $576e3e741fcaaea4$export$63b55d605f8a2340 = (props)=>{
        const { isInEditMode: isInEditMode, ...restProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            ...restProps,
            module: (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
            entryPoint: isInEditMode ? (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT) : undefined,
            shouldFireInitializedEvent: true
        });
    };
});
parcelRegister("9k8XP", function(module, exports) {
    $parcel$export(module.exports, "AsyncDashboardGadgetView", ()=>$7499d979082e3839$export$8f8b884c8f9b7f99);
    $parcel$export(module.exports, "AsyncDashboardGadgetEdit", ()=>$7499d979082e3839$export$11802f9302dce8a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1rTGO;
    var $k2DRb;
    var $3mOWa;
    const $7499d979082e3839$var$GADGET_START_EVENT = 'gadget-start';
    const $7499d979082e3839$var$GADGET_FINISH_EVENT = 'gadget-rendering-finished';
    const $7499d979082e3839$var$getUiKitModule = ()=>(parcelRequire("9q4Cn"));
    const $7499d979082e3839$export$d53932a75c2ba294 = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, $5uXOq.lazy)(()=>$7499d979082e3839$var$getUiKitModule().then((module)=>({
                default: module.DashboardGadgetView
            }))));
    const $7499d979082e3839$export$e388a2aaf41cd524 = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, $5uXOq.lazy)(()=>$7499d979082e3839$var$getUiKitModule().then((module)=>({
                default: module.DashboardGadgetEdit
            }))));
    const $7499d979082e3839$var$getIframeModule = ()=>(parcelRequire("ekrgl"));
    const $7499d979082e3839$export$6e328a6d6807e3ef = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, $5uXOq.lazy)(()=>$7499d979082e3839$var$getIframeModule().then((module)=>({
                default: module.DashboardGadgetViewRenderer
            }))));
    const $7499d979082e3839$export$6618f34be2146a7d = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, $5uXOq.lazy)(()=>$7499d979082e3839$var$getIframeModule().then((module)=>({
                default: module.DashboardGadgetEditRenderer
            }))));
    const $7499d979082e3839$var$getForgeExtensionModule = ()=>(parcelRequire("e81Fp"));
    const $7499d979082e3839$export$90dc543486d6f150 = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, $5uXOq.lazy)(()=>$7499d979082e3839$var$getForgeExtensionModule().then((module)=>({
                default: module.DashboardGadgetViewExtension
            }))));
    const $7499d979082e3839$export$8a87cc350601aff5 = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, $5uXOq.lazy)(()=>$7499d979082e3839$var$getForgeExtensionModule().then((module)=>({
                default: module.DashboardGadgetEditExtension
            }))));
    const $7499d979082e3839$var$useDashboardGadget = (onReportGadgetMetrics, extensionData, entryPoint)=>{
        const onInitialRender = (0, $5uXOq.useCallback)((payload)=>{
            if (payload !== undefined && payload.error == null) onReportGadgetMetrics($7499d979082e3839$var$GADGET_FINISH_EVENT, 'View');
            else onReportGadgetMetrics($7499d979082e3839$var$GADGET_FINISH_EVENT, 'ErrorMessage');
        }, [
            onReportGadgetMetrics
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            onReportGadgetMetrics($7499d979082e3839$var$GADGET_START_EVENT, 'View');
        }, [
            onReportGadgetMetrics
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            const extraPropsUiCommon = {
                module: (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                entryPoint: entryPoint,
                extensionData: {
                    ...extensionData,
                    entryPoint: entryPoint,
                    type: (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE)
                }
            };
            return {
                onInitialRender: onInitialRender,
                extraPropsUiCommon: extraPropsUiCommon
            };
        }, [
            entryPoint,
            extensionData,
            onInitialRender
        ]);
    };
    const $7499d979082e3839$export$8f8b884c8f9b7f99 = (props)=>{
        const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
        const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $7499d979082e3839$var$useDashboardGadget(onReportGadgetMetrics, extensionData);
        const extraPropsUiKit = {
            ...extraPropsUiCommon,
            onInitialRender: onInitialRender
        };
        const extraPropsCustomUi = {
            ...extraPropsUiCommon,
            onLoad: onInitialRender
        };
        if ((0, (0, parcelRequire("3mOWa")).isNativeUiExtension)(props.extension) || (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension)) return (0, ($parcel$interopDefault($5uXOq))).createElement($7499d979082e3839$export$90dc543486d6f150, {
            ...restProps,
            ...extraPropsCustomUi
        });
        return (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension) ? (0, ($parcel$interopDefault($5uXOq))).createElement($7499d979082e3839$export$6e328a6d6807e3ef, {
            ...restProps,
            ...extraPropsCustomUi
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($7499d979082e3839$export$d53932a75c2ba294, {
            ...restProps,
            ...extraPropsUiKit
        });
    };
    const $7499d979082e3839$export$11802f9302dce8a3 = (props)=>{
        const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
        const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $7499d979082e3839$var$useDashboardGadget(onReportGadgetMetrics, extensionData, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT));
        const extraPropsUiKitEdit = {
            ...extraPropsUiCommon,
            onInitialRender: onInitialRender
        };
        const extraPropsCustomUiEdit = {
            ...extraPropsUiCommon,
            onLoad: onInitialRender
        };
        if ((0, (0, parcelRequire("3mOWa")).isNativeUiExtension)(props.extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) || (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT))) return (0, ($parcel$interopDefault($5uXOq))).createElement($7499d979082e3839$export$8a87cc350601aff5, {
            ...restProps,
            ...extraPropsCustomUiEdit
        });
        return (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) ? (0, ($parcel$interopDefault($5uXOq))).createElement($7499d979082e3839$export$6618f34be2146a7d, {
            ...restProps,
            ...extraPropsCustomUiEdit
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($7499d979082e3839$export$e388a2aaf41cd524, {
            ...restProps,
            ...extraPropsUiKitEdit
        });
    };
});
parcelRegister("9q4Cn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bXeFZ")
    ]).then(()=>parcelRequire('iYHF5'));
});
parcelRegister("ekrgl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9r7dn")
    ]).then(()=>parcelRequire('86L7T'));
});
parcelRegister("e81Fp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("godsQ")
    ]).then(()=>parcelRequire('ayAHF'));
});
parcelRegister("dg9na", function(module, exports) {
    $parcel$export(module.exports, "savePreferences", ()=>$7fcdc9b72606be07$export$f1786e2fa4419c16);
    $parcel$export(module.exports, "transformUserPrefsForForgeAppConsumption", ()=>$7fcdc9b72606be07$export$b5d9bfce42b49862);
    var $hh0bW;
    var $dJl1T;
    var $JIPqS;
    var $jcw0u;
    var $5ow89;
    const $7fcdc9b72606be07$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    const $7fcdc9b72606be07$export$f1786e2fa4419c16 = async (data, preferences, setPreferences, setError, onComplete)=>{
        const { title: defaultTitle } = data;
        const newUserPrefs = {};
        Object.entries(preferences).forEach(([key, value])=>{
            newUserPrefs[key] = typeof value === 'string' ? JSON.stringify(value) : value;
        });
        const maybePromise = setPreferences(newUserPrefs, onComplete);
        if (!maybePromise) return;
        try {
            await maybePromise;
            setError(null);
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$7fcdc9b72606be07$var$expAttributes,
                wasExperienceSuccesful: true
            });
            (0, (0, parcelRequire("5ow89")).fireTrackEditedEvent)('dashboardGadgetEdit');
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.forge', `${e.message} [${defaultTitle}]`);
            setError((0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).CONFIG_ERROR);
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$7fcdc9b72606be07$var$expAttributes,
                wasExperienceSuccesful: false
            });
            (0, (0, parcelRequire("jcw0u")).default)({
                error: e,
                meta: {
                    id: (0, (0, parcelRequire("JIPqS")).SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
                    packageName: 'jiraDashboardInternalCommon'
                }
            });
            (0, (0, parcelRequire("5ow89")).fireOperationalEditFailedEvent)('dashboardGadgetEdit', {
                error: e
            });
        }
    };
    const $7fcdc9b72606be07$var$decodeQuotes = (value)=>value.replace(/(?:&quot;)/gm, '"');
    const $7fcdc9b72606be07$export$b5d9bfce42b49862 = (userPrefsFields)=>{
        const transformedUserPrefs = {};
        if (userPrefsFields !== undefined) userPrefsFields.forEach((field)=>{
            if (field.name !== 'isConfigured') transformedUserPrefs[field.name] = JSON.parse($7fcdc9b72606be07$var$decodeQuotes(field.value));
        });
        return transformedUserPrefs;
    };
});
parcelRegister("k3y1k", function(module, exports) {
    $parcel$export(module.exports, "InlineHtml", ()=>$4f214ca561897841$export$109427fbef437c1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $fNobW;
    var $344pu;
    var $8UPoO;
    var $7vg9b;
    const $4f214ca561897841$export$109427fbef437c1e = ({ id: id, inlineHtml: inlineHtml, isLoading: isLoading, setIsLoading: setIsLoading })=>{
        const inlineHtmlRef = (0, $5uXOq.useRef)(null);
        const [hasIntroLogo, setHasIntroLogo] = (0, $5uXOq.useState)(false);
        (0, (0, parcelRequire("7vg9b")).useLinkInterceptor)(inlineHtmlRef.current, isLoading);
        (0, $5uXOq.useEffect)(()=>{
            const slotHtml = document.createRange().createContextualFragment(inlineHtml);
            if (inlineHtmlRef.current) {
                inlineHtmlRef.current.innerHTML = '';
                inlineHtmlRef.current.appendChild(slotHtml);
                const introLogoElement = inlineHtmlRef.current.querySelector('.intro-logo');
                if (introLogoElement) setHasIntroLogo(true);
            }
            setIsLoading(false);
        }, [
            inlineHtml,
            setIsLoading
        ]);
        (0, (0, parcelRequire("8UPoO")).useOnGadgetRenderEffect)(id, inlineHtmlRef.current);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "inline-html-gadget",
            hold: isLoading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: hasIntroLogo && $4f214ca561897841$var$introStyles
        }, hasIntroLogo && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("344pu")).default), {
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: `gadget-${id}`,
            ref: inlineHtmlRef
        })));
    };
    const $4f214ca561897841$var$introStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'auto',
        height: '160px',
        display: 'flex',
        justifyContent: 'space-around',
        padding: 'space.200',
        gap: 'space.200'
    });
});
parcelRegister("344pu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$031bf061693e3531$export$2e2bcd8739ae039);
    var $dCLgq;
    var $6EOSB = parcelRequire("6EOSB");
    const $031bf061693e3531$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($6EOSB)),
        srcDark: ($parcel$interopDefault($6EOSB))
    });
    var $031bf061693e3531$export$2e2bcd8739ae039 = $031bf061693e3531$var$Illustration;
    const $031bf061693e3531$export$a179c88182cb9d56 = [
        0,
        0,
        431,
        406
    ];
});
parcelRegister("6EOSB", function(module, exports) {
    module.exports = new URL("graph-go-up-with-people.4705ad58.svg", import.meta.url).toString();
});
parcelRegister("ce1BZ", function(module, exports) {
    $parcel$export(module.exports, "ReactGadget", ()=>$e6dfd10c598d91ed$export$561f0f8350aca3ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $JIPqS;
    var $39xOx;
    var $bVDE5;
    var $4uQB7;
    var $8FVKN;
    var $i0rkS;
    var $5TsWX;
    var $kMe81;
    const $e6dfd10c598d91ed$var$expAttributes = {
        analyticsSource: 'dashboard',
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    const $e6dfd10c598d91ed$export$561f0f8350aca3ee = ({ id: id, userPrefs: userPrefs, isInEditMode: isInEditMode, reactKey: reactKey, onEditModeCancel: onEditModeCancel, onRenderComplete: onRenderComplete, setDefaultTitle: setDefaultTitle, customSkeletonHeightInPx: customSkeletonHeightInPx })=>{
        const [{ currentPageId: currentPageId }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const [, { broadcastMessage: broadcastMessageBusListener }] = (0, (0, parcelRequire("i0rkS")).useMessageBus)();
        const setPreferences = (0, (0, parcelRequire("8FVKN")).useGadgetSetPreferences)();
        const ref = (0, $5uXOq.useRef)(null);
        const isExperienceCompletedRef = (0, $5uXOq.useRef)(false);
        const { state: state, componentView: ComponentView, componentEdit: ComponentEdit, setState: setState } = (0, (0, parcelRequire("kMe81")).useReactGadgetState)(id, reactKey);
        const experienceKey = `${(0, (0, parcelRequire("JIPqS")).VIEW_REACT_GADGET_EXPERIENCE)}-${reactKey.split('/')[1]}`;
        const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType)=>{
            broadcastMessageBusListener((0, (0, parcelRequire("JIPqS")).GADGET_METRICS_TYPE).REPORT, {
                eventType: eventType,
                contentType: isInEditMode ? 'Config' : 'View',
                source: (0, (0, parcelRequire("5TsWX")).REACT_GADGET_METRICS)
            }, {
                gadgetId: id,
                pageId: currentPageId
            });
        }, [
            broadcastMessageBusListener,
            isInEditMode,
            id,
            currentPageId
        ]);
        const reportGadgetStart = (0, $5uXOq.useCallback)(()=>{
            reportGadgetMetrics((0, (0, parcelRequire("5TsWX")).GADGET_START_EVENT));
        }, [
            reportGadgetMetrics
        ]);
        const onGadgetFinish = (0, $5uXOq.useCallback)((shouldPersistHeight = true)=>{
            if (shouldPersistHeight) {
                const height = ref.current?.getBoundingClientRect().height;
                onRenderComplete(height);
            }
            reportGadgetMetrics((0, (0, parcelRequire("5TsWX")).GADGET_RENDERING_FINISHED_EVENT));
            if (!isExperienceCompletedRef.current) {
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$e6dfd10c598d91ed$var$expAttributes,
                    experience: experienceKey,
                    wasExperienceSuccesful: true
                });
                isExperienceCompletedRef.current = true;
            }
        }, [
            reportGadgetMetrics,
            onRenderComplete,
            experienceKey
        ]);
        const errorFallback = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQB7")).GadgetErrorFallback), {
                id: id,
                errorType: (0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR
            }), [
            id
        ]);
        const sendFailExperience = (0, $5uXOq.useCallback)(()=>{
            if (!isExperienceCompletedRef.current) {
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$e6dfd10c598d91ed$var$expAttributes,
                    experience: experienceKey,
                    wasExperienceSuccesful: false
                });
                isExperienceCompletedRef.current = true;
            }
        }, [
            experienceKey
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            reportGadgetMetrics((0, (0, parcelRequire("5TsWX")).GADGET_RENDER_CONTAINER_EVENT));
        }, [
            reportGadgetMetrics
        ]);
        const setGadgetContentTitle = (0, $5uXOq.useCallback)((contentTitle)=>{
            setDefaultTitle((initialDefaultTitle)=>contentTitle ? `${initialDefaultTitle}: ${contentTitle}` : initialDefaultTitle);
        }, [
            setDefaultTitle
        ]);
        const Component = isInEditMode ? ComponentEdit : ComponentView;
        if (state instanceof Error) {
            sendFailExperience();
            throw state;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: errorFallback,
            packageName: "jiraDashboardInternalCommon",
            id: reactKey,
            teamName: "endeavour",
            onError: sendFailExperience,
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, Component && (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            setPreferences: setPreferences,
            state: state,
            onGadgetStart: reportGadgetStart,
            onGadgetFinish: onGadgetFinish,
            userPrefs: userPrefs,
            onEditModeCancel: onEditModeCancel,
            setState: setState,
            setGadgetContentTitle: setGadgetContentTitle,
            customSkeletonHeightInPx: customSkeletonHeightInPx
        })));
    };
});
parcelRegister("kMe81", function(module, exports) {
    $parcel$export(module.exports, "useReactGadgetState", ()=>$6bed3136adbdd754$export$8e5d1b52830d94a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $kspzT;
    var $gh1hi;
    var $iXzvf;
    const $6bed3136adbdd754$export$8e5d1b52830d94a5 = (id, reactKey)=>{
        const { data: data, update: update, loading: loading, error: error } = (0, (0, parcelRequire("gh1hi")).useDashboardReactGadgetsResource)();
        const reactGadgetsState = data?.reactGadgetsState ?? null;
        const state = (()=>{
            if (reactGadgetsState != null && id in reactGadgetsState) return reactGadgetsState[id];
            if (loading) return null;
            if (reactGadgetsState == null) return error ?? new Error('Gadget resource not initialised');
            return new Error(`Gadget state not found in initialised resource for gadget with reactKey: "${reactKey}" and ID: "${id}"`);
        })();
        const { componentView: componentView, componentEdit: componentEdit } = (0, (0, parcelRequire("kspzT")).default)[reactKey];
        const setState = (0, $5uXOq.useCallback)((setterOrValue)=>{
            if (reactGadgetsState && id in reactGadgetsState) update((0, (0, parcelRequire("iXzvf")).lensReactGadget)(id, setterOrValue));
        }, [
            update,
            reactGadgetsState,
            id
        ]);
        return {
            state: state,
            componentView: componentView,
            componentEdit: componentEdit,
            setState: setState
        };
    };
});
parcelRegister("4ozF0", function(module, exports) {
    $parcel$export(module.exports, "GadgetLayoutWithAnalytics", ()=>$a21461a35586ce8b$export$fbd1c75042cfdd67);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $JIPqS;
    var $39xOx;
    var $iXVV6;
    var $4uQB7;
    var $lE1Ya;
    var $grY2f;
    function $a21461a35586ce8b$export$fbd1c75042cfdd67({ gadgetData: gadgetData, isDisplayed: isDisplayed, header: header, isContentHidden: isContentHidden, customWrapperStyles: customWrapperStyles, children: children, footer: footer, customPlaceholder: customPlaceholder }) {
        const { id: id, color: color, title: title, errorMessage: errorMessage } = gadgetData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            objectType: "gadget",
            objectId: gadgetData.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "gadget",
            packageName: "jiraDashboardInternalCommon",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                isDisplayed ? $a21461a35586ce8b$var$wrapperStyles : $a21461a35586ce8b$var$gadgetNotDisplayedStyles,
                ...Array.isArray(customWrapperStyles) ? customWrapperStyles : [
                    customWrapperStyles
                ],
                color && $a21461a35586ce8b$var$colorsMap[color]
            ],
            id: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: `gadget-title-${id}`
        }, header), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "aria-labelledby": `gadget-title-${id}`,
            id: `gadget-content-${id}`,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("grY2f")).GadgetBoundary), {
            data: gadgetData,
            isError: !title,
            errorFallback: errorMessage ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQB7")).GadgetErrorFallbackBase), {
                id: id,
                message: errorMessage
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uQB7")).GadgetErrorFallback), {
                id: id,
                errorType: !title ? (0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR : (0, (0, parcelRequire("JIPqS")).GADGET_ERROR_TYPE).VIEW_ERROR
            }),
            customPlaceholder: customPlaceholder
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                isContentHidden ? $a21461a35586ce8b$var$contentHiddenStyles : $a21461a35586ce8b$var$contentStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lE1Ya")).GadgetAnalyticsContainer), {
            data: gadgetData
        }, children), footer))))));
    }
    const $a21461a35586ce8b$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxShadow: 'elevation.shadow.raised',
        borderTopWidth: '4px',
        borderTopStyle: 'solid',
        borderRadius: 'border.radius.100',
        marginBottom: 'space.200',
        background: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$exports).N0})`,
        paddingInline: 'space.200',
        paddingBottom: 'space.200',
        position: 'relative',
        borderColor: 'color.border.brand'
    });
    const $a21461a35586ce8b$var$gadgetNotDisplayedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'none'
    });
    const $a21461a35586ce8b$var$colorsMap = Object.fromEntries(Object.entries((0, (0, parcelRequire("JIPqS")).COLOR_MAP)).map(([key, value])=>[
            key,
            (0, (0, parcelRequire("8CUq3")).xcss)({
                borderColor: value
            })
        ]));
    const $a21461a35586ce8b$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowWrap: 'anywhere'
    });
    const $a21461a35586ce8b$var$contentHiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'none'
    });
});
parcelRegister("lE1Ya", function(module, exports) {
    $parcel$export(module.exports, "GadgetAnalyticsContainer", ()=>$8dd46ecf3ec4fed0$export$33d5cbc3e6507749);
    var $5uXOq = parcelRequire("5uXOq");
    var $bOnpg;
    var $3Wusa;
    const $8dd46ecf3ec4fed0$export$33250e472f9e12c2 = 4840;
    const $8dd46ecf3ec4fed0$export$33d5cbc3e6507749 = ({ data: data, children: children })=>{
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const eventSent = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (data !== null && eventSent.current === false) {
                fireAnalytics({
                    ...(0, (0, parcelRequire("3Wusa")).getGadgetAnalyticsProps)(data),
                    action: 'viewed'
                });
                eventSent.current = true;
            }
        }, [
            data,
            fireAnalytics
        ]);
        if (!data) return null;
        if (data.renderedGadgetUrl != null && data.renderedGadgetUrl.length > $8dd46ecf3ec4fed0$export$33250e472f9e12c2) {
            if (eventSent.current === false) {
                fireAnalytics({
                    ...(0, (0, parcelRequire("3Wusa")).getGadgetAnalyticsProps)(data),
                    action: 'viewedFailed'
                });
                eventSent.current = true;
            }
            throw new Error('Request header is too large');
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("3Wusa", function(module, exports) {
    $parcel$export(module.exports, "getGadgetAnalyticsProps", ()=>$ad3242df71f39677$export$42d88d3ece4aff0);
    var $kspzT;
    const $ad3242df71f39677$export$42d88d3ece4aff0 = (data)=>{
        let gadgetType = 'UNKNOWN_GADGET';
        if (data.amdModule != null) gadgetType = data.amdModule;
        else if (data.forge != null) gadgetType = data.forge.key;
        else if ((0, (0, parcelRequire("kspzT")).isReactKey)(data.reactKey)) gadgetType = data.reactKey;
        return {
            eventType: (0, $4d5e0871c06cee03$export$947dac6c72b26f81),
            actionSubjectId: 'gadget',
            actionSubject: 'gadget',
            attributes: {
                gadgetTitle: data.title,
                gadgetType: gadgetType
            }
        };
    };
});
parcelRegister("grY2f", function(module, exports) {
    $parcel$export(module.exports, "GadgetBoundary", ()=>$4828aa186ac8828a$export$9327e9e817f0323d);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $39xOx;
    var $c1XZn;
    var $8UPoO;
    var $8FVKN;
    const $4828aa186ac8828a$export$9327e9e817f0323d = ({ data: data, errorFallback: errorFallback, customPlaceholder: customPlaceholder, isError: isError, children: children })=>{
        const { id: id } = data;
        const renderKey = (0, (0, parcelRequire("8FVKN")).useGadgetRenderKey)();
        const shouldRender = (0, (0, parcelRequire("8UPoO")).useShouldRenderGadget)(id);
        const renderFallback = (0, $5uXOq.useCallback)(()=>errorFallback, [
            errorFallback
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "gadget-content",
            packageName: "jiraDashboardInternalCommon",
            fallback: renderFallback
        }, (()=>{
            if (isError) return errorFallback;
            if (customPlaceholder) return customPlaceholder;
            if (!shouldRender) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c1XZn")).SkeletonGadgetContent), {
                customHeight: `${(0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT)}px`,
                isPulsing: true
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: renderKey
            }, children);
        })());
    };
});
parcelRegister("j3C3s", function(module, exports) {
    $parcel$export(module.exports, "GadgetTitleWrapper", ()=>$41769e611e2b6e1f$export$88d654f5e42c4cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    function $41769e611e2b6e1f$export$88d654f5e42c4cf({ isRenaming: isRenaming, children: children, id: id }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $41769e611e2b6e1f$var$titleStyles,
                isRenaming && $41769e611e2b6e1f$var$titleRenamingStyles
            ],
            id: id
        }, children);
    }
    const $41769e611e2b6e1f$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minHeight: "var(--ds-space-250, 20px)",
        flexGrow: 1,
        minWidth: '0',
        paddingBlock: 'space.200',
        paddingRight: 'space.100',
        wordBreak: 'break-word',
        marginRight: 'space.200'
    });
    const $41769e611e2b6e1f$var$titleRenamingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'text'
    });
});
parcelRegister("gFWXX", function(module, exports) {
    $parcel$export(module.exports, "TitleReadOnly", ()=>$dc1e643a17c4a39f$export$10ece9f949c62d6e);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $3bDjY;
    var $h0JHu;
    var $dIdda = parcelRequire("dIdda");
    var $6hp8I;
    const $dc1e643a17c4a39f$var$TitleInner = (0, $5uXOq.forwardRef)(({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey }, ref)=>{
        const displayTitle = forgeEnvironment ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0JHu")).ExtensionTitle), {
            extensionEnvType: forgeEnvironment,
            extensionEnvKey: forgeEnvironmentKey,
            extensionName: title
        }) : title;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "small",
            as: "h2",
            testId: "dashboard-internal-common.ui.gadget.title-readonly.title-inner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$HeaderTextWrapper, {
            ref: ref
        }, titleUrl !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            href: titleUrl
        }, displayTitle) : displayTitle));
    });
    const $dc1e643a17c4a39f$export$10ece9f949c62d6e = ({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey })=>{
        const dimensions = (0, (0, parcelRequire("6hp8I")).useDimensions)();
        const ref = (0, $5uXOq.useRef)(null);
        const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (ref.current == null) return;
            const { offsetWidth: offsetWidth, scrollWidth: scrollWidth } = ref.current;
            const shouldShowTooltip = offsetWidth < scrollWidth;
            if (showTooltip !== shouldShowTooltip) setShowTooltip(shouldShowTooltip);
        }, [
            dimensions,
            showTooltip
        ]);
        const tooltipContent = (0, $5uXOq.useMemo)(()=>{
            if (showTooltip) return forgeEnvironment ? `${title} (${forgeEnvironment})` : title;
            return null;
        }, [
            showTooltip,
            forgeEnvironment,
            title
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$TooltipWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$TitleInner, {
            title: title,
            ref: ref,
            titleUrl: titleUrl,
            forgeEnvironment: forgeEnvironment,
            forgeEnvironmentKey: forgeEnvironmentKey
        })));
    };
    const $dc1e643a17c4a39f$var$TooltipWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $dc1e643a17c4a39f$var$HeaderTextWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h0JHu", function(module, exports) {
    $parcel$export(module.exports, "ExtensionTitle", ()=>$8acb929a7e4cf7fc$export$3aa4a75e461c581c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $k2DRb;
    var $fl3Yy;
    const $8acb929a7e4cf7fc$var$shouldShowEnv = (extensionEnvType)=>[
            (0, (0, parcelRequire("k2DRb")).STAGING_ENVIRONMENT),
            (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT)
        ].includes(extensionEnvType);
    const $8acb929a7e4cf7fc$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName })=>{
        if (!$8acb929a7e4cf7fc$var$shouldShowEnv(extensionEnvType)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, extensionName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8acb929a7e4cf7fc$var$ExtensionTitleWrapper, null, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
            environmentType: extensionEnvType
        }));
    };
    const $8acb929a7e4cf7fc$var$ExtensionTitleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1q9y _13aiidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1yhBH", function(module, exports) {
    $parcel$export(module.exports, "GadgetToolbar", ()=>$5fcf8ae904c6c9b8$export$bef5bd636ffcc29c);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $gE1Ym;
    var $4h1Pq;
    var $5JpK2;
    var $jOrGg;
    var $j2iKG;
    var $kgoHi;
    var $3bDjY;
    var $koVbs;
    var $bOnpg;
    var $8FVKN;
    var $7K2Ba;
    function $5fcf8ae904c6c9b8$export$bef5bd636ffcc29c({ gadgetId: gadgetId, title: title, onMinimizeOrRestore: onMinimizeOrRestore, isMinimized: isMinimized, isMaximizable: isMaximizable, onMaximizeOrRestore: onMaximizeOrRestore, isMaximized: isMaximized, additionalToolbarItems: additionalToolbarItems }) {
        const onRefresh = (0, (0, parcelRequire("8FVKN")).useGadgetRefresh)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
            onClick: ()=>onMinimizeOrRestore(!isMinimized),
            action: "minimize-restore-button",
            tooltipMessageKey: (0, (0, parcelRequire("7K2Ba")).default)[isMinimized ? 'expand' : 'minimize'],
            ariaLabelMessageKey: (0, (0, parcelRequire("7K2Ba")).default)[isMinimized ? 'expandAriaLabel' : 'minimizeAriaLabel'],
            gadgetName: title,
            gadgetId: gadgetId,
            icon: isMinimized ? (0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))) : (0, ($parcel$interopDefault((0, parcelRequire("j2iKG")))))
        }), isMaximizable && (0, ($parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
            onClick: ()=>onMaximizeOrRestore(!isMaximized),
            action: "maximize-restore-button",
            tooltipMessageKey: (0, (0, parcelRequire("7K2Ba")).default)[isMaximized ? 'singleColumn' : 'maximize'],
            ariaLabelMessageKey: (0, (0, parcelRequire("7K2Ba")).default)[isMaximized ? 'singleColumn' : 'maximizeAriaLabel'],
            gadgetId: gadgetId,
            gadgetName: title,
            icon: isMaximized ? (0, ($parcel$interopDefault((0, parcelRequire("4h1Pq"))))) : (0, ($parcel$interopDefault((0, parcelRequire("gE1Ym")))))
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
            gadgetId: gadgetId,
            onClick: onRefresh,
            action: "refresh-button",
            tooltipMessageKey: (0, (0, parcelRequire("7K2Ba")).default).refresh,
            ariaLabelMessageKey: (0, (0, parcelRequire("7K2Ba")).default).refreshAriaLabel,
            gadgetName: title,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jOrGg")))))
        }), additionalToolbarItems);
    }
    const $5fcf8ae904c6c9b8$export$266a769812832828 = ({ gadgetId: gadgetId, onClick: onClick, action: action, tooltipMessageKey: tooltipMessageKey, ariaLabelMessageKey: ariaLabelMessageKey, gadgetName: gadgetName, icon: icon })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const onClickHandler = ()=>{
            fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
                actionSubject: `gadget.${action}`,
                action: 'clicked',
                actionSubjectId: 'gadget'
            });
            onClick();
        };
        const tooltipContent = formatMessage(tooltipMessageKey);
        const ariaLabel = formatMessage(ariaLabelMessageKey, {
            gadgetName: gadgetName
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            hideTooltipOnClick: true,
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "default",
            label: ariaLabel,
            onClick: onClickHandler,
            icon: icon,
            testId: `dashboard-internal-common.ui.gadget.toolbar.${action}`,
            "aria-controls": `gadget-content-${gadgetId}`
        }));
    };
});
parcelRegister("gE1Ym", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c1e1e97b4a9cecff$var$_react = $c1e1e97b4a9cecff$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c1e1e97b4a9cecff$var$_fullscreenEnter = $c1e1e97b4a9cecff$var$_interopRequireDefault((parcelRequire("5C3Gx")));
    var $c1e1e97b4a9cecff$var$_vidFullScreenOn = $c1e1e97b4a9cecff$var$_interopRequireDefault((parcelRequire("1Lys5")));
    function $c1e1e97b4a9cecff$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c1e1e97b4a9cecff$var$FullscreenEnterIcon = (props)=>$c1e1e97b4a9cecff$var$_react.default.createElement($c1e1e97b4a9cecff$var$_fullscreenEnter.default, Object.assign({
            LEGACY_fallbackIcon: $c1e1e97b4a9cecff$var$_vidFullScreenOn.default
        }, props));
    $c1e1e97b4a9cecff$var$FullscreenEnterIcon.Name = 'FullscreenEnterIconMigration';
    var $c1e1e97b4a9cecff$var$_default = module.exports.default = $c1e1e97b4a9cecff$var$FullscreenEnterIcon;
});
parcelRegister("5C3Gx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $41635c272d6a179a$var$_react = $41635c272d6a179a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $41635c272d6a179a$var$_UNSAFE_baseNew = $41635c272d6a179a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $41635c272d6a179a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $41635c272d6a179a$var$FullscreenEnterIcon = (props)=>$41635c272d6a179a$var$_react.default.createElement($41635c272d6a179a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 6V3c0-.69.56-1.25 1.25-1.25h3M14.25 10v3c0 .69-.56 1.25-1.25 1.25h-3m0-12.5h3c.69 0 1.25.56 1.25 1.25v3M6 14.25H3c-.69 0-1.25-.56-1.25-1.25v-3"/>`
        }, props));
    $41635c272d6a179a$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
    var $41635c272d6a179a$var$_default = module.exports.default = $41635c272d6a179a$var$FullscreenEnterIcon;
});
parcelRegister("1Lys5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1494e7af70bbd024$var$_react = $1494e7af70bbd024$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1494e7af70bbd024$var$_fullscreenEnter = $1494e7af70bbd024$var$_interopRequireDefault((parcelRequire("5C3Gx")));
    function $1494e7af70bbd024$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1494e7af70bbd024$var$VidFullScreenOnIcon = (props)=>$1494e7af70bbd024$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 0 1 2 0zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2M6 4h3a1 1 0 1 1 0 2H6v3a1 1 0 1 1-2 0V6a2 2 0 0 1 2-2m12 2h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
        }, props, {
            newIcon: $1494e7af70bbd024$var$_fullscreenEnter.default
        }));
    $1494e7af70bbd024$var$VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
    var $1494e7af70bbd024$var$_default = module.exports.default = $1494e7af70bbd024$var$VidFullScreenOnIcon;
});
parcelRegister("4h1Pq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $31ca2b071cc9d641$var$_react = $31ca2b071cc9d641$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $31ca2b071cc9d641$var$_fullscreenExit = $31ca2b071cc9d641$var$_interopRequireDefault((parcelRequire("g5bVM")));
    var $31ca2b071cc9d641$var$_fullScreen = $31ca2b071cc9d641$var$_interopRequireDefault((parcelRequire("aU3Qy")));
    function $31ca2b071cc9d641$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $31ca2b071cc9d641$var$FullscreenExitIcon = (props)=>$31ca2b071cc9d641$var$_react.default.createElement($31ca2b071cc9d641$var$_fullscreenExit.default, Object.assign({
            LEGACY_fallbackIcon: $31ca2b071cc9d641$var$_fullScreen.default
        }, props));
    $31ca2b071cc9d641$var$FullscreenExitIcon.Name = 'FullscreenExitIconMigration';
    var $31ca2b071cc9d641$var$_default = module.exports.default = $31ca2b071cc9d641$var$FullscreenExitIcon;
});
parcelRegister("g5bVM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb565e37400efb63$var$_react = $bb565e37400efb63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb565e37400efb63$var$_UNSAFE_baseNew = $bb565e37400efb63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bb565e37400efb63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb565e37400efb63$var$FullscreenExitIcon = (props)=>$bb565e37400efb63$var$_react.default.createElement($bb565e37400efb63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.25 1v3c0 .69-.56 1.25-1.25 1.25H1M10.75 15v-3c0-.69.56-1.25 1.25-1.25h3m0-5.5h-3c-.69 0-1.25-.56-1.25-1.25V1M1 10.75h3c.69 0 1.25.56 1.25 1.25v3"/>`
        }, props));
    $bb565e37400efb63$var$FullscreenExitIcon.displayName = 'FullscreenExitIcon';
    var $bb565e37400efb63$var$_default = module.exports.default = $bb565e37400efb63$var$FullscreenExitIcon;
});
parcelRegister("aU3Qy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f021e30f8edd1a3$var$_react = $7f021e30f8edd1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7f021e30f8edd1a3$var$_fullscreenExit = $7f021e30f8edd1a3$var$_interopRequireDefault((parcelRequire("g5bVM")));
    function $7f021e30f8edd1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f021e30f8edd1a3$var$MediaServicesFullScreenIcon = (props)=>$7f021e30f8edd1a3$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 8h3a1 1 0 0 1 0 2h-3a2 2 0 0 1-2-2V5a1 1 0 0 1 2 0zm-8 2H5a1 1 0 1 1 0-2h3V5a1 1 0 1 1 2 0v3a2 2 0 0 1-2 2m8 4h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3a2 2 0 0 1 2-2m-8 2H5a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
        }, props, {
            newIcon: $7f021e30f8edd1a3$var$_fullscreenExit.default
        }));
    $7f021e30f8edd1a3$var$MediaServicesFullScreenIcon.displayName = 'MediaServicesFullScreenIcon';
    var $7f021e30f8edd1a3$var$_default = module.exports.default = $7f021e30f8edd1a3$var$MediaServicesFullScreenIcon;
});
parcelRegister("5JpK2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));
    var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
    function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>$42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
        }, props));
    $42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
    var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;
});
parcelRegister("l14Zy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f4cd903aabaa4c53$var$_UNSAFE_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>$f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;
});
parcelRegister("6LXPU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
    function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>$4ee58c13163bfe09$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
        }));
    $4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;
});
parcelRegister("jOrGg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));
    var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
    function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e6c828a42ee64c30$var$RefreshIcon = (props)=>$e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
            LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
        }, props));
    $e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
    var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;
});
parcelRegister("gPelT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c3fc8ad083e2745c$var$_UNSAFE_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>$c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
        }, props));
    $c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
    var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;
});
parcelRegister("75Jbm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
    function $529c0c456318696f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $529c0c456318696f$var$RefreshIcon = (props)=>$529c0c456318696f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
        }, props, {
            newIcon: $529c0c456318696f$var$_refresh.default
        }));
    $529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
    var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;
});
parcelRegister("j2iKG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));
    var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
    function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>$ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
        }, props));
    $ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
    var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;
});
parcelRegister("8KRBa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $65fc322a3db160cb$var$_UNSAFE_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $65fc322a3db160cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>$65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
        }, props));
    $65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
    var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;
});
parcelRegister("2bcm3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1966313a87133c34$var$_react = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1966313a87133c34$var$_shrinkDiagonal = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("8KRBa")));
    function $1966313a87133c34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1966313a87133c34$var$MediaServicesFitToPageIcon = (props)=>$1966313a87133c34$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
        }, props, {
            newIcon: $1966313a87133c34$var$_shrinkDiagonal.default
        }));
    $1966313a87133c34$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
    var $1966313a87133c34$var$_default = module.exports.default = $1966313a87133c34$var$MediaServicesFitToPageIcon;
});
parcelRegister("7K2Ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d16755660d37c6c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9d16755660d37c6c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        minimize: {
            "id": "dashboard-internal-common.gadget.toolbar.minimize",
            "defaultMessage": "Minimize"
        },
        minimizeAriaLabel: {
            "id": "dashboard-internal-common.gadget.toolbar.minimize-aria-label",
            "defaultMessage": "Minimize {gadgetName}"
        },
        expand: {
            "id": "dashboard-internal-common.gadget.toolbar.expand",
            "defaultMessage": "Expand"
        },
        expandAriaLabel: {
            "id": "dashboard-internal-common.gadget.toolbar.expand-aria-label",
            "defaultMessage": "Expand {gadgetName}"
        },
        maximize: {
            "id": "dashboard-internal-common.gadget.toolbar.maximize",
            "defaultMessage": "Maximize"
        },
        maximizeAriaLabel: {
            "id": "dashboard-internal-common.gadget.toolbar.maximize-aria-label",
            "defaultMessage": "Maximize {gadgetName}"
        },
        refresh: {
            "id": "dashboard-internal-common.gadget.toolbar.refresh",
            "defaultMessage": "Refresh"
        },
        refreshAriaLabel: {
            "id": "dashboard-internal-common.gadget.toolbar.refresh-aria-label",
            "defaultMessage": "Refresh {gadgetName}"
        },
        singleColumn: {
            "id": "dashboard-internal-common.gadget.toolbar.single-column",
            "defaultMessage": "Single column"
        }
    });
});
parcelRegister("iIi7d", function(module, exports) {
    $parcel$export(module.exports, "LastRefreshed", ()=>$64481a9700f86c7d$export$66aab1cf9cd737cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $75Jbm;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $1p96B;
    var $9OXo1;
    var $8hIHC;
    const $64481a9700f86c7d$export$66aab1cf9cd737cc = ({ lastRefreshed: lastRefreshed, updateInterval: updateInterval })=>{
        const [lastRefreshedTimeAgo, setLastRefreshedTimeAgo] = (0, $5uXOq.useState)('');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { locale: locale } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        (0, $5uXOq.useEffect)(()=>{
            setLastRefreshedTimeAgo(formatMessage((0, (0, parcelRequire("8hIHC")).default).justNow));
            const refreshInterval = setInterval(()=>lastRefreshed != null && setLastRefreshedTimeAgo(formatMessage((0, (0, parcelRequire("8hIHC")).default).timeAgo, {
                    timeAgo: (0, (0, parcelRequire("1p96B")).formatDistanceStrictWithLocale)(lastRefreshed, new Date(), locale)
                })), updateInterval);
            return ()=>clearInterval(refreshInterval);
        }, [
            formatMessage,
            lastRefreshed,
            locale,
            updateInterval
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "row",
            alignItems: "center",
            xcss: $64481a9700f86c7d$var$lastRefreshedWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("75Jbm"))))), {
            size: "small",
            label: formatMessage((0, (0, parcelRequire("8hIHC")).default).lastRefreshedIcon)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            color: "color.text.subtle"
        }, lastRefreshedTimeAgo));
    };
    const $64481a9700f86c7d$var$lastRefreshedWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.200',
        color: 'color.text.subtle',
        gap: 'space.050'
    });
});
parcelRegister("8hIHC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3afac6d64be9e0b6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3afac6d64be9e0b6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        justNow: {
            "id": "dashboard-internal-common.last-refreshed.just-now",
            "defaultMessage": "Just now"
        },
        timeAgo: {
            "id": "dashboard-internal-common.last-refreshed.time-ago",
            "defaultMessage": "{timeAgo} ago"
        },
        lastRefreshedIcon: {
            "id": "dashboard-internal-common.last-refreshed.last-refreshed-icon",
            "defaultMessage": "Last refreshed"
        }
    });
});
parcelRegister("jATTU", function(module, exports) {
    $parcel$export(module.exports, "useEcosystemRefresh", ()=>$dc36a798f3ea6a32$export$a96edb2d9dc3e9bf);
    var $5uXOq = parcelRequire("5uXOq");
    var $3v45P;
    var $JIPqS;
    const $dc36a798f3ea6a32$export$1da99641cec7fdf3 = (payload, id)=>window.connectHost?.broadcastEvent((0, (0, parcelRequire("JIPqS")).CONNECT_GADGET_REFRESH_REQUEST_EVENT), {
            id: id
        }, payload);
    const $dc36a798f3ea6a32$export$a96edb2d9dc3e9bf = ({ id: id, connect: connect, forge: forge })=>{
        const isConnect = Boolean(connect?.addonKey);
        const isForge = Boolean(forge?.key);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const ecosystemOnRefresh = (0, $5uXOq.useCallback)(()=>{
            const payload = {
                origin: 'gadget',
                gadgetId: id
            };
            if (isConnect) $dc36a798f3ea6a32$export$1da99641cec7fdf3(payload, wrapperRef.current?.querySelector('iframe')?.id);
            else if (isForge) (0, (0, parcelRequire("3v45P")).emit)((0, (0, parcelRequire("JIPqS")).FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), payload);
        }, [
            id,
            isConnect,
            isForge
        ]);
        return {
            wrapperRef: wrapperRef,
            onRefresh: isConnect || isForge ? ecosystemOnRefresh : undefined
        };
    };
});
parcelRegister("hzLxu", function(module, exports) {
    $parcel$export(module.exports, "useGadgetEditableController", ()=>$11aa1fd44911c0cf$export$bcc758b734cee1d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $l7m8v;
    var $cmgca;
    var $iXzvf;
    var $h7J1E;
    var $gh1hi;
    const $11aa1fd44911c0cf$export$bcc758b734cee1d1 = ({ id: id, title: defaultTitle, customisedTitle: customisedTitle, configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs, amdModule: amdModule, reactKey: reactKey, isRenamable: isRenamable, isConnectDisabled: isConnectDisabled, saveTitle: saveTitle, userPreferencesAction: userPreferencesAction, userPreferencesService: userPreferencesService, instrumentation: instrumentation })=>{
        const { put: userPreferencesServicePut, refresh: userPreferencesServiceRefresh } = userPreferencesService;
        const { isConfigurable: isEditModeEnabled, isUnconfigured: isUnconfigured } = (0, (0, parcelRequire("l7m8v")).useConfigurationStatus)({
            configurable: configurable,
            hasNonHiddenUserPrefs: hasNonHiddenUserPrefs,
            renderedGadgetUrl: renderedGadgetUrl,
            userPrefs: userPrefs
        });
        const [isInEditMode, setIsInEditMode] = (0, $5uXOq.useState)(isEditModeEnabled && isUnconfigured);
        const isEditButtonDisabled = isInEditMode && !(0, (0, parcelRequire("cmgca")).isConnectGadget)({
            amdModule: amdModule
        });
        const onEditModeTrigger = (0, $5uXOq.useCallback)(()=>{
            instrumentation?.onEditModeEnter?.();
            setIsInEditMode(true);
        }, [
            setIsInEditMode,
            instrumentation
        ]);
        const onEditModeCancel = (0, $5uXOq.useCallback)(()=>setIsInEditMode(false), [
            setIsInEditMode
        ]);
        const [isRenaming, setIsRenaming] = (0, $5uXOq.useState)(false);
        const onRenameSave = (0, $5uXOq.useCallback)(async (newTitle)=>{
            if (isRenamable) await saveTitle(newTitle);
            setIsRenaming(false);
        }, [
            isRenamable,
            saveTitle
        ]);
        const { title: title, setDefaultTitle: setDefaultTitle, setTitle: setTitle } = (0, (0, parcelRequire("h7J1E")).useGadgetTitle)({
            defaultTitle: defaultTitle,
            title: customisedTitle,
            onSave: onRenameSave
        });
        const onRenameTrigger = (0, $5uXOq.useCallback)(()=>{
            setIsRenaming(true);
        }, [
            setIsRenaming
        ]);
        const onRenameCancel = (0, $5uXOq.useCallback)(()=>{
            setIsRenaming(false);
        }, [
            setIsRenaming
        ]);
        const { update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardReactGadgetsResource)();
        const setPreferences = (0, $5uXOq.useCallback)((preferences, onUpdate)=>{
            if (userPreferencesAction == null) throw new Error('gadget attempted to save preference without existing preferences');
            const maybePromise = userPreferencesServicePut(userPreferencesAction, preferences);
            if (!maybePromise) return null;
            return (async ()=>{
                try {
                    await maybePromise;
                } catch (e) {
                    throw new Error(`failed to put gadget preference: ${e.message}`);
                }
                if (reactKey) update((0, (0, parcelRequire("iXzvf")).lensReactGadget)(id, null));
                const userPrefsFromService = await userPreferencesServiceRefresh(userPreferencesAction, onUpdate);
                if (userPrefsFromService == null) throw new Error('failed to get preferences after put preferences');
            })();
        }, [
            userPreferencesAction,
            userPreferencesServicePut,
            userPreferencesServiceRefresh,
            update,
            id,
            reactKey
        ]);
        return {
            isUnconfigured: isUnconfigured,
            isEditModeEnabled: isEditModeEnabled,
            isEditButtonDisabled: isEditButtonDisabled,
            isInEditMode: isInEditMode,
            isConnectDisabled: isConnectDisabled,
            onEditModeTrigger: onEditModeTrigger,
            onEditModeCancel: onEditModeCancel,
            title: title,
            isRenaming: isRenaming,
            setDefaultTitle: setDefaultTitle,
            onRenameTrigger: onRenameTrigger,
            onRenameSave: setTitle,
            onRenameCancel: onRenameCancel,
            setPreferences: setPreferences
        };
    };
});
parcelRegister("l7m8v", function(module, exports) {
    $parcel$export(module.exports, "useConfigurationStatus", ()=>$93e0d1b0527a2ad8$export$416bc2c29f65a3f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $5IKQ6;
    const $93e0d1b0527a2ad8$export$416bc2c29f65a3f8 = ({ configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
        const isConfigurable = Boolean(configurable || hasNonHiddenUserPrefs || renderedGadgetUrl);
        const isUnconfigured = (0, $5uXOq.useMemo)(()=>isConfigurable && !(0, (0, parcelRequire("5IKQ6")).isGadgetConfigured)(userPrefs), [
            isConfigurable,
            userPrefs
        ]);
        return {
            isConfigurable: isConfigurable,
            isUnconfigured: isUnconfigured
        };
    };
});
parcelRegister("lB5Qw", function(module, exports) {
    $parcel$export(module.exports, "useDeleteGadget", ()=>$476984e53bb15767$export$fddaf21479a00190);
    var $5uXOq = parcelRequire("5uXOq");
    var $8h45R;
    var $cmJHP;
    var $eusud;
    var $pa9q9;
    var $gh1hi;
    var $fNTzJ;
    const $476984e53bb15767$var$deleteSuccessFlag = (name)=>({
            type: 'success',
            title: (0, (0, parcelRequire("fNTzJ")).messages).successTitle,
            description: [
                (0, (0, parcelRequire("fNTzJ")).messages).successDescription,
                {
                    name: name
                }
            ],
            isAutoDismiss: false,
            delayAnnouncement: 1500
        });
    const $476984e53bb15767$var$deleteFailureFlag = {
        type: 'error',
        title: (0, (0, parcelRequire("fNTzJ")).messages).failureTitle,
        description: (0, (0, parcelRequire("fNTzJ")).messages).failureDescription,
        isAutoDismiss: false,
        delayAnnouncement: 1500
    };
    const $476984e53bb15767$export$fddaf21479a00190 = (id, name)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const [, { remove: remove }] = (0, (0, parcelRequire("8h45R")).useGadgetAdditionalStateActions)();
        const flagService = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, $5uXOq.useCallback)(async ()=>{
            if (!data) return;
            const gadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}`;
            try {
                await (0, (0, parcelRequire("eusud")).performDeleteRequest)(gadgetUrl);
                update((0, (0, parcelRequire("cmJHP")).lensGadgetsList)((gadgets)=>gadgets.filter((element)=>element.id !== id)));
                remove(id);
                flagService.showFlag($476984e53bb15767$var$deleteSuccessFlag(name));
            } catch (_) {
                flagService.showFlag($476984e53bb15767$var$deleteFailureFlag);
            }
        }, [
            data,
            id,
            update,
            remove,
            flagService,
            name
        ]);
    };
});
parcelRegister("fNTzJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2261dff7bcf05f7b$export$defe85febe8b728c);
    var $7VHMR;
    const $2261dff7bcf05f7b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successTitle: {
            "id": "dashboard-edit.services.success-title",
            "defaultMessage": "Gadget has been removed"
        },
        successDescription: {
            "id": "dashboard-edit.services.success-description",
            "defaultMessage": "You've successfully removed the \"{name}\" gadget."
        },
        failureTitle: {
            "id": "dashboard-edit.services.failure-title",
            "defaultMessage": "We couldn't delete the gadget"
        },
        failureDescription: {
            "id": "dashboard-edit.services.failure-description",
            "defaultMessage": "Give it a couple of minutes, then try again."
        }
    });
});
parcelRegister("8VGwU", function(module, exports) {
    $parcel$export(module.exports, "useDuplicateGadget", ()=>$69dddfa95f9940b3$export$f1865177002d12dd);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $JIPqS;
    var $7RGnr;
    var $iyrll;
    var $cmJHP;
    var $iLC4C;
    var $jcw0u;
    var $eusud;
    var $pa9q9;
    var $7HGHK;
    var $gh1hi;
    var $wlDl0;
    var $eeAmR;
    var $fkIcM;
    const $69dddfa95f9940b3$export$6fb6758aa812bdfb = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).DUPLICATE_GADGET_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    const $69dddfa95f9940b3$var$errorFlagAttributes = {
        key: (0, (0, parcelRequire("7HGHK")).toFlagId)('gadgetDuplicateError'),
        type: 'error',
        title: (0, (0, parcelRequire("fkIcM")).default).errorFlagTitle,
        description: (0, (0, parcelRequire("fkIcM")).default).errorFlagDescription,
        actions: [
            {
                content: (0, (0, parcelRequire("fkIcM")).default).errorFlagAction,
                onClick: ()=>window.location.reload()
            }
        ]
    };
    const $69dddfa95f9940b3$var$successFlagAttributes = (name)=>({
            key: (0, (0, parcelRequire("7HGHK")).toFlagId)('gadgetDuplicateSuccess'),
            type: 'success',
            title: (0, (0, parcelRequire("fkIcM")).default).successFlagTitle,
            description: [
                (0, (0, parcelRequire("fkIcM")).default).successFlagDescription,
                {
                    name: name
                }
            ]
        });
    const $69dddfa95f9940b3$export$f1865177002d12dd = (id)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const { canAddGadgetWithinLimit: canAddGadgetWithinLimit, showGadgetLimitFlag: showGadgetLimitFlag } = (0, (0, parcelRequire("eeAmR")).useAddGadgetWithinLimit)((0, (0, parcelRequire("wlDl0")).MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS), (0, (0, parcelRequire("wlDl0")).MAX_ALLOWED_GADGETS_COUNT));
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const onBeforeGadgetAdded = (0, (0, parcelRequire("iyrll")).useOnAddedGadget)();
        return (0, $5uXOq.useCallback)(async ()=>{
            if (!data) return;
            const originalGadget = data.gadgets.find((gadget)=>gadget.id === id);
            if (!originalGadget) {
                showFlag($69dddfa95f9940b3$var$errorFlagAttributes);
                return;
            }
            const isGadgetIgnored = !!originalGadget?.amdModule && Object.values((0, (0, parcelRequire("wlDl0")).IGNORED_GADGETS_FROM_COUNT_MAP)).includes(originalGadget.amdModule);
            if (!canAddGadgetWithinLimit(data.gadgets, isGadgetIgnored)) {
                showGadgetLimitFlag();
                return;
            }
            const duplicateGadgetUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/duplicate`;
            (0, (0, parcelRequire("eusud")).performPostRequest)(duplicateGadgetUrl).then((gadgetData)=>{
                onBeforeGadgetAdded(gadgetData.id);
                update((0, (0, parcelRequire("cmJHP")).lensGadgetsList)((gadgets)=>[
                        ...(0, (0, parcelRequire("7RGnr")).mapToReactGadgets)([
                            gadgetData
                        ]),
                        ...gadgets
                    ]));
                showFlag($69dddfa95f9940b3$var$successFlagAttributes(originalGadget.title));
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$69dddfa95f9940b3$export$6fb6758aa812bdfb,
                    wasExperienceSuccesful: true
                });
            }).catch((error)=>{
                showFlag($69dddfa95f9940b3$var$errorFlagAttributes);
                (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                    error: error,
                    sendSuccessExperience: ()=>{
                        (0, (0, parcelRequire("hh0bW")).default)({
                            ...$69dddfa95f9940b3$export$6fb6758aa812bdfb,
                            wasExperienceSuccesful: true
                        });
                    },
                    sendFailedExperience: ()=>{
                        (0, (0, parcelRequire("hh0bW")).default)({
                            ...$69dddfa95f9940b3$export$6fb6758aa812bdfb,
                            wasExperienceSuccesful: false
                        });
                    },
                    logErrorEvent: (reason)=>{
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: (0, (0, parcelRequire("JIPqS")).DUPLICATE_GADGET_EXPERIENCE),
                                packageName: (0, (0, parcelRequire("wlDl0")).PACKAGE_NAME)
                            },
                            attributes: {
                                reason: reason,
                                endpoint: 'duplicateGadget'
                            }
                        });
                    }
                });
            });
        }, [
            data,
            canAddGadgetWithinLimit,
            id,
            showFlag,
            showGadgetLimitFlag,
            onBeforeGadgetAdded,
            update
        ]);
    };
});
parcelRegister("iLC4C", function(module, exports) {
    $parcel$export(module.exports, "handleFetchErrorAsExperience", ()=>$10506a1bb5cb99af$export$8b2399c5090eddc3);
    var $jJZqs;
    var $fZneA;
    const $10506a1bb5cb99af$export$65e55894e6e38a89 = 'client network error';
    const $10506a1bb5cb99af$export$796b9e0e5da90309 = 'unauthenticated (401)';
    const $10506a1bb5cb99af$export$8b2399c5090eddc3 = ({ error: error, sendSuccessExperience: sendSuccessExperience, sendFailedExperience: sendFailedExperience, logErrorEvent: logErrorEvent })=>{
        if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) {
            sendSuccessExperience();
            logErrorEvent($10506a1bb5cb99af$export$65e55894e6e38a89);
        } else if (error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.constructor === (0, (0, parcelRequire("jJZqs")).default)) {
            const errorCode = Number(error.message.substring(error.message.length - 3));
            if (errorCode === 304) sendSuccessExperience();
            else if (errorCode === 401) logErrorEvent($10506a1bb5cb99af$export$796b9e0e5da90309);
            else {
                sendFailedExperience();
                logErrorEvent(`${errorCode} status code response`);
            }
        } else {
            sendFailedExperience();
            logErrorEvent();
        }
    };
});
parcelRegister("wlDl0", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$b636aeae1a431342$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "MAX_ALLOWED_GADGETS_COUNT", ()=>$b636aeae1a431342$export$e11360046219e002);
    $parcel$export(module.exports, "MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS", ()=>$b636aeae1a431342$export$2ea683536c2351db);
    $parcel$export(module.exports, "IGNORED_GADGETS_FROM_COUNT_MAP", ()=>$b636aeae1a431342$export$7f4c0fee173151d3);
    const $b636aeae1a431342$export$b8b9d90f9e5bd72b = 'jiraDashboardEdit';
    const $b636aeae1a431342$export$93b482f0f653203d = [
        {
            pattern: /React does not recognize/,
            ignoredBecause: 'Warning from `createAnalyticsEvent` prop being forwarded to Atlaskit DropdownMenu.',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /The above error occurred in the (.+?) component/,
            ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /jira.frontend.common.error-boundary/,
            ignoredBecause: 'Unhandled error caught by error boundary',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /jira.frontend.experience-tracker.missing-provider/,
            ignoredBecause: 'Unhandled error caught by error boundary',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /Failed to load resource: the server responded with a status of 404/,
            ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /rest\/internal\/2\/log\/safe\/error/,
            ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /Encountered two children with the same key/,
            ignoredBecause: 'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /Unrecognised gadget type/,
            ignoredBecause: 'exception thrown: Unrecognised gadget type',
            jiraIssueId: 'DAG-688'
        },
        {
            pattern: /FetchError: Error server response/,
            ignoredBecause: 'exception thrown: Error server response',
            jiraIssueId: 'DAG-688'
        }
    ];
    const $b636aeae1a431342$export$e11360046219e002 = 20;
    const $b636aeae1a431342$export$2ea683536c2351db = 50;
    const $b636aeae1a431342$export$7f4c0fee173151d3 = {
        'rest/gadgets/1.0/g/com.atlassian.jira.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml': 'jira-dashboard-items/spacer'
    };
});
parcelRegister("eeAmR", function(module, exports) {
    $parcel$export(module.exports, "useAddGadgetWithinLimit", ()=>$e0a1534f8271bebf$export$c536a8bb380238f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $7HGHK;
    var $wlDl0;
    var $astCn;
    const $e0a1534f8271bebf$export$b9cafb79af2372cd = {
        key: (0, (0, parcelRequire("7HGHK")).toFlagId)('gadgetAddWithinLimitError'),
        type: 'error',
        title: (0, (0, parcelRequire("astCn")).default).gadgetLimitFlagTitle,
        description: (0, (0, parcelRequire("astCn")).default).gadgetLimitFlagDescription
    };
    const $e0a1534f8271bebf$export$c536a8bb380238f8 = (limitIncludeIgnoredGadgets, limitExcludeIgnoredGadgets)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const canAddGadgetWithinLimit = (0, $5uXOq.useCallback)((gadgets, isGadgetIgnored)=>isGadgetIgnored ? gadgets.length < limitIncludeIgnoredGadgets : gadgets.length < limitIncludeIgnoredGadgets && gadgets.filter((e)=>typeof e.amdModule !== 'undefined' ? !Object.values((0, (0, parcelRequire("wlDl0")).IGNORED_GADGETS_FROM_COUNT_MAP)).includes(e.amdModule) : true).length < limitExcludeIgnoredGadgets, [
            limitIncludeIgnoredGadgets,
            limitExcludeIgnoredGadgets
        ]);
        const showGadgetLimitFlag = (0, $5uXOq.useCallback)(()=>{
            showFlag($e0a1534f8271bebf$export$b9cafb79af2372cd);
        }, [
            showFlag
        ]);
        return {
            canAddGadgetWithinLimit: canAddGadgetWithinLimit,
            showGadgetLimitFlag: showGadgetLimitFlag
        };
    };
});
parcelRegister("astCn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dc750b26471aa12$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3dc750b26471aa12$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        gadgetLimitFlagTitle: {
            "id": "dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-title",
            "defaultMessage": "Error."
        },
        gadgetLimitFlagDescription: {
            "id": "dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-description",
            "defaultMessage": "Sorry, you have exceeded the maximum number of gadgets supported by your dashboard.  You must remove some gadgets before proceeding."
        }
    });
});
parcelRegister("fkIcM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30fd23e5ade8cf85$export$2e2bcd8739ae039);
    var $7VHMR;
    var $30fd23e5ade8cf85$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "dashboard-edit.services.duplicate-gadget.error-flag-title",
            "defaultMessage": "Error"
        },
        errorFlagDescription: {
            "id": "dashboard-edit.services.duplicate-gadget.error-flag-description",
            "defaultMessage": "We cannot duplicate that gadget at the moment"
        },
        errorFlagAction: {
            "id": "dashboard-edit.services.duplicate-gadget.error-flag-action",
            "defaultMessage": "Refresh"
        },
        successFlagTitle: {
            "id": "dashboard-edit.services.duplicate-gadget.success-flag-title",
            "defaultMessage": "Gadget has been duplicated"
        },
        successFlagDescription: {
            "id": "dashboard-edit.services.duplicate-gadget.success-flag-description",
            "defaultMessage": "You've successfully duplicated the \"{name}\" gadget."
        }
    });
});
parcelRegister("clqf8", function(module, exports) {
    $parcel$export(module.exports, "useSaveCustomGadgetTitleById", ()=>$4c7986e2f2b82ecd$export$4156ac3cf466d45d);
    var $5uXOq = parcelRequire("5uXOq");
    var $hh0bW;
    var $dJl1T;
    var $JIPqS;
    var $cmJHP;
    var $jcw0u;
    var $eusud;
    var $gh1hi;
    const $4c7986e2f2b82ecd$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).SAVE_CUSTOM_GADGET_TITLE_PREFERENCES),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    const $4c7986e2f2b82ecd$export$5b8abdff51d766d5 = ()=>{
        const { data: data, update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        return (0, $5uXOq.useCallback)(async (id, title)=>{
            const gadget = data?.gadgets.find((g)=>g.id === id);
            if (!gadget || title === gadget.customisedTitle || !data) return;
            const changeTitleUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/title`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(changeTitleUrl, {
                    body: JSON.stringify({
                        title: title
                    })
                });
                update((0, (0, parcelRequire("cmJHP")).lensGadget)(id, {
                    customisedTitle: title
                }));
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$4c7986e2f2b82ecd$var$expAttributes,
                    wasExperienceSuccesful: true
                });
                (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard', 'Set gadget title');
            } catch (error) {
                (0, (0, parcelRequire("hh0bW")).default)({
                    ...$4c7986e2f2b82ecd$var$expAttributes,
                    wasExperienceSuccesful: false
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, (0, parcelRequire("JIPqS")).SAVE_CUSTOM_GADGET_TITLE_PREFERENCES),
                        packageName: 'jiraDashboardEdit'
                    }
                });
                throw error;
            }
        }, [
            data
        ]);
    };
    const $4c7986e2f2b82ecd$export$4156ac3cf466d45d = (id)=>{
        const saveCustomTitle = $4c7986e2f2b82ecd$export$5b8abdff51d766d5();
        return (0, $5uXOq.useCallback)((title)=>saveCustomTitle(id, title), [
            id,
            saveCustomTitle
        ]);
    };
});
parcelRegister("hWMwQ", function(module, exports) {
    $parcel$export(module.exports, "useSaveGadgetColor", ()=>$781e1687ba03beb2$export$13794d1743e6e544);
    var $5uXOq = parcelRequire("5uXOq");
    var $cmJHP;
    var $eusud;
    var $gh1hi;
    const $781e1687ba03beb2$export$13794d1743e6e544 = (id)=>{
        const { data: data, update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        return (0, $5uXOq.useCallback)(async (newColorId)=>{
            if (!data) return;
            const colorUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/color`;
            await (0, (0, parcelRequire("eusud")).performPutRequest)(colorUrl, {
                body: JSON.stringify({
                    color: newColorId
                })
            });
            update((0, (0, parcelRequire("cmJHP")).lensGadget)(id, {
                color: newColorId
            }));
        }, [
            data,
            id,
            update
        ]);
    };
});
parcelRegister("4zy27", function(module, exports) {
    $parcel$export(module.exports, "ConfigDropdown", ()=>$77b3dd02970e5f8c$export$47c9dde399e23070);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    parcelRequire("3zNHM");
    var $lGTQx = parcelRequire("lGTQx");
    var $3zNHM = parcelRequire("3zNHM");
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $6qrUW;
    var $JIPqS;
    var $koVbs;
    var $e9QkH;
    var $lQvIi;
    var $44DPy;
    const $77b3dd02970e5f8c$export$47c9dde399e23070 = ({ isEditable: isEditable, isEditDisabled: isEditDisabled, gadgetColor: gadgetColor, gadgetId: gadgetId, gadgetTitle: gadgetTitle, onSaveColor: onSaveColor, onEditModeClick: onEditModeClick, onDeleteGadget: onDeleteGadget, onDuplicateGadget: onDuplicateGadget })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
        const [shouldFocusModalTrigger, setShouldFocusModalTrigger] = (0, $5uXOq.useState)(false);
        const [, { on: gadgetDeleteOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)(gadgetId);
        const modalTriggerRef = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        const colorPalette = (0, $5uXOq.useMemo)(()=>Object.values((0, (0, parcelRequire("JIPqS")).COLOR_MAP)).map((code)=>{
                const colorName = (0, (0, parcelRequire("JIPqS")).COLOR_NAME_MAP)[code];
                return {
                    label: colorName ? formatMessage(colorName) : code,
                    value: code
                };
            }), [
            formatMessage
        ]);
        const handleDropdownOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>setIsDropdownOpen(isOpen), []);
        const handleModalClose = (0, $5uXOq.useCallback)(()=>{
            setTimeout(()=>{
                if (isMounted.current) {
                    setIsDropdownOpen(true);
                    setShouldFocusModalTrigger(true);
                }
            }, 1);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldFocusModalTrigger && isDropdownOpen) {
                setTimeout(()=>{
                    modalTriggerRef.current?.focus();
                }, 50);
                setShouldFocusModalTrigger(false);
            }
        }, [
            isDropdownOpen,
            shouldFocusModalTrigger
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                isMounted.current = false;
            }, []);
        const onColourChange = (0, $5uXOq.useCallback)((_, newColor)=>{
            const colorId = Object.keys((0, (0, parcelRequire("JIPqS")).COLOR_MAP)).find((key)=>(0, (0, parcelRequire("JIPqS")).COLOR_MAP)[key] === newColor);
            if (colorId) onSaveColor(colorId);
        }, [
            onSaveColor
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($77b3dd02970e5f8c$var$DropdownWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            isOpen: isDropdownOpen,
            onOpenChange: handleDropdownOpenChange,
            isLoading: false,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    appearance: "subtle",
                    spacing: "default",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6qrUW"))))), {
                        label: formatMessage((0, (0, parcelRequire("44DPy")).default).moreActions, {
                            gadgetTitle: gadgetTitle
                        }),
                        size: "medium"
                    }),
                    testId: "dashboard-edit.ui.gadget-editable.config-dropdown.dropdown-button",
                    ref: triggerRef
                }),
            shouldFlip: true,
            placement: "bottom-end",
            appearance: "tall",
            shouldRenderToParent: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: formatMessage((0, (0, parcelRequire("44DPy")).default).colorHeading)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($77b3dd02970e5f8c$var$ColorWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lGTQx.default), {
            label: formatMessage((0, (0, parcelRequire("44DPy")).default).colorHeading),
            palette: colorPalette,
            selectedColor: (0, (0, parcelRequire("JIPqS")).COLOR_MAP)[gadgetColor],
            checkMarkColor: (0, (0, parcelRequire("JIPqS")).COLOR_CHECKMARK_MAP)[gadgetColor],
            mode: (0, $3zNHM.Compact),
            cols: Object.keys((0, (0, parcelRequire("JIPqS")).COLOR_MAP)).length,
            onChange: onColourChange
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, isEditable && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.edit",
            isDisabled: isEditDisabled,
            onClick: onEditModeClick
        }, formatMessage((0, (0, parcelRequire("44DPy")).default).configure)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.duplicate",
            onClick: onDuplicateGadget
        }, formatMessage((0, (0, parcelRequire("44DPy")).default).duplicate)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-edit.ui.gadget-editable.config-dropdown.delete",
            ref: modalTriggerRef,
            onClick: gadgetDeleteOpen
        }, formatMessage((0, (0, parcelRequire("44DPy")).default).delete))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQvIi")).DeleteGadgetModal), {
            id: gadgetId,
            onDeleteGadget: onDeleteGadget,
            gadgetName: gadgetTitle,
            onClose: handleModalClose
        }));
    };
    const $77b3dd02970e5f8c$var$DropdownWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l",
                __cmplp.className
            ])
        });
    });
    const $77b3dd02970e5f8c$var$ColorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4sd53 _n7zlfa5n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3zNHM", function(module, exports) {
    $parcel$export(module.exports, "Compact", ()=>$06f62cb25bd09d8d$export$6479582a9c9e50ce);
    $parcel$export(module.exports, "default", ()=>$06f62cb25bd09d8d$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "ColorPaletteMenu", ()=>(parcelRequire("lGTQx")).default);
    var $3PpqK = parcelRequire("3PpqK");
    var $kD00A = parcelRequire("kD00A");
    var $lGTQx = parcelRequire("lGTQx");
    const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
    var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);
});
parcelRegister("3PpqK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f994db29f75e4622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9dFI;
    var $1ErJq = parcelRequire("1ErJq");
    var $jKrb6 = parcelRequire("jKrb6");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $8RXs9;
    var $7oXeG = parcelRequire("7oXeG");
    function $f994db29f75e4622$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f994db29f75e4622$var$defaultPopperProps = {
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            }
        ],
        placement: 'bottom-start'
    };
    const $f994db29f75e4622$var$packageName = "platform-pkg";
    const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
    class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
            const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
            const fullLabel = this.getFullLabel(intl, value, label);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b9dFI")).default), {
                target: ({ ref: ref, isOpen: isOpen })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                        css: $f994db29f75e4622$var$colorCardWrapperStyles,
                        ref: ref
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId
                    })),
                popperProps: popperProps,
                maxMenuWidth: "auto",
                minMenuWidth: "auto",
                options: options,
                "aria-label": fullLabel,
                value: value,
                components: $jKrb6,
                onChange: this.onChangeSelect,
                searchThreshold: Number.MAX_VALUE,
                cols: cols,
                checkMarkColor: checkMarkColor,
                onKeyDown: this.onKeyDown,
                isTabbing: this.state.isTabbing,
                onOptionKeyDown: this.onOptionKeyDown
            });
        }
        constructor(...args){
            super(...args);
            this.createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
            this.state = {
                isTabbing: false
            };
            this.changeAnalyticsCaller = ()=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                    action: 'clicked',
                    actionSubject: 'color-picker',
                    attributes: {
                        componentName: 'color-picker',
                        packageName: $f994db29f75e4622$var$packageName,
                        packageVersion: $f994db29f75e4622$var$packageVersion
                    }
                })(createAnalyticsEvent);
                return undefined;
            };
            this.onChangeSelect = (option)=>{
                this.props.onChange(option.value, this.changeAnalyticsCaller());
            };
            this.onOptionKeyDown = (value)=>{
                this.props.onChange(value, this.changeAnalyticsCaller());
            };
            this.onKeyDown = (e)=>{
                const key = e.key;
                if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                    isTabbing: true
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                    isTabbing: false
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
            };
            this.getFullLabel = (intl, value, label)=>{
                if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                    color: value.label,
                    message: label
                });
                else return label;
            };
        }
    }
    const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, (0, parcelRequire("8RXs9")).default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
    var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: $f994db29f75e4622$var$packageName,
        packageVersion: $f994db29f75e4622$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
    const $f994db29f75e4622$var$colorCardWrapperStyles = {
        name: "1r5gb7q",
        styles: "display:inline-block"
    };
});
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $9ZKDH = parcelRequire("9ZKDH");
    var $dI393 = parcelRequire("dI393");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $VSDnB;
    var $7VXAu;
    var $7K5PP;
    var $eaXSR;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$FocusLock = (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args);
            this.menuRef = null;
            this.selectRef = null;
            this.targetRef = null;
            this.unbindWindowClick = null;
            this.unbindWindowKeydown = null;
            this.defaultStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            });
            this.isOpenControlled = this.props.isOpen !== undefined;
            this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
            this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            };
            this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            };
            this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            };
            this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            };
            this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            };
            this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            };
            this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            };
            this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            };
            this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                };
            this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                };
            this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            };
            this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            };
            this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            };
            this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const menuHandlers = !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? {
                    onMenuOpen: onMenuOpen,
                    onMenuClose: onMenuClose
                } : {};
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$ConditionalNodeResolverWrapper, {
                        hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver'),
                        innerRef: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$FocusLock, {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        ...menuHandlers,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer))));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
    const $768d8504b373d7ff$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return children;
    };
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ktgnN;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("ktgnN")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("ktgnN", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$ee7339595cce6cb1$export$deee3a793edee05f);
    var $62nHC;
    function $ee7339595cce6cb1$var$n(t) {
        var e;
        return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
    }
    function $ee7339595cce6cb1$var$o(t) {
        return $ee7339595cce6cb1$var$n(t).getComputedStyle(t);
    }
    function $ee7339595cce6cb1$var$i(t) {
        return t instanceof $ee7339595cce6cb1$var$n(t).Node;
    }
    function $ee7339595cce6cb1$var$r(t) {
        return $ee7339595cce6cb1$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
    }
    let $ee7339595cce6cb1$var$l;
    function $ee7339595cce6cb1$var$c() {
        if ($ee7339595cce6cb1$var$l) return $ee7339595cce6cb1$var$l;
        const t = navigator.userAgentData;
        return t && Array.isArray(t.brands) ? ($ee7339595cce6cb1$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $ee7339595cce6cb1$var$l) : navigator.userAgent;
    }
    function $ee7339595cce6cb1$var$s(t) {
        return t instanceof $ee7339595cce6cb1$var$n(t).HTMLElement;
    }
    function $ee7339595cce6cb1$var$f(t) {
        return t instanceof $ee7339595cce6cb1$var$n(t).Element;
    }
    function $ee7339595cce6cb1$var$u(t) {
        if ("undefined" == typeof ShadowRoot) return !1;
        return t instanceof $ee7339595cce6cb1$var$n(t).ShadowRoot || t instanceof ShadowRoot;
    }
    function $ee7339595cce6cb1$var$a(t) {
        const { overflow: e, overflowX: n, overflowY: i, display: r } = $ee7339595cce6cb1$var$o(t);
        return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
            "inline",
            "contents"
        ].includes(r);
    }
    function $ee7339595cce6cb1$var$d(t) {
        return [
            "table",
            "td",
            "th"
        ].includes($ee7339595cce6cb1$var$r(t));
    }
    function $ee7339595cce6cb1$var$h(t) {
        const e = /firefox/i.test($ee7339595cce6cb1$var$c()), n = $ee7339595cce6cb1$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
        return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
            "transform",
            "perspective"
        ].some((t)=>n.willChange.includes(t)) || [
            "paint",
            "layout",
            "strict",
            "content"
        ].some((t)=>{
            const e = n.contain;
            return null != e && e.includes(t);
        });
    }
    function $ee7339595cce6cb1$var$p() {
        return /^((?!chrome|android).)*safari/i.test($ee7339595cce6cb1$var$c());
    }
    function $ee7339595cce6cb1$var$g(t) {
        return [
            "html",
            "body",
            "#document"
        ].includes($ee7339595cce6cb1$var$r(t));
    }
    const $ee7339595cce6cb1$var$m = Math.min, $ee7339595cce6cb1$var$y = Math.max, $ee7339595cce6cb1$var$x = Math.round;
    function $ee7339595cce6cb1$var$w(t) {
        const e = $ee7339595cce6cb1$var$o(t);
        let n = parseFloat(e.width), i = parseFloat(e.height);
        const r = $ee7339595cce6cb1$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $ee7339595cce6cb1$var$x(n) !== l || $ee7339595cce6cb1$var$x(i) !== c;
        return f && (n = l, i = c), {
            width: n,
            height: i,
            fallback: f
        };
    }
    function $ee7339595cce6cb1$var$v(t) {
        return $ee7339595cce6cb1$var$f(t) ? t : t.contextElement;
    }
    const $ee7339595cce6cb1$var$b = {
        x: 1,
        y: 1
    };
    function $ee7339595cce6cb1$var$L(t) {
        const e = $ee7339595cce6cb1$var$v(t);
        if (!$ee7339595cce6cb1$var$s(e)) return $ee7339595cce6cb1$var$b;
        const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $ee7339595cce6cb1$var$w(e);
        let l = (r ? $ee7339595cce6cb1$var$x(n.width) : n.width) / o, c = (r ? $ee7339595cce6cb1$var$x(n.height) : n.height) / i;
        return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
            x: l,
            y: c
        };
    }
    function $ee7339595cce6cb1$var$E(e, o, i, r) {
        var l, c;
        void 0 === o && (o = !1), void 0 === i && (i = !1);
        const s = e.getBoundingClientRect(), u = $ee7339595cce6cb1$var$v(e);
        let a = $ee7339595cce6cb1$var$b;
        o && (r ? $ee7339595cce6cb1$var$f(r) && (a = $ee7339595cce6cb1$var$L(r)) : a = $ee7339595cce6cb1$var$L(e));
        const d = u ? $ee7339595cce6cb1$var$n(u) : window, h = $ee7339595cce6cb1$var$p() && i;
        let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
        if (u) {
            const t = $ee7339595cce6cb1$var$n(u), e = r && $ee7339595cce6cb1$var$f(r) ? $ee7339595cce6cb1$var$n(r) : r;
            let o = t.frameElement;
            for(; o && r && e !== t;){
                const t = $ee7339595cce6cb1$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
                e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $ee7339595cce6cb1$var$n(o).frameElement;
            }
        }
        return (0, (0, parcelRequire("62nHC")).rectToClientRect)({
            width: y,
            height: x,
            x: g,
            y: m
        });
    }
    function $ee7339595cce6cb1$var$T(t) {
        return (($ee7339595cce6cb1$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function $ee7339595cce6cb1$var$R(t) {
        return $ee7339595cce6cb1$var$f(t) ? {
            scrollLeft: t.scrollLeft,
            scrollTop: t.scrollTop
        } : {
            scrollLeft: t.pageXOffset,
            scrollTop: t.pageYOffset
        };
    }
    function $ee7339595cce6cb1$var$C(t) {
        return $ee7339595cce6cb1$var$E($ee7339595cce6cb1$var$T(t)).left + $ee7339595cce6cb1$var$R(t).scrollLeft;
    }
    function $ee7339595cce6cb1$var$F(t) {
        if ("html" === $ee7339595cce6cb1$var$r(t)) return t;
        const e = t.assignedSlot || t.parentNode || $ee7339595cce6cb1$var$u(t) && t.host || $ee7339595cce6cb1$var$T(t);
        return $ee7339595cce6cb1$var$u(e) ? e.host : e;
    }
    function $ee7339595cce6cb1$var$W(t) {
        const e = $ee7339595cce6cb1$var$F(t);
        return $ee7339595cce6cb1$var$g(e) ? e.ownerDocument.body : $ee7339595cce6cb1$var$s(e) && $ee7339595cce6cb1$var$a(e) ? e : $ee7339595cce6cb1$var$W(e);
    }
    function $ee7339595cce6cb1$export$3b57c1601291186b(t, e) {
        var o;
        void 0 === e && (e = []);
        const i = $ee7339595cce6cb1$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $ee7339595cce6cb1$var$n(i);
        return r ? e.concat(l, l.visualViewport || [], $ee7339595cce6cb1$var$a(i) ? i : []) : e.concat(i, $ee7339595cce6cb1$export$3b57c1601291186b(i));
    }
    function $ee7339595cce6cb1$var$S(e, i, r) {
        let l;
        if ("viewport" === i) l = function(t, e) {
            const o = $ee7339595cce6cb1$var$n(t), i = $ee7339595cce6cb1$var$T(t), r = o.visualViewport;
            let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
            if (r) {
                l = r.width, c = r.height;
                const t = $ee7339595cce6cb1$var$p();
                (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
            }
            return {
                width: l,
                height: c,
                x: s,
                y: f
            };
        }(e, r);
        else if ("document" === i) l = function(t) {
            const e = $ee7339595cce6cb1$var$T(t), n = $ee7339595cce6cb1$var$R(t), i = t.ownerDocument.body, r = $ee7339595cce6cb1$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $ee7339595cce6cb1$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
            let c = -n.scrollLeft + $ee7339595cce6cb1$var$C(t);
            const s = -n.scrollTop;
            return "rtl" === $ee7339595cce6cb1$var$o(i).direction && (c += $ee7339595cce6cb1$var$y(e.clientWidth, i.clientWidth) - r), {
                width: r,
                height: l,
                x: c,
                y: s
            };
        }($ee7339595cce6cb1$var$T(e));
        else if ($ee7339595cce6cb1$var$f(i)) l = function(t, e) {
            const n = $ee7339595cce6cb1$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $ee7339595cce6cb1$var$s(t) ? $ee7339595cce6cb1$var$L(t) : {
                x: 1,
                y: 1
            };
            return {
                width: t.clientWidth * r.x,
                height: t.clientHeight * r.y,
                x: i * r.x,
                y: o * r.y
            };
        }(i, r);
        else {
            const t = {
                ...i
            };
            if ($ee7339595cce6cb1$var$p()) {
                var c, u;
                const o = $ee7339595cce6cb1$var$n(e);
                t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
            }
            l = t;
        }
        return (0, (0, parcelRequire("62nHC")).rectToClientRect)(l);
    }
    function $ee7339595cce6cb1$var$A(t, e) {
        return $ee7339595cce6cb1$var$s(t) && "fixed" !== $ee7339595cce6cb1$var$o(t).position ? e ? e(t) : t.offsetParent : null;
    }
    function $ee7339595cce6cb1$var$H(t, e) {
        const i = $ee7339595cce6cb1$var$n(t);
        if (!$ee7339595cce6cb1$var$s(t)) return i;
        let l = $ee7339595cce6cb1$var$A(t, e);
        for(; l && $ee7339595cce6cb1$var$d(l) && "static" === $ee7339595cce6cb1$var$o(l).position;)l = $ee7339595cce6cb1$var$A(l, e);
        return l && ("html" === $ee7339595cce6cb1$var$r(l) || "body" === $ee7339595cce6cb1$var$r(l) && "static" === $ee7339595cce6cb1$var$o(l).position && !$ee7339595cce6cb1$var$h(l)) ? i : l || function(t) {
            let e = $ee7339595cce6cb1$var$F(t);
            for(; $ee7339595cce6cb1$var$s(e) && !$ee7339595cce6cb1$var$g(e);){
                if ($ee7339595cce6cb1$var$h(e)) return e;
                e = $ee7339595cce6cb1$var$F(e);
            }
            return null;
        }(t) || i;
    }
    function $ee7339595cce6cb1$var$V(t, e, n) {
        const o = $ee7339595cce6cb1$var$s(e), i = $ee7339595cce6cb1$var$T(e), l = $ee7339595cce6cb1$var$E(t, !0, "fixed" === n, e);
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const f = {
            x: 0,
            y: 0
        };
        if (o || !o && "fixed" !== n) {
            if (("body" !== $ee7339595cce6cb1$var$r(e) || $ee7339595cce6cb1$var$a(i)) && (c = $ee7339595cce6cb1$var$R(e)), $ee7339595cce6cb1$var$s(e)) {
                const t = $ee7339595cce6cb1$var$E(e, !0);
                f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
            } else i && (f.x = $ee7339595cce6cb1$var$C(i));
        }
        return {
            x: l.left + c.scrollLeft - f.x,
            y: l.top + c.scrollTop - f.y,
            width: l.width,
            height: l.height
        };
    }
    const $ee7339595cce6cb1$export$722a64dea1b767dc = {
        getClippingRect: function(t) {
            let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
            const c = "clippingAncestors" === n ? function(t, e) {
                const n = e.get(t);
                if (n) return n;
                let i = $ee7339595cce6cb1$export$3b57c1601291186b(t).filter((t)=>$ee7339595cce6cb1$var$f(t) && "body" !== $ee7339595cce6cb1$var$r(t)), l = null;
                const c = "fixed" === $ee7339595cce6cb1$var$o(t).position;
                let s = c ? $ee7339595cce6cb1$var$F(t) : t;
                for(; $ee7339595cce6cb1$var$f(s) && !$ee7339595cce6cb1$var$g(s);){
                    const t = $ee7339595cce6cb1$var$o(s), e = $ee7339595cce6cb1$var$h(s);
                    "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                        "absolute",
                        "fixed"
                    ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $ee7339595cce6cb1$var$F(s);
                }
                return e.set(t, i), i;
            }(e, this._c) : [].concat(n), s = [
                ...c,
                i
            ], u = s[0], a = s.reduce((t, n)=>{
                const o = $ee7339595cce6cb1$var$S(e, n, l);
                return t.top = $ee7339595cce6cb1$var$y(o.top, t.top), t.right = $ee7339595cce6cb1$var$m(o.right, t.right), t.bottom = $ee7339595cce6cb1$var$m(o.bottom, t.bottom), t.left = $ee7339595cce6cb1$var$y(o.left, t.left), t;
            }, $ee7339595cce6cb1$var$S(e, u, l));
            return {
                width: a.right - a.left,
                height: a.bottom - a.top,
                x: a.left,
                y: a.top
            };
        },
        convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
            let { rect: e, offsetParent: n, strategy: o } = t;
            const i = $ee7339595cce6cb1$var$s(n), l = $ee7339595cce6cb1$var$T(n);
            if (n === l) return e;
            let c = {
                scrollLeft: 0,
                scrollTop: 0
            }, f = {
                x: 1,
                y: 1
            };
            const u = {
                x: 0,
                y: 0
            };
            if ((i || !i && "fixed" !== o) && (("body" !== $ee7339595cce6cb1$var$r(n) || $ee7339595cce6cb1$var$a(l)) && (c = $ee7339595cce6cb1$var$R(n)), $ee7339595cce6cb1$var$s(n))) {
                const t = $ee7339595cce6cb1$var$E(n);
                f = $ee7339595cce6cb1$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
            }
            return {
                width: e.width * f.x,
                height: e.height * f.y,
                x: e.x * f.x - c.scrollLeft * f.x + u.x,
                y: e.y * f.y - c.scrollTop * f.y + u.y
            };
        },
        isElement: $ee7339595cce6cb1$var$f,
        getDimensions: function(t) {
            return $ee7339595cce6cb1$var$w(t);
        },
        getOffsetParent: $ee7339595cce6cb1$var$H,
        getDocumentElement: $ee7339595cce6cb1$var$T,
        getScale: $ee7339595cce6cb1$var$L,
        async getElementRects (t) {
            let { reference: e, floating: n, strategy: o } = t;
            const i = this.getOffsetParent || $ee7339595cce6cb1$var$H, r = this.getDimensions;
            return {
                reference: $ee7339595cce6cb1$var$V(e, await i(n), o),
                floating: {
                    x: 0,
                    y: 0,
                    ...await r(n)
                }
            };
        },
        getClientRects: (t)=>Array.from(t.getClientRects()),
        isRTL: (t)=>"rtl" === $ee7339595cce6cb1$var$o(t).direction
    };
    function $ee7339595cce6cb1$export$deee3a793edee05f(t, e, n, o) {
        void 0 === o && (o = {});
        const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
            ...$ee7339595cce6cb1$var$f(t) ? $ee7339595cce6cb1$export$3b57c1601291186b(t) : t.contextElement ? $ee7339595cce6cb1$export$3b57c1601291186b(t.contextElement) : [],
            ...$ee7339595cce6cb1$export$3b57c1601291186b(e)
        ] : [];
        u.forEach((t)=>{
            s && t.addEventListener("scroll", n, {
                passive: !0
            }), r && t.addEventListener("resize", n);
        });
        let a, d = null;
        l && (d = new ResizeObserver(()=>{
            n();
        }), $ee7339595cce6cb1$var$f(t) && !c && d.observe(t), $ee7339595cce6cb1$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
        let h = c ? $ee7339595cce6cb1$var$E(t) : null;
        return c && function e() {
            const o = $ee7339595cce6cb1$var$E(t);
            !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
            h = o, a = requestAnimationFrame(e);
        }(), n(), ()=>{
            var t;
            u.forEach((t)=>{
                s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
            }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
        };
    }
    const $ee7339595cce6cb1$export$48a53dcb22e581d0 = (t, n, o)=>{
        const i = new Map, r = {
            platform: $ee7339595cce6cb1$export$722a64dea1b767dc,
            ...o
        }, l = {
            ...r.platform,
            _c: i
        };
        return (0, (0, parcelRequire("62nHC")).computePosition)(t, n, {
            ...r,
            platform: l
        });
    };
});
parcelRegister("62nHC", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$465550d5da2db0f1$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "rectToClientRect", ()=>$465550d5da2db0f1$export$ee05aea0aeecbad4);
    function $465550d5da2db0f1$var$t(t) {
        return t.split("-")[1];
    }
    function $465550d5da2db0f1$var$e(t) {
        return "y" === t ? "height" : "width";
    }
    function $465550d5da2db0f1$var$n(t) {
        return t.split("-")[0];
    }
    function $465550d5da2db0f1$var$o(t) {
        return [
            "top",
            "bottom"
        ].includes($465550d5da2db0f1$var$n(t)) ? "x" : "y";
    }
    function $465550d5da2db0f1$var$i(i, r, a) {
        let { reference: l, floating: s } = i;
        const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $465550d5da2db0f1$var$o(r), u = $465550d5da2db0f1$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
        let p;
        switch($465550d5da2db0f1$var$n(r)){
            case "top":
                p = {
                    x: c,
                    y: l.y - s.height
                };
                break;
            case "bottom":
                p = {
                    x: c,
                    y: l.y + l.height
                };
                break;
            case "right":
                p = {
                    x: l.x + l.width,
                    y: f
                };
                break;
            case "left":
                p = {
                    x: l.x - s.width,
                    y: f
                };
                break;
            default:
                p = {
                    x: l.x,
                    y: l.y
                };
        }
        switch($465550d5da2db0f1$var$t(r)){
            case "start":
                p[m] -= g * (a && d ? -1 : 1);
                break;
            case "end":
                p[m] += g * (a && d ? -1 : 1);
        }
        return p;
    }
    const $465550d5da2db0f1$export$48a53dcb22e581d0 = async (t, e, n)=>{
        const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
        let f = await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }), { x: m, y: u } = $465550d5da2db0f1$var$i(f, o, c), g = o, d = {}, p = 0;
        for(let n = 0; n < s.length; n++){
            const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
                x: m,
                y: u,
                initialPlacement: o,
                placement: g,
                strategy: r,
                middlewareData: d,
                rects: f,
                platform: l,
                elements: {
                    reference: t,
                    floating: e
                }
            });
            m = null != y ? y : m, u = null != x ? x : u, d = {
                ...d,
                [a]: {
                    ...d[a],
                    ...w
                }
            }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
                reference: t,
                floating: e,
                strategy: r
            }) : v.rects), { x: m, y: u } = $465550d5da2db0f1$var$i(f, g, c)), n = -1);
        }
        return {
            x: m,
            y: u,
            placement: g,
            strategy: r,
            middlewareData: d
        };
    };
    function $465550d5da2db0f1$var$a(t) {
        return "number" != typeof t ? function(t) {
            return {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                ...t
            };
        }(t) : {
            top: t,
            right: t,
            bottom: t,
            left: t
        };
    }
    function $465550d5da2db0f1$export$ee05aea0aeecbad4(t) {
        return {
            ...t,
            top: t.y,
            left: t.x,
            right: t.x + t.width,
            bottom: t.y + t.height
        };
    }
    async function $465550d5da2db0f1$export$37b6bde19b108ecc(t, e) {
        var n;
        void 0 === e && (e = {});
        const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $465550d5da2db0f1$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $465550d5da2db0f1$export$ee05aea0aeecbad4(await r.getClippingRect({
            element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
            boundary: m,
            rootBoundary: u,
            strategy: f
        })), w = "floating" === g ? {
            ...s.floating,
            x: o,
            y: i
        } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
            x: 1,
            y: 1
        }, A = $465550d5da2db0f1$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
            rect: w,
            offsetParent: v,
            strategy: f
        }) : w);
        return {
            top: (x.top - A.top + h.top) / b.y,
            bottom: (A.bottom - x.bottom + h.bottom) / b.y,
            left: (x.left - A.left + h.left) / b.x,
            right: (A.right - x.right + h.right) / b.x
        };
    }
    const $465550d5da2db0f1$var$c = Math.min, $465550d5da2db0f1$var$f = Math.max;
    function $465550d5da2db0f1$var$m(t, e, n) {
        return $465550d5da2db0f1$var$f(t, $465550d5da2db0f1$var$c(e, n));
    }
    const $465550d5da2db0f1$export$f2120bbfa5450bd2 = (n)=>({
            name: "arrow",
            options: n,
            async fn (i) {
                const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
                if (null == r) return {};
                const p = $465550d5da2db0f1$var$a(l), h = {
                    x: s,
                    y: c
                }, y = $465550d5da2db0f1$var$o(f), x = $465550d5da2db0f1$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
                let D = T ? T[R] : 0;
                D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
                const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $465550d5da2db0f1$var$m(k, B, O), H = null != $465550d5da2db0f1$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
                return {
                    [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                    data: {
                        [y]: C,
                        centerOffset: B - C
                    }
                };
            }
        }), $465550d5da2db0f1$var$g = [
        "top",
        "right",
        "bottom",
        "left"
    ], $465550d5da2db0f1$var$d = $465550d5da2db0f1$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $465550d5da2db0f1$var$p = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    function $465550d5da2db0f1$var$h(t) {
        return t.replace(/left|right|bottom|top/g, (t)=>$465550d5da2db0f1$var$p[t]);
    }
    function $465550d5da2db0f1$var$y(n, i, r) {
        void 0 === r && (r = !1);
        const a = $465550d5da2db0f1$var$t(n), l = $465550d5da2db0f1$var$o(n), s = $465550d5da2db0f1$var$e(l);
        let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
        return i.reference[s] > i.floating[s] && (c = $465550d5da2db0f1$var$h(c)), {
            main: c,
            cross: $465550d5da2db0f1$var$h(c)
        };
    }
    const $465550d5da2db0f1$var$x = {
        start: "end",
        end: "start"
    };
    function $465550d5da2db0f1$var$w(t) {
        return t.replace(/start|end/g, (t)=>$465550d5da2db0f1$var$x[t]);
    }
    const $465550d5da2db0f1$export$91fb6ecbd551914 = function(e) {
        return void 0 === e && (e = {}), {
            name: "autoPlacement",
            options: e,
            async fn (o) {
                var i, r, a;
                const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $465550d5da2db0f1$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $465550d5da2db0f1$var$d ? function(e, o, i) {
                    return (e ? [
                        ...i.filter((n)=>$465550d5da2db0f1$var$t(n) === e),
                        ...i.filter((n)=>$465550d5da2db0f1$var$t(n) !== e)
                    ] : i.filter((t)=>$465550d5da2db0f1$var$n(t) === t)).filter((n)=>!e || $465550d5da2db0f1$var$t(n) === e || !!o && $465550d5da2db0f1$var$w(n) !== n);
                }(p || null, x, h) : h, A = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
                if (null == P) return {};
                const { main: E, cross: T } = $465550d5da2db0f1$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
                if (f !== P) return {
                    reset: {
                        placement: b[0]
                    }
                };
                const D = [
                    A[$465550d5da2db0f1$var$n(P)],
                    A[E],
                    A[T]
                ], L = [
                    ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                    {
                        placement: P,
                        overflows: D
                    }
                ], k = b[R + 1];
                if (k) return {
                    data: {
                        index: R + 1,
                        overflows: L
                    },
                    reset: {
                        placement: k
                    }
                };
                const O = L.map((e)=>{
                    const n = $465550d5da2db0f1$var$t(e.placement);
                    return [
                        e.placement,
                        n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                        e.overflows
                    ];
                }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $465550d5da2db0f1$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
                return B !== f ? {
                    data: {
                        index: R + 1,
                        overflows: L
                    },
                    reset: {
                        placement: B
                    }
                } : {};
            }
        };
    };
    const $465550d5da2db0f1$export$8a83211c878a3f1f = function(e) {
        return void 0 === e && (e = {}), {
            name: "flip",
            options: e,
            async fn (o) {
                var i;
                const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $465550d5da2db0f1$var$n(r), R = $465550d5da2db0f1$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                    $465550d5da2db0f1$var$h(c)
                ] : function(t) {
                    const e = $465550d5da2db0f1$var$h(t);
                    return [
                        $465550d5da2db0f1$var$w(t),
                        e,
                        $465550d5da2db0f1$var$w(e)
                    ];
                }(c));
                d || "none" === x || E.push(...function(e, o, i, r) {
                    const a = $465550d5da2db0f1$var$t(e);
                    let l = function(t, e, n) {
                        const o = [
                            "left",
                            "right"
                        ], i = [
                            "right",
                            "left"
                        ], r = [
                            "top",
                            "bottom"
                        ], a = [
                            "bottom",
                            "top"
                        ];
                        switch(t){
                            case "top":
                            case "bottom":
                                return n ? e ? i : o : e ? o : i;
                            case "left":
                            case "right":
                                return e ? r : a;
                            default:
                                return [];
                        }
                    }($465550d5da2db0f1$var$n(e), "start" === i, r);
                    return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($465550d5da2db0f1$var$w)))), l;
                }(c, v, x, P));
                const T = [
                    c,
                    ...E
                ], D = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, b), L = [];
                let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
                if (u && L.push(D[A]), g) {
                    const { main: t, cross: e } = $465550d5da2db0f1$var$y(r, l, P);
                    L.push(D[t], D[e]);
                }
                if (k = [
                    ...k,
                    {
                        placement: r,
                        overflows: L
                    }
                ], !L.every((t)=>t <= 0)) {
                    var O, B;
                    const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                    if (e) return {
                        data: {
                            index: t,
                            overflows: k
                        },
                        reset: {
                            placement: e
                        }
                    };
                    let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                    if (!n) switch(p){
                        case "bestFit":
                            {
                                var C;
                                const t = null == (C = k.map((t)=>[
                                        t.placement,
                                        t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                    ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                                t && (n = t);
                                break;
                            }
                        case "initialPlacement":
                            n = c;
                    }
                    if (r !== n) return {
                        reset: {
                            placement: n
                        }
                    };
                }
                return {};
            }
        };
    };
    function $465550d5da2db0f1$var$A(t, e) {
        return {
            top: t.top - e.height,
            right: t.right - e.width,
            bottom: t.bottom - e.height,
            left: t.left - e.width
        };
    }
    function $465550d5da2db0f1$var$R(t) {
        return $465550d5da2db0f1$var$g.some((e)=>t[e] >= 0);
    }
    const $465550d5da2db0f1$export$fe8985bb6374093c = function(t) {
        return void 0 === t && (t = {}), {
            name: "hide",
            options: t,
            async fn (e) {
                const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
                switch(n){
                    case "referenceHidden":
                        {
                            const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                                ...o,
                                elementContext: "reference"
                            }), i.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: t,
                                    referenceHidden: $465550d5da2db0f1$var$R(t)
                                }
                            };
                        }
                    case "escaped":
                        {
                            const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                                ...o,
                                altBoundary: !0
                            }), i.floating);
                            return {
                                data: {
                                    escapedOffsets: t,
                                    escaped: $465550d5da2db0f1$var$R(t)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $465550d5da2db0f1$var$E(t) {
        const e = $465550d5da2db0f1$var$c(...t.map((t)=>t.left)), n = $465550d5da2db0f1$var$c(...t.map((t)=>t.top));
        return {
            x: e,
            y: n,
            width: $465550d5da2db0f1$var$f(...t.map((t)=>t.right)) - e,
            height: $465550d5da2db0f1$var$f(...t.map((t)=>t.bottom)) - n
        };
    }
    const $465550d5da2db0f1$export$18c8ad048e32c7d5 = function(t) {
        return void 0 === t && (t = {}), {
            name: "inline",
            options: t,
            async fn (e) {
                const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                    const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                    let o = null;
                    for(let t = 0; t < e.length; t++){
                        const i = e[t];
                        !o || i.y - o.y > o.height / 2 ? n.push([
                            i
                        ]) : n[n.length - 1].push(i), o = i;
                    }
                    return n.map((t)=>$465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(t)));
                }(h), x = $465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(h)), w = $465550d5da2db0f1$var$a(g);
                const v = await m.getElementRects({
                    reference: {
                        getBoundingClientRect: function() {
                            if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                            if (y.length >= 2) {
                                if ("x" === $465550d5da2db0f1$var$o(i)) {
                                    const t = y[0], e = y[y.length - 1], o = "top" === $465550d5da2db0f1$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                    return {
                                        top: r,
                                        bottom: a,
                                        left: l,
                                        right: s,
                                        width: s - l,
                                        height: a - r,
                                        x: l,
                                        y: r
                                    };
                                }
                                const t = "left" === $465550d5da2db0f1$var$n(i), e = $465550d5da2db0f1$var$f(...y.map((t)=>t.right)), r = $465550d5da2db0f1$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                                return {
                                    top: l,
                                    bottom: s,
                                    left: r,
                                    right: e,
                                    width: e - r,
                                    height: s - l,
                                    x: r,
                                    y: l
                                };
                            }
                            return x;
                        }
                    },
                    floating: r.floating,
                    strategy: u
                });
                return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                    reset: {
                        rects: v
                    }
                } : {};
            }
        };
    };
    const $465550d5da2db0f1$export$cc800923e997bb8 = function(e) {
        return void 0 === e && (e = 0), {
            name: "offset",
            options: e,
            async fn (i) {
                const { x: r, y: a } = i, l = await async function(e, i) {
                    const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $465550d5da2db0f1$var$n(r), f = $465550d5da2db0f1$var$t(r), m = "x" === $465550d5da2db0f1$var$o(r), u = [
                        "left",
                        "top"
                    ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                    let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                        mainAxis: d,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : {
                        mainAxis: 0,
                        crossAxis: 0,
                        alignmentAxis: null,
                        ...d
                    };
                    return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                        x: h * g,
                        y: p * u
                    } : {
                        x: p * u,
                        y: h * g
                    };
                }(i, e);
                return {
                    x: r + l.x,
                    y: a + l.y,
                    data: l
                };
            }
        };
    };
    function $465550d5da2db0f1$var$L(t) {
        return "x" === t ? "y" : "x";
    }
    const $465550d5da2db0f1$export$fba63a578e423eb = function(t) {
        return void 0 === t && (t = {}), {
            name: "shift",
            options: t,
            async fn (e) {
                const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                    fn: (t)=>{
                        let { x: e, y: n } = t;
                        return {
                            x: e,
                            y: n
                        };
                    }
                }, ...u } = t, g = {
                    x: i,
                    y: r
                }, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(e, u), p = $465550d5da2db0f1$var$o($465550d5da2db0f1$var$n(a)), h = $465550d5da2db0f1$var$L(p);
                let y = g[p], x = g[h];
                if (l) {
                    const t = "y" === p ? "bottom" : "right";
                    y = $465550d5da2db0f1$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
                }
                if (c) {
                    const t = "y" === h ? "bottom" : "right";
                    x = $465550d5da2db0f1$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
                }
                const w = f.fn({
                    ...e,
                    [p]: y,
                    [h]: x
                });
                return {
                    ...w,
                    data: {
                        x: w.x - i,
                        y: w.y - r
                    }
                };
            }
        };
    }, $465550d5da2db0f1$export$7bf07e38f3dc4b69 = function(t) {
        return void 0 === t && (t = {}), {
            options: t,
            fn (e) {
                const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                    x: i,
                    y: r
                }, g = $465550d5da2db0f1$var$o(a), d = $465550d5da2db0f1$var$L(g);
                let p = u[g], h = u[d];
                const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                    mainAxis: y,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...y
                };
                if (f) {
                    const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                    p < e ? p = e : p > n && (p = n);
                }
                if (m) {
                    var w, v;
                    const t = "y" === g ? "width" : "height", e = [
                        "top",
                        "left"
                    ].includes($465550d5da2db0f1$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                    h < o ? h = o : h > i && (h = i);
                }
                return {
                    [g]: p,
                    [d]: h
                };
            }
        };
    }, $465550d5da2db0f1$export$346677f925de839c = function(e) {
        return void 0 === e && (e = {}), {
            name: "size",
            options: e,
            async fn (i) {
                const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(i, g), p = $465550d5da2db0f1$var$n(r), h = $465550d5da2db0f1$var$t(r), y = "x" === $465550d5da2db0f1$var$o(r), { width: x, height: w } = a.floating;
                let v, b;
                "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
                const A = w - d[v], R = x - d[b];
                let P = A, E = R;
                if (y ? E = $465550d5da2db0f1$var$c(x - d.right - d.left, R) : P = $465550d5da2db0f1$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                    const t = $465550d5da2db0f1$var$f(d.left, 0), e = $465550d5da2db0f1$var$f(d.right, 0), n = $465550d5da2db0f1$var$f(d.top, 0), o = $465550d5da2db0f1$var$f(d.bottom, 0);
                    y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $465550d5da2db0f1$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $465550d5da2db0f1$var$f(d.top, d.bottom));
                }
                await u({
                    ...i,
                    availableWidth: E,
                    availableHeight: P
                });
                const T = await l.getDimensions(m.floating);
                return x !== T.width || w !== T.height ? {
                    reset: {
                        rects: !0
                    }
                } : {};
            }
        };
    };
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $h3gNz;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("h3gNz")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("h3gNz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3cbc87a7256e0c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $9uJ4X;
    const $a3cbc87a7256e0c1$var$StateManagedSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const baseSelectProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...baseSelectProps
        });
    });
    var $a3cbc87a7256e0c1$export$2e2bcd8739ae039 = $a3cbc87a7256e0c1$var$StateManagedSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('safari') && !ua.includes('chrome');
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if ((!inputValue || inputValue === prevInputValue.current) && isA11yImprovementEnabled) return '';
            prevInputValue.current = inputValue;
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isAppleDevice: isAppleDevice,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isAppleDevice,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu' && isAppleDevice) {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("1ErJq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$609735830782207d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $VSDnB;
    var $f8Sb3;
    function $609735830782207d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id })=>{
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            event.currentTarget.focus();
            if (onClick) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: [
                $609735830782207d$var$sharedColorContainerStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorContainerSize : $609735830782207d$var$defaultColorContainerSize,
                $609735830782207d$var$colorCardButtonStyles,
                expanded && !(0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-dsp-20821-color-pickr-focus') && $609735830782207d$var$colorCardButtonFocusedStyles
            ],
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $609735830782207d$var$colorCardWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $609735830782207d$var$colorCardContentStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorCardContentSize : $609735830782207d$var$defaultColorCardContentSize
            ],
            style: {
                background: value || 'transparent'
            }
        }))));
    };
    var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
    const $609735830782207d$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: '6px',
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $609735830782207d$var$smallColorContainerSize = {
        name: "1435ao5",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
    };
    const $609735830782207d$var$defaultColorContainerSize = {
        name: "1uafl10",
        styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
    };
    const $609735830782207d$var$colorCardButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover': {
            borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        },
        ':not(:focus):hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            outline: 'none'
        }
    });
    const $609735830782207d$var$colorCardButtonFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        outline: 'none'
    });
    const $609735830782207d$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $609735830782207d$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
    const $609735830782207d$var$smallColorCardContentSize = {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    };
    const $609735830782207d$var$defaultColorCardContentSize = {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    };
});
parcelRegister("jKrb6", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$b794a85d007e2dce$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "Option", ()=>$b794a85d007e2dce$export$36d18380658d5d20);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$b794a85d007e2dce$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "Placeholder", ()=>$b794a85d007e2dce$export$84712d0562a614b8);
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $koVbs;
    var $7oXeG = parcelRequire("7oXeG");
    function $b794a85d007e2dce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
        const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorPaletteContainerStyles,
            role: "listbox",
            "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
            style: {
                maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
            },
            ref: innerRef
        }, children);
    };
    const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
        const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorCardWrapperStyles,
            ...innerProps,
            "aria-label": label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing
        }));
    };
    const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
    const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
    const $b794a85d007e2dce$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $b794a85d007e2dce$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
});
parcelRegister("l0sd0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d681a23420d49946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eJbwP;
    var $3bDjY;
    var $f8Sb3;
    var $bWn3s;
    function $d681a23420d49946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d681a23420d49946$var$ColorCard = (0, $5uXOq.forwardRef)((props, componentRef)=>{
        const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown } = props;
        const ref = (0, $5uXOq.useRef)(null);
        const isInitialFocus = (0, $5uXOq.useRef)(true);
        const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) {
                event.preventDefault();
                onClick(event, value);
            }
        }, [
            onClick,
            value
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
                event.preventDefault();
                if (isTabbing) event.stopPropagation();
                onClick(event, value);
            }
            if (isColorPaletteMenu) onKeyDown?.(event);
            else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, [
            isColorPaletteMenu,
            isTabbing,
            value,
            onClick,
            onKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
                focus: ()=>{
                    if (isColorPaletteMenu) {
                        if (isInitialFocus.current) {
                            autoFocus && !initialFocusRef && ref.current?.focus();
                            isInitialFocus.current = false;
                        } else ref.current?.focus();
                    }
                }
            }), [
            autoFocus,
            isColorPaletteMenu,
            initialFocusRef
        ]);
        const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
        const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
        const ariaChecked = isColorPaletteMenu ? selected : undefined;
        const ariaLabel = isColorPaletteMenu ? label : undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                css: [
                    $d681a23420d49946$var$sharedColorContainerStyles,
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && $d681a23420d49946$var$colorCardOptionTabbingStyles,
                    focused && (isColorPaletteMenu || !isTabbing) && $d681a23420d49946$var$colorCardOptionFocusedStyles
                ],
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardContentStyles,
                style: {
                    background: value || 'transparent'
                }
            }, selected && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJbwP"))))), {
                color: checkMarkColor,
                label: "",
                spacing: "spacious",
                LEGACY_margin: "1px"
            }))));
        });
    });
    var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
    const $d681a23420d49946$var$colorCardOptionTabbingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
        }
    });
    const $d681a23420d49946$var$colorCardOptionFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
    });
    const $d681a23420d49946$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-border-radius-200, 6px)",
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $d681a23420d49946$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $d681a23420d49946$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
});
parcelRegister("eJbwP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));
    var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>$ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
        }, props));
    $ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';
parcelRegister("bWn3s", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$8b16fea90e636ddb$export$c9058316764c140e);
    var $dv0OY;
    var $3XwZB;
    function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
        return (0, (0, parcelRequire("3XwZB")).createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
    }
});
parcelRegister("3XwZB", function(module, exports) {
    $parcel$export(module.exports, "createCallbackRef", ()=>$2e2079715de82b22$export$35a19128eb4acba4);
    function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
        let current = null;
        return {
            get current () {
                return current;
            },
            set current (value){
                const last = current;
                if (last !== value) {
                    current = value;
                    callback(value, last);
                }
            }
        };
    }
});
parcelRegister("5dAp2", function(module, exports) {
    $parcel$export(module.exports, "getWidth", ()=>$38874a93fb14a10d$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getOptions", ()=>$38874a93fb14a10d$export$d2312e68e1f5ad00);
    var $k5uoT;
    var $8QpSo;
    var $kD00A = parcelRequire("kD00A");
    const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
        const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, (0, parcelRequire("k5uoT")).gridSize)() / 2);
        return mode === (0, $kD00A.Mode).Standard ? width + (0, (0, parcelRequire("k5uoT")).gridSize)() : width;
    };
    const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((palette, selectedColor, showDefaultSwatchColor)=>{
        let focusedItemIndex = 0;
        let defaultSelectedColor = palette[0];
        if (!showDefaultSwatchColor) defaultSelectedColor = {
            label: '',
            value: ''
        };
        const value = palette.find((color, index)=>{
            if (color.value === selectedColor) {
                focusedItemIndex = index;
                return true;
            }
            return false;
        }) || defaultSelectedColor;
        return {
            options: palette,
            value: value,
            focusedItemIndex: focusedItemIndex
        };
    });
});
parcelRegister("kD00A", function(module, exports) {
    $parcel$export(module.exports, "Mode", ()=>$e25de60b37efd75a$export$9484bbecc3c49a2e);
    var $e25de60b37efd75a$export$9484bbecc3c49a2e;
    (function(Mode) {
        Mode[Mode["Compact"] = 0] = "Compact";
        Mode[Mode["Standard"] = 1] = "Standard";
    })($e25de60b37efd75a$export$9484bbecc3c49a2e || ($e25de60b37efd75a$export$9484bbecc3c49a2e = {}));
});
parcelRegister("7oXeG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d42a6da5a6d06680$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colorPickerAriaLabel: {
            id: 'jira.color-picker.src.color-picker-aria-label',
            defaultMessage: '{color} selected, {message}',
            description: 'This text is used as aria-label text in color picker component'
        },
        menuListAriaLabel: {
            id: 'jira.color-picker.src.menu-list-aria-label',
            defaultMessage: 'Color picker list',
            description: 'This text is used as aria-label text for the listbox element in color picker component'
        }
    });
});
parcelRegister("lGTQx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5e30770a4da4328$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kD00A = parcelRequire("kD00A");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    function $c5e30770a4da4328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef })=>{
        const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
        const fullLabel = `${label}, ${selectedValue.label} selected`;
        const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
        const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
        const createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
        const changeAnalyticsCaller = ()=>{
            if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-palette-menu',
                attributes: {
                    componentName: 'color-picker',
                    packageName: "platform-pkg",
                    packageVersion: "0.0.0-use.local"
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
        const handleChange = (event, value)=>{
            onChange(event, value, changeAnalyticsCaller());
        };
        (0, $5uXOq.useEffect)(()=>{
            colorCardRefs[focusedIndex]?.focus();
        }, [
            focusedIndex,
            colorCardRefs
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const numItems = options.length;
            switch(event.key){
                case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
                case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                    setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
                case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                    setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                    if (isFocusLockEnabled) {
                        event.preventDefault();
                        event.stopPropagation();
                        setFocusedIndex(selectedColorIndex);
                    }
                    break;
                default:
                    break;
            }
        }, [
            isFocusLockEnabled,
            selectedColorIndex,
            setFocusedIndex,
            options
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-label": fullLabel,
            role: isInsideMenu ? 'menu' : 'radiogroup',
            css: [
                $c5e30770a4da4328$var$colorPaletteMenuStyles,
                mode === (0, $kD00A.Mode).Standard && $c5e30770a4da4328$var$colorPaletteMenuStandardStyles
            ],
            style: {
                width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $c5e30770a4da4328$var$colorPaletteContainerStyles,
                mode === (0, $kD00A.Mode).Compact && $c5e30770a4da4328$var$colorPaletteContainerCompactStyles
            ]
        }, options.map(({ label: label, value: value }, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $c5e30770a4da4328$var$colorCardWrapperStyles,
                key: value
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
                type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                label: label,
                value: value,
                checkMarkColor: checkMarkColor,
                isOption: true,
                selected: value === selectedValue.value,
                onClick: handleChange,
                ref: (ref)=>{
                    colorCardRefs[index] = ref;
                },
                autoFocus: autoFocus,
                initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                isInsideMenu: isInsideMenu,
                onKeyDown: handleKeyDown
            })))));
    };
    var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    })((0, (0, parcelRequire("cb25w")).default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
    const $c5e30770a4da4328$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = {
        name: "h6te2n",
        styles: "padding:var(--ds-space-0, 0)"
    };
    const $c5e30770a4da4328$var$colorPaletteMenuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'relative',
        margin: "var(--ds-space-0, 0)",
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}, 0 0 8px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}`})`
    });
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("6qrUW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4adad3971ebc70ba$var$_react = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4adad3971ebc70ba$var$_showMoreHorizontal = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("8U6zd")));
    function $4adad3971ebc70ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4adad3971ebc70ba$var$EditorMoreIcon = (props)=>$4adad3971ebc70ba$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
        }, props, {
            newIcon: $4adad3971ebc70ba$var$_showMoreHorizontal.default
        }));
    $4adad3971ebc70ba$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
    var $4adad3971ebc70ba$var$_default = module.exports.default = $4adad3971ebc70ba$var$EditorMoreIcon;
});
parcelRegister("e9QkH", function(module, exports) {
    $parcel$export(module.exports, "useSwitchModals", ()=>$bbe85969245206f0$export$5ed4b99cbad4ebd6);
    var $2qauD;
    const { useSwitch: $bbe85969245206f0$var$useSwitch } = (0, (0, parcelRequire("2qauD")).createSwitchController)('jira-switch-modals');
    const $bbe85969245206f0$export$5ed4b99cbad4ebd6 = $bbe85969245206f0$var$useSwitch;
});
parcelRegister("2qauD", function(module, exports) {
    $parcel$export(module.exports, "createSwitchController", ()=>$a539fc33301c42ee$export$1856548326159ec8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7JoAD = parcelRequire("7JoAD");
    const $a539fc33301c42ee$export$1856548326159ec8 = (name, activeByDefault)=>{
        const actions = {
            on: (active)=>({ setState: setState })=>setState({
                        active: active
                    }),
            off: (active)=>({ setState: setState, getState: getState })=>{
                    if (getState().active === active || active === undefined) setState({
                        active: undefined
                    });
                },
            toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                    if (getState().active === active) dispatch(actions.off(active));
                    else dispatch(actions.on(active));
                }
        };
        const initialState = {
            active: activeByDefault
        };
        const store = (0, $7JoAD.createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const SwitchContainer = (0, $7JoAD.createContainer)(store);
        const selector = (state, key)=>state.active === key;
        const useSwitchInternal = (0, $7JoAD.createHook)(store, {
            selector: selector
        });
        const useSwitch = (active)=>{
            const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
            const on = (0, $5uXOq.useCallback)(()=>onSwitch(active), [
                onSwitch,
                active
            ]);
            const off = (0, $5uXOq.useCallback)(()=>offSwitch(active), [
                active,
                offSwitch
            ]);
            const toggle = (0, $5uXOq.useCallback)(()=>toggleSwitch(active), [
                toggleSwitch,
                active
            ]);
            return [
                isActive,
                {
                    on: on,
                    off: off,
                    toggle: toggle
                }
            ];
        };
        return {
            SwitchContainer: SwitchContainer,
            useSwitch: useSwitch
        };
    };
});
parcelRegister("lQvIi", function(module, exports) {
    $parcel$export(module.exports, "DeleteGadgetModal", ()=>$8aabe587794829c1$export$80937f1cc474f594);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $lfTZh;
    var $e9QkH;
    var $kxZPA;
    const $8aabe587794829c1$var$AsyncDeleteGadgetModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("ffKWD")), {
        moduleId: "./src/packages/global-pages/dashboard/edit/src/ui/gadget-editable/config-dropdown/delete-gadget-modal/main.tsx"
    });
    const $8aabe587794829c1$export$80937f1cc474f594 = ({ id: id, onDeleteGadget: onDeleteGadget, gadgetName: gadgetName, onClose: onClose })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)(id);
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "delete-gadget-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aabe587794829c1$var$AsyncDeleteGadgetModal, {
            gadgetName: gadgetName,
            onClose: ()=>{
                close();
                onClose?.();
            },
            onDeleteGadget: onDeleteGadget
        })) : null;
    };
});
parcelRegister("ffKWD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8Pcm9")
    ]).then(()=>parcelRequire('3uEJK'));
});
parcelRegister("44DPy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84fb4298c31695e7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $84fb4298c31695e7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreActions: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.more-actions",
            "defaultMessage": "More actions for {gadgetTitle} gadget"
        },
        expand: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.expand",
            "defaultMessage": "Expand"
        },
        maximize: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.maximize",
            "defaultMessage": "Maximize"
        },
        restore: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.restore",
            "defaultMessage": "Restore"
        },
        delete: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.delete",
            "defaultMessage": "Delete"
        },
        configure: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.configure",
            "defaultMessage": "Configure"
        },
        rename: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.rename",
            "defaultMessage": "Rename"
        },
        duplicate: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.duplicate",
            "defaultMessage": "Duplicate"
        },
        colorHeading: {
            "id": "dashboard-edit.gadget-editable.config-dropdown.color-heading",
            "defaultMessage": "Highlight color"
        }
    });
});
parcelRegister("g5A8z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$351b39883f35264f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $351b39883f35264f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rename: {
            "id": "dashboard-edit.gadget-editable.rename",
            "defaultMessage": "Rename {gadgetName}"
        }
    });
});
parcelRegister("jbkj1", function(module, exports) {
    $parcel$export(module.exports, "TitleEditor", ()=>$efd577c3c79b10d7$export$b7ae68644199241a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $78tet;
    var $bopR4;
    var $kgoHi;
    var $8CUq3;
    var $kY99m;
    var $koVbs;
    var $9AZKr;
    const $efd577c3c79b10d7$export$b7ae68644199241a = ({ isRenamable: isRenamable, isRenaming: isRenaming, title: title, onConfirmEdit: onConfirmEdit, onCancelEdit: onCancelEdit, onEdit: onEdit, editButtonLabel: editButtonLabel, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return !isRenamable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, !isRenaming && (0, ($parcel$interopDefault($5uXOq))).createElement($efd577c3c79b10d7$var$DragHandlerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("78tet"))))), {
            label: formatMessage((0, (0, parcelRequire("9AZKr")).default).dragLabel),
            primaryColor: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N80})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($efd577c3c79b10d7$var$InlineEditWrapper, {
            "data-testid": "dashboard-edit.ui.gadget-editable.title-editor.inline-edit-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bopR4")).default), {
            label: "",
            defaultValue: title,
            isEditing: isRenaming,
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                    ...fieldProps,
                    "aria-label": "Edit gadget title text input",
                    testId: "dashboard-edit.ui.gadget-editable.title-editor.text-input"
                }),
            readView: ()=>children,
            onConfirm: onConfirmEdit,
            onCancel: onCancelEdit,
            readViewFitContainerWidth: true,
            onEdit: onEdit,
            editButtonLabel: editButtonLabel
        })));
    };
    const $efd577c3c79b10d7$var$DragHandlerWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $efd577c3c79b10d7$var$dragHandlerWrapperStyles
        }, children);
    const $efd577c3c79b10d7$var$dragHandlerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexShrink: 0
    });
    const $efd577c3c79b10d7$var$InlineEditWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _80om1kdv _6u9n1osq _wb9k78py",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("78tet", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $531ff4bbcd008815$var$_dragHandle = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("idRxN")));
    function $531ff4bbcd008815$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>$531ff4bbcd008815$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
        }, props, {
            newIcon: $531ff4bbcd008815$var$_dragHandle.default
        }));
    $531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
    var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;
});
parcelRegister("idRxN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d442f9a78d3217d7$var$_react = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d442f9a78d3217d7$var$_UNSAFE_baseNew = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d442f9a78d3217d7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d442f9a78d3217d7$var$DragHandleIcon = (props)=>$d442f9a78d3217d7$var$_react.default.createElement($d442f9a78d3217d7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
        }, props));
    $d442f9a78d3217d7$var$DragHandleIcon.displayName = 'DragHandleIcon';
    var $d442f9a78d3217d7$var$_default = module.exports.default = $d442f9a78d3217d7$var$DragHandleIcon;
});
parcelRegister("bopR4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fb3572edb783a8f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $7O4UO;
    var $efXp3;
    var $VSDnB;
    var $5ILhZ;
    var $jldZL;
    var $1PDuf;
    var $pZGLJ;
    var $6LLMl;
    function $9fb3572edb783a8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9fb3572edb783a8f$var$fieldStyles = {
        name: "nziz0a",
        styles: "max-width:100%;position:relative"
    };
    const $9fb3572edb783a8f$var$analyticsAttributes = {
        componentName: 'inlineEdit',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
        const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
        const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
        const isControlled = typeof isEditing === 'undefined';
        const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
        const timerRef = (0, $5uXOq.useRef)();
        const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, (0, parcelRequire("pZGLJ")).default)(isEditing, isEditingState);
        const onCancel = (0, $5uXOq.useCallback)(()=>{
            if (isControlled) setEditingState(false);
            providedOnCancel?.();
        }, [
            isControlled,
            providedOnCancel
        ]);
        const onEditRequested = (0, $5uXOq.useCallback)(()=>{
            if (isControlled) setEditingState(true);
            providedOnEdit?.();
            if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
        }, [
            isControlled,
            shouldBeEditing,
            editViewRef,
            providedOnEdit
        ]);
        const onConfirm = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                if (isControlled) setEditingState(false);
                providedOnConfirm(value, analyticsEvent);
            },
            action: 'confirmed',
            analyticsData: analyticsContext,
            ...$9fb3572edb783a8f$var$analyticsAttributes
        });
        const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            onCancel();
        }, [
            onCancel
        ]);
        const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
            if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
                doNotFocusOnEditButton();
                if (formRef.current.checkValidity()) onSubmit();
            }
        }, [
            doNotFocusOnEditButton
        ]);
        const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
            if (!keepEditViewOpenOnBlur) {
                wasFocusReceivedSinceLastBlurRef.current = false;
                timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
            }
        }, [
            keepEditViewOpenOnBlur,
            tryAutoSubmitWhenBlur
        ]);
        const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
            wasFocusReceivedSinceLastBlurRef.current = true;
        }, []);
        const concatenatedEditButtonLabel = ()=>{
            if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
            return `${editButtonLabel}, ${editLabel}`;
        };
        const renderReadView = ()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6LLMl")).default), {
                editButtonLabel: concatenatedEditButtonLabel(),
                onEditRequested: onEditRequested,
                postReadViewClick: doNotFocusOnEditButton,
                editButtonRef: editButtonRef,
                readViewFitContainerWidth: readViewFitContainerWidth,
                readView: readView,
                testId: testId
            });
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("efXp3")).default), {
            onSubmit: (data)=>onConfirm(data.inlineEdit)
        }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("form", {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef
            }, shouldBeEditing ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7O4UO")).default), {
                name: "inlineEdit",
                label: label,
                defaultValue: defaultValue,
                validate: validate,
                isRequired: isRequired,
                key: "edit-view"
            }, ({ fieldProps: fieldProps, error: error })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $9fb3572edb783a8f$var$fieldStyles,
                    onBlur: (e)=>{
                        if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                    },
                    onFocus: onEditViewWrapperFocus
                }, editView({
                    ...fieldProps,
                    errorMessage: error
                }, editViewRef), !hideActionButtons ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1PDuf")).default), {
                    testId: testId,
                    cancelButtonLabel: cancelButtonLabel,
                    confirmButtonLabel: confirmButtonLabel,
                    onMouseDown: ()=>{
                        doNotFocusOnEditButton();
                    },
                    onCancelClick: (e)=>{
                        reset();
                        onCancelClick(e);
                    }
                }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    hidden: true,
                    type: "submit"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, "Submit")))) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7O4UO")).default), {
                name: "inlineEdit",
                label: label,
                defaultValue: "",
                isRequired: isRequired,
                key: "read-view"
            }, renderReadView)));
    };
    const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)($9fb3572edb783a8f$var$InnerInlineEdit, props);
    };
    var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("1PDuf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55d92d54fb10d87e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $42CjB;
    var $kbxJz;
    var $lLLkM;
    function $55d92d54fb10d87e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $55d92d54fb10d87e$var$buttonsContainerStyles = {
        name: "ki22df",
        styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
    };
    const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: "var(--ds-space-400, 32px)",
        zIndex: 200,
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&:last-child': {
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        '& > button': {
            backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
        },
        '& > button:hover': {
            backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
        },
        '& > button:active': {
            backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }
    });
    const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $55d92d54fb10d87e$var$buttonsContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $55d92d54fb10d87e$var$buttonWrapperBaseStyles,
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            type: "submit",
            icon: (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("kbxJz"))))), {
                    ...iconProps,
                    size: "small"
                }),
            onMouseDown: onMouseDown,
            label: confirmButtonLabel,
            testId: testId && `${testId}--confirm`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $55d92d54fb10d87e$var$buttonWrapperBaseStyles,
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            icon: (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                    ...iconProps,
                    size: "small"
                }),
            label: cancelButtonLabel,
            onClick: onCancelClick,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}--cancel`
        })));
    };
    var $55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;
});
parcelRegister("kbxJz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb1f0098e5a023eb$var$CheckIcon = (props)=>$eb1f0098e5a023eb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
        }, props, {
            newIcon: $eb1f0098e5a023eb$var$_checkMark.default
        }));
    $eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
    var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;
});
parcelRegister("pZGLJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5aa752dd00081f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d5aa752dd00081f6$var$usePrevious = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
        const editButtonRef = (0, $5uXOq.useRef)(null);
        const editViewRef = (0, $5uXOq.useRef)();
        const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
        const isControlled = typeof isEditing === 'undefined';
        const shouldBeEditing = isControlled ? isEditingState : isEditing;
        const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
        (0, $5uXOq.useEffect)(()=>{
            if (isEditingState && editViewRef.current) editViewRef.current.focus();
        }, [
            editViewRef,
            isEditingState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (prevIsEditing && !shouldBeEditing) {
                if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
                else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
            }
        }, [
            prevIsEditing,
            shouldBeEditing
        ]);
        const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
        return {
            editButtonRef: editButtonRef,
            editViewRef: editViewRef,
            shouldBeEditing: shouldBeEditing,
            doNotFocusOnEditButton: doNotFocusOnEditButton
        };
    };
    var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;
});
parcelRegister("6LLMl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ba9adf9a6463766$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5ILhZ;
    var $8CUq3;
    function $1ba9adf9a6463766$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1ba9adf9a6463766$var$readViewContainerStyles = {
        name: "1xe63ku",
        styles: "line-height:1"
    };
    const $1ba9adf9a6463766$var$editButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'block',
        margin: 'space.0',
        padding: 'space.0',
        appearance: 'none',
        background: 'transparent',
        border: 0,
        lineHeight: 1,
        outline: 0,
        ':focus-visible': {
            outline: 0
        },
        ':focus + div': {
            borderColor: 'color.border.focused',
            borderWidth: 'border.width.outline',
            borderStyle: 'solid'
        }
    });
    const $1ba9adf9a6463766$var$readViewWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        boxSizing: 'border-box',
        width: 'auto',
        maxWidth: '100%',
        border: '2px solid transparent',
        borderRadius: "var(--ds-border-radius, 3px)",
        transition: 'background 0.2s',
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        }
    });
    const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
    const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
        const startX = (0, $5uXOq.useRef)(0);
        const startY = (0, $5uXOq.useRef)(0);
        const mouseHasMovedAfterMouseDown = (event)=>{
            return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
        };
        const onReadViewClick = (event)=>{
            const element = event.target;
            if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
                event.preventDefault();
                onEditRequested();
                postReadViewClick();
            }
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1ba9adf9a6463766$var$readViewContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $1ba9adf9a6463766$var$editButtonStyles,
            onClick: onEditRequested,
            ref: editButtonRef,
            testId: testId && `${testId}--edit-button`,
            "aria-label": editButtonLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1ba9adf9a6463766$var$readViewWrapperStyles,
                readViewFitContainerWidth && $1ba9adf9a6463766$var$readViewFitContainerWidthStyles
            ],
            role: "presentation",
            onClick: onReadViewClick,
            onMouseDown: (e)=>{
                startX.current = e.clientX;
                startY.current = e.clientY;
            },
            "data-read-view-fit-container-width": readViewFitContainerWidth
        }, readView()));
    };
    var $1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("9AZKr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be24aee7105b9562$export$2e2bcd8739ae039);
    var $7VHMR;
    var $be24aee7105b9562$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dragLabel: {
            "id": "dashboard-edit.gadget-editable.title-editor.drag-label",
            "defaultMessage": "Drag to move gadget"
        }
    });
});
parcelRegister("49IUu", function(module, exports) {
    $parcel$export(module.exports, "useGadgetTitleChangeErrorFlag", ()=>$3d56e7ee629c6c9b$export$be3e1e1bb367fdda);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $7HGHK;
    var $c7hyj;
    const $3d56e7ee629c6c9b$export$be3e1e1bb367fdda = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, $5uXOq.useCallback)(()=>{
            showFlag({
                key: (0, (0, parcelRequire("7HGHK")).toFlagId)('gadgetTitleError'),
                type: 'error',
                title: (0, (0, parcelRequire("c7hyj")).default).errorFlagTitle,
                description: (0, (0, parcelRequire("c7hyj")).default).errorFlagDescription,
                actions: [
                    {
                        content: (0, (0, parcelRequire("c7hyj")).default).errorFlagAction,
                        onClick: ()=>window.location.reload()
                    }
                ]
            });
        }, [
            showFlag
        ]);
    };
});
parcelRegister("c7hyj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7e18ad0be6298b7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7e18ad0be6298b7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "dashboard-edit.gadget-editable.utils.error-flag-title",
            "defaultMessage": "Error saving gadget name"
        },
        errorFlagDescription: {
            "id": "dashboard-edit.gadget-editable.utils.error-flag-description",
            "defaultMessage": "Refresh the page and try again"
        },
        errorFlagAction: {
            "id": "dashboard-edit.gadget-editable.utils.error-flag-action",
            "defaultMessage": "Refresh"
        }
    });
});
parcelRegister("fVBqv", function(module, exports) {
    $parcel$export(module.exports, "AsyncAddGadgetPanel", ()=>$4367ed7a6cc463d2$export$6fe03cad6a67ebf8);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $wlDl0;
    var $GQeXq;
    var $8SHRg;
    var $b6VJM;
    var $ePdfe;
    const $4367ed7a6cc463d2$export$9c81367ce7c2e6b = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("qnxVY")), {
        moduleId: "./src/packages/global-pages/dashboard/edit/src/ui/header-editable/add-gadget-button/add-gadget-panel/main.tsx"
    });
    const $4367ed7a6cc463d2$export$6fe03cad6a67ebf8 = ()=>{
        const { isOpen: isRightPanelOpen } = (0, (0, parcelRequire("GQeXq")).useRightPanelState)();
        if (isRightPanelOpen === false) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "add-gadget",
            packageName: (0, (0, parcelRequire("wlDl0")).PACKAGE_NAME),
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).ADD_GADGET_EXPERIENCE),
                reason: 'AsyncAddGadgetPanel ErrorBoundary'
            },
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ePdfe")).PanelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6VJM")).Fallback), {
                    type: (0, (0, parcelRequire("b6VJM")).FALLBACK_TYPE).ERROR
                })),
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-gadget-panel",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8SHRg")).AddGadgetPanelSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4367ed7a6cc463d2$export$9c81367ce7c2e6b, null)));
    };
});
parcelRegister("8SHRg", function(module, exports) {
    $parcel$export(module.exports, "AddGadgetPanelSkeleton", ()=>$dd4abd02e6dc3342$export$c0396ff9a79b8c7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $dd4abd02e6dc3342$export$c0396ff9a79b8c7a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "100%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "20px",
            width: "100%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "40px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "calc(100% - 60px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "40px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "calc(100% - 60px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "40px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "calc(100% - 60px)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "40px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($dd4abd02e6dc3342$var$Skeleton, {
            height: "40px",
            width: "calc(100% - 60px)"
        })));
    const $dd4abd02e6dc3342$var$shimmer = null;
    const $dd4abd02e6dc3342$var$Skeleton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_dfjz0w": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.height}`),
                "--_1icprf0": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i16wa _1bsbb8e1 _2rko1y44 _18s8zu5n _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1yrq _1itknyvn _12vemgnk",
                __cmplp.className
            ])
        });
    });
    const $dd4abd02e6dc3342$var$GadgetSkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _1bsb1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $dd4abd02e6dc3342$var$GadgetSkeletonItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("b6VJM", function(module, exports) {
    $parcel$export(module.exports, "FALLBACK_TYPE", ()=>$d06366a77dbe58fd$export$a5e1f3074f2a926d);
    $parcel$export(module.exports, "Fallback", ()=>$d06366a77dbe58fd$export$fb8d7f40caaeea67);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $7q5TP;
    var $fC09Q;
    var $koVbs;
    var $xOZPZ;
    const $d06366a77dbe58fd$export$a5e1f3074f2a926d = {
        ERROR: 'ERROR',
        NOTFOUND: 'NOTFOUND'
    };
    const $d06366a77dbe58fd$var$FALLBACK_ERROR_IMAGE_SIZE = 84;
    const $d06366a77dbe58fd$export$fb8d7f40caaeea67 = ({ type: type })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (type === $d06366a77dbe58fd$export$a5e1f3074f2a926d.ERROR) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            xcss: $d06366a77dbe58fd$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7q5TP")).default), {
            alt: formatMessage((0, (0, parcelRequire("xOZPZ")).default).errorTitle),
            width: $d06366a77dbe58fd$var$FALLBACK_ERROR_IMAGE_SIZE
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d06366a77dbe58fd$var$textWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.accent.gray",
            size: "UNSAFE_small",
            weight: "bold"
        }, formatMessage((0, (0, parcelRequire("xOZPZ")).default).errorMessage))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            xcss: $d06366a77dbe58fd$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fC09Q")).default), {
            alt: formatMessage((0, (0, parcelRequire("xOZPZ")).default).emptyTitle),
            width: $d06366a77dbe58fd$var$FALLBACK_ERROR_IMAGE_SIZE
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d06366a77dbe58fd$var$textWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.accent.gray",
            size: "UNSAFE_small",
            weight: "bold"
        }, formatMessage((0, (0, parcelRequire("xOZPZ")).default).emptyMessage))));
    };
    const $d06366a77dbe58fd$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.300',
        marginBottom: 'space.200',
        textAlign: 'center',
        color: 'color.text.accent.gray'
    });
    const $d06366a77dbe58fd$var$textWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.300'
    });
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("xOZPZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1179501de393075$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c1179501de393075$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-message",
            "defaultMessage": "We're having some trouble getting all available gadgets, please try again later"
        },
        errorTitle: {
            "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.error-title",
            "defaultMessage": "Error"
        },
        emptyTitle: {
            "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-title",
            "defaultMessage": "We couldn\u2019t find any gadgets."
        },
        emptyMessage: {
            "id": "dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.fallback.empty-message",
            "defaultMessage": "No gadgets matched your search. Try again with different keywords."
        }
    });
});
parcelRegister("ePdfe", function(module, exports) {
    $parcel$export(module.exports, "PanelContainer", ()=>$a07bae344cb3fd25$export$7c4d2b536147788a);
    $parcel$export(module.exports, "PanelHeaderContainer", ()=>$a07bae344cb3fd25$export$90c3cb85c6ca5262);
    $parcel$export(module.exports, "PanelContentContainer", ()=>$a07bae344cb3fd25$export$f69c7d78cc611ef3);
    $parcel$export(module.exports, "Header", ()=>$a07bae344cb3fd25$export$8b251419efc915eb);
    $parcel$export(module.exports, "CategoryLozengeGroup", ()=>$a07bae344cb3fd25$export$dd826bcc21f46caa);
    $parcel$export(module.exports, "CategoryLozengeClickable", ()=>$a07bae344cb3fd25$export$c7b4c423388a9a6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $44v1T;
    const $a07bae344cb3fd25$export$7c4d2b536147788a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1s93bfy": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1reo15vq _18m915vq _4t3i1l47 _1kl71osx",
                __cmplp.className
            ])
        });
    });
    const $a07bae344cb3fd25$export$90c3cb85c6ca5262 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _2lx2vrvc _1bsb1osq _kqsw1if8 _1yt41rfa _154iidpf _1pby18b4 _11q7vuon",
                __cmplp.className
            ])
        });
    });
    const $a07bae344cb3fd25$export$f69c7d78cc611ef3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _18m91wug _1reo15vq _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $a07bae344cb3fd25$export$8b251419efc915eb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrpxbi _1e0c11p5 _yv0e1ghl _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $a07bae344cb3fd25$export$dd826bcc21f46caa = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1n261g80 _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $a07bae344cb3fd25$export$c7b4c423388a9a6c = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isActive: isActive, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1yt418iy _1e0c116y _4cvr1h6o _19itglyw _2rkow1gv _4t3i1ou6 _80omtlke _19pkidpf _otyru2gc _2hwx1b66 _uiztglyw _p12f1osq _1reo15vq _18m915vq _1bto1l2s _o5721q9c _s7n4jp4b _zulp1b66",
                __cmplp.isActive ? "_bfhk115i" : "_bfhk1g33",
                __cmplp.isActive ? "_syaz11ce" : "_syazjjyb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("qnxVY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("einKL").then(()=>parcelRequire('l3mnF'));
});
parcelRegister("6WXUd", function(module, exports) {
    $parcel$export(module.exports, "addGadgetPanelId", ()=>$0c49cfa6e72ac9c3$export$39a49c1fbe587c5b);
    var $gwIPs;
    const $0c49cfa6e72ac9c3$export$39a49c1fbe587c5b = 'addGadgetPanel';
    const $0c49cfa6e72ac9c3$export$94d3ae1073c5ce2e = (0, (0, parcelRequire("gwIPs")).gridSize) * 46;
});
parcelRegister("jd4if", function(module, exports) {
    $parcel$export(module.exports, "HeaderEditable", ()=>$23e4eca6700ded4d$export$3d14c3788ac5dc14);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $JIPqS;
    var $bOnpg;
    var $gYYRR;
    var $dZymr;
    var $1i27D;
    var $2PcTT;
    var $9jsHG;
    var $aNPat;
    var $koVbs;
    var $6jY6G;
    var $9OXo1;
    var $dCm1o;
    var $jaPSU;
    var $4WQJr;
    var $j2vUH;
    const $23e4eca6700ded4d$export$3d14c3788ac5dc14 = ({ data: data, banners: banners, onLayoutSelected: onLayoutSelected })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { isAnonymous: isAnonymous } = tenantContext;
        const { id: id, title: title, layout: layout } = data;
        const { headerItems: headerItems, toolItems: toolItems } = (0, (0, parcelRequire("2PcTT")).useConnectMenuItems)(id);
        const viewRoute = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const onClickHandler = (0, $5uXOq.useCallback)(()=>{
            fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
                action: 'clicked',
                actionSubject: 'dashboard.done-editing-button',
                actionSubjectId: (0, (0, parcelRequire("JIPqS")).DASHBOARD_EDIT_SOURCENAME)
            });
        }, [
            fireAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1i27D")).Header), {
            banners: banners
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1i27D")).HeaderTitle), null, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1i27D")).HeaderActions), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZymr")).ConnectHeader), {
            items: headerItems
        }), !isAnonymous && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jsHG")).FavoriteButton), {
            dashboardId: id,
            dashboardName: title
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jaPSU")).AddGadgetButton), {
            buttonType: (0, $324eda6c4db64a18$export$fdb820c8e86996c4),
            columnIndex: 0
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4WQJr")).ChangeLayoutButton), {
            layout: layout,
            onLayoutSelected: onLayoutSelected
        }), viewRoute && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aNPat")).RouteLinkButton), {
            to: viewRoute,
            params: {
                dashboardId: id
            },
            appearance: "primary",
            onClick: onClickHandler
        }, formatMessage((0, (0, parcelRequire("j2vUH")).default).done)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aNPat")).RouteLinkButtonOld), {
            appearance: "primary",
            to: viewRoute ?? undefined,
            params: {
                dashboardId: id
            },
            prefetch: "hover",
            onClick: onClickHandler
        }, formatMessage((0, (0, parcelRequire("j2vUH")).default).done)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYYRR")).ActionDropdown), {
            data: data,
            connectToolMenuItems: toolItems
        })));
    };
});
parcelRegister("gYYRR", function(module, exports) {
    $parcel$export(module.exports, "ActionDropdown", ()=>$255b9987b473f48f$export$d5503927a7d116d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $6qrUW;
    var $9UCCQ;
    var $JIPqS;
    var $koVbs;
    var $e9QkH;
    var $9OXo1;
    var $b8ziP;
    var $edp7U;
    var $dFiez;
    var $2h3Nr;
    var $fb7AH;
    var $fqLvm;
    var $2IJzF;
    var $8AXqQ;
    var $2EGKG;
    var $x5bVw;
    const $255b9987b473f48f$export$d5503927a7d116d = ({ data: data, connectToolMenuItems: connectToolMenuItems })=>{
        const { isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, (0, parcelRequire("b8ziP")).useDropdownItemOnClickHandler)();
        const dropdownTriggerButton = (0, $5uXOq.useRef)(null);
        const [, { on: modalCopyOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_COPY);
        const [, { on: modalAutomaticRefreshOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).AUTOMATIC_REFRESH);
        const [, { on: modalRenameAndShareOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
        const [, { on: modalDeleteOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_DELETE);
        const [, { on: modalCreateOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_CREATE);
        const onModalCloseCallback = (0, $5uXOq.useCallback)(()=>{
            setTimeout(()=>{
                if (dropdownTriggerButton.current) dropdownTriggerButton.current.focus();
            }, 1);
        }, [
            dropdownTriggerButton
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!data) return null;
        const dashboardId = data.id;
        const isDashboardOwner = atlassianAccountId === data.owner;
        const viewAsWallboardUrl = `/jira/dashboards/wallboard?dashboardId=${dashboardId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2EGKG")).RenameOrShareModal), {
            id: dashboardId,
            onModalCloseCallback: onModalCloseCallback
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fqLvm")).CopyModal), {
            id: dashboardId,
            onModalCloseCallback: onModalCloseCallback
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2h3Nr")).AutomaticRefreshModal), {
            id: dashboardId,
            onModalCloseCallback: onModalCloseCallback
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8AXqQ")).DeleteModal), {
            id: dashboardId,
            onModalCloseCallback: onModalCloseCallback
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fb7AH")).ConfigureWallboardModal), {
            onModalCloseCallback: onModalCloseCallback
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2IJzF")).CreateModal), {
            onModalCloseCallback: onModalCloseCallback
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: false,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    spacing: "default",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6qrUW"))))), {
                        label: formatMessage((0, (0, parcelRequire("dFiez")).default).moreActions),
                        size: "medium"
                    }),
                    ref: (buttonRef)=>{
                        if (typeof triggerRef === 'function') triggerRef(buttonRef);
                        if (dropdownTriggerButton.current === null) dropdownTriggerButton.current = buttonRef;
                    }
                }),
            shouldFlip: true,
            placement: "bottom-end",
            appearance: "tall",
            testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dropdown-menu",
            defaultOpen: (0, (0, parcelRequire("edp7U")).getIsDropdownDefaultOpen)('action-dropdown'),
            shouldRenderToParent: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: data.title
        }, data.writable && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.rename-and-share",
            onClick: modalRenameAndShareOpen
        }, formatMessage(data.systemDashboard ? (0, (0, parcelRequire("dFiez")).default).share : (0, (0, parcelRequire("dFiez")).default).renameOrShare)), !isAnonymous && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.copy",
            onClick: modalCopyOpen
        }, formatMessage((0, (0, parcelRequire("dFiez")).default).copy)), data.writable && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.automatic-refresh",
            onClick: modalAutomaticRefreshOpen
        }, formatMessage((0, (0, parcelRequire("dFiez")).default).automaticRefresh)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard",
            href: viewAsWallboardUrl,
            onClick: (e)=>dropdownItemClickHandler(e, viewAsWallboardUrl, 'dashboard.view-as-wallboard-item'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("dFiez")).default).wallboard)), isDashboardOwner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.delete",
            onClick: modalDeleteOpen
        }, formatMessage((0, (0, parcelRequire("dFiez")).default).moveToTrash)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("x5bVw")).WallboardSlideshow), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, !isAnonymous && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.create",
            onClick: modalCreateOpen
        }, formatMessage((0, (0, parcelRequire("dFiez")).default).create)), !isAnonymous && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.find",
            href: "/jira/dashboards",
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("dFiez")).default).find))), connectToolMenuItems && connectToolMenuItems.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dashboard-connect-menu-items",
            hasSeparator: true
        }, connectToolMenuItems.map(({ id: id, title: title, url: url, styleClass: styleClass })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: id,
                href: url,
                UNSAFE_shouldDisableRouterLink: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                id: id,
                className: styleClass
            }, title)))) : null));
    };
});
parcelRegister("b8ziP", function(module, exports) {
    $parcel$export(module.exports, "useDropdownItemOnClickHandler", ()=>$7f06fd4fc0d36f11$export$b9ed61ea9e46f071);
    var $dIdda = parcelRequire("dIdda");
    var $bOnpg;
    var $cdUgf;
    const $7f06fd4fc0d36f11$export$b9ed61ea9e46f071 = ()=>{
        const { push: push } = (0, $dIdda.useRouterActions)();
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const dropdownItemClickHandler = (e, url, actionSubject)=>{
            if (actionSubject) fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
                actionSubject: actionSubject,
                action: 'clicked',
                actionSubjectId: 'dashboard'
            });
            if (!(0, (0, parcelRequire("cdUgf")).clickedWithShortcutKeys)(e)) {
                e.preventDefault();
                push(url);
            }
        };
        return {
            dropdownItemClickHandler: dropdownItemClickHandler
        };
    };
});
parcelRegister("edp7U", function(module, exports) {
    $parcel$export(module.exports, "getIsDropdownDefaultOpen", ()=>$dad419d0b39d4c21$export$638abbdcabd86e67);
    const $dad419d0b39d4c21$export$638abbdcabd86e67 = (_)=>false;
});
parcelRegister("dFiez", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$172a2c76e18069ed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $172a2c76e18069ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreActions: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.more-actions",
            "defaultMessage": "More dashboard actions"
        },
        copy: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.copy",
            "defaultMessage": "Copy"
        },
        automaticRefresh: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.automatic-refresh",
            "defaultMessage": "Configure automatic refresh"
        },
        renameOrShare: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.rename-or-share",
            "defaultMessage": "Rename or share"
        },
        share: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.share",
            "defaultMessage": "Share dashboard"
        },
        moveToTrash: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.move-to-trash",
            "defaultMessage": "Move to trash"
        },
        find: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.find",
            "defaultMessage": "View all dashboards"
        },
        create: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.create",
            "defaultMessage": "Create a dashboard"
        },
        wallboard: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard",
            "defaultMessage": "View as wallboard"
        }
    });
});
parcelRegister("2h3Nr", function(module, exports) {
    $parcel$export(module.exports, "AutomaticRefreshModal", ()=>$de8465027ccce40b$export$47f35766b426b3bc);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $hh0bW;
    var $JIPqS;
    var $39xOx;
    var $lfTZh;
    var $e9QkH;
    var $kxZPA;
    var $iLC4C;
    var $89bLT;
    const $de8465027ccce40b$var$LazyDashboardModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("TfAoI")), {
        moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/automatic-refresh-modal/main.tsx"
    });
    const $de8465027ccce40b$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {
            isCancel: false
        }
    };
    const $de8465027ccce40b$var$sendSuccessExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$de8465027ccce40b$var$expAttributes,
            wasExperienceSuccesful: true
        });
    const $de8465027ccce40b$var$sendFailedExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$de8465027ccce40b$var$expAttributes,
            wasExperienceSuccesful: false
        });
    const $de8465027ccce40b$export$47f35766b426b3bc = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).AUTOMATIC_REFRESH);
        const onFailed = (err)=>{
            const error = err || new Error('automatic refresh modal configuration failed.');
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: $de8465027ccce40b$var$sendSuccessExperience,
                sendFailedExperience: $de8465027ccce40b$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).DASHBOARD_AUTOMATIC_REFRESH))
            });
            close();
            onModalCloseCallback?.();
        };
        const onCancel = ()=>{
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$de8465027ccce40b$var$expAttributes,
                wasExperienceSuccesful: true,
                additionalAttributes: {
                    isCancel: true
                }
            });
            close();
            onModalCloseCallback?.();
        };
        const onClose = ()=>{
            close();
            onModalCloseCallback?.();
        };
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: (0, (0, parcelRequire("JIPqS")).DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
            packageName: "dashboard",
            fallback: "flag",
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE)
            },
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dashboard-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), {
                isTinted: true
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($de8465027ccce40b$var$LazyDashboardModal, {
            id: id,
            onClose: onClose,
            onSuccess: $de8465027ccce40b$var$sendSuccessExperience,
            onCancel: onCancel,
            onFailed: onFailed
        }))) : null;
    };
});
parcelRegister("89bLT", function(module, exports) {
    $parcel$export(module.exports, "logErrorEventFunc", ()=>$98efc897ec5a605f$export$e315c4152a211ba8);
    var $jcw0u;
    const $98efc897ec5a605f$export$e315c4152a211ba8 = (error, eventId)=>(reason)=>{
            if (error != null) (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: eventId,
                    packageName: 'jiraDashboardInternalCommon'
                },
                attributes: {
                    reason: reason
                }
            });
        };
});
parcelRegister("TfAoI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6Fl1t")
    ]).then(()=>parcelRequire('eIgK0'));
});
parcelRegister("fb7AH", function(module, exports) {
    $parcel$export(module.exports, "ConfigureWallboardModal", ()=>$c591fac53db599f8$export$cf7e06d150dcce6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $JIPqS;
    var $39xOx;
    var $lfTZh;
    var $e9QkH;
    var $kxZPA;
    const $c591fac53db599f8$var$LazyDashboardModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("b5lUu")), {
        moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/configure-wallboard-modal/modal/index.tsx"
    });
    const $c591fac53db599f8$export$cf7e06d150dcce6d = ({ onModalCloseCallback: onModalCloseCallback })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).CONFIGURE_WALLBOARD);
        const onModalClose = ()=>{
            close();
            onModalCloseCallback?.();
        };
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "configure-wallboard-modal",
            packageName: "dashboard",
            fallback: "flag",
            teamName: "endeavour"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dashboard-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), {
                isTinted: true
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c591fac53db599f8$var$LazyDashboardModal, {
            onClose: onModalClose
        }))) : null;
    };
});
parcelRegister("b5lUu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1ftQg")
    ]).then(()=>parcelRequire('iFntg'));
});
parcelRegister("fqLvm", function(module, exports) {
    $parcel$export(module.exports, "CopyModal", ()=>$6aa3f9a2fe12b1cd$export$4a7ddad8989462fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $hh0bW;
    var $JIPqS;
    var $39xOx;
    var $34Vv8;
    var $lfTZh;
    var $e9QkH;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    var $iLC4C;
    var $89bLT;
    const $6aa3f9a2fe12b1cd$var$LazyDashboardModal = (0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("gzo7u")).then(({ CopyDashboardModal: CopyDashboardModal })=>CopyDashboardModal), {
        moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/copy-dashboard-modal/src/index.tsx"
    }));
    const $6aa3f9a2fe12b1cd$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).COPY_DASHBOARD_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {
            isCancel: false
        }
    };
    const $6aa3f9a2fe12b1cd$var$sendSuccessExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$6aa3f9a2fe12b1cd$var$expAttributes,
            wasExperienceSuccesful: true
        });
    const $6aa3f9a2fe12b1cd$var$sendFailedExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$6aa3f9a2fe12b1cd$var$expAttributes,
            wasExperienceSuccesful: false
        });
    const $6aa3f9a2fe12b1cd$export$bdd968b8df213d5c = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_COPY);
        const { push: push } = (0, $dIdda.useRouterActions)();
        const onSuccess = (_, response)=>{
            $6aa3f9a2fe12b1cd$var$sendSuccessExperience();
            close();
            if (response.view != null) push(response.view);
            else onModalCloseCallback?.();
        };
        const onInitiateFailed = (error)=>{
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error || new Error('copy dashboard modal initialisation failed'),
                sendSuccessExperience: $6aa3f9a2fe12b1cd$var$sendSuccessExperience,
                sendFailedExperience: $6aa3f9a2fe12b1cd$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).COPY_DASHBOARD))
            });
            close();
            onModalCloseCallback?.();
        };
        const onFailed = (error)=>{
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: $6aa3f9a2fe12b1cd$var$sendSuccessExperience,
                sendFailedExperience: $6aa3f9a2fe12b1cd$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).COPY_DASHBOARD))
            });
            close();
            onModalCloseCallback?.();
        };
        const onCancel = ()=>{
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$6aa3f9a2fe12b1cd$var$expAttributes,
                wasExperienceSuccesful: true,
                additionalAttributes: {
                    isCancel: true
                }
            });
            close();
            onModalCloseCallback?.();
        };
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dashboard-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6aa3f9a2fe12b1cd$var$LazyDashboardModal, {
            onInitiateFailed: onInitiateFailed,
            onSuccess: onSuccess,
            onFailed: onFailed,
            onCancel: onCancel,
            id: id
        })) : null;
    };
    const $6aa3f9a2fe12b1cd$export$4a7ddad8989462fb = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: (0, (0, parcelRequire("JIPqS")).COPY_DASHBOARD_EXPERIENCE),
            packageName: "dashboard",
            fallback: "flag",
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).COPY_DASHBOARD_EXPERIENCE)
            },
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6aa3f9a2fe12b1cd$export$bdd968b8df213d5c, props));
});
parcelRegister("gzo7u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5k9P8")
    ]).then(()=>parcelRequire('a7HF6'));
});
parcelRegister("2IJzF", function(module, exports) {
    $parcel$export(module.exports, "CreateModal", ()=>$cdded0b8b2569776$export$204e9f8d79be983e);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $jgE05;
    var $JIPqS;
    var $39xOx;
    var $lfTZh;
    var $gh1hi;
    var $e9QkH;
    var $dIdda = parcelRequire("dIdda");
    const $cdded0b8b2569776$export$e85d11db57ff5836 = ({ onModalCloseCallback: onModalCloseCallback })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_CREATE);
        const { clear: clear } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const { push: push } = (0, $dIdda.useRouterActions)();
        const onSuccess = (_, operationResult)=>{
            clear();
            push(`/jira/dashboards/${operationResult.id}/edit`);
            close();
        };
        const onCancel = ()=>{
            close();
            onModalCloseCallback?.();
        };
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dashboards-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgE05")).default), {
            onSuccess: onSuccess,
            onCancel: onCancel
        })) : null;
    };
    const $cdded0b8b2569776$export$204e9f8d79be983e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: (0, (0, parcelRequire("JIPqS")).CREATE_DASHBOARD_EXPERIENCE),
            packageName: "dashboard",
            fallback: "flag",
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).CREATE_DASHBOARD_EXPERIENCE)
            },
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cdded0b8b2569776$export$e85d11db57ff5836, props));
});
parcelRegister("jgE05", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$927aeb284ed7a228$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $927aeb284ed7a228$var$AsyncCreateDashboardModal = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("iDIjr")), {
        moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
    });
    const $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-dashboard-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($927aeb284ed7a228$var$AsyncCreateDashboardModal, props));
    var $927aeb284ed7a228$export$2e2bcd8739ae039 = $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer;
});
parcelRegister("iDIjr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8bdSJ")
    ]).then(()=>parcelRequire('eTZZm'));
});
parcelRegister("8AXqQ", function(module, exports) {
    $parcel$export(module.exports, "DeleteModal", ()=>$f85fc38ca5cf0b6c$export$73392e09138fecd6);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $j55bS;
    var $hh0bW;
    var $JIPqS;
    var $39xOx;
    var $lfTZh;
    var $gh1hi;
    var $e9QkH;
    var $kxZPA;
    var $dIdda = parcelRequire("dIdda");
    var $iLC4C;
    var $89bLT;
    const $f85fc38ca5cf0b6c$var$LazyDeleteModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("4tl1E")), {
        moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/delete-dashboard-modal/src/index.tsx"
    });
    const $f85fc38ca5cf0b6c$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).DELETE_DASHBOARD_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {
            isCancel: false
        }
    };
    const $f85fc38ca5cf0b6c$var$sendSuccessExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$f85fc38ca5cf0b6c$var$expAttributes,
            wasExperienceSuccesful: true
        });
    const $f85fc38ca5cf0b6c$var$sendFailedExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$f85fc38ca5cf0b6c$var$expAttributes,
            wasExperienceSuccesful: false
        });
    const $f85fc38ca5cf0b6c$export$daf5ee5ed602db71 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_DELETE);
        const { clear: clear } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        const { push: push } = (0, $dIdda.useRouterActions)();
        const onSuccess = ()=>{
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$f85fc38ca5cf0b6c$var$expAttributes,
                wasExperienceSuccesful: true
            });
            clear();
            close();
            push('/jira/dashboards');
        };
        const onInitiateFailed = (error)=>{
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error || new Error('delete dashboard modal initialisation failed'),
                sendSuccessExperience: $f85fc38ca5cf0b6c$var$sendSuccessExperience,
                sendFailedExperience: $f85fc38ca5cf0b6c$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).DELETE_DASHBOARD))
            });
            close();
            onModalCloseCallback?.();
        };
        const onFailed = (error)=>{
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: $f85fc38ca5cf0b6c$var$sendSuccessExperience,
                sendFailedExperience: $f85fc38ca5cf0b6c$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).DELETE_DASHBOARD))
            });
            close();
            onModalCloseCallback?.();
        };
        const onCancel = ()=>{
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$f85fc38ca5cf0b6c$var$expAttributes,
                wasExperienceSuccesful: true,
                additionalAttributes: {
                    isCancel: true
                }
            });
            close();
            onModalCloseCallback?.();
        };
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dashboards-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f85fc38ca5cf0b6c$var$LazyDeleteModal, {
            onInitiateSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onInitiateFailed: onInitiateFailed,
            onSuccess: onSuccess,
            onCancel: onCancel,
            onFailed: onFailed,
            id: id
        })) : null;
    };
    const $f85fc38ca5cf0b6c$export$73392e09138fecd6 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: (0, (0, parcelRequire("JIPqS")).DELETE_DASHBOARD_EXPERIENCE),
            packageName: "dashboard",
            fallback: "flag",
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).DELETE_DASHBOARD_EXPERIENCE)
            },
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f85fc38ca5cf0b6c$export$daf5ee5ed602db71, props));
});
parcelRegister("4tl1E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2CgxW")
    ]).then(()=>parcelRequire('6ee1k'));
});
parcelRegister("2EGKG", function(module, exports) {
    $parcel$export(module.exports, "RenameOrShareModal", ()=>$952ac229700a831b$export$a113d771e12d2a12);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $j55bS;
    var $hh0bW;
    var $JIPqS;
    var $39xOx;
    var $lfTZh;
    var $e9QkH;
    var $kxZPA;
    var $3TUxF;
    var $iLC4C;
    var $89bLT;
    const $952ac229700a831b$var$LazyRenameOrShareModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("cPlgF")), {
        moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/edit-dashboard-modal/src/index.tsx"
    });
    const $952ac229700a831b$var$expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, (0, parcelRequire("JIPqS")).RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
        application: null,
        edition: null,
        additionalAttributes: {
            isCancel: false
        }
    };
    const $952ac229700a831b$var$sendSuccessExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$952ac229700a831b$var$expAttributes,
            wasExperienceSuccesful: true
        });
    const $952ac229700a831b$var$sendFailedExperience = ()=>(0, (0, parcelRequire("hh0bW")).default)({
            ...$952ac229700a831b$var$expAttributes,
            wasExperienceSuccesful: false
        });
    const $952ac229700a831b$export$4f6c2201df28de83 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
        const [isOpen, { off: close }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
        const onEditDashboard = (0, (0, parcelRequire("3TUxF")).useEditDashboard)();
        const onSuccess = (_, response)=>{
            onEditDashboard(response);
            $952ac229700a831b$var$sendSuccessExperience();
            close();
            onModalCloseCallback?.();
        };
        const onInitiateFailed = (error)=>{
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error || new Error('rename or share dashboard modal initialisation failed'),
                sendSuccessExperience: $952ac229700a831b$var$sendSuccessExperience,
                sendFailedExperience: $952ac229700a831b$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).RENAME_OR_SHARE_DASHBOARD))
            });
            close();
            onModalCloseCallback?.();
        };
        const onFailed = (error)=>{
            (0, (0, parcelRequire("iLC4C")).handleFetchErrorAsExperience)({
                error: error,
                sendSuccessExperience: $952ac229700a831b$var$sendSuccessExperience,
                sendFailedExperience: $952ac229700a831b$var$sendFailedExperience,
                logErrorEvent: (0, (0, parcelRequire("89bLT")).logErrorEventFunc)(error, (0, (0, parcelRequire("JIPqS")).RENAME_OR_SHARE_DASHBOARD))
            });
            close();
            onModalCloseCallback?.();
        };
        const onCancel = ()=>{
            (0, (0, parcelRequire("hh0bW")).default)({
                ...$952ac229700a831b$var$expAttributes,
                wasExperienceSuccesful: true,
                additionalAttributes: {
                    isCancel: true
                }
            });
            close();
            onModalCloseCallback?.();
        };
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "rename-or-share-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($952ac229700a831b$var$LazyRenameOrShareModal, {
            onInitiateFailed: onInitiateFailed,
            onInitiateSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: onSuccess,
            onCancel: onCancel,
            onFailed: onFailed,
            id: id
        })) : null;
    };
    const $952ac229700a831b$export$a113d771e12d2a12 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: (0, (0, parcelRequire("JIPqS")).RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
            packageName: "dashboard",
            fallback: "flag",
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).RENAME_OR_SHARE_DASHBOARD_EXPERIENCE)
            },
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($952ac229700a831b$export$4f6c2201df28de83, props));
});
parcelRegister("3TUxF", function(module, exports) {
    $parcel$export(module.exports, "useEditDashboard", ()=>$481cf9cc3e288e09$export$a7520122589f9056);
    var $5uXOq = parcelRequire("5uXOq");
    var $gh1hi;
    const $481cf9cc3e288e09$export$a7520122589f9056 = ()=>{
        const { update: update } = (0, (0, parcelRequire("gh1hi")).useDashboardResource)();
        return (0, $5uXOq.useCallback)((dashboardData)=>{
            if (!dashboardData) return;
            update((currentData)=>currentData && {
                    ...currentData,
                    title: dashboardData.name
                });
        }, [
            update
        ]);
    };
});
parcelRegister("cPlgF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("XUjPB")
    ]).then(()=>parcelRequire('fZpfn'));
});
parcelRegister("x5bVw", function(module, exports) {
    $parcel$export(module.exports, "WallboardSlideshow", ()=>$e8bb3a64b8086b53$export$db3bf5ee6d309e34);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $9UCCQ;
    var $JIPqS;
    var $jcw0u;
    var $koVbs;
    var $e9QkH;
    var $9OXo1;
    var $bOnpg;
    var $b8ziP;
    var $drb8j;
    const $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL = '/';
    const $e8bb3a64b8086b53$export$11aea547bd3c125e = async ()=>{
        try {
            const response = await fetch('/rest/wallboard/latest/slideshow/url', {
                method: 'GET'
            });
            if (!response.ok) throw new Error(`Error server response: ${response.status}`);
            return response.text();
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'viewWallboardSlideshow',
                    packageName: 'jiraDashboardInternalCommon'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL;
        }
    };
    const $e8bb3a64b8086b53$export$db3bf5ee6d309e34 = ()=>{
        const { isAnonymous: isAnonymous } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [wallboardSlideshowUrl, setWallboardSlideshowUrl] = (0, $5uXOq.useState)(undefined);
        const [, { on: modalWallboardOpen }] = (0, (0, parcelRequire("e9QkH")).useSwitchModals)((0, (0, parcelRequire("JIPqS")).MODAL_ID).CONFIGURE_WALLBOARD);
        const fireAnalytics = (0, (0, parcelRequire("bOnpg")).useDashboardAnalytics)();
        const configureWallboardSlideShowClickHandler = (0, $5uXOq.useCallback)(()=>{
            fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
                actionSubjectId: 'dashboard',
                actionSubject: 'wallboard-slideshow.configure',
                action: 'clicked'
            });
            setTimeout(()=>{
                modalWallboardOpen();
            }, 1);
        }, [
            fireAnalytics,
            modalWallboardOpen
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, (0, parcelRequire("b8ziP")).useDropdownItemOnClickHandler)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isAnonymous && wallboardSlideshowUrl === undefined) $e8bb3a64b8086b53$export$11aea547bd3c125e().then((url)=>{
                setWallboardSlideshowUrl(url || $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL);
            });
        }, [
            isAnonymous,
            wallboardSlideshowUrl
        ]);
        const isViewWallboardSlideshowEnabled = wallboardSlideshowUrl !== $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL && !isAnonymous;
        const wallboardSlideshowUrlWithFallback = wallboardSlideshowUrl || $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
            isDisabled: !isViewWallboardSlideshowEnabled,
            href: wallboardSlideshowUrlWithFallback,
            onClick: (e)=>dropdownItemClickHandler(e, wallboardSlideshowUrlWithFallback, 'dashboard.view-wallboard-slideshow-item'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("drb8j")).default).wallboardSlideshow)), !isAnonymous && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.configure-wallboard",
            onClick: configureWallboardSlideShowClickHandler
        }, formatMessage((0, (0, parcelRequire("drb8j")).default).wallboardSetup)));
    };
});
parcelRegister("drb8j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bd6bbd173094bd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3bd6bbd173094bd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        wallboardSlideshow: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
            "defaultMessage": "View wallboard slide show"
        },
        wallboardSetup: {
            "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-setup",
            "defaultMessage": "Configure wallboard slide show"
        }
    });
});
parcelRegister("dZymr", function(module, exports) {
    $parcel$export(module.exports, "ConnectHeader", ()=>$fa1518cc236818d0$export$a7c3d2bbc29ad451);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $5ILhZ;
    var $hrlU6;
    var $edp7U;
    var $dUyq4;
    const $fa1518cc236818d0$export$965e85c1e0261738 = ({ item: item })=>{
        const webItemRef = (0, $5uXOq.useRef)(null);
        const onWebItemClick = ()=>{
            (0, (0, parcelRequire("hrlU6")).withConnectHost)((connectHost)=>{
                if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            id: item.id,
            appearance: "subtle",
            onClick: onWebItemClick,
            ref: webItemRef
        }, item.title);
    };
    const $fa1518cc236818d0$var$DropdownPressableItem = ({ item: item })=>{
        const webItemRef = (0, $5uXOq.useRef)(null);
        const onWebItemClick = ()=>{
            (0, (0, parcelRequire("hrlU6")).withConnectHost)((connectHost)=>{
                if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            id: item.id,
            onClick: onWebItemClick,
            ref: (ref)=>{
                if (ref) webItemRef.current = ref;
            },
            backgroundColor: "color.background.neutral.subtle"
        }, item.title);
    };
    const $fa1518cc236818d0$export$275428e5ee6cc209 = ({ items: items })=>{
        if (items.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: false,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "subtle",
                    spacing: "default",
                    ...triggerProps,
                    ref: triggerRef
                }, "+", items.length),
            shouldFlip: true,
            placement: "bottom-end",
            testId: "dashboard-internal-common.ui.dashboard-content.header.connect-header.dropdown-menu",
            defaultOpen: (0, (0, parcelRequire("edp7U")).getIsDropdownDefaultOpen)('connect-header')
        }, items.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: item.id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$var$DropdownPressableItem, {
                item: item
            }))));
    };
    const $fa1518cc236818d0$export$a7c3d2bbc29ad451 = ({ items: items })=>{
        if (!items) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUyq4")).ConnectHeaderWrapper), null, items.slice(0, 4).map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$export$965e85c1e0261738, {
                item: item,
                key: item.id
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$export$275428e5ee6cc209, {
            items: items.slice(4)
        }));
    };
});
parcelRegister("dUyq4", function(module, exports) {
    $parcel$export(module.exports, "ConnectHeaderWrapper", ()=>$a7fb468cf68df072$export$70cdd2ea5140c2c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $a7fb468cf68df072$export$70cdd2ea5140c2c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _13kxotz2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1i27D", function(module, exports) {
    $parcel$export(module.exports, "HeaderTitle", ()=>$f69e2b51e1f910f6$export$edb76fdb8665f52);
    $parcel$export(module.exports, "HeaderActions", ()=>$f69e2b51e1f910f6$export$223875819fd7cf93);
    $parcel$export(module.exports, "Header", ()=>$f69e2b51e1f910f6$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bJcWY;
    var $aZdfU;
    var $cS37j;
    var $kSvVK;
    const $f69e2b51e1f910f6$export$edb76fdb8665f52 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), {
            medium: 4,
            testId: "dashboard-internal-common.ui.dashboard-content.header.header-title"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), null, children));
    const $f69e2b51e1f910f6$export$223875819fd7cf93 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), {
            medium: 8
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kSvVK")).ActionWrapper), null, children)));
    const $f69e2b51e1f910f6$export$8b251419efc915eb = ({ banners: banners, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("header", {
            "data-testid": "dashboard-internal-common.ui.dashboard-content.header.dashboard-header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), {
            layout: "fluid",
            spacing: "compact"
        }, children), banners && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kSvVK")).BannersWrapper), null, banners));
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("kSvVK", function(module, exports) {
    $parcel$export(module.exports, "ActionWrapper", ()=>$3989dffa8d1c8135$export$3122aab815c89f9a);
    $parcel$export(module.exports, "BannersWrapper", ()=>$3989dffa8d1c8135$export$ab656bce1543f51a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $3989dffa8d1c8135$export$3122aab815c89f9a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _18s81d9c _zulpu2gc _xlknidpf _dgz5idpf _18sqidpf _wrjxidpf _18vqd8e8",
                __cmplp.className
            ])
        });
    });
    const $3989dffa8d1c8135$export$ab656bce1543f51a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc _zum8idpf _10361ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2PcTT", function(module, exports) {
    $parcel$export(module.exports, "useConnectMenuItems", ()=>$fdeff8836b607085$export$58f1b171f06c90ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $7f4tk;
    const $fdeff8836b607085$export$58f1b171f06c90ef = (dashboardId)=>{
        const [connectMenuItems, setConnectMenuItems] = (0, $5uXOq.useState)({
            headerItems: [],
            toolItems: []
        });
        (0, $5uXOq.useEffect)(()=>{
            if (dashboardId == null) return;
            (async ()=>{
                const resourceUrl = `/rest/dashboards/1.0/connect/menuItems/${dashboardId}`;
                try {
                    const response = await (0, (0, parcelRequire("7f4tk")).default)(resourceUrl);
                    setConnectMenuItems(response);
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'fetchConnectMenuItems',
                            packageName: 'jiraDashboardInternalCommon',
                            teamName: 'endeavour'
                        }
                    });
                }
            })();
        }, [
            dashboardId
        ]);
        return connectMenuItems;
    };
});
parcelRegister("9jsHG", function(module, exports) {
    $parcel$export(module.exports, "FavoriteButton", ()=>$74ae53576ce577d5$export$8d5dab2ad1e19ea0);
    var $5uXOq = parcelRequire("5uXOq");
    var $hLZZY;
    var $hcObS;
    var $eXQym;
    const $74ae53576ce577d5$export$8d5dab2ad1e19ea0 = ({ dashboardId: dashboardId, dashboardName: dashboardName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcObS")).FavoriteButtonWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hLZZY")).default), {
            baseUrl: "",
            itemId: dashboardId,
            itemType: (0, (0, parcelRequire("eXQym")).DASHBOARDS_ITEM_TYPE),
            favoriteItemName: dashboardName
        }));
});
parcelRegister("hLZZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a968ac170a325ff4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4041n;
    var $fH2dG;
    class $a968ac170a325ff4$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4041n")).FavoriteChangeConsumer), null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fH2dG")).FavoriteButton), {
                    ...this.props,
                    favoriteChangeContext: favoriteChangeContext
                }));
        }
    }
});
parcelRegister("fH2dG", function(module, exports) {
    $parcel$export(module.exports, "FavoriteButton", ()=>$e0f2aac973023e83$export$8d5dab2ad1e19ea0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hcObS;
    var $eXQym;
    var $1WPu2;
    const $e0f2aac973023e83$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
    class $e0f2aac973023e83$export$8d5dab2ad1e19ea0 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isFavoriteInitial: undefined,
                favoriteItemName: undefined,
                isSmall: false,
                hideTooltip: false,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        constructor(props){
            super(props);
            this.onClick = (analyticsEvent)=>{
                const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
                const { changeFavorite: changeFavorite } = favoriteChangeContext;
                if (changeFavorite) changeFavorite({
                    id: itemId,
                    type: itemType,
                    value: !this.getIsFavorite()
                }, analyticsEvent);
                if (typeof onClick === 'function') onClick();
            };
            this.state = {
                isFavorite: props.isFavoriteInitial
            };
        }
        componentDidMount() {
            const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
            if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
            if (!$e0f2aac973023e83$var$isProduction && !(0, (0, parcelRequire("eXQym")).VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, (0, parcelRequire("eXQym")).VALID_ITEM_TYPES))}]\n\n`);
            if (typeof this.props.isFavoriteInitial !== 'undefined') this.props.favoriteChangeContext.items[itemType][itemId] = {
                id: itemId,
                type: itemType,
                value: this.props.isFavoriteInitial,
                pending: false
            };
            if (this.getIsFavorite() === undefined) (0, (0, parcelRequire("1WPu2")).getFavorite)(baseUrl, {
                id: itemId,
                type: itemType
            }).then((isFavorite)=>{
                this.setState({
                    isFavorite: isFavorite
                });
            });
        }
        getIsFavorite() {
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
            let itemChanged;
            if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
            return itemChanged ? itemChanged.value : this.state.isFavorite;
        }
        getIsPending() {
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
            let itemChanged;
            if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
            return itemChanged ? itemChanged.pending : false;
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "favourite-button.favorite-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcObS")).default), {
                isFavorite: this.getIsFavorite(),
                favoriteItemName: this.props.favoriteItemName,
                pending: this.getIsPending(),
                hideTooltip: this.props.hideTooltip,
                tooltipPosition: this.props.tooltipPosition,
                onClick: this.onClick,
                isShownInList: this.props.isShownInList,
                isSmall: this.props.isSmall
            }));
        }
    }
});
parcelRegister("hcObS", function(module, exports) {
    $parcel$export(module.exports, "FavoriteButtonWrapper", ()=>$0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
    $parcel$export(module.exports, "default", ()=>$0a68425ce3fc2fa8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $basmW = parcelRequire("basmW");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $dm1qi;
    var $dAf5R;
    var $5oTeF;
    var $bH1hf;
    var $7FtaJ;
    var $1Cvrw;
    var $fNobW;
    var $3bDjY;
    var $iQv12;
    var $7XYc4;
    var $az4zD;
    var $dCm1o;
    var $6fQ6A;
    const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
    const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
    class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isFavorite: undefined,
                favoriteItemName: undefined,
                isShownInList: false,
                isSmall: false,
                hideTooltip: false,
                onClick: (0, ($parcel$interopDefault($8Rkzz))),
                tooltipPosition: 'bottom',
                skipAnimation: false
            };
        }
        componentDidUpdate(prevProps) {
            if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
                this.onAnimationStart();
                this.onSettingAnimationEnd();
            }
        }
        onAnimationStart() {
            this.setState({
                isAnimating: !this.state.isAnimating
            });
        }
        onSettingAnimationEnd() {
            setTimeout(()=>{
                this.setState({
                    isAnimating: false
                });
            }, $0a68425ce3fc2fa8$var$animationTime * 2);
        }
        render() {
            const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
            const { isAnimating: isAnimating } = this.state;
            if (isFavorite === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "favourite-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
                "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
                isSmall: isSmall
            }));
            const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
            const buttonContentOld = (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
                isFavorite: isFavorite,
                isAnimating: isAnimating,
                "data-testid": iconWrapperTestId,
                isSmall: isSmall
            }, isFavorite ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dm1qi"))))), {
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("bH1hf"))))),
                LEGACY_size: isSmall ? 'small' : undefined,
                color: "currentColor",
                label: formatMessage((0, (0, parcelRequire("6fQ6A")).default).removeFromStarred)
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dAf5R"))))), {
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("5oTeF"))))),
                LEGACY_size: isSmall ? 'small' : undefined,
                color: "currentColor",
                label: formatMessage((0, (0, parcelRequire("6fQ6A")).default).addToStarred)
            }));
            const renderIcon = ()=>{
                const label = isFavorite ? formatMessage((0, (0, parcelRequire("6fQ6A")).default).removeFromStarred) : formatMessage((0, (0, parcelRequire("6fQ6A")).default).addToStarred);
                let StarIconComponent;
                if (isSmall) StarIconComponent = isFavorite ? (0, ($parcel$interopDefault((0, parcelRequire("7FtaJ"))))) : (0, ($parcel$interopDefault((0, parcelRequire("1Cvrw")))));
                else StarIconComponent = isFavorite ? (0, ($parcel$interopDefault((0, parcelRequire("dm1qi"))))) : (0, ($parcel$interopDefault((0, parcelRequire("dAf5R")))));
                return (0, ($parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                    color: "currentColor",
                    label: label
                });
            };
            const buttonContent = (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
                isFavorite: isFavorite,
                isAnimating: isAnimating,
                "data-testid": iconWrapperTestId,
                isSmall: isSmall
            }, renderIcon());
            const tooltipContent = isFavorite ? formatMessage((0, (0, parcelRequire("6fQ6A")).default).removeFromStarred) : formatMessage((0, (0, parcelRequire("6fQ6A")).default).addToStarred);
            const ariaLabel = favoriteItemName ? formatMessage((0, (0, parcelRequire("6fQ6A")).default).toggleStarredWithItemName, {
                itemName: favoriteItemName
            }) : formatMessage((0, (0, parcelRequire("6fQ6A")).default).toggleStarred);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
                role: "presentation",
                onClick: this.onBtnClickWrapper,
                onKeyPress: this.onBtnClickWrapper,
                "data-is-favorite": isFavorite
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: !hideTooltip && tooltipContent,
                hideTooltipOnClick: true,
                position: tooltipPosition
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: isShownInList ? 'subtle-link' : 'subtle',
                spacing: "none",
                "aria-label": ariaLabel,
                "aria-pressed": isFavorite,
                onClick: !pending ? this.onClick : (0, ($parcel$interopDefault($8Rkzz)))
            }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isAnimating: false
            };
            this.onBtnClickWrapper = (e)=>{
                e.stopPropagation();
                e.preventDefault();
            };
            this.onClick = (_, analyticsEvent)=>{
                this.props.onClick(analyticsEvent);
            };
        }
    }
    var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onClick: ()=>({
                name: 'star'
            })
    }), (0, (0, parcelRequire("az4zD")).injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
    const $0a68425ce3fc2fa8$var$animationTime = 500;
    const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
                __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
                __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
                __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
                __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld);
    const $0a68425ce3fc2fa8$var$FavIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
                __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$export$db65185b5889c83 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSmall: isSmall, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
                __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("6fQ6A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10bc2ec5d9a72db1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addToStarred: {
            "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
            "defaultMessage": "Add to Starred"
        },
        removeFromStarred: {
            "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
            "defaultMessage": "Remove from Starred"
        },
        toggleStarred: {
            "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
            "defaultMessage": "Star"
        },
        toggleStarredWithItemName: {
            "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
            "defaultMessage": "Star {itemName}"
        }
    });
});
parcelRegister("1WPu2", function(module, exports) {
    $parcel$export(module.exports, "getFavorite", ()=>$1961b1823763022d$export$fce5eda070ce88d0);
    var $eusud;
    const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
    const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, (0, parcelRequire("eusud")).performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));
});
parcelRegister("aNPat", function(module, exports) {
    $parcel$export(module.exports, "RouteLinkButtonOld", ()=>$bacdc7ee50699d04$export$c74dddf61fcdf9b0);
    $parcel$export(module.exports, "RouteLinkButton", ()=>$bacdc7ee50699d04$export$64b500ddabb836a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1GGwS;
    var $dIdda = parcelRequire("dIdda");
    const $bacdc7ee50699d04$export$c74dddf61fcdf9b0 = ({ children: children, to: to, params: params, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            component: (0, $dIdda.Link),
            ...rest,
            ...to && {
                key: to.name,
                href: (0, $dIdda.generatePath)(to.path, params),
                to: to,
                params: params
            }
        }, children);
    const $bacdc7ee50699d04$export$64b500ddabb836a3 = ({ to: to, params: params, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
            ...rest,
            key: to.name,
            href: (0, $dIdda.generatePath)(to.path, params)
        }, children);
});
parcelRegister("1GGwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9768e745d0380796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $fuBHX;
    const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $9768e745d0380796$var$WithRef = (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
    const $9768e745d0380796$var$LinkButton = (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
    var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;
});
const $324eda6c4db64a18$export$fdb820c8e86996c4 = 'button';
const $324eda6c4db64a18$export$e9a9f8a43cd26ad7 = 'link';
parcelRegister("jaPSU", function(module, exports) {
    $parcel$export(module.exports, "AddGadgetButton", ()=>$f6eb6d5ae55a77cd$export$d063cb109cc3ff77);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $JIPqS;
    var $39xOx;
    var $koVbs;
    var $GQeXq;
    var $6WXUd;
    var $ka8Tu;
    var $j3JoF;
    const $f6eb6d5ae55a77cd$export$ac0f6789672a17a7 = ({ buttonType: buttonType, columnIndex: columnIndex })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onOpenRightPanel: onOpenRightPanel, onFocusTrigger: onFocusTrigger } = (0, (0, parcelRequire("GQeXq")).useRightPanelToggle)();
        const { isTriggerFocused: isTriggerFocused } = (0, (0, parcelRequire("GQeXq")).useRightPanelState)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const addGadgetButtonOnClick = (0, $5uXOq.useCallback)(()=>{
            onOpenRightPanel(`${(0, (0, parcelRequire("6WXUd")).addGadgetPanelId)}-${columnIndex}`);
        }, [
            onOpenRightPanel,
            columnIndex
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            onFocusTrigger(()=>buttonRef.current?.focus?.());
        }, [
            onFocusTrigger,
            isTriggerFocused
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3JoF")).AddGadgetWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: buttonRef,
            appearance: buttonType === (0, $324eda6c4db64a18$export$fdb820c8e86996c4) ? 'default' : 'link',
            spacing: buttonType === (0, $324eda6c4db64a18$export$fdb820c8e86996c4) ? 'default' : 'none',
            onClick: addGadgetButtonOnClick
        }, formatMessage(buttonType === (0, $324eda6c4db64a18$export$fdb820c8e86996c4) ? (0, (0, parcelRequire("ka8Tu")).default).title : (0, (0, parcelRequire("ka8Tu")).default).linkTitle)));
    };
    const $f6eb6d5ae55a77cd$export$d063cb109cc3ff77 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "add-gadget",
            packageName: "dashboard",
            fallback: "flag",
            attributes: {
                task: (0, (0, parcelRequire("JIPqS")).ADD_GADGET_EXPERIENCE),
                reason: 'AddGadgetButton with panel ErrorBoundary'
            },
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f6eb6d5ae55a77cd$export$ac0f6789672a17a7, props));
});
parcelRegister("ka8Tu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7af260209e83a08b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7af260209e83a08b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "dashboard-edit.header-editable.add-gadget-button.title",
            "defaultMessage": "Add gadget"
        },
        linkTitle: {
            "id": "dashboard-edit.header-editable.add-gadget-button.link-title",
            "defaultMessage": "add a new gadget"
        },
        errorFlagTitle: {
            "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-title",
            "defaultMessage": "Error"
        },
        errorFlagDescription: {
            "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-description",
            "defaultMessage": "We cannot add any new gadgets at the moment"
        },
        errorFlagAction: {
            "id": "dashboard-edit.header-editable.add-gadget-button.error-flag-action",
            "defaultMessage": "Refresh"
        }
    });
});
parcelRegister("j3JoF", function(module, exports) {
    $parcel$export(module.exports, "AddGadgetWrapper", ()=>$4e1c9976b10072ae$export$b49fa20d3975c37f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $4e1c9976b10072ae$export$b49fa20d3975c37f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1nu9",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4WQJr", function(module, exports) {
    $parcel$export(module.exports, "ChangeLayoutButton", ()=>$dfb79944ea48976b$export$9a00daacadaaca0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1I7E8;
    var $koVbs;
    var $9Fpaj;
    var $lGD0O;
    const $dfb79944ea48976b$export$9a00daacadaaca0d = ({ layout: layout, onLayoutSelected: onLayoutSelected })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Fpaj")).LayoutPicker), {
                    onLayoutSelected: onLayoutSelected,
                    activeLayout: layout
                }),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    testId: "dashboard-edit.ui.header-editable.change-layout-button.layout-picker",
                    ...triggerProps,
                    onClick: ()=>setIsOpen(!isOpen),
                    isSelected: isOpen
                }, formatMessage((0, (0, parcelRequire("lGD0O")).default).title)),
            placement: "bottom-end"
        });
    };
});
parcelRegister("9Fpaj", function(module, exports) {
    $parcel$export(module.exports, "LayoutPicker", ()=>$325a23a1c061fe45$export$6aaa4206f6548ae5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $9AeOS;
    var $6ZnKV;
    var $c1wLk;
    var $4Sdei;
    var $djE5p;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $JIPqS;
    var $koVbs;
    var $jPb9c;
    const $325a23a1c061fe45$export$6aaa4206f6548ae5 = ({ onLayoutSelected: onLayoutSelected, activeLayout: activeLayout })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const layoutComponents = {
            A: (0, ($parcel$interopDefault((0, parcelRequire("9AeOS"))))),
            AA: (0, ($parcel$interopDefault((0, parcelRequire("c1wLk"))))),
            AAA: (0, ($parcel$interopDefault((0, parcelRequire("6ZnKV"))))),
            BA: (0, ($parcel$interopDefault((0, parcelRequire("4Sdei"))))),
            AB: (0, ($parcel$interopDefault((0, parcelRequire("djE5p")))))
        };
        const { oneColumn: oneColumn, twoColumns: twoColumns, threeColumns: threeColumns, leftSidebar: leftSidebar, rightSidebar: rightSidebar } = (0, (0, parcelRequire("jPb9c")).default);
        const tooltips = {
            A: oneColumn,
            AA: twoColumns,
            AAA: threeColumns,
            BA: leftSidebar,
            AB: rightSidebar
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $325a23a1c061fe45$var$pickerWrapperStyles,
            role: "radiogroup"
        }, (0, (0, parcelRequire("JIPqS")).LAYOUTS).map((layout)=>{
            const Layout = layoutComponents[layout];
            const isSelected = layout === activeLayout;
            const label = formatMessage(tooltips[layout]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($325a23a1c061fe45$var$LayoutWrapper, {
                key: layout,
                isSelected: isSelected
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: label,
                hideTooltipOnClick: true,
                position: "bottom"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($325a23a1c061fe45$var$ButtonStyled, {
                testId: `dashboard-edit.ui.header-editable.change-layout-button.layout-picker.label.${layout}`,
                id: `layout-${layout}`,
                role: "radio",
                appearance: "subtle",
                spacing: "default",
                isSelected: isSelected,
                "aria-checked": isSelected,
                onClick: ()=>onLayoutSelected(layout),
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement(Layout, {
                    label: label
                })
            })));
        }));
    };
    const $325a23a1c061fe45$var$pickerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.050'
    });
    const $325a23a1c061fe45$var$LayoutWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSelected: isSelected, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l",
                __cmplp.isSelected && "_szfs1p4p",
                __cmplp.className
            ])
        });
    });
    const $325a23a1c061fe45$var$ButtonStyled = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bg41i6y",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9AeOS", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6fa2f8b981785d39$var$_react = $6fa2f8b981785d39$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6fa2f8b981785d39$var$_layoutOneColumn = $6fa2f8b981785d39$var$_interopRequireDefault((parcelRequire("laf27")));
    var $6fa2f8b981785d39$var$_layoutSingle = $6fa2f8b981785d39$var$_interopRequireDefault((parcelRequire("9FvHK")));
    function $6fa2f8b981785d39$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6fa2f8b981785d39$var$LayoutOneColumnIcon = (props)=>$6fa2f8b981785d39$var$_react.default.createElement($6fa2f8b981785d39$var$_layoutOneColumn.default, Object.assign({
            LEGACY_fallbackIcon: $6fa2f8b981785d39$var$_layoutSingle.default
        }, props));
    $6fa2f8b981785d39$var$LayoutOneColumnIcon.Name = 'LayoutOneColumnIconMigration';
    var $6fa2f8b981785d39$var$_default = module.exports.default = $6fa2f8b981785d39$var$LayoutOneColumnIcon;
});
parcelRegister("laf27", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f686316ba098f47b$var$_react = $f686316ba098f47b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f686316ba098f47b$var$_UNSAFE_baseNew = $f686316ba098f47b$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f686316ba098f47b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f686316ba098f47b$var$LayoutOneColumnIcon = (props)=>$f686316ba098f47b$var$_react.default.createElement($f686316ba098f47b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.375c0-.345.28-.625.625-.625h13.25c.345 0 .625.28.625.625v11.25c0 .345-.28.625-.625.625H1.375a.625.625 0 0 1-.625-.625z"/>`
        }, props));
    $f686316ba098f47b$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
    var $f686316ba098f47b$var$_default = module.exports.default = $f686316ba098f47b$var$LayoutOneColumnIcon;
});
parcelRegister("9FvHK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $70a0894233ed0f2d$var$_react = $70a0894233ed0f2d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $70a0894233ed0f2d$var$_layoutOneColumn = $70a0894233ed0f2d$var$_interopRequireDefault((parcelRequire("laf27")));
    function $70a0894233ed0f2d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $70a0894233ed0f2d$var$EditorLayoutSingleIcon = (props)=>$70a0894233ed0f2d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="16" height="14" x="4" y="5" fill="currentcolor" rx="2"/></svg>`
        }, props, {
            newIcon: $70a0894233ed0f2d$var$_layoutOneColumn.default
        }));
    $70a0894233ed0f2d$var$EditorLayoutSingleIcon.displayName = 'EditorLayoutSingleIcon';
    var $70a0894233ed0f2d$var$_default = module.exports.default = $70a0894233ed0f2d$var$EditorLayoutSingleIcon;
});
parcelRegister("6ZnKV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $516addfb9491e154$var$_react = $516addfb9491e154$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $516addfb9491e154$var$_layoutThreeColumns = $516addfb9491e154$var$_interopRequireDefault((parcelRequire("bh6Q5")));
    var $516addfb9491e154$var$_layoutThreeEqual = $516addfb9491e154$var$_interopRequireDefault((parcelRequire("jlnXH")));
    function $516addfb9491e154$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $516addfb9491e154$var$LayoutThreeColumnsIcon = (props)=>$516addfb9491e154$var$_react.default.createElement($516addfb9491e154$var$_layoutThreeColumns.default, Object.assign({
            LEGACY_fallbackIcon: $516addfb9491e154$var$_layoutThreeEqual.default
        }, props));
    $516addfb9491e154$var$LayoutThreeColumnsIcon.Name = 'LayoutThreeColumnsIconMigration';
    var $516addfb9491e154$var$_default = module.exports.default = $516addfb9491e154$var$LayoutThreeColumnsIcon;
});
parcelRegister("bh6Q5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8356965a09dcfb04$var$_react = $8356965a09dcfb04$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8356965a09dcfb04$var$_UNSAFE_baseNew = $8356965a09dcfb04$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8356965a09dcfb04$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8356965a09dcfb04$var$LayoutThreeColumnsIcon = (props)=>$8356965a09dcfb04$var$_react.default.createElement($8356965a09dcfb04$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h1.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.5a.63.63 0 0 1-.62-.62zm11.75 0c0-.34.28-.62.63-.62h1.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.5a.63.63 0 0 1-.62-.62zm-6 0c0-.34.28-.62.63-.62h1.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H7.14a.63.63 0 0 1-.62-.62z"/>`
        }, props));
    $8356965a09dcfb04$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
    var $8356965a09dcfb04$var$_default = module.exports.default = $8356965a09dcfb04$var$LayoutThreeColumnsIcon;
});
parcelRegister("jlnXH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e15290ccf9d9577f$var$_react = $e15290ccf9d9577f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e15290ccf9d9577f$var$_layoutThreeColumns = $e15290ccf9d9577f$var$_interopRequireDefault((parcelRequire("bh6Q5")));
    function $e15290ccf9d9577f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e15290ccf9d9577f$var$EditorLayoutThreeEqualIcon = (props)=>$e15290ccf9d9577f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $e15290ccf9d9577f$var$_layoutThreeColumns.default
        }));
    $e15290ccf9d9577f$var$EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
    var $e15290ccf9d9577f$var$_default = module.exports.default = $e15290ccf9d9577f$var$EditorLayoutThreeEqualIcon;
});
parcelRegister("c1wLk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c0efdf379a64ff4$var$_react = $8c0efdf379a64ff4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c0efdf379a64ff4$var$_layoutTwoColumns = $8c0efdf379a64ff4$var$_interopRequireDefault((parcelRequire("lhITB")));
    var $8c0efdf379a64ff4$var$_layoutTwoEqual = $8c0efdf379a64ff4$var$_interopRequireDefault((parcelRequire("fdFa0")));
    function $8c0efdf379a64ff4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c0efdf379a64ff4$var$LayoutTwoColumnsIcon = (props)=>$8c0efdf379a64ff4$var$_react.default.createElement($8c0efdf379a64ff4$var$_layoutTwoColumns.default, Object.assign({
            LEGACY_fallbackIcon: $8c0efdf379a64ff4$var$_layoutTwoEqual.default
        }, props));
    $8c0efdf379a64ff4$var$LayoutTwoColumnsIcon.Name = 'LayoutTwoColumnsIconMigration';
    var $8c0efdf379a64ff4$var$_default = module.exports.default = $8c0efdf379a64ff4$var$LayoutTwoColumnsIcon;
});
parcelRegister("lhITB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f7ee02e1f6e030a1$var$_react = $f7ee02e1f6e030a1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f7ee02e1f6e030a1$var$_UNSAFE_baseNew = $f7ee02e1f6e030a1$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f7ee02e1f6e030a1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f7ee02e1f6e030a1$var$LayoutTwoColumnsIcon = (props)=>$f7ee02e1f6e030a1$var$_react.default.createElement($f7ee02e1f6e030a1$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h4.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-4.5a.63.63 0 0 1-.62-.62zm8.75 0c0-.34.28-.62.63-.62h4.5c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-4.5a.63.63 0 0 1-.62-.62z"/>`
        }, props));
    $f7ee02e1f6e030a1$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
    var $f7ee02e1f6e030a1$var$_default = module.exports.default = $f7ee02e1f6e030a1$var$LayoutTwoColumnsIcon;
});
parcelRegister("fdFa0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b147ff8615535e6d$var$_react = $b147ff8615535e6d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $b147ff8615535e6d$var$_layoutTwoColumns = $b147ff8615535e6d$var$_interopRequireDefault((parcelRequire("lhITB")));
    function $b147ff8615535e6d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b147ff8615535e6d$var$EditorLayoutTwoEqualIcon = (props)=>$b147ff8615535e6d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $b147ff8615535e6d$var$_layoutTwoColumns.default
        }));
    $b147ff8615535e6d$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
    var $b147ff8615535e6d$var$_default = module.exports.default = $b147ff8615535e6d$var$EditorLayoutTwoEqualIcon;
});
parcelRegister("4Sdei", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $38c677aaaf42481d$var$_react = $38c677aaaf42481d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $38c677aaaf42481d$var$_layoutTwoColumnsSidebarLeft = $38c677aaaf42481d$var$_interopRequireDefault((parcelRequire("1A6di")));
    var $38c677aaaf42481d$var$_layoutTwoLeftSidebar = $38c677aaaf42481d$var$_interopRequireDefault((parcelRequire("fQUS1")));
    function $38c677aaaf42481d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $38c677aaaf42481d$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>$38c677aaaf42481d$var$_react.default.createElement($38c677aaaf42481d$var$_layoutTwoColumnsSidebarLeft.default, Object.assign({
            LEGACY_fallbackIcon: $38c677aaaf42481d$var$_layoutTwoLeftSidebar.default
        }, props));
    $38c677aaaf42481d$var$LayoutTwoColumnsSidebarLeftIcon.Name = 'LayoutTwoColumnsSidebarLeftIconMigration';
    var $38c677aaaf42481d$var$_default = module.exports.default = $38c677aaaf42481d$var$LayoutTwoColumnsSidebarLeftIcon;
});
parcelRegister("1A6di", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $126df91b70991685$var$_react = $126df91b70991685$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $126df91b70991685$var$_UNSAFE_baseNew = $126df91b70991685$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $126df91b70991685$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>$126df91b70991685$var$_react.default.createElement($126df91b70991685$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 2.38a.63.63 0 0 0-.62-.62H6.88a.63.63 0 0 0-.62.63v11.25c0 .35.28.63.63.63h7.75c.35 0 .63-.28.63-.62zm-12 0a.63.63 0 0 0-.62-.62H1.38a.63.63 0 0 0-.62.63v11.25c0 .35.28.63.63.63h1.25c.35 0 .63-.28.63-.62z"/>`
        }, props));
    $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
    var $126df91b70991685$var$_default = module.exports.default = $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon;
});
parcelRegister("fQUS1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b8a7d39eebff8995$var$_react = $b8a7d39eebff8995$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $b8a7d39eebff8995$var$_layoutTwoColumnsSidebarLeft = $b8a7d39eebff8995$var$_interopRequireDefault((parcelRequire("1A6di")));
    function $b8a7d39eebff8995$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b8a7d39eebff8995$var$EditorLayoutTwoLeftSidebarIcon = (props)=>$b8a7d39eebff8995$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m5 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $b8a7d39eebff8995$var$_layoutTwoColumnsSidebarLeft.default
        }));
    $b8a7d39eebff8995$var$EditorLayoutTwoLeftSidebarIcon.displayName = 'EditorLayoutTwoLeftSidebarIcon';
    var $b8a7d39eebff8995$var$_default = module.exports.default = $b8a7d39eebff8995$var$EditorLayoutTwoLeftSidebarIcon;
});
parcelRegister("djE5p", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9b1c250435ceb0c0$var$_react = $9b1c250435ceb0c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9b1c250435ceb0c0$var$_layoutTwoColumnsSidebarRight = $9b1c250435ceb0c0$var$_interopRequireDefault((parcelRequire("dpENk")));
    var $9b1c250435ceb0c0$var$_layoutTwoRightSidebar = $9b1c250435ceb0c0$var$_interopRequireDefault((parcelRequire("l2xML")));
    function $9b1c250435ceb0c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9b1c250435ceb0c0$var$LayoutTwoColumnsSidebarRightIcon = (props)=>$9b1c250435ceb0c0$var$_react.default.createElement($9b1c250435ceb0c0$var$_layoutTwoColumnsSidebarRight.default, Object.assign({
            LEGACY_fallbackIcon: $9b1c250435ceb0c0$var$_layoutTwoRightSidebar.default
        }, props));
    $9b1c250435ceb0c0$var$LayoutTwoColumnsSidebarRightIcon.Name = 'LayoutTwoColumnsSidebarRightIconMigration';
    var $9b1c250435ceb0c0$var$_default = module.exports.default = $9b1c250435ceb0c0$var$LayoutTwoColumnsSidebarRightIcon;
});
parcelRegister("dpENk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9c3d41243faee441$var$_react = $9c3d41243faee441$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9c3d41243faee441$var$_UNSAFE_baseNew = $9c3d41243faee441$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9c3d41243faee441$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9c3d41243faee441$var$LayoutTwoColumnsSidebarRightIcon = (props)=>$9c3d41243faee441$var$_react.default.createElement($9c3d41243faee441$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 2.38c0-.34.28-.62.63-.62h7.75c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63H1.39a.63.63 0 0 1-.62-.62zm12 0c0-.34.28-.62.63-.62h1.25c.35 0 .63.28.63.63v11.25c0 .35-.28.63-.62.63h-1.25a.63.63 0 0 1-.62-.62z"/>`
        }, props));
    $9c3d41243faee441$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
    var $9c3d41243faee441$var$_default = module.exports.default = $9c3d41243faee441$var$LayoutTwoColumnsSidebarRightIcon;
});
parcelRegister("l2xML", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f513fdf84d71d01e$var$_react = $f513fdf84d71d01e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f513fdf84d71d01e$var$_layoutTwoColumnsSidebarRight = $f513fdf84d71d01e$var$_interopRequireDefault((parcelRequire("dpENk")));
    function $f513fdf84d71d01e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f513fdf84d71d01e$var$EditorLayoutTwoRightSidebarIcon = (props)=>$f513fdf84d71d01e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M5 5h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $f513fdf84d71d01e$var$_layoutTwoColumnsSidebarRight.default
        }));
    $f513fdf84d71d01e$var$EditorLayoutTwoRightSidebarIcon.displayName = 'EditorLayoutTwoRightSidebarIcon';
    var $f513fdf84d71d01e$var$_default = module.exports.default = $f513fdf84d71d01e$var$EditorLayoutTwoRightSidebarIcon;
});
parcelRegister("jPb9c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$564d95df49a37670$export$2e2bcd8739ae039);
    var $7VHMR;
    var $564d95df49a37670$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        oneColumn: {
            "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.one-column",
            "defaultMessage": "One column"
        },
        twoColumns: {
            "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.two-columns",
            "defaultMessage": "Two columns"
        },
        threeColumns: {
            "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.three-columns",
            "defaultMessage": "Three columns"
        },
        leftSidebar: {
            "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.left-sidebar",
            "defaultMessage": "Left sidebar"
        },
        rightSidebar: {
            "id": "dashboard-edit.header-editable.change-layout-button.layout-picker.right-sidebar",
            "defaultMessage": "Right sidebar"
        }
    });
});
parcelRegister("lGD0O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$608d314fb191503b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $608d314fb191503b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "dashboard-edit.header-editable.change-layout-button.title",
            "defaultMessage": "Change layout"
        }
    });
});
parcelRegister("j2vUH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$745fb374d564170e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $745fb374d564170e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        done: {
            "id": "dashboard-edit.header-editable.done",
            "defaultMessage": "Done"
        }
    });
});
parcelRegister("c92ZE", function(module, exports) {
    $parcel$export(module.exports, "ColumnPlaceholder", ()=>$d55f4cd547a10456$export$f0705bf8199f32ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $JIPqS;
    var $5HxxK;
    var $4Bpvs;
    var $koVbs;
    var $jaPSU;
    var $NMMas;
    const $d55f4cd547a10456$var$GadgetPlaceholder = ({ isDraggingOver: isDraggingOver, columnIndex: columnIndex })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const heightRef = (0, $5uXOq.useRef)(null);
        const [height, setHeight] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            if (!heightRef.current) return;
            const distanceFromTopOfWindow = heightRef.current.getBoundingClientRect().top;
            setHeight(`calc(100vh - ${distanceFromTopOfWindow}px - ${(0, (0, parcelRequire("JIPqS")).FOOTER_MARGIN)}px)`);
        }, [
            heightRef
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: heightRef,
            style: {
                height: height
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            xcss: [
                $d55f4cd547a10456$var$wrapperStyles,
                isDraggingOver ? $d55f4cd547a10456$var$draggingStyles : $d55f4cd547a10456$var$notDraggingStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d55f4cd547a10456$var$imageStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Bpvs")).default), {
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d55f4cd547a10456$var$contentStyles
        }, formatMessage((0, (0, parcelRequire("NMMas")).default).description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jaPSU")).AddGadgetButton), {
            buttonType: (0, $324eda6c4db64a18$export$e9a9f8a43cd26ad7),
            columnIndex: columnIndex
        })))));
    };
    const $d55f4cd547a10456$export$f0705bf8199f32ef = ({ customHeight: customHeight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HxxK")).ColumnPlaceholderContextConsumer), null, (placeholderProps)=>placeholderProps && (0, ($parcel$interopDefault($5uXOq))).createElement($d55f4cd547a10456$var$GadgetPlaceholder, {
                ...placeholderProps,
                customHeight: customHeight
            }));
    const $d55f4cd547a10456$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        minHeight: '400px',
        marginBottom: 'space.200',
        border: `dashed ${`var(--ds-border-bold, ${(0, $829f609a65d26a98$exports).N60})`} 1px`,
        borderRadius: 'border.radius.050',
        transition: 'background-color 0.2s ease'
    });
    const $d55f4cd547a10456$var$notDraggingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: `var(--ds-background-input, ${(0, $829f609a65d26a98$exports).N0})`
    });
    const $d55f4cd547a10456$var$draggingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$exports).N20})`
    });
    const $d55f4cd547a10456$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
        marginTop: 'space.200',
        color: 'color.text.subtlest'
    });
    const $d55f4cd547a10456$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '112px',
        marginInline: 'auto'
    });
});
parcelRegister("NMMas", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$504fdc54c0343192$export$2e2bcd8739ae039);
    var $7VHMR;
    var $504fdc54c0343192$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        description: {
            "id": "dashboard-edit.placeholder.description",
            "defaultMessage": "Drag a gadget to this column or "
        }
    });
});
parcelRegister("hsZLS", function(module, exports) {
    $parcel$export(module.exports, "useLayoutChangeErrorFlag", ()=>$6fa515ca378d1a90$export$c213d29262fac822);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $7HGHK;
    var $qFl2H;
    const $6fa515ca378d1a90$export$c213d29262fac822 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, $5uXOq.useCallback)(()=>{
            showFlag({
                key: (0, (0, parcelRequire("7HGHK")).toFlagId)('layoutChangeError'),
                type: 'error',
                title: (0, (0, parcelRequire("qFl2H")).default).changeLayoutErrorFlagTitle,
                description: (0, (0, parcelRequire("qFl2H")).default).changeLayoutErrorFlagDescription,
                actions: [
                    {
                        content: (0, (0, parcelRequire("qFl2H")).default).errorFlagAction,
                        onClick: ()=>window.location.reload()
                    }
                ]
            });
        }, [
            showFlag
        ]);
    };
});
parcelRegister("qFl2H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5183843c1b01a1c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a5183843c1b01a1c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeLayoutErrorFlagTitle: {
            "id": "dashboard-edit.utils.change-layout-error.change-layout-error-flag-title",
            "defaultMessage": "Error"
        },
        changeLayoutErrorFlagDescription: {
            "id": "dashboard-edit.utils.change-layout-error.change-layout-error-flag-description",
            "defaultMessage": "Failed to save layout, please refresh the page"
        },
        errorFlagAction: {
            "id": "dashboard-edit.utils.change-layout-error.error-flag-action",
            "defaultMessage": "Refresh"
        }
    });
});
